var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec58e"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec58e"] = parcelRequire;
}
parcelRequire.register("N7Lcz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
var $093a98c17cb6b6b8$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $093a98c17cb6b6b8$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$093a98c17cb6b6b8$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($093a98c17cb6b6b8$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($093a98c17cb6b6b8$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($093a98c17cb6b6b8$var$isNull(x) || !$093a98c17cb6b6b8$var$isObject(x)) str += " " + x;
    else str += " " + $093a98c17cb6b6b8$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $hPtJY !== "undefined" && $hPtJY.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $hPtJY === "undefined") return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($hPtJY.throwDeprecation) throw new Error(msg);
            else if ($hPtJY.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $093a98c17cb6b6b8$var$debugs = {};
var $093a98c17cb6b6b8$var$debugEnvRegex = /^$/;
var $093a98c17cb6b6b8$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$093a98c17cb6b6b8$var$debugs[set]) {
        if ($093a98c17cb6b6b8$var$debugEnvRegex.test(set)) {
            var pid = $hPtJY.pid;
            $093a98c17cb6b6b8$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $093a98c17cb6b6b8$var$debugs[set] = function() {};
    }
    return $093a98c17cb6b6b8$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $093a98c17cb6b6b8$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $093a98c17cb6b6b8$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($093a98c17cb6b6b8$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $093a98c17cb6b6b8$var$stylizeWithColor;
    return $093a98c17cb6b6b8$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $093a98c17cb6b6b8$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$093a98c17cb6b6b8$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$093a98c17cb6b6b8$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $093a98c17cb6b6b8$var$stylizeWithColor(str, styleType) {
    var style = $093a98c17cb6b6b8$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $093a98c17cb6b6b8$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $093a98c17cb6b6b8$var$inspect.colors[style][1] + "m";
    else return str;
}
function $093a98c17cb6b6b8$var$stylizeNoColor(str, styleType) {
    return str;
}
function $093a98c17cb6b6b8$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $093a98c17cb6b6b8$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $093a98c17cb6b6b8$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$093a98c17cb6b6b8$var$isString(ret)) ret = $093a98c17cb6b6b8$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $093a98c17cb6b6b8$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $093a98c17cb6b6b8$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($093a98c17cb6b6b8$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $093a98c17cb6b6b8$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($093a98c17cb6b6b8$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($093a98c17cb6b6b8$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($093a98c17cb6b6b8$var$isError(value)) return $093a98c17cb6b6b8$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($093a98c17cb6b6b8$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($093a98c17cb6b6b8$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($093a98c17cb6b6b8$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($093a98c17cb6b6b8$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($093a98c17cb6b6b8$var$isError(value)) base = " " + $093a98c17cb6b6b8$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces);
}
function $093a98c17cb6b6b8$var$formatPrimitive(ctx, value) {
    if ($093a98c17cb6b6b8$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($093a98c17cb6b6b8$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($093a98c17cb6b6b8$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($093a98c17cb6b6b8$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($093a98c17cb6b6b8$var$isNull(value)) return ctx.stylize("null", "null");
}
function $093a98c17cb6b6b8$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($093a98c17cb6b6b8$var$hasOwnProperty(value, String(i))) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$093a98c17cb6b6b8$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($093a98c17cb6b6b8$var$isNull(recurseTimes)) str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, null);
            else str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").substr(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($093a98c17cb6b6b8$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.substr(1, name.length - 2);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("7He6T"));
function $093a98c17cb6b6b8$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $093a98c17cb6b6b8$var$isArray;
function $093a98c17cb6b6b8$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
module.exports.isBoolean = $093a98c17cb6b6b8$var$isBoolean;
function $093a98c17cb6b6b8$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $093a98c17cb6b6b8$var$isNull;
function $093a98c17cb6b6b8$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $093a98c17cb6b6b8$var$isNullOrUndefined;
function $093a98c17cb6b6b8$var$isNumber(arg) {
    return typeof arg === "number";
}
module.exports.isNumber = $093a98c17cb6b6b8$var$isNumber;
function $093a98c17cb6b6b8$var$isString(arg) {
    return typeof arg === "string";
}
module.exports.isString = $093a98c17cb6b6b8$var$isString;
function $093a98c17cb6b6b8$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
module.exports.isSymbol = $093a98c17cb6b6b8$var$isSymbol;
function $093a98c17cb6b6b8$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $093a98c17cb6b6b8$var$isUndefined;
function $093a98c17cb6b6b8$var$isRegExp(re) {
    return $093a98c17cb6b6b8$var$isObject(re) && $093a98c17cb6b6b8$var$objectToString(re) === "[object RegExp]";
}
module.exports.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
module.exports.types.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
function $093a98c17cb6b6b8$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
module.exports.isObject = $093a98c17cb6b6b8$var$isObject;
function $093a98c17cb6b6b8$var$isDate(d) {
    return $093a98c17cb6b6b8$var$isObject(d) && $093a98c17cb6b6b8$var$objectToString(d) === "[object Date]";
}
module.exports.isDate = $093a98c17cb6b6b8$var$isDate;
module.exports.types.isDate = $093a98c17cb6b6b8$var$isDate;
function $093a98c17cb6b6b8$var$isError(e) {
    return $093a98c17cb6b6b8$var$isObject(e) && ($093a98c17cb6b6b8$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
module.exports.isError = $093a98c17cb6b6b8$var$isError;
module.exports.types.isNativeError = $093a98c17cb6b6b8$var$isError;
function $093a98c17cb6b6b8$var$isFunction(arg) {
    return typeof arg === "function";
}
module.exports.isFunction = $093a98c17cb6b6b8$var$isFunction;
function $093a98c17cb6b6b8$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
module.exports.isPrimitive = $093a98c17cb6b6b8$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("kotBY"));
function $093a98c17cb6b6b8$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $093a98c17cb6b6b8$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $093a98c17cb6b6b8$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $093a98c17cb6b6b8$var$timestamp() {
    var d = new Date();
    var time = [
        $093a98c17cb6b6b8$var$pad(d.getHours()),
        $093a98c17cb6b6b8$var$pad(d.getMinutes()),
        $093a98c17cb6b6b8$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $093a98c17cb6b6b8$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log("%s - %s", $093a98c17cb6b6b8$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("dlqwk"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$093a98c17cb6b6b8$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $093a98c17cb6b6b8$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol && original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol]) {
        var fn = original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol;
function $093a98c17cb6b6b8$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $093a98c17cb6b6b8$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $hPtJY.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $hPtJY.nextTick($093a98c17cb6b6b8$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $093a98c17cb6b6b8$var$callbackify;

});
parcelRequire.register("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRequire.register("7He6T", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $f4HGZ = parcelRequire("f4HGZ");

var $5WnCa = parcelRequire("5WnCa");

var $gJrpv = parcelRequire("gJrpv");

var $hN833 = parcelRequire("hN833");
function $59a77e8886024a57$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $59a77e8886024a57$var$BigIntSupported = typeof BigInt !== "undefined";
var $59a77e8886024a57$var$SymbolSupported = typeof Symbol !== "undefined";
var $59a77e8886024a57$var$ObjectToString = $59a77e8886024a57$var$uncurryThis(Object.prototype.toString);
var $59a77e8886024a57$var$numberValue = $59a77e8886024a57$var$uncurryThis(Number.prototype.valueOf);
var $59a77e8886024a57$var$stringValue = $59a77e8886024a57$var$uncurryThis(String.prototype.valueOf);
var $59a77e8886024a57$var$booleanValue = $59a77e8886024a57$var$uncurryThis(Boolean.prototype.valueOf);
if ($59a77e8886024a57$var$BigIntSupported) var $59a77e8886024a57$var$bigIntValue = $59a77e8886024a57$var$uncurryThis(BigInt.prototype.valueOf);
if ($59a77e8886024a57$var$SymbolSupported) var $59a77e8886024a57$var$symbolValue = $59a77e8886024a57$var$uncurryThis(Symbol.prototype.valueOf);
function $59a77e8886024a57$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $f4HGZ;
module.exports.isGeneratorFunction = $5WnCa;
module.exports.isTypedArray = $hN833;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $59a77e8886024a57$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $59a77e8886024a57$var$isPromise;
function $59a77e8886024a57$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $hN833(value) || $59a77e8886024a57$var$isDataView(value);
}
module.exports.isArrayBufferView = $59a77e8886024a57$var$isArrayBufferView;
function $59a77e8886024a57$var$isUint8Array(value) {
    return $gJrpv(value) === "Uint8Array";
}
module.exports.isUint8Array = $59a77e8886024a57$var$isUint8Array;
function $59a77e8886024a57$var$isUint8ClampedArray(value) {
    return $gJrpv(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $59a77e8886024a57$var$isUint8ClampedArray;
function $59a77e8886024a57$var$isUint16Array(value) {
    return $gJrpv(value) === "Uint16Array";
}
module.exports.isUint16Array = $59a77e8886024a57$var$isUint16Array;
function $59a77e8886024a57$var$isUint32Array(value) {
    return $gJrpv(value) === "Uint32Array";
}
module.exports.isUint32Array = $59a77e8886024a57$var$isUint32Array;
function $59a77e8886024a57$var$isInt8Array(value) {
    return $gJrpv(value) === "Int8Array";
}
module.exports.isInt8Array = $59a77e8886024a57$var$isInt8Array;
function $59a77e8886024a57$var$isInt16Array(value) {
    return $gJrpv(value) === "Int16Array";
}
module.exports.isInt16Array = $59a77e8886024a57$var$isInt16Array;
function $59a77e8886024a57$var$isInt32Array(value) {
    return $gJrpv(value) === "Int32Array";
}
module.exports.isInt32Array = $59a77e8886024a57$var$isInt32Array;
function $59a77e8886024a57$var$isFloat32Array(value) {
    return $gJrpv(value) === "Float32Array";
}
module.exports.isFloat32Array = $59a77e8886024a57$var$isFloat32Array;
function $59a77e8886024a57$var$isFloat64Array(value) {
    return $gJrpv(value) === "Float64Array";
}
module.exports.isFloat64Array = $59a77e8886024a57$var$isFloat64Array;
function $59a77e8886024a57$var$isBigInt64Array(value) {
    return $gJrpv(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $59a77e8886024a57$var$isBigInt64Array;
function $59a77e8886024a57$var$isBigUint64Array(value) {
    return $gJrpv(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $59a77e8886024a57$var$isBigUint64Array;
function $59a77e8886024a57$var$isMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Map]";
}
$59a77e8886024a57$var$isMapToString.working = typeof Map !== "undefined" && $59a77e8886024a57$var$isMapToString(new Map());
function $59a77e8886024a57$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $59a77e8886024a57$var$isMapToString.working ? $59a77e8886024a57$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $59a77e8886024a57$var$isMap;
function $59a77e8886024a57$var$isSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Set]";
}
$59a77e8886024a57$var$isSetToString.working = typeof Set !== "undefined" && $59a77e8886024a57$var$isSetToString(new Set());
function $59a77e8886024a57$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $59a77e8886024a57$var$isSetToString.working ? $59a77e8886024a57$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $59a77e8886024a57$var$isSet;
function $59a77e8886024a57$var$isWeakMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WeakMap]";
}
$59a77e8886024a57$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $59a77e8886024a57$var$isWeakMapToString(new WeakMap());
function $59a77e8886024a57$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $59a77e8886024a57$var$isWeakMapToString.working ? $59a77e8886024a57$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $59a77e8886024a57$var$isWeakMap;
function $59a77e8886024a57$var$isWeakSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WeakSet]";
}
$59a77e8886024a57$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $59a77e8886024a57$var$isWeakSetToString(new WeakSet());
function $59a77e8886024a57$var$isWeakSet(value) {
    return $59a77e8886024a57$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $59a77e8886024a57$var$isWeakSet;
function $59a77e8886024a57$var$isArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$59a77e8886024a57$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $59a77e8886024a57$var$isArrayBufferToString(new ArrayBuffer());
function $59a77e8886024a57$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $59a77e8886024a57$var$isArrayBufferToString.working ? $59a77e8886024a57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $59a77e8886024a57$var$isArrayBuffer;
function $59a77e8886024a57$var$isDataViewToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object DataView]";
}
$59a77e8886024a57$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $59a77e8886024a57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $59a77e8886024a57$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $59a77e8886024a57$var$isDataViewToString.working ? $59a77e8886024a57$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $59a77e8886024a57$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $59a77e8886024a57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $59a77e8886024a57$var$isSharedArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $59a77e8886024a57$var$isSharedArrayBuffer(value) {
    if (typeof $59a77e8886024a57$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $59a77e8886024a57$var$isSharedArrayBufferToString.working === "undefined") $59a77e8886024a57$var$isSharedArrayBufferToString.working = $59a77e8886024a57$var$isSharedArrayBufferToString(new $59a77e8886024a57$var$SharedArrayBufferCopy());
    return $59a77e8886024a57$var$isSharedArrayBufferToString.working ? $59a77e8886024a57$var$isSharedArrayBufferToString(value) : value instanceof $59a77e8886024a57$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $59a77e8886024a57$var$isSharedArrayBuffer;
function $59a77e8886024a57$var$isAsyncFunction(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $59a77e8886024a57$var$isAsyncFunction;
function $59a77e8886024a57$var$isMapIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $59a77e8886024a57$var$isMapIterator;
function $59a77e8886024a57$var$isSetIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $59a77e8886024a57$var$isSetIterator;
function $59a77e8886024a57$var$isGeneratorObject(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $59a77e8886024a57$var$isGeneratorObject;
function $59a77e8886024a57$var$isWebAssemblyCompiledModule(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $59a77e8886024a57$var$isWebAssemblyCompiledModule;
function $59a77e8886024a57$var$isNumberObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$numberValue);
}
module.exports.isNumberObject = $59a77e8886024a57$var$isNumberObject;
function $59a77e8886024a57$var$isStringObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$stringValue);
}
module.exports.isStringObject = $59a77e8886024a57$var$isStringObject;
function $59a77e8886024a57$var$isBooleanObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$booleanValue);
}
module.exports.isBooleanObject = $59a77e8886024a57$var$isBooleanObject;
function $59a77e8886024a57$var$isBigIntObject(value) {
    return $59a77e8886024a57$var$BigIntSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$bigIntValue);
}
module.exports.isBigIntObject = $59a77e8886024a57$var$isBigIntObject;
function $59a77e8886024a57$var$isSymbolObject(value) {
    return $59a77e8886024a57$var$SymbolSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$symbolValue);
}
module.exports.isSymbolObject = $59a77e8886024a57$var$isSymbolObject;
function $59a77e8886024a57$var$isBoxedPrimitive(value) {
    return $59a77e8886024a57$var$isNumberObject(value) || $59a77e8886024a57$var$isStringObject(value) || $59a77e8886024a57$var$isBooleanObject(value) || $59a77e8886024a57$var$isBigIntObject(value) || $59a77e8886024a57$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $59a77e8886024a57$var$isBoxedPrimitive;
function $59a77e8886024a57$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($59a77e8886024a57$var$isArrayBuffer(value) || $59a77e8886024a57$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $59a77e8886024a57$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRequire.register("f4HGZ", function(module, exports) {
"use strict";

var $af991f1d6c80f097$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $hXu6F = parcelRequire("hXu6F");
var $af991f1d6c80f097$var$$toString = $hXu6F("Object.prototype.toString");
var $af991f1d6c80f097$var$isStandardArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $af991f1d6c80f097$var$$toString(value) === "[object Arguments]";
};
var $af991f1d6c80f097$var$isLegacyArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $af991f1d6c80f097$var$$toString(value) !== "[object Array]" && $af991f1d6c80f097$var$$toString(value.callee) === "[object Function]";
};
var $af991f1d6c80f097$var$supportsStandardArguments = function() {
    return $af991f1d6c80f097$var$isStandardArguments(arguments);
}();
$af991f1d6c80f097$var$isStandardArguments.isLegacyArguments = $af991f1d6c80f097$var$isLegacyArguments; // for tests
module.exports = $af991f1d6c80f097$var$supportsStandardArguments ? $af991f1d6c80f097$var$isStandardArguments : $af991f1d6c80f097$var$isLegacyArguments;

});
parcelRequire.register("3KyxH", function(module, exports) {
"use strict";

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasToStringTagShams() {
    return $7YWkK() && !!Symbol.toStringTag;
};

});
parcelRequire.register("7YWkK", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRequire.register("hXu6F", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d12f4cdcd6b10506$var$$indexOf(name, ".prototype.") > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});
parcelRequire.register("1zENl", function(module, exports) {
"use strict";
var $1258b452ecf218a1$var$undefined;
var $1258b452ecf218a1$var$$SyntaxError = SyntaxError;
var $1258b452ecf218a1$var$$Function = Function;
var $1258b452ecf218a1$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1258b452ecf218a1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1258b452ecf218a1$var$$gOPD) try {
    $1258b452ecf218a1$var$$gOPD({}, "");
} catch (e) {
    $1258b452ecf218a1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $1258b452ecf218a1$var$$TypeError();
};
var $1258b452ecf218a1$var$ThrowTypeError = $1258b452ecf218a1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1258b452ecf218a1$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();
var $1258b452ecf218a1$var$getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === "undefined" ? $1258b452ecf218a1$var$undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? $1258b452ecf218a1$var$undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? $1258b452ecf218a1$var$undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : $1258b452ecf218a1$var$undefined,
    "%AsyncFromSyncIteratorPrototype%": $1258b452ecf218a1$var$undefined,
    "%AsyncFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGenerator%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncIteratorPrototype%": $1258b452ecf218a1$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? $1258b452ecf218a1$var$undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? $1258b452ecf218a1$var$undefined : BigInt,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? $1258b452ecf218a1$var$undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? $1258b452ecf218a1$var$undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? $1258b452ecf218a1$var$undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? $1258b452ecf218a1$var$undefined : FinalizationRegistry,
    "%Function%": $1258b452ecf218a1$var$$Function,
    "%GeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? $1258b452ecf218a1$var$undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? $1258b452ecf218a1$var$undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? $1258b452ecf218a1$var$undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1258b452ecf218a1$var$hasSymbols ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : $1258b452ecf218a1$var$undefined,
    "%JSON%": typeof JSON === "object" ? JSON : $1258b452ecf218a1$var$undefined,
    "%Map%": typeof Map === "undefined" ? $1258b452ecf218a1$var$undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1258b452ecf218a1$var$hasSymbols ? $1258b452ecf218a1$var$undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? $1258b452ecf218a1$var$undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? $1258b452ecf218a1$var$undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? $1258b452ecf218a1$var$undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? $1258b452ecf218a1$var$undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1258b452ecf218a1$var$hasSymbols ? $1258b452ecf218a1$var$undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? $1258b452ecf218a1$var$undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols ? $1258b452ecf218a1$var$getProto(""[Symbol.iterator]()) : $1258b452ecf218a1$var$undefined,
    "%Symbol%": $1258b452ecf218a1$var$hasSymbols ? Symbol : $1258b452ecf218a1$var$undefined,
    "%SyntaxError%": $1258b452ecf218a1$var$$SyntaxError,
    "%ThrowTypeError%": $1258b452ecf218a1$var$ThrowTypeError,
    "%TypedArray%": $1258b452ecf218a1$var$TypedArray,
    "%TypeError%": $1258b452ecf218a1$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? $1258b452ecf218a1$var$undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? $1258b452ecf218a1$var$undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? $1258b452ecf218a1$var$undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? $1258b452ecf218a1$var$undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? $1258b452ecf218a1$var$undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? $1258b452ecf218a1$var$undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? $1258b452ecf218a1$var$undefined : WeakSet
};
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gvair = parcelRequire("gvair");

var $8aKn2 = parcelRequire("8aKn2");
var $1258b452ecf218a1$var$$concat = $gvair.call(Function.call, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call(Function.apply, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call(Function.call, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call(Function.call, String.prototype.slice);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $1258b452ecf218a1$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $1258b452ecf218a1$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($8aKn2($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($8aKn2($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $1258b452ecf218a1$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $1258b452ecf218a1$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $1258b452ecf218a1$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $1258b452ecf218a1$var$$TypeError('"allowMissing" argument must be a boolean');
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $1258b452ecf218a1$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($8aKn2($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $1258b452ecf218a1$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1258b452ecf218a1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1258b452ecf218a1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $8aKn2(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRequire.register("24qIq", function(module, exports) {
"use strict";
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $1820ada193f67aeb$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $7YWkK();
};

});

parcelRequire.register("gvair", function(module, exports) {
"use strict";

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRequire.register("kAGnA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $efd80b1d7fbb2850$var$slice = Array.prototype.slice;
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$funcType = "[object Function]";
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $efd80b1d7fbb2850$var$toStr.call(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($efd80b1d7fbb2850$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($efd80b1d7fbb2850$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRequire.register("8aKn2", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");
module.exports = $gvair.call(Function.call, Object.prototype.hasOwnProperty);

});


parcelRequire.register("cOB0F", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");

var $1zENl = parcelRequire("1zENl");
var $9546dce5bd4976bd$var$$apply = $1zENl("%Function.prototype.apply%");
var $9546dce5bd4976bd$var$$call = $1zENl("%Function.prototype.call%");
var $9546dce5bd4976bd$var$$reflectApply = $1zENl("%Reflect.apply%", true) || $gvair.call($9546dce5bd4976bd$var$$call, $9546dce5bd4976bd$var$$apply);
var $9546dce5bd4976bd$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
var $9546dce5bd4976bd$var$$defineProperty = $1zENl("%Object.defineProperty%", true);
var $9546dce5bd4976bd$var$$max = $1zENl("%Math.max%");
if ($9546dce5bd4976bd$var$$defineProperty) try {
    $9546dce5bd4976bd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $9546dce5bd4976bd$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    var func = $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$call, arguments);
    if ($9546dce5bd4976bd$var$$gOPD && $9546dce5bd4976bd$var$$defineProperty) {
        var desc = $9546dce5bd4976bd$var$$gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $9546dce5bd4976bd$var$$defineProperty(func, "length", {
            value: 1 + $9546dce5bd4976bd$var$$max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var $9546dce5bd4976bd$var$applyBind = function applyBind() {
    return $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$apply, arguments);
};
if ($9546dce5bd4976bd$var$$defineProperty) $9546dce5bd4976bd$var$$defineProperty(module.exports, "apply", {
    value: $9546dce5bd4976bd$var$applyBind
});
else module.exports.apply = $9546dce5bd4976bd$var$applyBind;

});



parcelRequire.register("5WnCa", function(module, exports) {
"use strict";
var $4534afe844d627e4$var$toStr = Object.prototype.toString;
var $4534afe844d627e4$var$fnToStr = Function.prototype.toString;
var $4534afe844d627e4$var$isFnRegex = /^\s*(?:function)?\*/;

var $4534afe844d627e4$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $4534afe844d627e4$var$getProto = Object.getPrototypeOf;
var $4534afe844d627e4$var$getGeneratorFunc = function() {
    if (!$4534afe844d627e4$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $4534afe844d627e4$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($4534afe844d627e4$var$isFnRegex.test($4534afe844d627e4$var$fnToStr.call(fn))) return true;
    if (!$4534afe844d627e4$var$hasToStringTag) {
        var str = $4534afe844d627e4$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$4534afe844d627e4$var$getProto) return false;
    if (typeof $4534afe844d627e4$var$GeneratorFunction === "undefined") {
        var generatorFunc = $4534afe844d627e4$var$getGeneratorFunc();
        $4534afe844d627e4$var$GeneratorFunction = generatorFunc ? $4534afe844d627e4$var$getProto(generatorFunc) : false;
    }
    return $4534afe844d627e4$var$getProto(fn) === $4534afe844d627e4$var$GeneratorFunction;
};

});

parcelRequire.register("gJrpv", function(module, exports) {
"use strict";

var $1n2vj = parcelRequire("1n2vj");

var $8yXCr = parcelRequire("8yXCr");

var $hXu6F = parcelRequire("hXu6F");
var $c2e61c703a2c9ae0$var$$toString = $hXu6F("Object.prototype.toString");

var $c2e61c703a2c9ae0$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $c2e61c703a2c9ae0$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $c2e61c703a2c9ae0$var$typedArrays = $8yXCr();
var $c2e61c703a2c9ae0$var$$slice = $hXu6F("String.prototype.slice");
var $c2e61c703a2c9ae0$var$toStrTags = {};

var $6SeTG = parcelRequire("6SeTG");
var $c2e61c703a2c9ae0$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($c2e61c703a2c9ae0$var$hasToStringTag && $6SeTG && $c2e61c703a2c9ae0$var$getPrototypeOf) $1n2vj($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    if (typeof $c2e61c703a2c9ae0$var$g[typedArray] === "function") {
        var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
        if (Symbol.toStringTag in arr) {
            var proto = $c2e61c703a2c9ae0$var$getPrototypeOf(arr);
            var descriptor = $6SeTG(proto, Symbol.toStringTag);
            if (!descriptor) {
                var superProto = $c2e61c703a2c9ae0$var$getPrototypeOf(proto);
                descriptor = $6SeTG(superProto, Symbol.toStringTag);
            }
            $c2e61c703a2c9ae0$var$toStrTags[typedArray] = descriptor.get;
        }
    }
});
var $c2e61c703a2c9ae0$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var foundName = false;
    $1n2vj($c2e61c703a2c9ae0$var$toStrTags, function(getter, typedArray) {
        if (!foundName) try {
            var name = getter.call(value);
            if (name === typedArray) foundName = name;
        } catch (e) {}
    });
    return foundName;
};

var $hN833 = parcelRequire("hN833");
module.exports = function whichTypedArray(value) {
    if (!$hN833(value)) return false;
    if (!$c2e61c703a2c9ae0$var$hasToStringTag || !(Symbol.toStringTag in value)) return $c2e61c703a2c9ae0$var$$slice($c2e61c703a2c9ae0$var$$toString(value), 8, -1);
    return $c2e61c703a2c9ae0$var$tryTypedArrays(value);
};

});
parcelRequire.register("1n2vj", function(module, exports) {
var $0ff9e1aaf16a50e1$var$hasOwn = Object.prototype.hasOwnProperty;
var $0ff9e1aaf16a50e1$var$toString = Object.prototype.toString;
module.exports = function forEach(obj, fn, ctx) {
    if ($0ff9e1aaf16a50e1$var$toString.call(fn) !== "[object Function]") throw new TypeError("iterator must be a function");
    var l = obj.length;
    if (l === +l) for(var i = 0; i < l; i++)fn.call(ctx, obj[i], i, obj);
    else {
        for(var k in obj)if ($0ff9e1aaf16a50e1$var$hasOwn.call(obj, k)) fn.call(ctx, obj[k], k, obj);
    }
};

});

parcelRequire.register("8yXCr", function(module, exports) {
"use strict";
var $63bfbecf41903c8f$var$possibleNames = [
    "BigInt64Array",
    "BigUint64Array",
    "Float32Array",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Uint8Array",
    "Uint8ClampedArray"
];
var $63bfbecf41903c8f$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
module.exports = function availableTypedArrays() {
    var out = [];
    for(var i = 0; i < $63bfbecf41903c8f$var$possibleNames.length; i++)if (typeof $63bfbecf41903c8f$var$g[$63bfbecf41903c8f$var$possibleNames[i]] === "function") out[out.length] = $63bfbecf41903c8f$var$possibleNames[i];
    return out;
};

});

parcelRequire.register("6SeTG", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $5013578038c7b048$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
if ($5013578038c7b048$var$$gOPD) try {
    $5013578038c7b048$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $5013578038c7b048$var$$gOPD = null;
}
module.exports = $5013578038c7b048$var$$gOPD;

});

parcelRequire.register("hN833", function(module, exports) {
"use strict";

var $1n2vj = parcelRequire("1n2vj");

var $8yXCr = parcelRequire("8yXCr");

var $hXu6F = parcelRequire("hXu6F");
var $cf3d4182e663752d$var$$toString = $hXu6F("Object.prototype.toString");

var $cf3d4182e663752d$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $cf3d4182e663752d$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $cf3d4182e663752d$var$typedArrays = $8yXCr();
var $cf3d4182e663752d$var$$indexOf = $hXu6F("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $cf3d4182e663752d$var$$slice = $hXu6F("String.prototype.slice");
var $cf3d4182e663752d$var$toStrTags = {};

var $6SeTG = parcelRequire("6SeTG");
var $cf3d4182e663752d$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($cf3d4182e663752d$var$hasToStringTag && $6SeTG && $cf3d4182e663752d$var$getPrototypeOf) $1n2vj($cf3d4182e663752d$var$typedArrays, function(typedArray) {
    var arr = new $cf3d4182e663752d$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $cf3d4182e663752d$var$getPrototypeOf(arr);
        var descriptor = $6SeTG(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $cf3d4182e663752d$var$getPrototypeOf(proto);
            descriptor = $6SeTG(superProto, Symbol.toStringTag);
        }
        $cf3d4182e663752d$var$toStrTags[typedArray] = descriptor.get;
    }
});
var $cf3d4182e663752d$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var anyTrue = false;
    $1n2vj($cf3d4182e663752d$var$toStrTags, function(getter, typedArray) {
        if (!anyTrue) try {
            anyTrue = getter.call(value) === typedArray;
        } catch (e) {}
    });
    return anyTrue;
};
module.exports = function isTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$cf3d4182e663752d$var$hasToStringTag || !(Symbol.toStringTag in value)) {
        var tag = $cf3d4182e663752d$var$$slice($cf3d4182e663752d$var$$toString(value), 8, -1);
        return $cf3d4182e663752d$var$$indexOf($cf3d4182e663752d$var$typedArrays, tag) > -1;
    }
    if (!$6SeTG) return false;
    return $cf3d4182e663752d$var$tryTypedArrays(value);
};

});



parcelRequire.register("kotBY", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});

parcelRequire.register("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRequire.register("aLUwE", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $7d7a23f7babfddb7$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $7d7a23f7babfddb7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $7d7a23f7babfddb7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7d7a23f7babfddb7$var$_typeof(obj);
}
function $7d7a23f7babfddb7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $cCihK = parcelRequire("cCihK");
var $7d7a23f7babfddb7$var$_require$codes = $cCihK.codes, $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT = $7d7a23f7babfddb7$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_ARG_TYPE, $7d7a23f7babfddb7$var$ERR_INVALID_ARG_VALUE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_ARG_VALUE, $7d7a23f7babfddb7$var$ERR_INVALID_RETURN_VALUE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_RETURN_VALUE, $7d7a23f7babfddb7$var$ERR_MISSING_ARGS = $7d7a23f7babfddb7$var$_require$codes.ERR_MISSING_ARGS;

var $8pS6q = parcelRequire("8pS6q");

var $N7Lcz = parcelRequire("N7Lcz");
var $7d7a23f7babfddb7$var$inspect = $N7Lcz.inspect;

var $N7Lcz = parcelRequire("N7Lcz");
var $7d7a23f7babfddb7$require$_require$types = $N7Lcz.types;
var $7d7a23f7babfddb7$var$isPromise = $7d7a23f7babfddb7$require$_require$types.isPromise, $7d7a23f7babfddb7$var$isRegExp = $7d7a23f7babfddb7$require$_require$types.isRegExp;

var $7d7a23f7babfddb7$var$objectAssign = Object.assign ? Object.assign : (parcelRequire("dYBnA")).assign;

var $7d7a23f7babfddb7$var$objectIs = Object.is ? Object.is : (parcelRequire("eT9RM"));
var $7d7a23f7babfddb7$var$errorCache = new Map();
var $7d7a23f7babfddb7$var$isDeepEqual;
var $7d7a23f7babfddb7$var$isDeepStrictEqual;
var $7d7a23f7babfddb7$var$parseExpressionAt;
var $7d7a23f7babfddb7$var$findNodeAround;
var $7d7a23f7babfddb7$var$decoder;

function $7d7a23f7babfddb7$var$lazyLoadComparison() {
    var comparison = (parcelRequire("3LKhK"));
    $7d7a23f7babfddb7$var$isDeepEqual = comparison.isDeepEqual;
    $7d7a23f7babfddb7$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
} // Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $7d7a23f7babfddb7$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $7d7a23f7babfddb7$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "",
    "",
    "\\u000b",
    "\\f",
    "",
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $7d7a23f7babfddb7$var$escapeFn = function escapeFn(str) {
    return $7d7a23f7babfddb7$var$meta[str.charCodeAt(0)];
};
var $7d7a23f7babfddb7$var$warned = false; // The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $7d7a23f7babfddb7$var$assert = module.exports = $7d7a23f7babfddb7$var$ok;
var $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL = {}; // All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $7d7a23f7babfddb7$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $8pS6q(obj);
}
function $7d7a23f7babfddb7$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = "Failed";
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($7d7a23f7babfddb7$var$warned === false) {
            $7d7a23f7babfddb7$var$warned = true;
            var warn = $hPtJY.emitWarning ? $hPtJY.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
        }
        if (argsLen === 2) operator = "!=";
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? "fail" : operator,
        stackStartFn: stackStartFn || $7d7a23f7babfddb7$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $8pS6q(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$7d7a23f7babfddb7$var$assert.fail = $7d7a23f7babfddb7$var$fail; // The AssertionError is defined in internal/error.
$7d7a23f7babfddb7$var$assert.AssertionError = $8pS6q;
function $7d7a23f7babfddb7$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = "No value argument passed to `assert.ok()`";
        } else if (message instanceof Error) throw message;
        var err = new $8pS6q({
            actual: value,
            expected: true,
            message: message,
            operator: "==",
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
} // Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $7d7a23f7babfddb7$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $7d7a23f7babfddb7$var$innerOk.apply(void 0, [
        $7d7a23f7babfddb7$var$ok,
        args.length
    ].concat(args));
}
$7d7a23f7babfddb7$var$assert.ok = $7d7a23f7babfddb7$var$ok; // The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $7d7a23f7babfddb7$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
     // eslint-disable-next-line eqeqeq
    if (actual != expected) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "==",
        stackStartFn: equal
    });
}; // The non-equality assertion tests for whether two objects are not
// equal with !=.
$7d7a23f7babfddb7$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
     // eslint-disable-next-line eqeqeq
    if (actual == expected) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "!=",
        stackStartFn: notEqual
    });
}; // The equivalence assertion tests a deep equality relation.
$7d7a23f7babfddb7$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if (!$7d7a23f7babfddb7$var$isDeepEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepEqual",
        stackStartFn: deepEqual
    });
}; // The non-equivalence assertion tests for any deep inequality.
$7d7a23f7babfddb7$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if ($7d7a23f7babfddb7$var$isDeepEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepEqual",
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $7d7a23f7babfddb7$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if (!$7d7a23f7babfddb7$var$isDeepStrictEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepStrictEqual",
        stackStartFn: deepStrictEqual
    });
};
$7d7a23f7babfddb7$var$assert.notDeepStrictEqual = $7d7a23f7babfddb7$var$notDeepStrictEqual;
function $7d7a23f7babfddb7$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if ($7d7a23f7babfddb7$var$isDeepStrictEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepStrictEqual",
        stackStartFn: $7d7a23f7babfddb7$var$notDeepStrictEqual
    });
}
$7d7a23f7babfddb7$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if (!$7d7a23f7babfddb7$var$objectIs(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "strictEqual",
        stackStartFn: strictEqual
    });
};
$7d7a23f7babfddb7$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$objectIs(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notStrictEqual",
        stackStartFn: notStrictEqual
    });
};
var $7d7a23f7babfddb7$var$Comparison = function Comparison(obj, keys, actual) {
    var _this = this;
    $7d7a23f7babfddb7$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === "string" && $7d7a23f7babfddb7$var$isRegExp(obj[key]) && obj[key].test(actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
};
function $7d7a23f7babfddb7$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$7d7a23f7babfddb7$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $7d7a23f7babfddb7$var$Comparison(actual, keys);
            var b = new $7d7a23f7babfddb7$var$Comparison(expected, keys, actual);
            var err = new $8pS6q({
                actual: a,
                expected: b,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $7d7a23f7babfddb7$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $7d7a23f7babfddb7$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== "function") {
        if ($7d7a23f7babfddb7$var$isRegExp(expected)) return expected.test(actual); // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("expected", [
            "Function",
            "RegExp"
        ], expected);
         // Handle primitives properly.
        if ($7d7a23f7babfddb7$var$_typeof(actual) !== "object" || actual === null) {
            var err = new $8pS6q({
                actual: actual,
                expected: expected,
                message: msg,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected); // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push("name", "message");
        else if (keys.length === 0) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_VALUE("error", expected, "may not be an empty object");
        if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === "string" && $7d7a23f7babfddb7$var$isRegExp(expected[key]) && expected[key].test(actual[key])) return;
            $7d7a23f7babfddb7$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    } // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $7d7a23f7babfddb7$var$getActual(fn) {
    if (typeof fn !== "function") throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("fn", "Function", fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL;
}
function $7d7a23f7babfddb7$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $7d7a23f7babfddb7$var$isPromise(obj) || obj !== null && $7d7a23f7babfddb7$var$_typeof(obj) === "object" && typeof obj.then === "function" && typeof obj.catch === "function";
}
function $7d7a23f7babfddb7$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === "function") {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn(); // Fail in case no promise is returned.
            if (!$7d7a23f7babfddb7$var$checkIsPromise(resultPromise)) throw new $7d7a23f7babfddb7$var$ERR_INVALID_RETURN_VALUE("instance of Promise", "promiseFn", resultPromise);
        } else if ($7d7a23f7babfddb7$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("promiseFn", [
            "Function",
            "Promise"
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $7d7a23f7babfddb7$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === "string") {
        if (arguments.length === 4) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("error", [
            "Object",
            "Error",
            "Function",
            "RegExp"
        ], error);
        if ($7d7a23f7babfddb7$var$_typeof(actual) === "object" && actual !== null) {
            if (actual.message === error) throw new $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error message "'.concat(actual.message, '" is identical to the message.'));
        } else if (actual === error) throw new $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error "'.concat(actual, '" is identical to the message.'));
        message = error;
        error = undefined;
    } else if (error != null && $7d7a23f7babfddb7$var$_typeof(error) !== "object" && typeof error !== "function") throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("error", [
        "Object",
        "Error",
        "Function",
        "RegExp"
    ], error);
    if (actual === $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL) {
        var details = "";
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "rejects" ? "rejection" : "exception";
        $7d7a23f7babfddb7$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$7d7a23f7babfddb7$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $7d7a23f7babfddb7$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === "string") {
        message = error;
        error = undefined;
    }
    if (!error || $7d7a23f7babfddb7$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "doesNotReject" ? "rejection" : "exception";
        $7d7a23f7babfddb7$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + 'Actual message: "'.concat(actual && actual.message, '"'),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$7d7a23f7babfddb7$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $7d7a23f7babfddb7$var$expectsError.apply(void 0, [
        throws,
        $7d7a23f7babfddb7$var$getActual(promiseFn)
    ].concat(args));
};
$7d7a23f7babfddb7$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $7d7a23f7babfddb7$var$waitForActual(promiseFn).then(function(result) {
        return $7d7a23f7babfddb7$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$7d7a23f7babfddb7$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $7d7a23f7babfddb7$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $7d7a23f7babfddb7$var$getActual(fn)
    ].concat(args));
};
$7d7a23f7babfddb7$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $7d7a23f7babfddb7$var$waitForActual(fn).then(function(result) {
        return $7d7a23f7babfddb7$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$7d7a23f7babfddb7$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = "ifError got unwanted exception: ";
        if ($7d7a23f7babfddb7$var$_typeof(err) === "object" && typeof err.message === "string") {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $7d7a23f7babfddb7$var$inspect(err);
        var newErr = new $8pS6q({
            actual: err,
            expected: null,
            operator: "ifError",
            message: message,
            stackStartFn: ifError
        }); // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === "string") {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split("\n");
            tmp2.shift(); // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split("\n");
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join("\n"), "\n").concat(tmp2.join("\n"));
        }
        throw newErr;
    }
}; // Expose a strict only variant of assert
function $7d7a23f7babfddb7$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $7d7a23f7babfddb7$var$innerOk.apply(void 0, [
        $7d7a23f7babfddb7$var$strict,
        args.length
    ].concat(args));
}
$7d7a23f7babfddb7$var$assert.strict = $7d7a23f7babfddb7$var$objectAssign($7d7a23f7babfddb7$var$strict, $7d7a23f7babfddb7$var$assert, {
    equal: $7d7a23f7babfddb7$var$assert.strictEqual,
    deepEqual: $7d7a23f7babfddb7$var$assert.deepStrictEqual,
    notEqual: $7d7a23f7babfddb7$var$assert.notStrictEqual,
    notDeepEqual: $7d7a23f7babfddb7$var$assert.notDeepStrictEqual
});
$7d7a23f7babfddb7$var$assert.strict.strict = $7d7a23f7babfddb7$var$assert.strict;

});
parcelRequire.register("cCihK", function(module, exports) {

$parcel$export(module.exports, "codes", () => $92f737b1c63f6b54$export$e45cb6485273080e, (v) => $92f737b1c63f6b54$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $92f737b1c63f6b54$export$e45cb6485273080e;
"use strict"; // The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $92f737b1c63f6b54$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $92f737b1c63f6b54$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $92f737b1c63f6b54$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $92f737b1c63f6b54$var$_typeof(obj);
}
function $92f737b1c63f6b54$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $92f737b1c63f6b54$var$_possibleConstructorReturn(self, call) {
    if (call && ($92f737b1c63f6b54$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $92f737b1c63f6b54$var$_assertThisInitialized(self);
}
function $92f737b1c63f6b54$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $92f737b1c63f6b54$var$_getPrototypeOf(o) {
    $92f737b1c63f6b54$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $92f737b1c63f6b54$var$_getPrototypeOf(o);
}
function $92f737b1c63f6b54$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $92f737b1c63f6b54$var$_setPrototypeOf(subClass, superClass);
}
function $92f737b1c63f6b54$var$_setPrototypeOf(o, p) {
    $92f737b1c63f6b54$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $92f737b1c63f6b54$var$_setPrototypeOf(o, p);
}
var $92f737b1c63f6b54$var$codes = {}; // Lazy loaded
var $92f737b1c63f6b54$var$assert;
var $92f737b1c63f6b54$var$util;
function $92f737b1c63f6b54$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $92f737b1c63f6b54$var$_inherits(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $92f737b1c63f6b54$var$_classCallCheck(this, NodeError);
            _this = $92f737b1c63f6b54$var$_possibleConstructorReturn(this, $92f737b1c63f6b54$var$_getPrototypeOf(NodeError).call(this, getMessage(arg1, arg2, arg3)));
            _this.code = code;
            return _this;
        }
        return NodeError;
    }(Base);
    $92f737b1c63f6b54$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $92f737b1c63f6b54$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $92f737b1c63f6b54$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $92f737b1c63f6b54$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $92f737b1c63f6b54$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$92f737b1c63f6b54$var$createErrorType("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);

$92f737b1c63f6b54$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    if ($92f737b1c63f6b54$var$assert === undefined) $92f737b1c63f6b54$var$assert = (parcelRequire("aLUwE"));
    $92f737b1c63f6b54$var$assert(typeof name === "string", "'name' must be a string"); // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $92f737b1c63f6b54$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($92f737b1c63f6b54$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($92f737b1c63f6b54$var$oneOf(expected, "type"));
    else {
        var type = $92f737b1c63f6b54$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($92f737b1c63f6b54$var$oneOf(expected, "type"));
    } // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($92f737b1c63f6b54$var$_typeof(actual));
    return msg;
}, TypeError);

$92f737b1c63f6b54$var$createErrorType("ERR_INVALID_ARG_VALUE", function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "is invalid";
    if ($92f737b1c63f6b54$var$util === undefined) $92f737b1c63f6b54$var$util = (parcelRequire("N7Lcz"));
    var inspected = $92f737b1c63f6b54$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$92f737b1c63f6b54$var$createErrorType("ERR_INVALID_RETURN_VALUE", function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($92f737b1c63f6b54$var$_typeof(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);

$92f737b1c63f6b54$var$createErrorType("ERR_MISSING_ARGS", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($92f737b1c63f6b54$var$assert === undefined) $92f737b1c63f6b54$var$assert = (parcelRequire("aLUwE"));
    $92f737b1c63f6b54$var$assert(args.length > 0, "At least one arg needs to be specified");
    var msg = "The ";
    var len = args.length;
    args = args.map(function(a) {
        return '"'.concat(a, '"');
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(", ");
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$92f737b1c63f6b54$export$e45cb6485273080e = $92f737b1c63f6b54$var$codes;

});

parcelRequire.register("8pS6q", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $620aa032cca82da4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $620aa032cca82da4$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $620aa032cca82da4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $620aa032cca82da4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $620aa032cca82da4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $620aa032cca82da4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $620aa032cca82da4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $620aa032cca82da4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $620aa032cca82da4$var$_possibleConstructorReturn(self, call) {
    if (call && ($620aa032cca82da4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $620aa032cca82da4$var$_assertThisInitialized(self);
}
function $620aa032cca82da4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $620aa032cca82da4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $620aa032cca82da4$var$_setPrototypeOf(subClass, superClass);
}
function $620aa032cca82da4$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $620aa032cca82da4$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$620aa032cca82da4$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $620aa032cca82da4$var$_construct(Class, arguments, $620aa032cca82da4$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $620aa032cca82da4$var$_setPrototypeOf(Wrapper, Class);
    };
    return $620aa032cca82da4$var$_wrapNativeSuper(Class);
}
function $620aa032cca82da4$var$isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $620aa032cca82da4$var$_construct(Parent, args, Class) {
    if ($620aa032cca82da4$var$isNativeReflectConstruct()) $620aa032cca82da4$var$_construct = Reflect.construct;
    else $620aa032cca82da4$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $620aa032cca82da4$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $620aa032cca82da4$var$_construct.apply(null, arguments);
}
function $620aa032cca82da4$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $620aa032cca82da4$var$_setPrototypeOf(o, p) {
    $620aa032cca82da4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $620aa032cca82da4$var$_setPrototypeOf(o, p);
}
function $620aa032cca82da4$var$_getPrototypeOf(o) {
    $620aa032cca82da4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $620aa032cca82da4$var$_getPrototypeOf(o);
}
function $620aa032cca82da4$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $620aa032cca82da4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $620aa032cca82da4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $620aa032cca82da4$var$_typeof(obj);
}

var $N7Lcz = parcelRequire("N7Lcz");
var $620aa032cca82da4$var$inspect = $N7Lcz.inspect;

var $cCihK = parcelRequire("cCihK");
var $620aa032cca82da4$var$ERR_INVALID_ARG_TYPE = $cCihK.codes.ERR_INVALID_ARG_TYPE; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $620aa032cca82da4$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $620aa032cca82da4$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return "";
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $620aa032cca82da4$var$blue = "";
var $620aa032cca82da4$var$green = "";
var $620aa032cca82da4$var$red = "";
var $620aa032cca82da4$var$white = "";
var $620aa032cca82da4$var$kReadableOperator = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
}; // Comparing short primitives should just show === / !== instead of using the
// diff.
var $620aa032cca82da4$var$kMaxShortLength = 10;
function $620aa032cca82da4$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, "message", {
        value: source.message
    });
    return target;
}
function $620aa032cca82da4$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $620aa032cca82da4$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $620aa032cca82da4$var$createErrDiff(actual, expected, operator) {
    var other = "";
    var res = "";
    var lastPos = 0;
    var end = "";
    var skipped = false;
    var actualInspected = $620aa032cca82da4$var$inspectValue(actual);
    var actualLines = actualInspected.split("\n");
    var expectedLines = $620aa032cca82da4$var$inspectValue(expected).split("\n");
    var i = 0;
    var indicator = ""; // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === "strictEqual" && $620aa032cca82da4$var$_typeof(actual) === "object" && $620aa032cca82da4$var$_typeof(expected) === "object" && actual !== null && expected !== null) operator = "strictEqualObject";
     // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length; // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $620aa032cca82da4$var$kMaxShortLength) {
            if (($620aa032cca82da4$var$_typeof(actual) !== "object" || actual === null) && ($620aa032cca82da4$var$_typeof(expected) !== "object" || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($620aa032cca82da4$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== "strictEqualObject") {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $hPtJY.stderr && $hPtJY.stderr.isTTY ? $hPtJY.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                 // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($620aa032cca82da4$var$repeat(" ", i), "^");
                    i = 0;
                }
            }
        }
    } // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length); // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split("\n"); // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($620aa032cca82da4$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join("\n"), "\n");
    }
    if (i > 3) {
        end = "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white).concat(end);
        skipped = true;
    }
    if (other !== "") {
        end = "\n  ".concat(other).concat(end);
        other = "";
    }
    var printedLines = 0;
    var msg = $620aa032cca82da4$var$kReadableOperator[operator] + "\n".concat($620aa032cca82da4$var$green, "+ actual").concat($620aa032cca82da4$var$white, " ").concat($620aa032cca82da4$var$red, "- expected").concat($620aa032cca82da4$var$white);
    var skippedMsg = " ".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            } // Mark the current line as the last diverging one.
            lastPos = i; // Add the expected line to the cache.
            other += "\n".concat($620aa032cca82da4$var$red, "-").concat($620aa032cca82da4$var$white, " ").concat(expectedLines[i]);
            printedLines++; // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            } // Mark the current line as the last diverging one.
            lastPos = i; // Add the actual line to the result.
            res += "\n".concat($620aa032cca82da4$var$green, "+").concat($620aa032cca82da4$var$white, " ").concat(actualLines[i]);
            printedLines++; // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i]; // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$620aa032cca82da4$var$endsWith(actualLine, ",") || actualLine.slice(0, -1) !== expectedLine); // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $620aa032cca82da4$var$endsWith(expectedLine, ",") && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ",";
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                } // Mark the current line as the last diverging one.
                lastPos = i; // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($620aa032cca82da4$var$green, "+").concat($620aa032cca82da4$var$white, " ").concat(actualLine);
                other += "\n".concat($620aa032cca82da4$var$red, "-").concat($620aa032cca82da4$var$white, " ").concat(expectedLine);
                printedLines += 2; // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = ""; // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        } // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white).concat(other, "\n") + "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : "", "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $620aa032cca82da4$var$AssertionError = /*#__PURE__*/ function(_Error) {
    $620aa032cca82da4$var$_inherits(AssertionError, _Error);
    function AssertionError(options) {
        var _this;
        $620aa032cca82da4$var$_classCallCheck(this, AssertionError);
        if ($620aa032cca82da4$var$_typeof(options) !== "object" || options === null) throw new $620aa032cca82da4$var$ERR_INVALID_ARG_TYPE("options", "Object", options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, String(message)));
        else {
            if ($hPtJY.stderr && $hPtJY.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($hPtJY.stderr && $hPtJY.stderr.getColorDepth && $hPtJY.stderr.getColorDepth() !== 1) {
                    $620aa032cca82da4$var$blue = "\x1b[34m";
                    $620aa032cca82da4$var$green = "\x1b[32m";
                    $620aa032cca82da4$var$white = "\x1b[39m";
                    $620aa032cca82da4$var$red = "\x1b[31m";
                } else {
                    $620aa032cca82da4$var$blue = "";
                    $620aa032cca82da4$var$green = "";
                    $620aa032cca82da4$var$white = "";
                    $620aa032cca82da4$var$red = "";
                }
            } // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($620aa032cca82da4$var$_typeof(actual) === "object" && actual !== null && $620aa032cca82da4$var$_typeof(expected) === "object" && expected !== null && "stack" in actual && actual instanceof Error && "stack" in expected && expected instanceof Error) {
                actual = $620aa032cca82da4$var$copyError(actual);
                expected = $620aa032cca82da4$var$copyError(expected);
            }
            if (operator === "deepStrictEqual" || operator === "strictEqual") _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, $620aa032cca82da4$var$createErrDiff(actual, expected, operator)));
            else if (operator === "notDeepStrictEqual" || operator === "notStrictEqual") {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $620aa032cca82da4$var$kReadableOperator[operator];
                var res = $620aa032cca82da4$var$inspectValue(actual).split("\n"); // In case "actual" is an object, it should not be reference equal.
                if (operator === "notStrictEqual" && $620aa032cca82da4$var$_typeof(actual) === "object" && actual !== null) base = $620aa032cca82da4$var$kReadableOperator.notStrictEqualObject;
                 // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    while(res.length > 27)res.pop();
                } // Only print a single input.
                if (res.length === 1) _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, "".concat(base, " ").concat(res[0])));
                else _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, "".concat(base, "\n\n").concat(res.join("\n"), "\n")));
            } else {
                var _res = $620aa032cca82da4$var$inspectValue(actual);
                var other = "";
                var knownOperators = $620aa032cca82da4$var$kReadableOperator[operator];
                if (operator === "notDeepEqual" || operator === "notEqual") {
                    _res = "".concat($620aa032cca82da4$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($620aa032cca82da4$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === "deepEqual" || operator === "equal") _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, "".concat(_res).concat(other)));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($620aa032cca82da4$var$_assertThisInitialized(_this), "name", {
            value: "AssertionError [ERR_ASSERTION]",
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = "ERR_ASSERTION";
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($620aa032cca82da4$var$_assertThisInitialized(_this), stackStartFn);
         // Create error message including the error code in the name.
        _this.stack; // Reset the name.
        _this.name = "AssertionError";
        return $620aa032cca82da4$var$_possibleConstructorReturn(_this);
    }
    $620aa032cca82da4$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: $620aa032cca82da4$var$inspect.custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $620aa032cca82da4$var$inspect(this, $620aa032cca82da4$var$_objectSpread({}, ctx, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}($620aa032cca82da4$var$_wrapNativeSuper(Error));
module.exports = $620aa032cca82da4$var$AssertionError;

});

parcelRequire.register("dYBnA", function(module, exports) {
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */ "use strict";
function $a2cddfb99e0a6135$var$assign(target, firstSource) {
    if (target === undefined || target === null) throw new TypeError("Cannot convert first argument to object");
    var to = Object(target);
    for(var i = 1; i < arguments.length; i++){
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) continue;
        var keysArray = Object.keys(Object(nextSource));
        for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++){
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) to[nextKey] = nextSource[nextKey];
        }
    }
    return to;
}
function $a2cddfb99e0a6135$var$polyfill() {
    if (!Object.assign) Object.defineProperty(Object, "assign", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: $a2cddfb99e0a6135$var$assign
    });
}
module.exports = {
    assign: $a2cddfb99e0a6135$var$assign,
    polyfill: $a2cddfb99e0a6135$var$polyfill
};

});

parcelRequire.register("eT9RM", function(module, exports) {
"use strict";

var $1UbTr = parcelRequire("1UbTr");

var $cOB0F = parcelRequire("cOB0F");

var $6wuPW = parcelRequire("6wuPW");

var $5SxoI = parcelRequire("5SxoI");

var $bNbuK = parcelRequire("bNbuK");
var $ad6ddb07ef0cb149$var$polyfill = $cOB0F($5SxoI(), Object);
$1UbTr($ad6ddb07ef0cb149$var$polyfill, {
    getPolyfill: $5SxoI,
    implementation: $6wuPW,
    shim: $bNbuK
});
module.exports = $ad6ddb07ef0cb149$var$polyfill;

});
parcelRequire.register("1UbTr", function(module, exports) {
"use strict";

var $81enX = parcelRequire("81enX");
var $16343f2546a69e4c$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $16343f2546a69e4c$var$toStr = Object.prototype.toString;
var $16343f2546a69e4c$var$concat = Array.prototype.concat;
var $16343f2546a69e4c$var$origDefineProperty = Object.defineProperty;
var $16343f2546a69e4c$var$isFunction = function(fn) {
    return typeof fn === "function" && $16343f2546a69e4c$var$toStr.call(fn) === "[object Function]";
};

var $16343f2546a69e4c$var$hasPropertyDescriptors = (parcelRequire("i16wS"))();
var $16343f2546a69e4c$var$supportsDescriptors = $16343f2546a69e4c$var$origDefineProperty && $16343f2546a69e4c$var$hasPropertyDescriptors;
var $16343f2546a69e4c$var$defineProperty = function(object, name, value, predicate) {
    if (name in object && (!$16343f2546a69e4c$var$isFunction(predicate) || !predicate())) return;
    if ($16343f2546a69e4c$var$supportsDescriptors) $16343f2546a69e4c$var$origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value; // eslint-disable-line no-param-reassign
};
var $16343f2546a69e4c$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $81enX(map);
    if ($16343f2546a69e4c$var$hasSymbols) props = $16343f2546a69e4c$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$16343f2546a69e4c$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$16343f2546a69e4c$var$defineProperties.supportsDescriptors = !!$16343f2546a69e4c$var$supportsDescriptors;
module.exports = $16343f2546a69e4c$var$defineProperties;

});
parcelRequire.register("81enX", function(module, exports) {
"use strict";
var $5d69935f2747da8d$var$slice = Array.prototype.slice;

var $z1gio = parcelRequire("z1gio");
var $5d69935f2747da8d$var$origKeys = Object.keys;

var $5d69935f2747da8d$var$keysShim = $5d69935f2747da8d$var$origKeys ? function keys(o) {
    return $5d69935f2747da8d$var$origKeys(o);
} : (parcelRequire("4nFCC"));
var $5d69935f2747da8d$var$originalKeys = Object.keys;
$5d69935f2747da8d$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($z1gio(object)) return $5d69935f2747da8d$var$originalKeys($5d69935f2747da8d$var$slice.call(object));
            return $5d69935f2747da8d$var$originalKeys(object);
        };
    } else Object.keys = $5d69935f2747da8d$var$keysShim;
    return Object.keys || $5d69935f2747da8d$var$keysShim;
};
module.exports = $5d69935f2747da8d$var$keysShim;

});
parcelRequire.register("z1gio", function(module, exports) {
"use strict";
var $06943f92b55ad7fa$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $06943f92b55ad7fa$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $06943f92b55ad7fa$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRequire.register("4nFCC", function(module, exports) {
"use strict";
var $330998a67e44345d$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $330998a67e44345d$var$has = Object.prototype.hasOwnProperty;
    var $330998a67e44345d$var$toStr = Object.prototype.toString;
    var $330998a67e44345d$var$isArgs = (parcelRequire("z1gio")); // eslint-disable-line global-require
    var $330998a67e44345d$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $330998a67e44345d$var$hasDontEnumBug = !$330998a67e44345d$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $330998a67e44345d$var$hasProtoEnumBug = $330998a67e44345d$var$isEnumerable.call(function() {}, "prototype");
    var $330998a67e44345d$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $330998a67e44345d$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $330998a67e44345d$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $330998a67e44345d$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$330998a67e44345d$var$excludedKeys["$" + k] && $330998a67e44345d$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $330998a67e44345d$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$330998a67e44345d$var$hasAutomationEqualityBug) return $330998a67e44345d$var$equalsConstructorPrototype(o);
        try {
            return $330998a67e44345d$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $330998a67e44345d$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $330998a67e44345d$var$toStr.call(object) === "[object Function]";
        var isArguments = $330998a67e44345d$var$isArgs(object);
        var isString = isObject && $330998a67e44345d$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $330998a67e44345d$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$330998a67e44345d$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $330998a67e44345d$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($330998a67e44345d$var$hasDontEnumBug) {
            var skipConstructor = $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $330998a67e44345d$var$dontEnums.length; ++k)if (!(skipConstructor && $330998a67e44345d$var$dontEnums[k] === "constructor") && $330998a67e44345d$var$has.call(object, $330998a67e44345d$var$dontEnums[k])) theKeys.push($330998a67e44345d$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $330998a67e44345d$var$keysShim;

});


parcelRequire.register("i16wS", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $d1dd62937e17e68d$var$$defineProperty = $1zENl("%Object.defineProperty%", true);
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($d1dd62937e17e68d$var$$defineProperty) try {
        $d1dd62937e17e68d$var$$defineProperty({}, "a", {
            value: 1
        });
        return true;
    } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
    }
    return false;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$d1dd62937e17e68d$var$hasPropertyDescriptors()) return null;
    try {
        return $d1dd62937e17e68d$var$$defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});


parcelRequire.register("6wuPW", function(module, exports) {
"use strict";
var $4bfda6cb765ad269$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($4bfda6cb765ad269$var$numberIsNaN(a) && $4bfda6cb765ad269$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRequire.register("5SxoI", function(module, exports) {
"use strict";

var $6wuPW = parcelRequire("6wuPW");
module.exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : $6wuPW;
};

});

parcelRequire.register("bNbuK", function(module, exports) {
"use strict";

var $5SxoI = parcelRequire("5SxoI");

var $1UbTr = parcelRequire("1UbTr");
module.exports = function shimObjectIs() {
    var polyfill = $5SxoI();
    $1UbTr(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRequire.register("3LKhK", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";
function $2be9aa30bff457b9$var$_slicedToArray(arr, i) {
    return $2be9aa30bff457b9$var$_arrayWithHoles(arr) || $2be9aa30bff457b9$var$_iterableToArrayLimit(arr, i) || $2be9aa30bff457b9$var$_nonIterableRest();
}
function $2be9aa30bff457b9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $2be9aa30bff457b9$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $2be9aa30bff457b9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2be9aa30bff457b9$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2be9aa30bff457b9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2be9aa30bff457b9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2be9aa30bff457b9$var$_typeof(obj);
}
var $2be9aa30bff457b9$var$regexFlagsSupported = /a/g.flags !== undefined;
var $2be9aa30bff457b9$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $2be9aa30bff457b9$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $2be9aa30bff457b9$var$objectIs = Object.is ? Object.is : (parcelRequire("eT9RM"));
var $2be9aa30bff457b9$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $2be9aa30bff457b9$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("c8Cyq"));
function $2be9aa30bff457b9$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $2be9aa30bff457b9$var$hasOwnProperty = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.hasOwnProperty);
var $2be9aa30bff457b9$var$propertyIsEnumerable = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $2be9aa30bff457b9$var$objectToString = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.toString);

var $N7Lcz = parcelRequire("N7Lcz");
var $2be9aa30bff457b9$require$_require$types = $N7Lcz.types;
var $2be9aa30bff457b9$var$isAnyArrayBuffer = $2be9aa30bff457b9$require$_require$types.isAnyArrayBuffer, $2be9aa30bff457b9$var$isArrayBufferView = $2be9aa30bff457b9$require$_require$types.isArrayBufferView, $2be9aa30bff457b9$var$isDate = $2be9aa30bff457b9$require$_require$types.isDate, $2be9aa30bff457b9$var$isMap = $2be9aa30bff457b9$require$_require$types.isMap, $2be9aa30bff457b9$var$isRegExp = $2be9aa30bff457b9$require$_require$types.isRegExp, $2be9aa30bff457b9$var$isSet = $2be9aa30bff457b9$require$_require$types.isSet, $2be9aa30bff457b9$var$isNativeError = $2be9aa30bff457b9$require$_require$types.isNativeError, $2be9aa30bff457b9$var$isBoxedPrimitive = $2be9aa30bff457b9$require$_require$types.isBoxedPrimitive, $2be9aa30bff457b9$var$isNumberObject = $2be9aa30bff457b9$require$_require$types.isNumberObject, $2be9aa30bff457b9$var$isStringObject = $2be9aa30bff457b9$require$_require$types.isStringObject, $2be9aa30bff457b9$var$isBooleanObject = $2be9aa30bff457b9$require$_require$types.isBooleanObject, $2be9aa30bff457b9$var$isBigIntObject = $2be9aa30bff457b9$require$_require$types.isBigIntObject, $2be9aa30bff457b9$var$isSymbolObject = $2be9aa30bff457b9$require$_require$types.isSymbolObject, $2be9aa30bff457b9$var$isFloat32Array = $2be9aa30bff457b9$require$_require$types.isFloat32Array, $2be9aa30bff457b9$var$isFloat64Array = $2be9aa30bff457b9$require$_require$types.isFloat64Array;
function $2be9aa30bff457b9$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    } // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $2be9aa30bff457b9$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($2be9aa30bff457b9$var$isNonIndex).concat($2be9aa30bff457b9$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
} // Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $2be9aa30bff457b9$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $2be9aa30bff457b9$var$ONLY_ENUMERABLE = undefined;
var $2be9aa30bff457b9$var$kStrict = true;
var $2be9aa30bff457b9$var$kLoose = false;
var $2be9aa30bff457b9$var$kNoIterator = 0;
var $2be9aa30bff457b9$var$kIsArray = 1;
var $2be9aa30bff457b9$var$kIsSet = 2;
var $2be9aa30bff457b9$var$kIsMap = 3; // Check if they have the same source and flags
function $2be9aa30bff457b9$var$areSimilarRegExps(a, b) {
    return $2be9aa30bff457b9$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $2be9aa30bff457b9$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $2be9aa30bff457b9$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $2be9aa30bff457b9$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $2be9aa30bff457b9$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $2be9aa30bff457b9$var$isEqualBoxedPrimitive(val1, val2) {
    if ($2be9aa30bff457b9$var$isNumberObject(val1)) return $2be9aa30bff457b9$var$isNumberObject(val2) && $2be9aa30bff457b9$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($2be9aa30bff457b9$var$isStringObject(val1)) return $2be9aa30bff457b9$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($2be9aa30bff457b9$var$isBooleanObject(val1)) return $2be9aa30bff457b9$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($2be9aa30bff457b9$var$isBigIntObject(val1)) return $2be9aa30bff457b9$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $2be9aa30bff457b9$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
} // Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $2be9aa30bff457b9$var$objectIs(val1, val2) : true;
    } // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($2be9aa30bff457b9$var$_typeof(val1) !== "object") return typeof val1 === "number" && $2be9aa30bff457b9$var$numberIsNaN(val1) && $2be9aa30bff457b9$var$numberIsNaN(val2);
        if ($2be9aa30bff457b9$var$_typeof(val2) !== "object" || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $2be9aa30bff457b9$var$_typeof(val1) !== "object") {
            if (val2 === null || $2be9aa30bff457b9$var$_typeof(val2) !== "object") // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $2be9aa30bff457b9$var$_typeof(val2) !== "object") return false;
    }
    var val1Tag = $2be9aa30bff457b9$var$objectToString(val1);
    var val2Tag = $2be9aa30bff457b9$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val1, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        var keys2 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val2, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsArray, keys1);
    } // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === "[object Object]") {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$2be9aa30bff457b9$var$isMap(val1) && $2be9aa30bff457b9$var$isMap(val2) || !$2be9aa30bff457b9$var$isSet(val1) && $2be9aa30bff457b9$var$isSet(val2)) return false;
    }
    if ($2be9aa30bff457b9$var$isDate(val1)) {
        if (!$2be9aa30bff457b9$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($2be9aa30bff457b9$var$isRegExp(val1)) {
        if (!$2be9aa30bff457b9$var$isRegExp(val2) || !$2be9aa30bff457b9$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($2be9aa30bff457b9$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($2be9aa30bff457b9$var$isArrayBufferView(val1)) {
        if (!strict && ($2be9aa30bff457b9$var$isFloat32Array(val1) || $2be9aa30bff457b9$var$isFloat64Array(val1))) {
            if (!$2be9aa30bff457b9$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$2be9aa30bff457b9$var$areSimilarTypedArrays(val1, val2)) return false;
         // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val1, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        var _keys2 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val2, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kNoIterator, _keys);
    } else if ($2be9aa30bff457b9$var$isSet(val1)) {
        if (!$2be9aa30bff457b9$var$isSet(val2) || val1.size !== val2.size) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsSet);
    } else if ($2be9aa30bff457b9$var$isMap(val1)) {
        if (!$2be9aa30bff457b9$var$isMap(val2) || val1.size !== val2.size) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsMap);
    } else if ($2be9aa30bff457b9$var$isAnyArrayBuffer(val1)) {
        if (!$2be9aa30bff457b9$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($2be9aa30bff457b9$var$isBoxedPrimitive(val1) && !$2be9aa30bff457b9$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kNoIterator);
}
function $2be9aa30bff457b9$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $2be9aa30bff457b9$var$propertyIsEnumerable(val, k);
    });
}
function $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2); // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    } // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$2be9aa30bff457b9$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($2be9aa30bff457b9$var$propertyIsEnumerable(val1, key)) {
                    if (!$2be9aa30bff457b9$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($2be9aa30bff457b9$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $2be9aa30bff457b9$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $2be9aa30bff457b9$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $2be9aa30bff457b9$var$kNoIterator || iterationType === $2be9aa30bff457b9$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
     // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $2be9aa30bff457b9$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $2be9aa30bff457b9$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $2be9aa30bff457b9$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($2be9aa30bff457b9$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
} // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim) {
    switch($2be9aa30bff457b9$var$_typeof(prim)){
        case "undefined":
            return null;
        case "object":
            // Only pass in null as object!
            return undefined;
        case "symbol":
            return false;
        case "string":
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case "number":
            if ($2be9aa30bff457b9$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $2be9aa30bff457b9$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$2be9aa30bff457b9$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $2be9aa30bff457b9$var$innerDeepEqual(item, curB, false, memo);
}
function $2be9aa30bff457b9$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $2be9aa30bff457b9$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i]; // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($2be9aa30bff457b9$var$_typeof(val) === "object" && val !== null) {
            if (set === null) set = new Set();
             // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false; // Fast path to detect missing string, symbol, undefined and null values.
            if (!$2be9aa30bff457b9$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $2be9aa30bff457b9$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i]; // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($2be9aa30bff457b9$var$_typeof(_val) === "object" && _val !== null) {
                if (!$2be9aa30bff457b9$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$2be9aa30bff457b9$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $2be9aa30bff457b9$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $2be9aa30bff457b9$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($2be9aa30bff457b9$var$innerDeepEqual(key1, key2, strict, memo) && $2be9aa30bff457b9$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $2be9aa30bff457b9$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $2be9aa30bff457b9$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $2be9aa30bff457b9$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($2be9aa30bff457b9$var$_typeof(key) === "object" && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$2be9aa30bff457b9$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false; // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$2be9aa30bff457b9$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $2be9aa30bff457b9$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $2be9aa30bff457b9$var$_slicedToArray(bEntries[_i2], 2), key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($2be9aa30bff457b9$var$_typeof(key) === "object" && key !== null) {
                if (!$2be9aa30bff457b9$var$mapHasEqualEntry(set, a, key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(key) || !$2be9aa30bff457b9$var$innerDeepEqual(a.get(key), item, false, memo)) && !$2be9aa30bff457b9$var$mapHasEqualEntry(set, a, key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $2be9aa30bff457b9$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $2be9aa30bff457b9$var$kIsSet) {
        if (!$2be9aa30bff457b9$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $2be9aa30bff457b9$var$kIsMap) {
        if (!$2be9aa30bff457b9$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $2be9aa30bff457b9$var$kIsArray) for(; i < a.length; i++){
        if ($2be9aa30bff457b9$var$hasOwnProperty(a, i)) {
            if (!$2be9aa30bff457b9$var$hasOwnProperty(b, i) || !$2be9aa30bff457b9$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($2be9aa30bff457b9$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$2be9aa30bff457b9$var$hasOwnProperty(b, key) || !$2be9aa30bff457b9$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
     // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key = keys[i];
        if (!$2be9aa30bff457b9$var$innerDeepEqual(a[_key], b[_key], strict, memos)) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$isDeepEqual(val1, val2) {
    return $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, $2be9aa30bff457b9$var$kLoose);
}
function $2be9aa30bff457b9$var$isDeepStrictEqual(val1, val2) {
    return $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, $2be9aa30bff457b9$var$kStrict);
}
module.exports = {
    isDeepEqual: $2be9aa30bff457b9$var$isDeepEqual,
    isDeepStrictEqual: $2be9aa30bff457b9$var$isDeepStrictEqual
};

});
parcelRequire.register("c8Cyq", function(module, exports) {
"use strict";

var $cOB0F = parcelRequire("cOB0F");

var $1UbTr = parcelRequire("1UbTr");

var $8sYH2 = parcelRequire("8sYH2");

var $91M8b = parcelRequire("91M8b");

var $hCf9I = parcelRequire("hCf9I");
var $8d642377f5822430$var$polyfill = $cOB0F($91M8b(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $1UbTr($8d642377f5822430$var$polyfill, {
    getPolyfill: $91M8b,
    implementation: $8sYH2,
    shim: $hCf9I
});
module.exports = $8d642377f5822430$var$polyfill;

});
parcelRequire.register("8sYH2", function(module, exports) {
"use strict";
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRequire.register("91M8b", function(module, exports) {
"use strict";

var $8sYH2 = parcelRequire("8sYH2");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a")) return Number.isNaN;
    return $8sYH2;
};

});

parcelRequire.register("hCf9I", function(module, exports) {
"use strict";

var $1UbTr = parcelRequire("1UbTr");

var $91M8b = parcelRequire("91M8b");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $91M8b();
    $1UbTr(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRequire.register("hVfHM", function(module, exports) {
module.exports = {
    "4r5e": 1,
    "5h1t": 1,
    "5hit": 1,
    "a55": 1,
    "anal": 1,
    "anus": 1,
    "ar5e": 1,
    "arrse": 1,
    "arse": 1,
    "ass": 1,
    "ass-fucker": 1,
    "asses": 1,
    "assfucker": 1,
    "assfukka": 1,
    "asshole": 1,
    "assholes": 1,
    "asswhole": 1,
    "a_s_s": 1,
    "b!tch": 1,
    "b00bs": 1,
    "b17ch": 1,
    "b1tch": 1,
    "ballbag": 1,
    "balls": 1,
    "ballsack": 1,
    "bastard": 1,
    "beastial": 1,
    "beastiality": 1,
    "bellend": 1,
    "bestial": 1,
    "bestiality": 1,
    "bi+ch": 1,
    "biatch": 1,
    "bitch": 1,
    "bitcher": 1,
    "bitchers": 1,
    "bitches": 1,
    "bitchin": 1,
    "bitching": 1,
    "bloody": 1,
    "blow job": 1,
    "blowjob": 1,
    "blowjobs": 1,
    "boiolas": 1,
    "bollock": 1,
    "bollok": 1,
    "boner": 1,
    "boob": 1,
    "boobs": 1,
    "booobs": 1,
    "boooobs": 1,
    "booooobs": 1,
    "booooooobs": 1,
    "breasts": 1,
    "buceta": 1,
    "bugger": 1,
    "bum": 1,
    "bunny fucker": 1,
    "butt": 1,
    "butthole": 1,
    "buttmuch": 1,
    "buttplug": 1,
    "c0ck": 1,
    "c0cksucker": 1,
    "carpet muncher": 1,
    "cawk": 1,
    "chink": 1,
    "cipa": 1,
    "cl1t": 1,
    "clit": 1,
    "clitoris": 1,
    "clits": 1,
    "cnut": 1,
    "cock": 1,
    "cock-sucker": 1,
    "cockface": 1,
    "cockhead": 1,
    "cockmunch": 1,
    "cockmuncher": 1,
    "cocks": 1,
    "cocksuck": 1,
    "cocksucked": 1,
    "cocksucker": 1,
    "cocksucking": 1,
    "cocksucks": 1,
    "cocksuka": 1,
    "cocksukka": 1,
    "cok": 1,
    "cokmuncher": 1,
    "coksucka": 1,
    "coon": 1,
    "cox": 1,
    "crap": 1,
    "cum": 1,
    "cummer": 1,
    "cumming": 1,
    "cums": 1,
    "cumshot": 1,
    "cunilingus": 1,
    "cunillingus": 1,
    "cunnilingus": 1,
    "cunt": 1,
    "cuntlick": 1,
    "cuntlicker": 1,
    "cuntlicking": 1,
    "cunts": 1,
    "cyalis": 1,
    "cyberfuc": 1,
    "cyberfuck": 1,
    "cyberfucked": 1,
    "cyberfucker": 1,
    "cyberfuckers": 1,
    "cyberfucking": 1,
    "d1ck": 1,
    "damn": 1,
    "dick": 1,
    "dickhead": 1,
    "dildo": 1,
    "dildos": 1,
    "dink": 1,
    "dinks": 1,
    "dirsa": 1,
    "dlck": 1,
    "dog-fucker": 1,
    "doggin": 1,
    "dogging": 1,
    "donkeyribber": 1,
    "doosh": 1,
    "duche": 1,
    "dyke": 1,
    "ejaculate": 1,
    "ejaculated": 1,
    "ejaculates": 1,
    "ejaculating": 1,
    "ejaculatings": 1,
    "ejaculation": 1,
    "ejakulate": 1,
    "f u c k": 1,
    "f u c k e r": 1,
    "f4nny": 1,
    "fag": 1,
    "fagging": 1,
    "faggitt": 1,
    "faggot": 1,
    "faggs": 1,
    "fagot": 1,
    "fagots": 1,
    "fags": 1,
    "fanny": 1,
    "fannyflaps": 1,
    "fannyfucker": 1,
    "fanyy": 1,
    "fatass": 1,
    "fcuk": 1,
    "fcuker": 1,
    "fcuking": 1,
    "feck": 1,
    "fecker": 1,
    "felching": 1,
    "fellate": 1,
    "fellatio": 1,
    "fingerfuck": 1,
    "fingerfucked": 1,
    "fingerfucker": 1,
    "fingerfuckers": 1,
    "fingerfucking": 1,
    "fingerfucks": 1,
    "fistfuck": 1,
    "fistfucked": 1,
    "fistfucker": 1,
    "fistfuckers": 1,
    "fistfucking": 1,
    "fistfuckings": 1,
    "fistfucks": 1,
    "flange": 1,
    "fook": 1,
    "fooker": 1,
    "fuck": 1,
    "fucka": 1,
    "fucked": 1,
    "fucker": 1,
    "fuckers": 1,
    "fuckhead": 1,
    "fuckheads": 1,
    "fuckin": 1,
    "fucking": 1,
    "fuckings": 1,
    "fuckingshitmotherfucker": 1,
    "fuckme": 1,
    "fucks": 1,
    "fuckwhit": 1,
    "fuckwit": 1,
    "fudge packer": 1,
    "fudgepacker": 1,
    "fuk": 1,
    "fuker": 1,
    "fukker": 1,
    "fukkin": 1,
    "fuks": 1,
    "fukwhit": 1,
    "fukwit": 1,
    "fux": 1,
    "fux0r": 1,
    "f_u_c_k": 1,
    "gangbang": 1,
    "gangbanged": 1,
    "gangbangs": 1,
    "gaylord": 1,
    "gaysex": 1,
    "goatse": 1,
    "God": 1,
    "god-dam": 1,
    "god-damned": 1,
    "goddamn": 1,
    "goddamned": 1,
    "hardcoresex": 1,
    "hell": 1,
    "heshe": 1,
    "hoar": 1,
    "hoare": 1,
    "hoer": 1,
    "homo": 1,
    "hore": 1,
    "horniest": 1,
    "horny": 1,
    "hotsex": 1,
    "jack-off": 1,
    "jackoff": 1,
    "jap": 1,
    "jerk-off": 1,
    "jism": 1,
    "jiz": 1,
    "jizm": 1,
    "jizz": 1,
    "kawk": 1,
    "knob": 1,
    "knobead": 1,
    "knobed": 1,
    "knobend": 1,
    "knobhead": 1,
    "knobjocky": 1,
    "knobjokey": 1,
    "kock": 1,
    "kondum": 1,
    "kondums": 1,
    "kum": 1,
    "kummer": 1,
    "kumming": 1,
    "kums": 1,
    "kunilingus": 1,
    "l3i+ch": 1,
    "l3itch": 1,
    "labia": 1,
    "lust": 1,
    "lusting": 1,
    "m0f0": 1,
    "m0fo": 1,
    "m45terbate": 1,
    "ma5terb8": 1,
    "ma5terbate": 1,
    "masochist": 1,
    "master-bate": 1,
    "masterb8": 1,
    "masterbat*": 1,
    "masterbat3": 1,
    "masterbate": 1,
    "masterbation": 1,
    "masterbations": 1,
    "masturbate": 1,
    "mo-fo": 1,
    "mof0": 1,
    "mofo": 1,
    "mothafuck": 1,
    "mothafucka": 1,
    "mothafuckas": 1,
    "mothafuckaz": 1,
    "mothafucked": 1,
    "mothafucker": 1,
    "mothafuckers": 1,
    "mothafuckin": 1,
    "mothafucking": 1,
    "mothafuckings": 1,
    "mothafucks": 1,
    "mother fucker": 1,
    "motherfuck": 1,
    "motherfucked": 1,
    "motherfucker": 1,
    "motherfuckers": 1,
    "motherfuckin": 1,
    "motherfucking": 1,
    "motherfuckings": 1,
    "motherfuckka": 1,
    "motherfucks": 1,
    "muff": 1,
    "mutha": 1,
    "muthafecker": 1,
    "muthafuckker": 1,
    "muther": 1,
    "mutherfucker": 1,
    "n1gga": 1,
    "n1gger": 1,
    "nazi": 1,
    "nigg3r": 1,
    "nigg4h": 1,
    "nigga": 1,
    "niggah": 1,
    "niggas": 1,
    "niggaz": 1,
    "nigger": 1,
    "niggers": 1,
    "nob": 1,
    "nob jokey": 1,
    "nobhead": 1,
    "nobjocky": 1,
    "nobjokey": 1,
    "numbnuts": 1,
    "nutsack": 1,
    "orgasim": 1,
    "orgasims": 1,
    "orgasm": 1,
    "orgasms": 1,
    "p0rn": 1,
    "pawn": 1,
    "pecker": 1,
    "penis": 1,
    "penisfucker": 1,
    "phonesex": 1,
    "phuck": 1,
    "phuk": 1,
    "phuked": 1,
    "phuking": 1,
    "phukked": 1,
    "phukking": 1,
    "phuks": 1,
    "phuq": 1,
    "pigfucker": 1,
    "pimpis": 1,
    "piss": 1,
    "pissed": 1,
    "pisser": 1,
    "pissers": 1,
    "pisses": 1,
    "pissflaps": 1,
    "pissin": 1,
    "pissing": 1,
    "pissoff": 1,
    "poop": 1,
    "porn": 1,
    "porno": 1,
    "pornography": 1,
    "pornos": 1,
    "prick": 1,
    "pricks": 1,
    "pron": 1,
    "pube": 1,
    "pusse": 1,
    "pussi": 1,
    "pussies": 1,
    "pussy": 1,
    "pussys": 1,
    "rectum": 1,
    "retard": 1,
    "rimjaw": 1,
    "rimming": 1,
    "s hit": 1,
    "s.o.b.": 1,
    "sadist": 1,
    "schlong": 1,
    "screwing": 1,
    "scroat": 1,
    "scrote": 1,
    "scrotum": 1,
    "semen": 1,
    "sex": 1,
    "sh!+": 1,
    "sh!t": 1,
    "sh1t": 1,
    "shag": 1,
    "shagger": 1,
    "shaggin": 1,
    "shagging": 1,
    "shemale": 1,
    "shi+": 1,
    "shit": 1,
    "shitdick": 1,
    "shite": 1,
    "shited": 1,
    "shitey": 1,
    "shitfuck": 1,
    "shitfull": 1,
    "shithead": 1,
    "shiting": 1,
    "shitings": 1,
    "shits": 1,
    "shitted": 1,
    "shitter": 1,
    "shitters": 1,
    "shitting": 1,
    "shittings": 1,
    "shitty": 1,
    "skank": 1,
    "slut": 1,
    "sluts": 1,
    "smegma": 1,
    "smut": 1,
    "snatch": 1,
    "son-of-a-bitch": 1,
    "spac": 1,
    "spunk": 1,
    "s_h_i_t": 1,
    "t1tt1e5": 1,
    "t1tties": 1,
    "teets": 1,
    "teez": 1,
    "testical": 1,
    "testicle": 1,
    "tit": 1,
    "titfuck": 1,
    "tits": 1,
    "titt": 1,
    "tittie5": 1,
    "tittiefucker": 1,
    "titties": 1,
    "tittyfuck": 1,
    "tittywank": 1,
    "titwank": 1,
    "tosser": 1,
    "turd": 1,
    "tw4t": 1,
    "twat": 1,
    "twathead": 1,
    "twatty": 1,
    "twunt": 1,
    "twunter": 1,
    "v14gra": 1,
    "v1gra": 1,
    "vagina": 1,
    "viagra": 1,
    "vulva": 1,
    "w00se": 1,
    "wang": 1,
    "wank": 1,
    "wanker": 1,
    "wanky": 1,
    "whoar": 1,
    "whore": 1,
    "willies": 1,
    "willy": 1,
    "xrated": 1,
    "xxx": 1
};

});

parcelRequire.register("4NgFl", function(module, exports) {
module.exports = [
    "4r5e",
    "5h1t",
    "5hit",
    "a55",
    "anal",
    "anus",
    "ar5e",
    "arrse",
    "arse",
    "ass",
    "ass-fucker",
    "asses",
    "assfucker",
    "assfukka",
    "asshole",
    "assholes",
    "asswhole",
    "a_s_s",
    "b!tch",
    "b00bs",
    "b17ch",
    "b1tch",
    "ballbag",
    "balls",
    "ballsack",
    "bastard",
    "beastial",
    "beastiality",
    "bellend",
    "bestial",
    "bestiality",
    "bi+ch",
    "biatch",
    "bitch",
    "bitcher",
    "bitchers",
    "bitches",
    "bitchin",
    "bitching",
    "bloody",
    "blow job",
    "blowjob",
    "blowjobs",
    "boiolas",
    "bollock",
    "bollok",
    "boner",
    "boob",
    "boobs",
    "booobs",
    "boooobs",
    "booooobs",
    "booooooobs",
    "breasts",
    "buceta",
    "bugger",
    "bum",
    "bunny fucker",
    "butt",
    "butthole",
    "buttmuch",
    "buttplug",
    "c0ck",
    "c0cksucker",
    "carpet muncher",
    "cawk",
    "chink",
    "cipa",
    "cl1t",
    "clit",
    "clitoris",
    "clits",
    "cnut",
    "cock",
    "cock-sucker",
    "cockface",
    "cockhead",
    "cockmunch",
    "cockmuncher",
    "cocks",
    "cocksuck",
    "cocksucked",
    "cocksucker",
    "cocksucking",
    "cocksucks",
    "cocksuka",
    "cocksukka",
    "cok",
    "cokmuncher",
    "coksucka",
    "coon",
    "cox",
    "crap",
    "cum",
    "cummer",
    "cumming",
    "cums",
    "cumshot",
    "cunilingus",
    "cunillingus",
    "cunnilingus",
    "cunt",
    "cuntlick",
    "cuntlicker",
    "cuntlicking",
    "cunts",
    "cyalis",
    "cyberfuc",
    "cyberfuck",
    "cyberfucked",
    "cyberfucker",
    "cyberfuckers",
    "cyberfucking",
    "d1ck",
    "damn",
    "dick",
    "dickhead",
    "dildo",
    "dildos",
    "dink",
    "dinks",
    "dirsa",
    "dlck",
    "dog-fucker",
    "doggin",
    "dogging",
    "donkeyribber",
    "doosh",
    "duche",
    "dyke",
    "ejaculate",
    "ejaculated",
    "ejaculates",
    "ejaculating",
    "ejaculatings",
    "ejaculation",
    "ejakulate",
    "f u c k",
    "f u c k e r",
    "f4nny",
    "fag",
    "fagging",
    "faggitt",
    "faggot",
    "faggs",
    "fagot",
    "fagots",
    "fags",
    "fanny",
    "fannyflaps",
    "fannyfucker",
    "fanyy",
    "fatass",
    "fcuk",
    "fcuker",
    "fcuking",
    "feck",
    "fecker",
    "felching",
    "fellate",
    "fellatio",
    "fingerfuck",
    "fingerfucked",
    "fingerfucker",
    "fingerfuckers",
    "fingerfucking",
    "fingerfucks",
    "fistfuck",
    "fistfucked",
    "fistfucker",
    "fistfuckers",
    "fistfucking",
    "fistfuckings",
    "fistfucks",
    "flange",
    "fook",
    "fooker",
    "fuck",
    "fucka",
    "fucked",
    "fucker",
    "fuckers",
    "fuckhead",
    "fuckheads",
    "fuckin",
    "fucking",
    "fuckings",
    "fuckingshitmotherfucker",
    "fuckme",
    "fucks",
    "fuckwhit",
    "fuckwit",
    "fudge packer",
    "fudgepacker",
    "fuk",
    "fuker",
    "fukker",
    "fukkin",
    "fuks",
    "fukwhit",
    "fukwit",
    "fux",
    "fux0r",
    "f_u_c_k",
    "gangbang",
    "gangbanged",
    "gangbangs",
    "gaylord",
    "gaysex",
    "goatse",
    "God",
    "god-dam",
    "god-damned",
    "goddamn",
    "goddamned",
    "hardcoresex",
    "hell",
    "heshe",
    "hoar",
    "hoare",
    "hoer",
    "homo",
    "hore",
    "horniest",
    "horny",
    "hotsex",
    "jack-off",
    "jackoff",
    "jap",
    "jerk-off",
    "jism",
    "jiz",
    "jizm",
    "jizz",
    "kawk",
    "knob",
    "knobead",
    "knobed",
    "knobend",
    "knobhead",
    "knobjocky",
    "knobjokey",
    "kock",
    "kondum",
    "kondums",
    "kum",
    "kummer",
    "kumming",
    "kums",
    "kunilingus",
    "l3i+ch",
    "l3itch",
    "labia",
    "lust",
    "lusting",
    "m0f0",
    "m0fo",
    "m45terbate",
    "ma5terb8",
    "ma5terbate",
    "masochist",
    "master-bate",
    "masterb8",
    "masterbat*",
    "masterbat3",
    "masterbate",
    "masterbation",
    "masterbations",
    "masturbate",
    "mo-fo",
    "mof0",
    "mofo",
    "mothafuck",
    "mothafucka",
    "mothafuckas",
    "mothafuckaz",
    "mothafucked",
    "mothafucker",
    "mothafuckers",
    "mothafuckin",
    "mothafucking",
    "mothafuckings",
    "mothafucks",
    "mother fucker",
    "motherfuck",
    "motherfucked",
    "motherfucker",
    "motherfuckers",
    "motherfuckin",
    "motherfucking",
    "motherfuckings",
    "motherfuckka",
    "motherfucks",
    "muff",
    "mutha",
    "muthafecker",
    "muthafuckker",
    "muther",
    "mutherfucker",
    "n1gga",
    "n1gger",
    "nazi",
    "nigg3r",
    "nigg4h",
    "nigga",
    "niggah",
    "niggas",
    "niggaz",
    "nigger",
    "niggers",
    "nob",
    "nob jokey",
    "nobhead",
    "nobjocky",
    "nobjokey",
    "numbnuts",
    "nutsack",
    "orgasim",
    "orgasims",
    "orgasm",
    "orgasms",
    "p0rn",
    "pawn",
    "pecker",
    "penis",
    "penisfucker",
    "phonesex",
    "phuck",
    "phuk",
    "phuked",
    "phuking",
    "phukked",
    "phukking",
    "phuks",
    "phuq",
    "pigfucker",
    "pimpis",
    "piss",
    "pissed",
    "pisser",
    "pissers",
    "pisses",
    "pissflaps",
    "pissin",
    "pissing",
    "pissoff",
    "poop",
    "porn",
    "porno",
    "pornography",
    "pornos",
    "prick",
    "pricks",
    "pron",
    "pube",
    "pusse",
    "pussi",
    "pussies",
    "pussy",
    "pussys",
    "rectum",
    "retard",
    "rimjaw",
    "rimming",
    "s hit",
    "s.o.b.",
    "sadist",
    "schlong",
    "screwing",
    "scroat",
    "scrote",
    "scrotum",
    "semen",
    "sex",
    "sh!+",
    "sh!t",
    "sh1t",
    "shag",
    "shagger",
    "shaggin",
    "shagging",
    "shemale",
    "shi+",
    "shit",
    "shitdick",
    "shite",
    "shited",
    "shitey",
    "shitfuck",
    "shitfull",
    "shithead",
    "shiting",
    "shitings",
    "shits",
    "shitted",
    "shitter",
    "shitters",
    "shitting",
    "shittings",
    "shitty",
    "skank",
    "slut",
    "sluts",
    "smegma",
    "smut",
    "snatch",
    "son-of-a-bitch",
    "spac",
    "spunk",
    "s_h_i_t",
    "t1tt1e5",
    "t1tties",
    "teets",
    "teez",
    "testical",
    "testicle",
    "tit",
    "titfuck",
    "tits",
    "titt",
    "tittie5",
    "tittiefucker",
    "titties",
    "tittyfuck",
    "tittywank",
    "titwank",
    "tosser",
    "turd",
    "tw4t",
    "twat",
    "twathead",
    "twatty",
    "twunt",
    "twunter",
    "v14gra",
    "v1gra",
    "vagina",
    "viagra",
    "vulva",
    "w00se",
    "wang",
    "wank",
    "wanker",
    "wanky",
    "whoar",
    "whore",
    "willies",
    "willy",
    "xrated",
    "xxx"
];

});

parcelRequire.register("76U8F", function(module, exports) {
module.exports = /\b(4r5e|5h1t|5hit|a55|anal|anus|ar5e|arrse|arse|ass|ass-fucker|asses|assfucker|assfukka|asshole|assholes|asswhole|a_s_s|b!tch|b00bs|b17ch|b1tch|ballbag|balls|ballsack|bastard|beastial|beastiality|bellend|bestial|bestiality|bi\+ch|biatch|bitch|bitcher|bitchers|bitches|bitchin|bitching|bloody|blow job|blowjob|blowjobs|boiolas|bollock|bollok|boner|boob|boobs|booobs|boooobs|booooobs|booooooobs|breasts|buceta|bugger|bum|bunny fucker|butt|butthole|buttmuch|buttplug|c0ck|c0cksucker|carpet muncher|cawk|chink|cipa|cl1t|clit|clitoris|clits|cnut|cock|cock-sucker|cockface|cockhead|cockmunch|cockmuncher|cocks|cocksuck|cocksucked|cocksucker|cocksucking|cocksucks|cocksuka|cocksukka|cok|cokmuncher|coksucka|coon|cox|crap|cum|cummer|cumming|cums|cumshot|cunilingus|cunillingus|cunnilingus|cunt|cuntlick|cuntlicker|cuntlicking|cunts|cyalis|cyberfuc|cyberfuck|cyberfucked|cyberfucker|cyberfuckers|cyberfucking|d1ck|damn|dick|dickhead|dildo|dildos|dink|dinks|dirsa|dlck|dog-fucker|doggin|dogging|donkeyribber|doosh|duche|dyke|ejaculate|ejaculated|ejaculates|ejaculating|ejaculatings|ejaculation|ejakulate|f u c k|f u c k e r|f4nny|fag|fagging|faggitt|faggot|faggs|fagot|fagots|fags|fanny|fannyflaps|fannyfucker|fanyy|fatass|fcuk|fcuker|fcuking|feck|fecker|felching|fellate|fellatio|fingerfuck|fingerfucked|fingerfucker|fingerfuckers|fingerfucking|fingerfucks|fistfuck|fistfucked|fistfucker|fistfuckers|fistfucking|fistfuckings|fistfucks|flange|fook|fooker|fuck|fucka|fucked|fucker|fuckers|fuckhead|fuckheads|fuckin|fucking|fuckings|fuckingshitmotherfucker|fuckme|fucks|fuckwhit|fuckwit|fudge packer|fudgepacker|fuk|fuker|fukker|fukkin|fuks|fukwhit|fukwit|fux|fux0r|f_u_c_k|gangbang|gangbanged|gangbangs|gaylord|gaysex|goatse|God|god-dam|god-damned|goddamn|goddamned|hardcoresex|hell|heshe|hoar|hoare|hoer|homo|hore|horniest|horny|hotsex|jack-off|jackoff|jap|jerk-off|jism|jiz|jizm|jizz|kawk|knob|knobead|knobed|knobend|knobhead|knobjocky|knobjokey|kock|kondum|kondums|kum|kummer|kumming|kums|kunilingus|l3i\+ch|l3itch|labia|lust|lusting|m0f0|m0fo|m45terbate|ma5terb8|ma5terbate|masochist|master-bate|masterb8|masterbat*|masterbat3|masterbate|masterbation|masterbations|masturbate|mo-fo|mof0|mofo|mothafuck|mothafucka|mothafuckas|mothafuckaz|mothafucked|mothafucker|mothafuckers|mothafuckin|mothafucking|mothafuckings|mothafucks|mother fucker|motherfuck|motherfucked|motherfucker|motherfuckers|motherfuckin|motherfucking|motherfuckings|motherfuckka|motherfucks|muff|mutha|muthafecker|muthafuckker|muther|mutherfucker|n1gga|n1gger|nazi|nigg3r|nigg4h|nigga|niggah|niggas|niggaz|nigger|niggers|nob|nob jokey|nobhead|nobjocky|nobjokey|numbnuts|nutsack|orgasim|orgasims|orgasm|orgasms|p0rn|pawn|pecker|penis|penisfucker|phonesex|phuck|phuk|phuked|phuking|phukked|phukking|phuks|phuq|pigfucker|pimpis|piss|pissed|pisser|pissers|pisses|pissflaps|pissin|pissing|pissoff|poop|porn|porno|pornography|pornos|prick|pricks|pron|pube|pusse|pussi|pussies|pussy|pussys|rectum|retard|rimjaw|rimming|s hit|s.o.b.|sadist|schlong|screwing|scroat|scrote|scrotum|semen|sex|sh!\+|sh!t|sh1t|shag|shagger|shaggin|shagging|shemale|shi\+|shit|shitdick|shite|shited|shitey|shitfuck|shitfull|shithead|shiting|shitings|shits|shitted|shitter|shitters|shitting|shittings|shitty|skank|slut|sluts|smegma|smut|snatch|son-of-a-bitch|spac|spunk|s_h_i_t|t1tt1e5|t1tties|teets|teez|testical|testicle|tit|titfuck|tits|titt|tittie5|tittiefucker|titties|tittyfuck|tittywank|titwank|tosser|turd|tw4t|twat|twathead|twatty|twunt|twunter|v14gra|v1gra|vagina|viagra|vulva|w00se|wang|wank|wanker|wanky|whoar|whore|willies|willy|xrated|xxx)\b/gi;

});

// TODO: Consider making this a facade/proxy/replacing-with ng2-logger or typescript-logging?
class $4ea2add0f99203f1$export$d8d414c26e02ce25 {
    static getColourCode(colourFg, colourBg = $4ea2add0f99203f1$export$1fbe18870751587c.Unspecified) {
        return $4ea2add0f99203f1$export$1fbe18870751587c.Unspecified == colourBg ? `${$4ea2add0f99203f1$var$Escape}[${colourFg}m` : `${$4ea2add0f99203f1$var$Escape}[${colourFg};${colourBg + 10}m`;
    }
    static getReset() {
        return $4ea2add0f99203f1$var$Reset;
    }
}
const $4ea2add0f99203f1$var$Escape = "\x1b";
const $4ea2add0f99203f1$var$Reset = `${$4ea2add0f99203f1$var$Escape}[m`;
var $4ea2add0f99203f1$export$1fbe18870751587c;
(function(Colour) {
    Colour[Colour["Unspecified"] = 0] = "Unspecified";
    Colour[Colour["Black"] = 30] = "Black";
    Colour[Colour["Red"] = 31] = "Red";
    Colour[Colour["Green"] = 32] = "Green";
    Colour[Colour["Yellow"] = 33] = "Yellow";
    Colour[Colour["Blue"] = 34] = "Blue";
    Colour[Colour["Magenta"] = 35] = "Magenta";
    Colour[Colour["Cyan"] = 36] = "Cyan";
    Colour[Colour["White"] = 37] = "White";
})($4ea2add0f99203f1$export$1fbe18870751587c || ($4ea2add0f99203f1$export$1fbe18870751587c = {}));



class $af6ccbbc61a9e913$export$519e2c0966f00128 {
    static getColourCode(colourFg, colourBg = (0, $4ea2add0f99203f1$export$1fbe18870751587c).Unspecified) {
        return (0, $4ea2add0f99203f1$export$1fbe18870751587c).Unspecified === colourBg ? `color:${$af6ccbbc61a9e913$var$Colours.get(colourFg)}` : `color:${$af6ccbbc61a9e913$var$Colours.get(colourFg)};background:${$af6ccbbc61a9e913$var$Colours.get(colourBg)}`;
    }
}
const $af6ccbbc61a9e913$var$Colours = new Map([
    [
        (0, $4ea2add0f99203f1$export$1fbe18870751587c).Unspecified,
        "Unspecified"
    ],
    [
        (0, $4ea2add0f99203f1$export$1fbe18870751587c).Black,
        "Black"
    ],
    [
        (0, $4ea2add0f99203f1$export$1fbe18870751587c).Red,
        "Red"
    ],
    [
        (0, $4ea2add0f99203f1$export$1fbe18870751587c).Green,
        "Green"
    ],
    [
        (0, $4ea2add0f99203f1$export$1fbe18870751587c).Yellow,
        "Yellow"
    ],
    [
        (0, $4ea2add0f99203f1$export$1fbe18870751587c).Blue,
        "DodgerBlue"
    ],
    [
        (0, $4ea2add0f99203f1$export$1fbe18870751587c).Magenta,
        "Magenta"
    ],
    [
        (0, $4ea2add0f99203f1$export$1fbe18870751587c).Cyan,
        "Cyan"
    ],
    [
        (0, $4ea2add0f99203f1$export$1fbe18870751587c).White,
        "White"
    ]
]);



var $hPtJY = parcelRequire("hPtJY");
function $238e43054c33a2f4$export$e95f987c539957b2(envVarName, key) {
    if (envVarName && (0, (/*@__PURE__*/$parcel$interopDefault($hPtJY))) && (0, (/*@__PURE__*/$parcel$interopDefault($hPtJY))).env) {
        const envValue = (0, (/*@__PURE__*/$parcel$interopDefault($hPtJY))).env[envVarName];
        if (envValue) return $238e43054c33a2f4$export$96c3657b1384e651(envValue, key);
    }
    return undefined;
}
function $238e43054c33a2f4$export$96c3657b1384e651(variable, key, separator = ",") {
    const pairs = variable.split(separator);
    for (const pair of pairs){
        const [pairKey, pairValue] = pair.split("=");
        if (pairKey.trim() === key) return pairValue.trim();
    }
    return undefined;
}



var $N7Lcz = parcelRequire("N7Lcz");
function $003b09fe89de2289$export$21625637effda04(s) {
    return JSON.parse(s);
}
function $003b09fe89de2289$export$d5b7a8bf56ee1fe2(o, pretty) {
    const json = JSON.stringify(o, undefined, pretty ? 2 : undefined);
    return "{}" !== json ? json : "" + o;
}
function $003b09fe89de2289$export$f84e8e69fd4488a5(o, pretty) {
    if ("string" === typeof o) return o;
    // Non-null object with own `toString()`, use that
    if (o && "object" === typeof o && o.hasOwnProperty("toString")) {
        const toStringResult = "" + o;
        if (toStringResult && 0 !== toStringResult.length && "{}" !== toStringResult && "[object Object]" !== toStringResult) return toStringResult;
    }
    // Otherwise try JSON
    try {
        const json = JSON.stringify(o, undefined, pretty ? 2 : undefined);
        if ("{}" !== json && "[{}]" !== json) return json;
    } catch  {} // JSON can fail if circular so ignore if that happens
    if (o instanceof Event) return $003b09fe89de2289$export$330aca6d49e42465(o);
    // if JSON is 'empty', try system default in case any better.
    // const defaultToString = '' + o;
    const defaultToString = $N7Lcz.inspect(o);
    return 0 !== defaultToString.length ? defaultToString : "{}";
}
function $003b09fe89de2289$export$330aca6d49e42465(e, pretty = false) {
    let NL = "", NLS = "", CNL = ", ", CNLS = ", ", FS = ": ";
    if (pretty) {
        // newline
        NL = "\n";
        // newline + space
        NLS = "\n  ";
        // comma + newline
        CNL = ",\n";
        // comma + newline + space
        CNLS = ",\n  ";
        // field-value separator + space
        FS = ":	";
    }
    let s = "constructor" in e && "name" in e.constructor ? e.constructor.name + " " : "";
    s += "{" + NLS;
    function addMember(name) {
        if (name in e) s += `${CNLS}${name}${FS}${e[name]}`;
    }
    // First line = no comma
    s += `type${FS}${e.type}`;
    // WebSocket CloseEvent
    addMember("code");
    addMember("reason");
    addMember("wasClean");
    // WebSocket ErrorEvent
    addMember("message");
    addMember("error");
    // Hack of last ','
    // return s.substring(0, s.length - 1 - CNLS.length) + '}';
    return s + NL + "}";
}


var $7653766080191e46$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["All"] = 0] = "All";
    LogLevel[LogLevel["Silly"] = 0] = "Silly";
    LogLevel[LogLevel["Debug"] = 1] = "Debug";
    LogLevel[LogLevel["Default"] = 2] = "Default";
    LogLevel[LogLevel["Log"] = 2] = "Log";
    LogLevel[LogLevel["Production"] = 3] = "Production";
    LogLevel[LogLevel["Warn"] = 3] = "Warn";
    LogLevel[LogLevel["Error"] = 4] = "Error";
    LogLevel[LogLevel["None"] = 5] = "None";
})($7653766080191e46$export$243e62d78d3b544d || ($7653766080191e46$export$243e62d78d3b544d = {}));
function $7653766080191e46$export$140fef95598d790d(logLevelString) {
    const keys = Object.keys($7653766080191e46$export$243e62d78d3b544d);
    for (const key of keys){
        const value = $7653766080191e46$export$243e62d78d3b544d[key];
        if ("number" === typeof value && key === logLevelString) return value;
    }
    return undefined;
}
const $7653766080191e46$var$LogEnvVarName = "MFG_LOG";
const $7653766080191e46$var$LogEnvValueDelimiter = "-";
function $7653766080191e46$var$getDefaultLevel(loggerName) {
    return $7653766080191e46$var$getDefaultLevelNoDefault(loggerName) ?? $7653766080191e46$var$defaultDefaultLevel;
}
function $7653766080191e46$var$getFlags(value, delim) {
    // Check for, use and consume any flags
    let flags = [];
    let pos1 = 0;
    let valueWithoutFlags;
    while(-1 !== (pos1 = value.indexOf(delim, pos1))){
        if (undefined === valueWithoutFlags) // first search is end of valueWithoutFlags
        valueWithoutFlags = value.substring(0, pos1);
        const pos2 = value.indexOf(delim, pos1 + 1);
        const flag = -1 === pos2 ? value.substring(pos1 + 1) : value.substring(pos1 + 1, pos2);
        flags.push(flag);
        // Move next-search start pos up to previously found / end of string
        pos1 = -1 === pos2 ? value.length : pos2 - 1;
    }
    return {
        flags: flags,
        valueWithoutFlags: undefined === valueWithoutFlags ? value : valueWithoutFlags
    };
}
function $7653766080191e46$var$getDefaultLevelNoDefault(loggerName) {
    if (undefined !== loggerName) {
        const levelFromEnv = (0, $238e43054c33a2f4$export$e95f987c539957b2)($7653766080191e46$var$LogEnvVarName, loggerName);
        if (undefined !== levelFromEnv) {
            const { flags: flags , valueWithoutFlags: valueWithoutFlags  } = $7653766080191e46$var$getFlags(levelFromEnv, $7653766080191e46$var$LogEnvValueDelimiter);
            const maybeLevel = $7653766080191e46$export$140fef95598d790d(valueWithoutFlags);
            if (undefined !== maybeLevel) return {
                level: maybeLevel,
                flags: flags
            };
        }
    }
    return undefined;
}
let $7653766080191e46$var$defaultDefaultLevel = $7653766080191e46$var$getDefaultLevelNoDefault("Default") ?? {
    level: $7653766080191e46$export$243e62d78d3b544d.Default,
    flags: []
};
class $7653766080191e46$export$4ac4545211fd8567 {
    static build(loggerName, defaultLevel = $7653766080191e46$export$243e62d78d3b544d.Default) {
        const nameToCheck = loggerName ?? "";
        const registeredLogger = $7653766080191e46$var$loggers.get(nameToCheck);
        if (registeredLogger) // Could check default level being changed here and allow replacing
        return registeredLogger;
        let showTimeStamps = $7653766080191e46$export$4ac4545211fd8567.defaultShowTimestamps;
        let showStacks = $7653766080191e46$export$4ac4545211fd8567.defaultShowStacks;
        if ($7653766080191e46$export$243e62d78d3b544d.Default === defaultLevel) {
            const levelAndFlags = $7653766080191e46$var$getDefaultLevel(loggerName);
            defaultLevel = levelAndFlags.level;
            for (const flag of levelAndFlags.flags)switch(flag){
                case "T":
                    showTimeStamps = true;
                    break;
                case "S":
                    showStacks = true;
                    break;
            }
        }
        const instance = new $7653766080191e46$export$4ac4545211fd8567(loggerName, defaultLevel);
        if (showTimeStamps) instance.showTimestamps = true;
        if (showStacks) instance.setShowStacks(true);
        // Creates a new function to allow direct call then map on all other functions of instance via second argument
        const newLogger = Object.assign((level, ...args)=>instance.logByLevel(level, ...args), {
            // TODO: Map the multi-argument direct-call function too.
            log: mappedLog,
            silly: mappedSilly,
            debug: mappedDebug,
            warn: mappedWarn,
            error: mappedError,
            resetLevel: ()=>{
                instance.resetLevel();
                return newLogger;
            },
            logf: (level, logFunction)=>instance.logf(level, logFunction),
            /* Abortive attempt to use accessors on the underlying field (see below)
			get level() {
				return instance.level;
			},
			set level(newVal: LogLevel) {
				instance.level = newVal;
			},
			*/ getLevel: ()=>instance.getLevel(),
            setLevel: (newLevel)=>{
                instance.setLevel(newLevel);
                return newLogger;
            },
            setShowStacks: instance.setShowStacks,
            // 'name' is a JS function special value so we cannot overwrite it!
            loggerName: instance.loggerName
        });
        function mappedLog(...args) {
            return instance.logWithColourAndPrefix($7653766080191e46$export$243e62d78d3b544d.Log, console.log, (0, $4ea2add0f99203f1$export$1fbe18870751587c).Unspecified, "NORMAL:", mappedLog, ...args);
        }
        function mappedSilly(...args) {
            return instance.logWithColourAndPrefix($7653766080191e46$export$243e62d78d3b544d.Silly, console.debug, (0, $4ea2add0f99203f1$export$1fbe18870751587c).Cyan, "SILLY:", mappedSilly, ...args);
        }
        function mappedDebug(...args) {
            return instance.logWithColourAndPrefix($7653766080191e46$export$243e62d78d3b544d.Debug, console.debug, (0, $4ea2add0f99203f1$export$1fbe18870751587c).Blue, "DEBUG:", mappedDebug, ...args);
        }
        function mappedWarn(...args) {
            return instance.logWithColourAndPrefix($7653766080191e46$export$243e62d78d3b544d.Warn, console.warn, (0, $4ea2add0f99203f1$export$1fbe18870751587c).Yellow, "WARN:", mappedWarn, ...args);
        }
        function mappedError(...args) {
            return instance.logWithColourAndPrefix($7653766080191e46$export$243e62d78d3b544d.Error, console.error, (0, $4ea2add0f99203f1$export$1fbe18870751587c).Red, "ERROR:", mappedError, ...args);
        }
        $7653766080191e46$var$loggers.set(nameToCheck, newLogger);
        if ($7653766080191e46$export$243e62d78d3b544d.Default !== defaultLevel) console.log(loggerName, "logging at level", $7653766080191e46$export$243e62d78d3b544d[defaultLevel]);
        return newLogger;
    }
    /**
	 * Set the Logging level for a given loggerName.
	 * @param loggerName The logger loggerName or '' for the default.
	 * @param level The new logging level.
	 */ static setLevel(loggerName, level) {
        const registeredLogger = $7653766080191e46$var$loggers.get(loggerName);
        if (registeredLogger) {
            registeredLogger.setLevel(level);
            return;
        }
        // No logger yet registered with that name.
        // Instead of ignoring, assume we wish to set that level for future use.
        // This does mean its default level will be the default and cannot be overridden
        const newLogger = this.build(loggerName);
        newLogger.setLevel(level);
    }
    /**
	 * Set whether to show the call stacks for a given loggerName.
	 * @param loggerName The logger loggerName or '' for the default.
	 * @param show Whether to show stacks for this logger.
	 */ static setShowStacks(loggerName, show) {
        const registeredLogger = $7653766080191e46$var$loggers.get(loggerName);
        if (registeredLogger) {
            registeredLogger.setShowStacks(show);
            return;
        }
        // No logger yet registered with that name.
        // Instead of ignoring, assume we wish to set value for future use.
        const newLogger = this.build(loggerName);
        newLogger.setShowStacks(show);
    }
    /**
	 * Set the default level all new loggers will be created with and update all loggers to this level.
	 */ static setDefaultDefaultLevelAndAllExistingLevels(level) {
        $7653766080191e46$var$defaultDefaultLevel.level = level;
        $7653766080191e46$var$loggers.forEach((logger)=>logger.setLevel(level));
    }
    /**
	 * Set the default for whether to show stacks (also updates all existing loggers).
	 */ static setDefaultShowStacksAndUpdateAllExisting(show) {
        $7653766080191e46$export$4ac4545211fd8567.defaultShowStacks = show;
        $7653766080191e46$var$loggers.forEach((logger)=>logger.setShowStacks(show));
    }
    static resetLevels() {
        $7653766080191e46$var$loggers.forEach((logger)=>logger.resetLevel());
    }
    static resetLevelsAndStacks() {
        $7653766080191e46$var$loggers.forEach((logger)=>{
            logger.resetLevel();
            logger.setShowStacks($7653766080191e46$export$4ac4545211fd8567.defaultShowStacks);
        });
    }
    constructor(loggerName, level = $7653766080191e46$export$243e62d78d3b544d.All){
        this.loggerName = loggerName;
        this.level = level;
        this.getLevel = ()=>this.level;
        this.setLevel = (newLevel)=>{
            this.level = newLevel;
        };
        this.setShowStacks = (show)=>{
            this.showStack = show;
        };
        this.logByLevel = (level, ...args)=>{
            if (level < this.level) return;
            if ($7653766080191e46$export$243e62d78d3b544d.Error <= level) this.logWithColourAndPrefix($7653766080191e46$export$243e62d78d3b544d.Error, console.error, (0, $4ea2add0f99203f1$export$1fbe18870751587c).Red, "ERROR:", this.logByLevel, ...args);
            else if ($7653766080191e46$export$243e62d78d3b544d.Warn === level) this.logWithColourAndPrefix($7653766080191e46$export$243e62d78d3b544d.Warn, console.warn, (0, $4ea2add0f99203f1$export$1fbe18870751587c).Yellow, "WARN:", this.logByLevel, ...args);
            else if ($7653766080191e46$export$243e62d78d3b544d.Debug === level) this.logWithColourAndPrefix($7653766080191e46$export$243e62d78d3b544d.Debug, console.debug, (0, $4ea2add0f99203f1$export$1fbe18870751587c).Blue, "DEBUG:", this.logByLevel, ...args);
            else if ($7653766080191e46$export$243e62d78d3b544d.Silly === level) this.logWithColourAndPrefix($7653766080191e46$export$243e62d78d3b544d.Silly, console.debug, (0, $4ea2add0f99203f1$export$1fbe18870751587c).Cyan, "SILLY:", this.logByLevel, ...args);
            else this.logWithColourAndPrefix($7653766080191e46$export$243e62d78d3b544d.Log, console.log, (0, $4ea2add0f99203f1$export$1fbe18870751587c).Unspecified, "NORMAL:", this.logByLevel, ...args);
        };
        this.log = (...args)=>this.logWithColourAndPrefix($7653766080191e46$export$243e62d78d3b544d.Log, console.debug, (0, $4ea2add0f99203f1$export$1fbe18870751587c).Unspecified, "NORMAL:", this.log, ...args);
        this.normal = (...args)=>this.logWithColourAndPrefix($7653766080191e46$export$243e62d78d3b544d.Log, console.debug, (0, $4ea2add0f99203f1$export$1fbe18870751587c).Unspecified, "NORMAL:", this.normal, ...args);
        this.silly = (...args)=>this.logWithColourAndPrefix($7653766080191e46$export$243e62d78d3b544d.Silly, console.debug, (0, $4ea2add0f99203f1$export$1fbe18870751587c).Cyan, "SILLY:", this.silly, ...args);
        this.debug = (...args)=>this.logWithColourAndPrefix($7653766080191e46$export$243e62d78d3b544d.Debug, console.debug, (0, $4ea2add0f99203f1$export$1fbe18870751587c).Blue, "DEBUG:", this.debug, ...args);
        this.warn = (...args)=>this.logWithColourAndPrefix($7653766080191e46$export$243e62d78d3b544d.Warn, console.warn, (0, $4ea2add0f99203f1$export$1fbe18870751587c).Yellow, "WARN:", this.warn, ...args);
        this.error = (...args)=>this.logWithColourAndPrefix($7653766080191e46$export$243e62d78d3b544d.Error, console.error, (0, $4ea2add0f99203f1$export$1fbe18870751587c).Red, "ERROR:", this.error, ...args);
        this.logWithColourAndPrefix = (level, logActual, colour, prefix, topLevelLogFunction, ...args)=>{
            if (level < this.level) return;
            let stack;
            if (this.indentWithStack || this.showStack) {
                const error = new Error("(stack)");
                if (Error.captureStackTrace) {
                    if (!topLevelLogFunction) topLevelLogFunction = this.logWithColourAndPrefix;
                    // omit beyond this from the stack
                    Error.captureStackTrace(error, topLevelLogFunction);
                }
                if (error.stack) {
                    const StackPrefixLength = 15;
                    stack = error.stack.substring(StackPrefixLength);
                } else {
                    // In future, do not bother trying to use stack
                    this.showStack = false;
                    this.indentWithStack = false;
                }
            }
            let indent = "";
            if (this.showTimestamps) // Stuff the timestamp in the indent
            indent = indent + $7653766080191e46$export$4ac4545211fd8567.getTimeStamp() + " ";
            if (stack && this.indentWithStack) {
                const splitResult = stack.split("\n");
                const filtered = splitResult.filter((s)=>!$7653766080191e46$export$4ac4545211fd8567.IndentFilterRegex.test(s));
                const depth = filtered.length - 1; // there's always 1 element in stack
                indent = indent + " ".repeat(depth);
                if ($7653766080191e46$export$4ac4545211fd8567.FilterOthersCodeFromStacks) stack = filtered.join("\n");
            }
            $7653766080191e46$export$4ac4545211fd8567.replaceObjectsWithToString(args, indent);
            if ("undefined" === typeof window) {
                // Node
                const prefixColour = (0, $4ea2add0f99203f1$export$d8d414c26e02ce25).getColourCode(colour);
                const suffixColour = (0, $4ea2add0f99203f1$export$d8d414c26e02ce25).getReset();
                this.loggerName ? logActual(prefixColour + indent + this.loggerName, prefix, ...args, suffixColour) : logActual(prefixColour + indent + prefix, ...args, suffixColour);
            } else {
                // Browser
                const colourData = (0, $af6ccbbc61a9e913$export$519e2c0966f00128).getColourCode(colour);
                this.loggerName ? logActual("%c" + indent + this.loggerName + " " + prefix + " " + args.join(" "), colourData) : logActual("%c" + indent + prefix + " " + args.join(" "), colourData);
            }
            if (stack && this.showStack) logActual(stack, "\n");
        };
        this.logf = (level, logFunction)=>{
            if (level < this.level) return;
            this.logByLevel(level, logFunction());
        };
        this.resetLevel = ()=>{
            this.level = this.defaultLevel;
        };
        this.indentWithStack = true;
        this.showStack = $7653766080191e46$export$4ac4545211fd8567.defaultShowStacks;
        this.showTimestamps = $7653766080191e46$export$4ac4545211fd8567.defaultShowTimestamps;
        this.defaultLevel = level;
    }
    static replaceObjectsWithToString(args, indent, recursion = 10) {
        for(let i = 0; i < args.length; i++)switch(typeof args[i]){
            case "undefined":
            case "string":
            case "number":
            case "boolean":
                break;
            case "function":
                try {
                    args[i] = args[i]();
                    if (0 < recursion && Array.isArray(args[i])) {
                        const result = this.replaceObjectsWithToString(args[i], indent, recursion - 1);
                        args[i] = result.join(" ");
                    }
                } catch  {
                // nop = we can but try
                }
                break;
            case "object":
            default:
                args[i] = (0, $003b09fe89de2289$export$f84e8e69fd4488a5)(args[i]);
                break;
        }
        // Do indents
        if (indent) {
            indent = "\n" + indent;
            for(let i = 0; i < args.length; i++)if (args[i] instanceof String || "string" === typeof args[i]) args[i] = args[i].replaceAll("\n", indent);
        }
        return args;
    }
    static getTimeStamp() {
        const date = new Date();
        const [year, month, day, hour, minutes, seconds] = [
            date.getFullYear(),
            date.getMonth() + 1,
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds()
        ];
        function n(num) {
            return num.toString().padStart(2, "0");
        }
        return `${year}${n(month)}${n(day)}-${n(hour)}${n(minutes)}${n(seconds)}`;
    }
    static #_ = (()=>{
        this.IndentFilterRegex = /modules|runMicrotasks|processTicksAndRejections|Log\.ts|at Module\.|at require\./;
    })();
    static #_1 = (()=>{
        this.FilterOthersCodeFromStacks = true;
    })();
    static #_2 = (()=>{
        this.defaultShowTimestamps = false;
    })();
    static #_3 = (()=>{
        this.defaultShowStacks = false;
    })();
}
// Maps from 'loggerName' to list of loggers registered with that loggerName
const $7653766080191e46$var$loggers = new Map();
// Rather than changing default log level, set environmental variable "MFG_LOG" with the form:
// "MyClass=Silly,ClassThatShowsTimeStamps=Log-T,ClassWithStacks=Log-S,Default=Warn"
// Appending "-S" will show stacks with logs; Appending "-T" will show timestamps; or use both.
const $7653766080191e46$var$Log = $7653766080191e46$export$4ac4545211fd8567.build(); // or build(undefined, LogLevel.All);
var $7653766080191e46$export$2e2bcd8739ae039 = $7653766080191e46$var$Log;



const $2282782f43399dd4$export$18392905b7dc50 = "";
const $2282782f43399dd4$export$358c10a8ced53a05 = "0000";
const $2282782f43399dd4$export$a6fe2dd80e8fc03e = "1-4 numbers";
function $2282782f43399dd4$export$3636fa6b664761ad(joinCode) {
    // non-null and 4-digits only
    return !!joinCode && /^\d{4}$/.test(joinCode);
}



var $6384862cb2bc9a13$exports = {};
"use strict";
/*!
 * Strongly Typed Events for TypeScript
 * https://github.com/KeesCBakker/StronlyTypedEvents/
 * http://keestalkstech.com
 *
 * Copyright Kees C. Bakker / KeesTalksTech
 * Released under the MIT license
 */ Object.defineProperty($6384862cb2bc9a13$exports, "__esModule", {
    value: true
});
$6384862cb2bc9a13$exports.NonUniformPromiseSimpleEventList = $6384862cb2bc9a13$exports.PromiseSimpleEventList = $6384862cb2bc9a13$exports.PromiseSimpleEventHandlingBase = $6384862cb2bc9a13$exports.PromiseSimpleEventDispatcher = $6384862cb2bc9a13$exports.PromiseSignalList = $6384862cb2bc9a13$exports.PromiseSignalHandlingBase = $6384862cb2bc9a13$exports.PromiseSignalDispatcher = $6384862cb2bc9a13$exports.NonUniformPromiseEventList = $6384862cb2bc9a13$exports.PromiseEventList = $6384862cb2bc9a13$exports.PromiseEventHandlingBase = $6384862cb2bc9a13$exports.PromiseEventDispatcher = $6384862cb2bc9a13$exports.SignalList = $6384862cb2bc9a13$exports.SignalHandlingBase = $6384862cb2bc9a13$exports.SignalDispatcher = $6384862cb2bc9a13$exports.NonUniformSimpleEventList = $6384862cb2bc9a13$exports.SimpleEventList = $6384862cb2bc9a13$exports.SimpleEventHandlingBase = $6384862cb2bc9a13$exports.SimpleEventDispatcher = $6384862cb2bc9a13$exports.NonUniformEventList = $6384862cb2bc9a13$exports.EventList = $6384862cb2bc9a13$exports.EventHandlingBase = $6384862cb2bc9a13$exports.EventDispatcher = $6384862cb2bc9a13$exports.HandlingBase = $6384862cb2bc9a13$exports.PromiseDispatcherBase = $6384862cb2bc9a13$exports.PromiseSubscription = $6384862cb2bc9a13$exports.DispatchError = $6384862cb2bc9a13$exports.EventManagement = $6384862cb2bc9a13$exports.EventListBase = $6384862cb2bc9a13$exports.DispatcherWrapper = $6384862cb2bc9a13$exports.DispatcherBase = $6384862cb2bc9a13$exports.Subscription = void 0;
var $3a0124824db7da71$exports = {};
"use strict";
/*!
 * Strongly Typed Events for TypeScript - Core
 * https://github.com/KeesCBakker/StronlyTypedEvents/
 * http://keestalkstech.com
 *
 * Copyright Kees C. Bakker / KeesTalksTech
 * Released under the MIT license
 */ Object.defineProperty($3a0124824db7da71$exports, "__esModule", {
    value: true
});
$3a0124824db7da71$exports.SubscriptionChangeEventDispatcher = $3a0124824db7da71$exports.HandlingBase = $3a0124824db7da71$exports.PromiseDispatcherBase = $3a0124824db7da71$exports.PromiseSubscription = $3a0124824db7da71$exports.DispatchError = $3a0124824db7da71$exports.EventManagement = $3a0124824db7da71$exports.EventListBase = $3a0124824db7da71$exports.DispatcherWrapper = $3a0124824db7da71$exports.DispatcherBase = $3a0124824db7da71$exports.Subscription = void 0;
var $83404bba45115341$exports = {};
"use strict";
Object.defineProperty($83404bba45115341$exports, "__esModule", {
    value: true
});
$83404bba45115341$exports.SubscriptionChangeEventDispatcher = $83404bba45115341$exports.DispatcherBase = void 0;
var $e9edec946bfbebaf$exports = {};
"use strict";
Object.defineProperty($e9edec946bfbebaf$exports, "__esModule", {
    value: true
});
$e9edec946bfbebaf$exports.DispatcherWrapper = void 0;
/**
 * Hides the implementation of the event dispatcher. Will expose methods that
 * are relevent to the event.
 *
 * @export
 * @class DispatcherWrapper
 * @implements {ISubscribable<TEventHandler>}
 * @template TEventHandler The type of event handler.
 */ class $e9edec946bfbebaf$var$DispatcherWrapper {
    /**
     * Creates an instance of DispatcherWrapper.
     * @param {ISubscribable<TEventHandler>} dispatcher
     *
     * @memberOf DispatcherWrapper
     */ constructor(dispatcher){
        this._subscribe = (fn)=>dispatcher.subscribe(fn);
        this._unsubscribe = (fn)=>dispatcher.unsubscribe(fn);
        this._one = (fn)=>dispatcher.one(fn);
        this._has = (fn)=>dispatcher.has(fn);
        this._clear = ()=>dispatcher.clear();
        this._count = ()=>dispatcher.count;
        this._onSubscriptionChange = ()=>dispatcher.onSubscriptionChange;
    }
    /**
     * Triggered when subscriptions are changed (added or removed).
     *
     * @readonly
     * @type {ISubscribable<SubscriptionChangeEventHandler>}
     * @memberOf DispatcherWrapper
     */ get onSubscriptionChange() {
        return this._onSubscriptionChange();
    }
    /**
     * Returns the number of subscriptions.
     *
     * @readonly
     * @type {number}
     * @memberOf DispatcherWrapper
     */ get count() {
        return this._count();
    }
    /**
     * Subscribe to the event dispatcher.
     *
     * @param {TEventHandler} fn The event handler that is called when the event is dispatched.
     * @returns {() => void} A function that unsubscribes the event handler from the event.
     *
     * @memberOf DispatcherWrapper
     */ subscribe(fn) {
        return this._subscribe(fn);
    }
    /**
     * Subscribe to the event dispatcher.
     *
     * @param {TEventHandler} fn The event handler that is called when the event is dispatched.
     * @returns {() => void} A function that unsubscribes the event handler from the event.
     *
     * @memberOf DispatcherWrapper
     */ sub(fn) {
        return this.subscribe(fn);
    }
    /**
     * Unsubscribe from the event dispatcher.
     *
     * @param {TEventHandler} fn The event handler that is called when the event is dispatched.
     *
     * @memberOf DispatcherWrapper
     */ unsubscribe(fn) {
        this._unsubscribe(fn);
    }
    /**
     * Unsubscribe from the event dispatcher.
     *
     * @param {TEventHandler} fn The event handler that is called when the event is dispatched.
     *
     * @memberOf DispatcherWrapper
     */ unsub(fn) {
        this.unsubscribe(fn);
    }
    /**
     * Subscribe once to the event with the specified name.
     *
     * @returns {() => void} A function that unsubscribes the event handler from the event.
     *
     * @memberOf DispatcherWrapper
     */ one(fn) {
        return this._one(fn);
    }
    /**
     * Checks it the event has a subscription for the specified handler.
     *
     * @param {TEventHandler} fn The event handler that is called when the event is dispatched.
     *
     * @memberOf DispatcherWrapper
     */ has(fn) {
        return this._has(fn);
    }
    /**
     * Clears all the subscriptions.
     *
     * @memberOf DispatcherWrapper
     */ clear() {
        this._clear();
    }
}
$e9edec946bfbebaf$exports.DispatcherWrapper = $e9edec946bfbebaf$var$DispatcherWrapper;


var $97f95aaa3453e34b$exports = {};
"use strict";
Object.defineProperty($97f95aaa3453e34b$exports, "__esModule", {
    value: true
});
$97f95aaa3453e34b$exports.Subscription = void 0;
/**
 * Stores a handler. Manages execution meta data.
 * @class Subscription
 * @template TEventHandler
 */ class $97f95aaa3453e34b$var$Subscription {
    /**
     * Creates an instance of Subscription.
     *
     * @param {TEventHandler} handler The handler for the subscription.
     * @param {boolean} isOnce Indicates if the handler should only be executed once.
     */ constructor(handler, isOnce){
        this.handler = handler;
        this.isOnce = isOnce;
        /**
         * Indicates if the subscription has been executed before.
         */ this.isExecuted = false;
    }
    /**
     * Executes the handler.
     *
     * @param {boolean} executeAsync True if the even should be executed async.
     * @param {*} scope The scope the scope of the event.
     * @param {IArguments} args The arguments for the event.
     */ execute(executeAsync, scope, args) {
        if (!this.isOnce || !this.isExecuted) {
            this.isExecuted = true;
            var fn = this.handler;
            if (executeAsync) setTimeout(()=>{
                fn.apply(scope, args);
            }, 1);
            else fn.apply(scope, args);
        }
    }
}
$97f95aaa3453e34b$exports.Subscription = $97f95aaa3453e34b$var$Subscription;


var $eb4650c9efd49947$exports = {};
"use strict";
Object.defineProperty($eb4650c9efd49947$exports, "__esModule", {
    value: true
});
$eb4650c9efd49947$exports.EventManagement = void 0;
/**
 * Allows the user to interact with the event.
 *
 * @export
 * @class EventManagement
 * @implements {IEventManagement}
 */ class $eb4650c9efd49947$var$EventManagement {
    /**
     * Creates an instance of EventManagement.
     * @param {() => void} unsub An unsubscribe handler.
     *
     * @memberOf EventManagement
     */ constructor(unsub){
        this.unsub = unsub;
        this.propagationStopped = false;
    }
    /**
     * Stops the propagation of the event.
     * Cannot be used when async dispatch is done.
     *
     * @memberOf EventManagement
     */ stopPropagation() {
        this.propagationStopped = true;
    }
}
$eb4650c9efd49947$exports.EventManagement = $eb4650c9efd49947$var$EventManagement;


/**
 * Base class for implementation of the dispatcher. It facilitates the subscribe
 * and unsubscribe methods based on generic handlers. The TEventType specifies
 * the type of event that should be exposed. Use the asEvent to expose the
 * dispatcher as event.
 *
 * @export
 * @abstract
 * @class DispatcherBase
 * @implements {ISubscribable<TEventHandler>}
 * @template TEventHandler The type of event handler.
 */ class $83404bba45115341$var$DispatcherBase {
    constructor(){
        /**
         * The subscriptions.
         *
         * @protected
         *
         * @memberOf DispatcherBase
         */ this._subscriptions = new Array();
    }
    /**
     * Returns the number of subscriptions.
     *
     * @readonly
     * @type {number}
     * @memberOf DispatcherBase
     */ get count() {
        return this._subscriptions.length;
    }
    /**
     * Triggered when subscriptions are changed (added or removed).
     *
     * @readonly
     * @type {ISubscribable<SubscriptionChangeEventHandler>}
     * @memberOf DispatcherBase
     */ get onSubscriptionChange() {
        if (this._onSubscriptionChange == null) this._onSubscriptionChange = new $83404bba45115341$var$SubscriptionChangeEventDispatcher();
        return this._onSubscriptionChange.asEvent();
    }
    /**
     * Subscribe to the event dispatcher.
     *
     * @param {TEventHandler} fn The event handler that is called when the event is dispatched.
     * @returns A function that unsubscribes the event handler from the event.
     *
     * @memberOf DispatcherBase
     */ subscribe(fn) {
        if (fn) {
            this._subscriptions.push(this.createSubscription(fn, false));
            this.triggerSubscriptionChange();
        }
        return ()=>{
            this.unsubscribe(fn);
        };
    }
    /**
     * Subscribe to the event dispatcher.
     *
     * @param {TEventHandler} fn The event handler that is called when the event is dispatched.
     * @returns A function that unsubscribes the event handler from the event.
     *
     * @memberOf DispatcherBase
     */ sub(fn) {
        return this.subscribe(fn);
    }
    /**
     * Subscribe once to the event with the specified name.
     *
     * @param {TEventHandler} fn The event handler that is called when the event is dispatched.
     * @returns A function that unsubscribes the event handler from the event.
     *
     * @memberOf DispatcherBase
     */ one(fn) {
        if (fn) {
            this._subscriptions.push(this.createSubscription(fn, true));
            this.triggerSubscriptionChange();
        }
        return ()=>{
            this.unsubscribe(fn);
        };
    }
    /**
     * Checks it the event has a subscription for the specified handler.
     *
     * @param {TEventHandler} fn The event handler.
     *
     * @memberOf DispatcherBase
     */ has(fn) {
        if (!fn) return false;
        return this._subscriptions.some((sub)=>sub.handler == fn);
    }
    /**
     * Unsubscribes the handler from the dispatcher.
     *
     * @param {TEventHandler} fn The event handler.
     *
     * @memberOf DispatcherBase
     */ unsubscribe(fn) {
        if (!fn) return;
        let changes = false;
        for(let i = 0; i < this._subscriptions.length; i++)if (this._subscriptions[i].handler == fn) {
            this._subscriptions.splice(i, 1);
            changes = true;
            break;
        }
        if (changes) this.triggerSubscriptionChange();
    }
    /**
     * Unsubscribes the handler from the dispatcher.
     *
     * @param {TEventHandler} fn The event handler.
     *
     * @memberOf DispatcherBase
     */ unsub(fn) {
        this.unsubscribe(fn);
    }
    /**
     * Generic dispatch will dispatch the handlers with the given arguments.
     *
     * @protected
     * @param {boolean} executeAsync `True` if the even should be executed async.
     * @param {*} scope The scope of the event. The scope becomes the `this` for handler.
     * @param {IArguments} args The arguments for the event.
     * @returns {(IPropagationStatus | null)} The propagation status, or if an `executeAsync` is used `null`.
     *
     * @memberOf DispatcherBase
     */ _dispatch(executeAsync, scope, args) {
        //execute on a copy because of bug #9
        for (let sub of [
            ...this._subscriptions
        ]){
            let ev = new $eb4650c9efd49947$exports.EventManagement(()=>this.unsub(sub.handler));
            let nargs = Array.prototype.slice.call(args);
            nargs.push(ev);
            let s = sub;
            s.execute(executeAsync, scope, nargs);
            //cleanup subs that are no longer needed
            this.cleanup(sub);
            if (!executeAsync && ev.propagationStopped) return {
                propagationStopped: true
            };
        }
        if (executeAsync) return null;
        return {
            propagationStopped: false
        };
    }
    /**
     * Creates a subscription.
     *
     * @protected
     * @param {TEventHandler} handler The handler.
     * @param {boolean} isOnce True if the handler should run only one.
     * @returns {ISubscription<TEventHandler>} The subscription.
     *
     * @memberOf DispatcherBase
     */ createSubscription(handler, isOnce) {
        return new $97f95aaa3453e34b$exports.Subscription(handler, isOnce);
    }
    /**
     * Cleans up subs that ran and should run only once.
     *
     * @protected
     * @param {ISubscription<TEventHandler>} sub The subscription.
     *
     * @memberOf DispatcherBase
     */ cleanup(sub) {
        let changes = false;
        if (sub.isOnce && sub.isExecuted) {
            let i = this._subscriptions.indexOf(sub);
            if (i > -1) {
                this._subscriptions.splice(i, 1);
                changes = true;
            }
        }
        if (changes) this.triggerSubscriptionChange();
    }
    /**
     * Creates an event from the dispatcher. Will return the dispatcher
     * in a wrapper. This will prevent exposure of any dispatcher methods.
     *
     * @returns {ISubscribable<TEventHandler>}
     *
     * @memberOf DispatcherBase
     */ asEvent() {
        if (this._wrap == null) this._wrap = new $e9edec946bfbebaf$exports.DispatcherWrapper(this);
        return this._wrap;
    }
    /**
     * Clears the subscriptions.
     *
     * @memberOf DispatcherBase
     */ clear() {
        if (this._subscriptions.length != 0) {
            this._subscriptions.splice(0, this._subscriptions.length);
            this.triggerSubscriptionChange();
        }
    }
    /**
     * Triggers the subscription change event.
     *
     * @private
     *
     * @memberOf DispatcherBase
     */ triggerSubscriptionChange() {
        if (this._onSubscriptionChange != null) this._onSubscriptionChange.dispatch(this.count);
    }
}
$83404bba45115341$exports.DispatcherBase = $83404bba45115341$var$DispatcherBase;
/**
 * Dispatcher for subscription changes.
 *
 * @export
 * @class SubscriptionChangeEventDispatcher
 * @extends {DispatcherBase<SubscriptionChangeEventHandler>}
 */ class $83404bba45115341$var$SubscriptionChangeEventDispatcher extends $83404bba45115341$var$DispatcherBase {
    /**
     * Dispatches the event.
     *
     * @param {number} count The currrent number of subscriptions.
     *
     * @memberOf SubscriptionChangeEventDispatcher
     */ dispatch(count) {
        this._dispatch(false, this, arguments);
    }
}
$83404bba45115341$exports.SubscriptionChangeEventDispatcher = $83404bba45115341$var$SubscriptionChangeEventDispatcher;


Object.defineProperty($3a0124824db7da71$exports, "DispatcherBase", {
    enumerable: true,
    get: function() {
        return $83404bba45115341$exports.DispatcherBase;
    }
});
Object.defineProperty($3a0124824db7da71$exports, "SubscriptionChangeEventDispatcher", {
    enumerable: true,
    get: function() {
        return $83404bba45115341$exports.SubscriptionChangeEventDispatcher;
    }
});
var $971fd0262968e517$exports = {};
"use strict";
Object.defineProperty($971fd0262968e517$exports, "__esModule", {
    value: true
});
$971fd0262968e517$exports.DispatchError = void 0;
/**
 * Indicates an error with dispatching.
 *
 * @export
 * @class DispatchError
 * @extends {Error}
 */ class $971fd0262968e517$var$DispatchError extends Error {
    /**
     * Creates an instance of DispatchError.
     * @param {string} message The message.
     *
     * @memberOf DispatchError
     */ constructor(message){
        super(message);
    }
}
$971fd0262968e517$exports.DispatchError = $971fd0262968e517$var$DispatchError;


Object.defineProperty($3a0124824db7da71$exports, "DispatchError", {
    enumerable: true,
    get: function() {
        return $971fd0262968e517$exports.DispatchError;
    }
});

Object.defineProperty($3a0124824db7da71$exports, "DispatcherWrapper", {
    enumerable: true,
    get: function() {
        return $e9edec946bfbebaf$exports.DispatcherWrapper;
    }
});
var $ed05157ec038f965$exports = {};
"use strict";
Object.defineProperty($ed05157ec038f965$exports, "__esModule", {
    value: true
});
$ed05157ec038f965$exports.EventListBase = void 0;
/**
 * Base class for event lists classes. Implements the get and remove.
 *
 * @export
 * @abstract
 * @class EventListBaset
 * @template TEventDispatcher The type of event dispatcher.
 */ class $ed05157ec038f965$var$EventListBase {
    constructor(){
        this._events = {};
    }
    /**
     * Gets the dispatcher associated with the name.
     *
     * @param {string} name The name of the event.
     * @returns {TEventDispatcher} The disptacher.
     *
     * @memberOf EventListBase
     */ get(name) {
        let event = this._events[name];
        if (event) return event;
        event = this.createDispatcher();
        this._events[name] = event;
        return event;
    }
    /**
     * Removes the dispatcher associated with the name.
     *
     * @param {string} name
     *
     * @memberOf EventListBase
     */ remove(name) {
        delete this._events[name];
    }
}
$ed05157ec038f965$exports.EventListBase = $ed05157ec038f965$var$EventListBase;


Object.defineProperty($3a0124824db7da71$exports, "EventListBase", {
    enumerable: true,
    get: function() {
        return $ed05157ec038f965$exports.EventListBase;
    }
});

Object.defineProperty($3a0124824db7da71$exports, "EventManagement", {
    enumerable: true,
    get: function() {
        return $eb4650c9efd49947$exports.EventManagement;
    }
});
var $d40127368ffbeef0$exports = {};
"use strict";
Object.defineProperty($d40127368ffbeef0$exports, "__esModule", {
    value: true
});
$d40127368ffbeef0$exports.HandlingBase = void 0;
/**
 * Base class that implements event handling. With a an
 * event list this base class will expose events that can be
 * subscribed to. This will give your class generic events.
 *
 * @export
 * @abstract
 * @class HandlingBase
 * @template TEventHandler The type of event handler.
 * @template TDispatcher The type of dispatcher.
 * @template TList The type of event list.
 */ class $d40127368ffbeef0$var$HandlingBase {
    /**
     * Creates an instance of HandlingBase.
     * @param {TList} events The event list. Used for event management.
     *
     * @memberOf HandlingBase
     */ constructor(events){
        this.events = events;
    }
    /**
     * Subscribes once to the event with the specified name.
     * @param {string} name The name of the event.
     * @param {TEventHandler} fn The event handler.
     *
     * @memberOf HandlingBase
     */ one(name, fn) {
        this.events.get(name).one(fn);
    }
    /**
     * Checks it the event has a subscription for the specified handler.
     * @param {string} name The name of the event.
     * @param {TEventHandler} fn The event handler.
     *
     * @memberOf HandlingBase
     */ has(name, fn) {
        return this.events.get(name).has(fn);
    }
    /**
     * Subscribes to the event with the specified name.
     * @param {string} name The name of the event.
     * @param {TEventHandler} fn The event handler.
     *
     * @memberOf HandlingBase
     */ subscribe(name, fn) {
        this.events.get(name).subscribe(fn);
    }
    /**
     * Subscribes to the event with the specified name.
     * @param {string} name The name of the event.
     * @param {TEventHandler} fn The event handler.
     *
     * @memberOf HandlingBase
     */ sub(name, fn) {
        this.subscribe(name, fn);
    }
    /**
     * Unsubscribes from the event with the specified name.
     * @param {string} name The name of the event.
     * @param {TEventHandler} fn The event handler.
     *
     * @memberOf HandlingBase
     */ unsubscribe(name, fn) {
        this.events.get(name).unsubscribe(fn);
    }
    /**
     * Unsubscribes from the event with the specified name.
     * @param {string} name The name of the event.
     * @param {TEventHandler} fn The event handler.
     *
     * @memberOf HandlingBase
     */ unsub(name, fn) {
        this.unsubscribe(name, fn);
    }
}
$d40127368ffbeef0$exports.HandlingBase = $d40127368ffbeef0$var$HandlingBase;


Object.defineProperty($3a0124824db7da71$exports, "HandlingBase", {
    enumerable: true,
    get: function() {
        return $d40127368ffbeef0$exports.HandlingBase;
    }
});
var $09aa6c1a7ddf3dfb$exports = {};
"use strict";
Object.defineProperty($09aa6c1a7ddf3dfb$exports, "__esModule", {
    value: true
});
$09aa6c1a7ddf3dfb$exports.PromiseDispatcherBase = void 0;
var $f462bf64df2612ac$exports = {};
"use strict";
Object.defineProperty($f462bf64df2612ac$exports, "__esModule", {
    value: true
});
$f462bf64df2612ac$exports.PromiseSubscription = void 0;
/**
 * Subscription implementation for events with promises.
 *
 * @export
 * @class PromiseSubscription
 * @implements {ISubscription<TEventHandler>}
 * @template TEventHandler The type of event handler.
 */ class $f462bf64df2612ac$var$PromiseSubscription {
    /**
     * Creates an instance of PromiseSubscription.
     * @param {TEventHandler} handler The handler for the subscription.
     * @param {boolean} isOnce Indicates if the handler should only be executed once.
     *
     * @memberOf PromiseSubscription
     */ constructor(handler, isOnce){
        this.handler = handler;
        this.isOnce = isOnce;
        /**
         * Indicates if the subscription has been executed before.
         *
         * @memberOf PromiseSubscription
         */ this.isExecuted = false;
    }
    /**
     * Executes the handler.
     *
     * @param {boolean} executeAsync True if the even should be executed async.
     * @param {*} scope The scope the scope of the event.
     * @param {IArguments} args The arguments for the event.
     *
     * @memberOf PromiseSubscription
     */ async execute(executeAsync, scope, args) {
        if (!this.isOnce || !this.isExecuted) {
            this.isExecuted = true;
            //TODO: do we need to cast to any -- seems yuck
            var fn = this.handler;
            if (executeAsync) {
                setTimeout(()=>{
                    fn.apply(scope, args);
                }, 1);
                return;
            }
            let result = fn.apply(scope, args);
            await result;
        }
    }
}
$f462bf64df2612ac$exports.PromiseSubscription = $f462bf64df2612ac$var$PromiseSubscription;





/**
 * Dispatcher base for dispatchers that use promises. Each promise
 * is awaited before the next is dispatched, unless the event is
 * dispatched with the executeAsync flag.
 *
 * @export
 * @abstract
 * @class PromiseDispatcherBase
 * @extends {DispatcherBase<TEventHandler>}
 * @template TEventHandler The type of event handler.
 */ class $09aa6c1a7ddf3dfb$var$PromiseDispatcherBase extends $83404bba45115341$exports.DispatcherBase {
    /**
     * The normal dispatch cannot be used in this class.
     *
     * @protected
     * @param {boolean} executeAsync `True` if the even should be executed async.
     * @param {*} scope The scope of the event. The scope becomes the `this` for handler.
     * @param {IArguments} args The arguments for the event.
     * @returns {(IPropagationStatus | null)} The propagation status, or if an `executeAsync` is used `null`.
     *
     * @memberOf DispatcherBase
     */ _dispatch(executeAsync, scope, args) {
        throw new $971fd0262968e517$exports.DispatchError("_dispatch not supported. Use _dispatchAsPromise.");
    }
    /**
     * Crates a new subscription.
     *
     * @protected
     * @param {TEventHandler} handler The handler.
     * @param {boolean} isOnce Indicates if the handler should only run once.
     * @returns {ISubscription<TEventHandler>} The subscription.
     *
     * @memberOf PromiseDispatcherBase
     */ createSubscription(handler, isOnce) {
        return new $f462bf64df2612ac$exports.PromiseSubscription(handler, isOnce);
    }
    /**
     * Generic dispatch will dispatch the handlers with the given arguments.
     *
     * @protected
     * @param {boolean} executeAsync `True` if the even should be executed async.
     * @param {*} scope The scope of the event. The scope becomes the `this` for handler.
     * @param {IArguments} args The arguments for the event.
     * @returns {(IPropagationStatus | null)} The propagation status, or if an `executeAsync` is used `null`.
     *
     * @memberOf DispatcherBase
     */ async _dispatchAsPromise(executeAsync, scope, args) {
        //execute on a copy because of bug #9
        for (let sub of [
            ...this._subscriptions
        ]){
            let ev = new $eb4650c9efd49947$exports.EventManagement(()=>this.unsub(sub.handler));
            let nargs = Array.prototype.slice.call(args);
            nargs.push(ev);
            let ps = sub;
            await ps.execute(executeAsync, scope, nargs);
            //cleanup subs that are no longer needed
            this.cleanup(sub);
            if (!executeAsync && ev.propagationStopped) return {
                propagationStopped: true
            };
        }
        if (executeAsync) return null;
        return {
            propagationStopped: false
        };
    }
}
$09aa6c1a7ddf3dfb$exports.PromiseDispatcherBase = $09aa6c1a7ddf3dfb$var$PromiseDispatcherBase;


Object.defineProperty($3a0124824db7da71$exports, "PromiseDispatcherBase", {
    enumerable: true,
    get: function() {
        return $09aa6c1a7ddf3dfb$exports.PromiseDispatcherBase;
    }
});

Object.defineProperty($3a0124824db7da71$exports, "PromiseSubscription", {
    enumerable: true,
    get: function() {
        return $f462bf64df2612ac$exports.PromiseSubscription;
    }
});

Object.defineProperty($3a0124824db7da71$exports, "Subscription", {
    enumerable: true,
    get: function() {
        return $97f95aaa3453e34b$exports.Subscription;
    }
});


Object.defineProperty($6384862cb2bc9a13$exports, "Subscription", {
    enumerable: true,
    get: function() {
        return $3a0124824db7da71$exports.Subscription;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "DispatcherBase", {
    enumerable: true,
    get: function() {
        return $3a0124824db7da71$exports.DispatcherBase;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "DispatcherWrapper", {
    enumerable: true,
    get: function() {
        return $3a0124824db7da71$exports.DispatcherWrapper;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "EventListBase", {
    enumerable: true,
    get: function() {
        return $3a0124824db7da71$exports.EventListBase;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "EventManagement", {
    enumerable: true,
    get: function() {
        return $3a0124824db7da71$exports.EventManagement;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "DispatchError", {
    enumerable: true,
    get: function() {
        return $3a0124824db7da71$exports.DispatchError;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "PromiseSubscription", {
    enumerable: true,
    get: function() {
        return $3a0124824db7da71$exports.PromiseSubscription;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "PromiseDispatcherBase", {
    enumerable: true,
    get: function() {
        return $3a0124824db7da71$exports.PromiseDispatcherBase;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "HandlingBase", {
    enumerable: true,
    get: function() {
        return $3a0124824db7da71$exports.HandlingBase;
    }
});
var $653a67a2697eedcd$exports = {};
"use strict";
/*!
 * Strongly Typed Events for TypeScript - Core
 * https://github.com/KeesCBakker/StronlyTypedEvents/
 * http://keestalkstech.com
 *
 * Copyright Kees C. Bakker / KeesTalksTech
 * Released under the MIT license
 */ Object.defineProperty($653a67a2697eedcd$exports, "__esModule", {
    value: true
});
$653a67a2697eedcd$exports.NonUniformEventList = $653a67a2697eedcd$exports.EventList = $653a67a2697eedcd$exports.EventHandlingBase = $653a67a2697eedcd$exports.EventDispatcher = void 0;
var $d59b5d46d7054680$exports = {};
"use strict";
Object.defineProperty($d59b5d46d7054680$exports, "__esModule", {
    value: true
});
$d59b5d46d7054680$exports.EventDispatcher = void 0;

/**
 * Dispatcher implementation for events. Can be used to subscribe, unsubscribe
 * or dispatch events. Use the ToEvent() method to expose the event.
 *
 * @export
 * @class EventDispatcher
 * @extends {DispatcherBase<IEventHandler<TSender, TArgs>>}
 * @implements {IEvent<TSender, TArgs>}
 * @template TSender The sender type.
 * @template TArgs The event arguments type.
 */ class $d59b5d46d7054680$var$EventDispatcher extends $3a0124824db7da71$exports.DispatcherBase {
    /**
     * Creates an instance of EventDispatcher.
     *
     * @memberOf EventDispatcher
     */ constructor(){
        super();
    }
    /**
     * Dispatches the event.
     *
     * @param {TSender} sender The sender.
     * @param {TArgs} args The arguments.
     * @returns {IPropagationStatus} The propagation status to interact with the event
     *
     * @memberOf EventDispatcher
     */ dispatch(sender, args) {
        const result = this._dispatch(false, this, arguments);
        if (result == null) throw new $3a0124824db7da71$exports.DispatchError("Got `null` back from dispatch.");
        return result;
    }
    /**
     * Dispatches the event in an async way. Does not support event interaction.
     *
     * @param {TSender} sender The sender.
     * @param {TArgs} args The arguments.
     *
     * @memberOf EventDispatcher
     */ dispatchAsync(sender, args) {
        this._dispatch(true, this, arguments);
    }
    /**
     * Creates an event from the dispatcher. Will return the dispatcher
     * in a wrapper. This will prevent exposure of any dispatcher methods.
     *
     * @returns {IEvent<TSender, TArgs>} The event.
     *
     * @memberOf EventDispatcher
     */ asEvent() {
        return super.asEvent();
    }
}
$d59b5d46d7054680$exports.EventDispatcher = $d59b5d46d7054680$var$EventDispatcher;


Object.defineProperty($653a67a2697eedcd$exports, "EventDispatcher", {
    enumerable: true,
    get: function() {
        return $d59b5d46d7054680$exports.EventDispatcher;
    }
});
var $4804fc2e8cc8f0fd$exports = {};
"use strict";
Object.defineProperty($4804fc2e8cc8f0fd$exports, "__esModule", {
    value: true
});
$4804fc2e8cc8f0fd$exports.EventHandlingBase = void 0;

var $4f4766fbbd242942$exports = {};
"use strict";
Object.defineProperty($4f4766fbbd242942$exports, "__esModule", {
    value: true
});
$4f4766fbbd242942$exports.EventList = void 0;


/**
 * Storage class for multiple events that are accessible by name.
 * Events dispatchers are automatically created.
 */ class $4f4766fbbd242942$var$EventList extends $3a0124824db7da71$exports.EventListBase {
    /**
     * Creates a new EventList instance.
     */ constructor(){
        super();
    }
    /**
     * Creates a new dispatcher instance.
     */ createDispatcher() {
        return new $d59b5d46d7054680$exports.EventDispatcher();
    }
}
$4f4766fbbd242942$exports.EventList = $4f4766fbbd242942$var$EventList;


/**
 * Extends objects with signal event handling capabilities.
 */ class $4804fc2e8cc8f0fd$var$EventHandlingBase extends $3a0124824db7da71$exports.HandlingBase {
    constructor(){
        super(new $4f4766fbbd242942$exports.EventList());
    }
}
$4804fc2e8cc8f0fd$exports.EventHandlingBase = $4804fc2e8cc8f0fd$var$EventHandlingBase;


Object.defineProperty($653a67a2697eedcd$exports, "EventHandlingBase", {
    enumerable: true,
    get: function() {
        return $4804fc2e8cc8f0fd$exports.EventHandlingBase;
    }
});

Object.defineProperty($653a67a2697eedcd$exports, "EventList", {
    enumerable: true,
    get: function() {
        return $4f4766fbbd242942$exports.EventList;
    }
});
var $81a5b65251dd1e23$exports = {};
"use strict";
Object.defineProperty($81a5b65251dd1e23$exports, "__esModule", {
    value: true
});
$81a5b65251dd1e23$exports.NonUniformEventList = void 0;

/**
 * Similar to EventList, but instead of TArgs, a map of event names ang argument types is provided with TArgsMap.
 */ class $81a5b65251dd1e23$var$NonUniformEventList {
    constructor(){
        this._events = {};
    }
    /**
     * Gets the dispatcher associated with the name.
     * @param name The name of the event.
     */ get(name) {
        if (this._events[name]) // @TODO avoid typecasting. Not sure why TS thinks this._events[name] could still be undefined.
        return this._events[name];
        const event = this.createDispatcher();
        this._events[name] = event;
        return event;
    }
    /**
     * Removes the dispatcher associated with the name.
     * @param name The name of the event.
     */ remove(name) {
        delete this._events[name];
    }
    /**
     * Creates a new dispatcher instance.
     */ createDispatcher() {
        return new $d59b5d46d7054680$exports.EventDispatcher();
    }
}
$81a5b65251dd1e23$exports.NonUniformEventList = $81a5b65251dd1e23$var$NonUniformEventList;


Object.defineProperty($653a67a2697eedcd$exports, "NonUniformEventList", {
    enumerable: true,
    get: function() {
        return $81a5b65251dd1e23$exports.NonUniformEventList;
    }
});


Object.defineProperty($6384862cb2bc9a13$exports, "EventDispatcher", {
    enumerable: true,
    get: function() {
        return $653a67a2697eedcd$exports.EventDispatcher;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "EventHandlingBase", {
    enumerable: true,
    get: function() {
        return $653a67a2697eedcd$exports.EventHandlingBase;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "EventList", {
    enumerable: true,
    get: function() {
        return $653a67a2697eedcd$exports.EventList;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "NonUniformEventList", {
    enumerable: true,
    get: function() {
        return $653a67a2697eedcd$exports.NonUniformEventList;
    }
});
var $78970071675302d1$exports = {};
"use strict";
Object.defineProperty($78970071675302d1$exports, "__esModule", {
    value: true
});
$78970071675302d1$exports.NonUniformSimpleEventList = $78970071675302d1$exports.SimpleEventList = $78970071675302d1$exports.SimpleEventHandlingBase = $78970071675302d1$exports.SimpleEventDispatcher = void 0;
var $d9b3c4eb1444a109$exports = {};
"use strict";
Object.defineProperty($d9b3c4eb1444a109$exports, "__esModule", {
    value: true
});
$d9b3c4eb1444a109$exports.SimpleEventDispatcher = void 0;

/**
 * The dispatcher handles the storage of subsciptions and facilitates
 * subscription, unsubscription and dispatching of a simple event
 *
 * @export
 * @class SimpleEventDispatcher
 * @extends {DispatcherBase<ISimpleEventHandler<TArgs>>}
 * @implements {ISimpleEvent<TArgs>}
 * @template TArgs
 */ class $d9b3c4eb1444a109$var$SimpleEventDispatcher extends $3a0124824db7da71$exports.DispatcherBase {
    /**
     * Creates an instance of SimpleEventDispatcher.
     *
     * @memberOf SimpleEventDispatcher
     */ constructor(){
        super();
    }
    /**
     * Dispatches the event.
     *
     * @param {TArgs} args The arguments object.
     * @returns {IPropagationStatus} The status of the event.
     *
     * @memberOf SimpleEventDispatcher
     */ dispatch(args) {
        const result = this._dispatch(false, this, arguments);
        if (result == null) throw new $3a0124824db7da71$exports.DispatchError("Got `null` back from dispatch.");
        return result;
    }
    /**
     * Dispatches the event without waiting for the result.
     *
     * @param {TArgs} args The arguments object.
     *
     * @memberOf SimpleEventDispatcher
     */ dispatchAsync(args) {
        this._dispatch(true, this, arguments);
    }
    /**
     * Creates an event from the dispatcher. Will return the dispatcher
     * in a wrapper. This will prevent exposure of any dispatcher methods.
     *
     * @returns {ISimpleEvent<TArgs>} The event.
     *
     * @memberOf SimpleEventDispatcher
     */ asEvent() {
        return super.asEvent();
    }
}
$d9b3c4eb1444a109$exports.SimpleEventDispatcher = $d9b3c4eb1444a109$var$SimpleEventDispatcher;


Object.defineProperty($78970071675302d1$exports, "SimpleEventDispatcher", {
    enumerable: true,
    get: function() {
        return $d9b3c4eb1444a109$exports.SimpleEventDispatcher;
    }
});
var $10a5f3249f7aca6e$exports = {};
"use strict";
Object.defineProperty($10a5f3249f7aca6e$exports, "__esModule", {
    value: true
});
$10a5f3249f7aca6e$exports.SimpleEventHandlingBase = void 0;

var $1cecdccca4006ad9$exports = {};
"use strict";
Object.defineProperty($1cecdccca4006ad9$exports, "__esModule", {
    value: true
});
$1cecdccca4006ad9$exports.SimpleEventList = void 0;


/**
 * Storage class for multiple simple events that are accessible by name.
 * Events dispatchers are automatically created.
 */ class $1cecdccca4006ad9$var$SimpleEventList extends $3a0124824db7da71$exports.EventListBase {
    /**
     * Creates a new SimpleEventList instance.
     */ constructor(){
        super();
    }
    /**
     * Creates a new dispatcher instance.
     */ createDispatcher() {
        return new $d9b3c4eb1444a109$exports.SimpleEventDispatcher();
    }
}
$1cecdccca4006ad9$exports.SimpleEventList = $1cecdccca4006ad9$var$SimpleEventList;


/**
 * Extends objects with signal event handling capabilities.
 */ class $10a5f3249f7aca6e$var$SimpleEventHandlingBase extends $3a0124824db7da71$exports.HandlingBase {
    constructor(){
        super(new $1cecdccca4006ad9$exports.SimpleEventList());
    }
}
$10a5f3249f7aca6e$exports.SimpleEventHandlingBase = $10a5f3249f7aca6e$var$SimpleEventHandlingBase;


Object.defineProperty($78970071675302d1$exports, "SimpleEventHandlingBase", {
    enumerable: true,
    get: function() {
        return $10a5f3249f7aca6e$exports.SimpleEventHandlingBase;
    }
});
var $979165f74ff3b43b$exports = {};
"use strict";
Object.defineProperty($979165f74ff3b43b$exports, "__esModule", {
    value: true
});
$979165f74ff3b43b$exports.NonUniformSimpleEventList = void 0;

/**
 * Similar to EventList, but instead of TArgs, a map of event names ang argument types is provided with TArgsMap.
 */ class $979165f74ff3b43b$var$NonUniformSimpleEventList {
    constructor(){
        this._events = {};
    }
    /**
     * Gets the dispatcher associated with the name.
     * @param name The name of the event.
     */ get(name) {
        if (this._events[name]) // @TODO avoid typecasting. Not sure why TS thinks this._events[name] could still be undefined.
        return this._events[name];
        const event = this.createDispatcher();
        this._events[name] = event;
        return event;
    }
    /**
     * Removes the dispatcher associated with the name.
     * @param name The name of the event.
     */ remove(name) {
        delete this._events[name];
    }
    /**
     * Creates a new dispatcher instance.
     */ createDispatcher() {
        return new $d9b3c4eb1444a109$exports.SimpleEventDispatcher();
    }
}
$979165f74ff3b43b$exports.NonUniformSimpleEventList = $979165f74ff3b43b$var$NonUniformSimpleEventList;


Object.defineProperty($78970071675302d1$exports, "NonUniformSimpleEventList", {
    enumerable: true,
    get: function() {
        return $979165f74ff3b43b$exports.NonUniformSimpleEventList;
    }
});

Object.defineProperty($78970071675302d1$exports, "SimpleEventList", {
    enumerable: true,
    get: function() {
        return $1cecdccca4006ad9$exports.SimpleEventList;
    }
});


Object.defineProperty($6384862cb2bc9a13$exports, "SimpleEventDispatcher", {
    enumerable: true,
    get: function() {
        return $78970071675302d1$exports.SimpleEventDispatcher;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "SimpleEventHandlingBase", {
    enumerable: true,
    get: function() {
        return $78970071675302d1$exports.SimpleEventHandlingBase;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "SimpleEventList", {
    enumerable: true,
    get: function() {
        return $78970071675302d1$exports.SimpleEventList;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "NonUniformSimpleEventList", {
    enumerable: true,
    get: function() {
        return $78970071675302d1$exports.NonUniformSimpleEventList;
    }
});
var $cea58cbe975346df$exports = {};
"use strict";
/*!
 * Strongly Typed Events for TypeScript - Promise Signals
 * https://github.com/KeesCBakker/StronlyTypedEvents/
 * http://keestalkstech.com
 *
 * Copyright Kees C. Bakker / KeesTalksTech
 * Released under the MIT license
 */ Object.defineProperty($cea58cbe975346df$exports, "__esModule", {
    value: true
});
$cea58cbe975346df$exports.SignalList = $cea58cbe975346df$exports.SignalHandlingBase = $cea58cbe975346df$exports.SignalDispatcher = void 0;
var $b4d397d76d5a4188$exports = {};
"use strict";
Object.defineProperty($b4d397d76d5a4188$exports, "__esModule", {
    value: true
});
$b4d397d76d5a4188$exports.SignalDispatcher = void 0;

/**
 * The dispatcher handles the storage of subsciptions and facilitates
 * subscription, unsubscription and dispatching of a signal event.
 *
 * @export
 * @class SignalDispatcher
 * @extends {DispatcherBase<ISignalHandler>}
 * @implements {ISignal}
 */ class $b4d397d76d5a4188$var$SignalDispatcher extends $3a0124824db7da71$exports.DispatcherBase {
    /**
     * Dispatches the signal.
     *
     * @returns {IPropagationStatus} The status of the signal.
     *
     * @memberOf SignalDispatcher
     */ dispatch() {
        const result = this._dispatch(false, this, arguments);
        if (result == null) throw new $3a0124824db7da71$exports.DispatchError("Got `null` back from dispatch.");
        return result;
    }
    /**
     * Dispatches the signal without waiting for the result.
     *
     * @memberOf SignalDispatcher
     */ dispatchAsync() {
        this._dispatch(true, this, arguments);
    }
    /**
     * Creates an event from the dispatcher. Will return the dispatcher
     * in a wrapper. This will prevent exposure of any dispatcher methods.
     *
     * @returns {ISignal} The signal.
     *
     * @memberOf SignalDispatcher
     */ asEvent() {
        return super.asEvent();
    }
}
$b4d397d76d5a4188$exports.SignalDispatcher = $b4d397d76d5a4188$var$SignalDispatcher;


Object.defineProperty($cea58cbe975346df$exports, "SignalDispatcher", {
    enumerable: true,
    get: function() {
        return $b4d397d76d5a4188$exports.SignalDispatcher;
    }
});
var $71a46b8128076aca$exports = {};
"use strict";
Object.defineProperty($71a46b8128076aca$exports, "__esModule", {
    value: true
});
$71a46b8128076aca$exports.SignalHandlingBase = void 0;

var $2211c763516f9be0$exports = {};
"use strict";
Object.defineProperty($2211c763516f9be0$exports, "__esModule", {
    value: true
});
$2211c763516f9be0$exports.SignalList = void 0;


/**
 * Storage class for multiple signal events that are accessible by name.
 * Events dispatchers are automatically created.
 *
 * @export
 * @class SignalList
 * @extends {EventListBase<SignalDispatcher>}
 */ class $2211c763516f9be0$var$SignalList extends $3a0124824db7da71$exports.EventListBase {
    /**
     * Creates an instance of SignalList.
     *
     * @memberOf SignalList
     */ constructor(){
        super();
    }
    /**
     * Creates a new dispatcher instance.
     *
     * @protected
     * @returns {SignalDispatcher}
     *
     * @memberOf SignalList
     */ createDispatcher() {
        return new $b4d397d76d5a4188$exports.SignalDispatcher();
    }
}
$2211c763516f9be0$exports.SignalList = $2211c763516f9be0$var$SignalList;


/**
 * Extends objects with signal event handling capabilities.
 *
 * @export
 * @abstract
 * @class SignalHandlingBase
 * @extends {HandlingBase<ISignalHandler, SignalDispatcher, SignalList>}
 * @implements {ISignalHandling}
 */ class $71a46b8128076aca$var$SignalHandlingBase extends $3a0124824db7da71$exports.HandlingBase {
    /**
     * Creates an instance of SignalHandlingBase.
     *
     * @memberOf SignalHandlingBase
     */ constructor(){
        super(new $2211c763516f9be0$exports.SignalList());
    }
}
$71a46b8128076aca$exports.SignalHandlingBase = $71a46b8128076aca$var$SignalHandlingBase;


Object.defineProperty($cea58cbe975346df$exports, "SignalHandlingBase", {
    enumerable: true,
    get: function() {
        return $71a46b8128076aca$exports.SignalHandlingBase;
    }
});

Object.defineProperty($cea58cbe975346df$exports, "SignalList", {
    enumerable: true,
    get: function() {
        return $2211c763516f9be0$exports.SignalList;
    }
});


Object.defineProperty($6384862cb2bc9a13$exports, "SignalDispatcher", {
    enumerable: true,
    get: function() {
        return $cea58cbe975346df$exports.SignalDispatcher;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "SignalHandlingBase", {
    enumerable: true,
    get: function() {
        return $cea58cbe975346df$exports.SignalHandlingBase;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "SignalList", {
    enumerable: true,
    get: function() {
        return $cea58cbe975346df$exports.SignalList;
    }
});
var $022e8749cd173560$exports = {};
"use strict";
/*!
 * Strongly Typed Events for TypeScript - Core
 * https://github.com/KeesCBakker/StronlyTypedEvents/
 * http://keestalkstech.com
 *
 * Copyright Kees C. Bakker / KeesTalksTech
 * Released under the MIT license
 */ Object.defineProperty($022e8749cd173560$exports, "__esModule", {
    value: true
});
$022e8749cd173560$exports.NonUniformPromiseEventList = $022e8749cd173560$exports.PromiseEventList = $022e8749cd173560$exports.PromiseEventHandlingBase = $022e8749cd173560$exports.PromiseEventDispatcher = void 0;
var $9820ff392cb15412$exports = {};
"use strict";
Object.defineProperty($9820ff392cb15412$exports, "__esModule", {
    value: true
});
$9820ff392cb15412$exports.PromiseEventDispatcher = void 0;

/**
 * Dispatcher implementation for events. Can be used to subscribe, unsubscribe
 * or dispatch events. Use the ToEvent() method to expose the event.
 *
 * @export
 * @class PromiseEventDispatcher
 * @extends {PromiseDispatcherBase<IPromiseEventHandler<TSender, TArgs>>}
 * @implements {IPromiseEvent<TSender, TArgs>}
 * @template TSender
 * @template TArgs
 */ class $9820ff392cb15412$var$PromiseEventDispatcher extends $3a0124824db7da71$exports.PromiseDispatcherBase {
    /**
     * Creates a new EventDispatcher instance.
     */ constructor(){
        super();
    }
    /**
     * Dispatches the event.
     *
     * @param {TSender} sender The sender object.
     * @param {TArgs} args The argument object.
     * @returns {Promise<IPropagationStatus>} The status.
     *
     * @memberOf PromiseEventDispatcher
     */ async dispatch(sender, args) {
        const result = await this._dispatchAsPromise(false, this, arguments);
        if (result == null) throw new $3a0124824db7da71$exports.DispatchError("Got `null` back from dispatch.");
        return result;
    }
    /**
     * Dispatches the event without waiting for the result.
     *
     * @param {TSender} sender The sender object.
     * @param {TArgs} args The argument object.
     *
     * @memberOf PromiseEventDispatcher
     */ dispatchAsync(sender, args) {
        this._dispatchAsPromise(true, this, arguments);
    }
    /**
     * Creates an event from the dispatcher. Will return the dispatcher
     * in a wrapper. This will prevent exposure of any dispatcher methods.
     */ asEvent() {
        return super.asEvent();
    }
}
$9820ff392cb15412$exports.PromiseEventDispatcher = $9820ff392cb15412$var$PromiseEventDispatcher;


Object.defineProperty($022e8749cd173560$exports, "PromiseEventDispatcher", {
    enumerable: true,
    get: function() {
        return $9820ff392cb15412$exports.PromiseEventDispatcher;
    }
});
var $49e153b0c0efeb24$exports = {};
"use strict";
Object.defineProperty($49e153b0c0efeb24$exports, "__esModule", {
    value: true
});
$49e153b0c0efeb24$exports.PromiseEventHandlingBase = void 0;

var $d50da02e97cc9e10$exports = {};
"use strict";
Object.defineProperty($d50da02e97cc9e10$exports, "__esModule", {
    value: true
});
$d50da02e97cc9e10$exports.PromiseEventList = void 0;


/**
 * Storage class for multiple events that are accessible by name.
 * Events dispatchers are automatically created.
 */ class $d50da02e97cc9e10$var$PromiseEventList extends $3a0124824db7da71$exports.EventListBase {
    /**
     * Creates a new EventList instance.
     */ constructor(){
        super();
    }
    /**
     * Creates a new dispatcher instance.
     */ createDispatcher() {
        return new $9820ff392cb15412$exports.PromiseEventDispatcher();
    }
}
$d50da02e97cc9e10$exports.PromiseEventList = $d50da02e97cc9e10$var$PromiseEventList;


/**
 * Extends objects with signal event handling capabilities.
 */ class $49e153b0c0efeb24$var$PromiseEventHandlingBase extends $3a0124824db7da71$exports.HandlingBase {
    constructor(){
        super(new $d50da02e97cc9e10$exports.PromiseEventList());
    }
}
$49e153b0c0efeb24$exports.PromiseEventHandlingBase = $49e153b0c0efeb24$var$PromiseEventHandlingBase;


Object.defineProperty($022e8749cd173560$exports, "PromiseEventHandlingBase", {
    enumerable: true,
    get: function() {
        return $49e153b0c0efeb24$exports.PromiseEventHandlingBase;
    }
});

Object.defineProperty($022e8749cd173560$exports, "PromiseEventList", {
    enumerable: true,
    get: function() {
        return $d50da02e97cc9e10$exports.PromiseEventList;
    }
});
var $631263c3ba98f2c3$exports = {};
"use strict";
Object.defineProperty($631263c3ba98f2c3$exports, "__esModule", {
    value: true
});
$631263c3ba98f2c3$exports.NonUniformPromiseEventList = void 0;

/**
 * Similar to EventList, but instead of TArgs, a map of event names ang argument types is provided with TArgsMap.
 */ class $631263c3ba98f2c3$var$NonUniformPromiseEventList {
    constructor(){
        this._events = {};
    }
    /**
     * Gets the dispatcher associated with the name.
     * @param name The name of the event.
     */ get(name) {
        if (this._events[name]) // @TODO avoid typecasting. Not sure why TS thinks this._events[name] could still be undefined.
        return this._events[name];
        const event = this.createDispatcher();
        this._events[name] = event;
        return event;
    }
    /**
     * Removes the dispatcher associated with the name.
     * @param name The name of the event.
     */ remove(name) {
        delete this._events[name];
    }
    /**
     * Creates a new dispatcher instance.
     */ createDispatcher() {
        return new $9820ff392cb15412$exports.PromiseEventDispatcher();
    }
}
$631263c3ba98f2c3$exports.NonUniformPromiseEventList = $631263c3ba98f2c3$var$NonUniformPromiseEventList;


Object.defineProperty($022e8749cd173560$exports, "NonUniformPromiseEventList", {
    enumerable: true,
    get: function() {
        return $631263c3ba98f2c3$exports.NonUniformPromiseEventList;
    }
});


Object.defineProperty($6384862cb2bc9a13$exports, "PromiseEventDispatcher", {
    enumerable: true,
    get: function() {
        return $022e8749cd173560$exports.PromiseEventDispatcher;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "PromiseEventHandlingBase", {
    enumerable: true,
    get: function() {
        return $022e8749cd173560$exports.PromiseEventHandlingBase;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "PromiseEventList", {
    enumerable: true,
    get: function() {
        return $022e8749cd173560$exports.PromiseEventList;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "NonUniformPromiseEventList", {
    enumerable: true,
    get: function() {
        return $022e8749cd173560$exports.NonUniformPromiseEventList;
    }
});
var $ce27ec8dc94800be$exports = {};
"use strict";
/*!
 * Strongly Typed Events for TypeScript - Promise Signals
 * https://github.com/KeesCBakker/StronlyTypedEvents/
 * http://keestalkstech.com
 *
 * Copyright Kees C. Bakker / KeesTalksTech
 * Released under the MIT license
 */ Object.defineProperty($ce27ec8dc94800be$exports, "__esModule", {
    value: true
});
$ce27ec8dc94800be$exports.PromiseSignalList = $ce27ec8dc94800be$exports.PromiseSignalHandlingBase = $ce27ec8dc94800be$exports.PromiseSignalDispatcher = void 0;
var $aaf69823134e5136$exports = {};
"use strict";
Object.defineProperty($aaf69823134e5136$exports, "__esModule", {
    value: true
});
$aaf69823134e5136$exports.PromiseSignalDispatcher = void 0;

/**
 * The dispatcher handles the storage of subsciptions and facilitates
 * subscription, unsubscription and dispatching of a signal event.
 */ class $aaf69823134e5136$var$PromiseSignalDispatcher extends $3a0124824db7da71$exports.PromiseDispatcherBase {
    /**
     * Creates a new SignalDispatcher instance.
     */ constructor(){
        super();
    }
    /**
     * Dispatches the signal.
     *
     * @returns {IPropagationStatus} The status of the dispatch.
     *
     * @memberOf SignalDispatcher
     */ async dispatch() {
        const result = await this._dispatchAsPromise(false, this, arguments);
        if (result == null) throw new $3a0124824db7da71$exports.DispatchError("Got `null` back from dispatch.");
        return result;
    }
    /**
     * Dispatches the signal threaded.
     */ dispatchAsync() {
        this._dispatchAsPromise(true, this, arguments);
    }
    /**
     * Creates an event from the dispatcher. Will return the dispatcher
     * in a wrapper. This will prevent exposure of any dispatcher methods.
     */ asEvent() {
        return super.asEvent();
    }
}
$aaf69823134e5136$exports.PromiseSignalDispatcher = $aaf69823134e5136$var$PromiseSignalDispatcher;


Object.defineProperty($ce27ec8dc94800be$exports, "PromiseSignalDispatcher", {
    enumerable: true,
    get: function() {
        return $aaf69823134e5136$exports.PromiseSignalDispatcher;
    }
});
var $3960e174aad92640$exports = {};
"use strict";
Object.defineProperty($3960e174aad92640$exports, "__esModule", {
    value: true
});
$3960e174aad92640$exports.PromiseSignalHandlingBase = void 0;

var $81c142fd8306c18f$exports = {};
"use strict";
Object.defineProperty($81c142fd8306c18f$exports, "__esModule", {
    value: true
});
$81c142fd8306c18f$exports.PromiseSignalList = void 0;


/**
 * Storage class for multiple signal events that are accessible by name.
 * Events dispatchers are automatically created.
 */ class $81c142fd8306c18f$var$PromiseSignalList extends $3a0124824db7da71$exports.EventListBase {
    /**
     * Creates a new SignalList instance.
     */ constructor(){
        super();
    }
    /**
     * Creates a new dispatcher instance.
     */ createDispatcher() {
        return new $aaf69823134e5136$exports.PromiseSignalDispatcher();
    }
}
$81c142fd8306c18f$exports.PromiseSignalList = $81c142fd8306c18f$var$PromiseSignalList;


/**
 * Extends objects with signal event handling capabilities.
 */ class $3960e174aad92640$var$PromiseSignalHandlingBase extends $3a0124824db7da71$exports.HandlingBase {
    constructor(){
        super(new $81c142fd8306c18f$exports.PromiseSignalList());
    }
}
$3960e174aad92640$exports.PromiseSignalHandlingBase = $3960e174aad92640$var$PromiseSignalHandlingBase;


Object.defineProperty($ce27ec8dc94800be$exports, "PromiseSignalHandlingBase", {
    enumerable: true,
    get: function() {
        return $3960e174aad92640$exports.PromiseSignalHandlingBase;
    }
});

Object.defineProperty($ce27ec8dc94800be$exports, "PromiseSignalList", {
    enumerable: true,
    get: function() {
        return $81c142fd8306c18f$exports.PromiseSignalList;
    }
});


Object.defineProperty($6384862cb2bc9a13$exports, "PromiseSignalDispatcher", {
    enumerable: true,
    get: function() {
        return $ce27ec8dc94800be$exports.PromiseSignalDispatcher;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "PromiseSignalHandlingBase", {
    enumerable: true,
    get: function() {
        return $ce27ec8dc94800be$exports.PromiseSignalHandlingBase;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "PromiseSignalList", {
    enumerable: true,
    get: function() {
        return $ce27ec8dc94800be$exports.PromiseSignalList;
    }
});
var $9db9e770f6e4cf0d$exports = {};
"use strict";
/*!
 * Strongly Typed Events for TypeScript - Core
 * https://github.com/KeesCBakker/StronlyTypedEvents/
 * http://keestalkstech.com
 *
 * Copyright Kees C. Bakker / KeesTalksTech
 * Released under the MIT license
 */ Object.defineProperty($9db9e770f6e4cf0d$exports, "__esModule", {
    value: true
});
$9db9e770f6e4cf0d$exports.NonUniformPromiseSimpleEventList = $9db9e770f6e4cf0d$exports.PromiseSimpleEventList = $9db9e770f6e4cf0d$exports.PromiseSimpleEventHandlingBase = $9db9e770f6e4cf0d$exports.PromiseSimpleEventDispatcher = void 0;
var $55dec8cb37f14493$exports = {};
"use strict";
Object.defineProperty($55dec8cb37f14493$exports, "__esModule", {
    value: true
});
$55dec8cb37f14493$exports.NonUniformPromiseSimpleEventList = void 0;
var $da0e685363b37755$exports = {};
"use strict";
Object.defineProperty($da0e685363b37755$exports, "__esModule", {
    value: true
});
$da0e685363b37755$exports.PromiseSimpleEventDispatcher = void 0;

/**
 * The dispatcher handles the storage of subsciptions and facilitates
 * subscription, unsubscription and dispatching of a simple event
 *
 * @export
 * @class PromiseSimpleEventDispatcher
 * @extends {PromiseDispatcherBase<IPromiseSimpleEventHandler<TArgs>>}
 * @implements {IPromiseSimpleEvent<TArgs>}
 * @template TArgs
 */ class $da0e685363b37755$var$PromiseSimpleEventDispatcher extends $3a0124824db7da71$exports.PromiseDispatcherBase {
    /**
     * Creates a new SimpleEventDispatcher instance.
     */ constructor(){
        super();
    }
    /**
     * Dispatches the event.
     * @param args The arguments object.
     * @returns {IPropagationStatus} The status of the dispatch.
     * @memberOf PromiseSimpleEventDispatcher
     */ async dispatch(args) {
        const result = await this._dispatchAsPromise(false, this, arguments);
        if (result == null) throw new $3a0124824db7da71$exports.DispatchError("Got `null` back from dispatch.");
        return result;
    }
    /**
     * Dispatches the event without waiting for it to complete.
     * @param args The argument object.
     * @memberOf PromiseSimpleEventDispatcher
     */ dispatchAsync(args) {
        this._dispatchAsPromise(true, this, arguments);
    }
    /**
     * Creates an event from the dispatcher. Will return the dispatcher
     * in a wrapper. This will prevent exposure of any dispatcher methods.
     */ asEvent() {
        return super.asEvent();
    }
}
$da0e685363b37755$exports.PromiseSimpleEventDispatcher = $da0e685363b37755$var$PromiseSimpleEventDispatcher;


/**
 * Similar to EventList, but instead of TArgs, a map of event names ang argument types is provided with TArgsMap.
 */ class $55dec8cb37f14493$var$NonUniformPromiseSimpleEventList {
    constructor(){
        this._events = {};
    }
    /**
     * Gets the dispatcher associated with the name.
     * @param name The name of the event.
     */ get(name) {
        if (this._events[name]) // @TODO avoid typecasting. Not sure why TS thinks this._events[name] could still be undefined.
        return this._events[name];
        const event = this.createDispatcher();
        this._events[name] = event;
        return event;
    }
    /**
     * Removes the dispatcher associated with the name.
     * @param name The name of the event.
     */ remove(name) {
        delete this._events[name];
    }
    /**
     * Creates a new dispatcher instance.
     */ createDispatcher() {
        return new $da0e685363b37755$exports.PromiseSimpleEventDispatcher();
    }
}
$55dec8cb37f14493$exports.NonUniformPromiseSimpleEventList = $55dec8cb37f14493$var$NonUniformPromiseSimpleEventList;


Object.defineProperty($9db9e770f6e4cf0d$exports, "NonUniformPromiseSimpleEventList", {
    enumerable: true,
    get: function() {
        return $55dec8cb37f14493$exports.NonUniformPromiseSimpleEventList;
    }
});

Object.defineProperty($9db9e770f6e4cf0d$exports, "PromiseSimpleEventDispatcher", {
    enumerable: true,
    get: function() {
        return $da0e685363b37755$exports.PromiseSimpleEventDispatcher;
    }
});
var $40170ad9560e0889$exports = {};
"use strict";
Object.defineProperty($40170ad9560e0889$exports, "__esModule", {
    value: true
});
$40170ad9560e0889$exports.PromiseSimpleEventHandlingBase = void 0;

var $bba3004b06c5ca26$exports = {};
"use strict";
Object.defineProperty($bba3004b06c5ca26$exports, "__esModule", {
    value: true
});
$bba3004b06c5ca26$exports.PromiseSimpleEventList = void 0;


/**
 * Storage class for multiple simple events that are accessible by name.
 * Events dispatchers are automatically created.
 */ class $bba3004b06c5ca26$var$PromiseSimpleEventList extends $3a0124824db7da71$exports.EventListBase {
    /**
     * Creates a new SimpleEventList instance.
     */ constructor(){
        super();
    }
    /**
     * Creates a new dispatcher instance.
     */ createDispatcher() {
        return new $da0e685363b37755$exports.PromiseSimpleEventDispatcher();
    }
}
$bba3004b06c5ca26$exports.PromiseSimpleEventList = $bba3004b06c5ca26$var$PromiseSimpleEventList;


/**
 * Extends objects with signal event handling capabilities.
 */ class $40170ad9560e0889$var$PromiseSimpleEventHandlingBase extends $3a0124824db7da71$exports.HandlingBase {
    constructor(){
        super(new $bba3004b06c5ca26$exports.PromiseSimpleEventList());
    }
}
$40170ad9560e0889$exports.PromiseSimpleEventHandlingBase = $40170ad9560e0889$var$PromiseSimpleEventHandlingBase;


Object.defineProperty($9db9e770f6e4cf0d$exports, "PromiseSimpleEventHandlingBase", {
    enumerable: true,
    get: function() {
        return $40170ad9560e0889$exports.PromiseSimpleEventHandlingBase;
    }
});

Object.defineProperty($9db9e770f6e4cf0d$exports, "PromiseSimpleEventList", {
    enumerable: true,
    get: function() {
        return $bba3004b06c5ca26$exports.PromiseSimpleEventList;
    }
});


Object.defineProperty($6384862cb2bc9a13$exports, "PromiseSimpleEventDispatcher", {
    enumerable: true,
    get: function() {
        return $9db9e770f6e4cf0d$exports.PromiseSimpleEventDispatcher;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "PromiseSimpleEventHandlingBase", {
    enumerable: true,
    get: function() {
        return $9db9e770f6e4cf0d$exports.PromiseSimpleEventHandlingBase;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "PromiseSimpleEventList", {
    enumerable: true,
    get: function() {
        return $9db9e770f6e4cf0d$exports.PromiseSimpleEventList;
    }
});
Object.defineProperty($6384862cb2bc9a13$exports, "NonUniformPromiseSimpleEventList", {
    enumerable: true,
    get: function() {
        return $9db9e770f6e4cf0d$exports.NonUniformPromiseSimpleEventList;
    }
});


var $ece558983632ed02$export$b044ccb39e003d90;
(function(ResponseCode) {
    ResponseCode[ResponseCode[/** Should not be used since suggests uninitialised value. */ "UnknownDoNotUse"] = 0] = "UnknownDoNotUse";
    ResponseCode[ResponseCode[/** Success, duh. */ "Success"] = 1] = "Success";
    ResponseCode[ResponseCode[/** Failure of the operation requested. */ "Failure"] = 2] = "Failure";
    ResponseCode[ResponseCode[/**
	 * This error code should really be more specific.
	 * Should only be used until a more specific error code is added.
	 */ "OtherError"] = 3] = "OtherError";
    ResponseCode[ResponseCode[/** Any parsing or decoding error (such as JSON parsing). */ "ObjectDecodingError"] = 4] = "ObjectDecodingError";
    ResponseCode[ResponseCode[/** The join code supplied does not connect to a game. */ "JoinCodeInvalid"] = 5] = "JoinCodeInvalid";
    ResponseCode[ResponseCode[/** The join code supplied does not work (perhaps the game is full?). */ "JoinCodeNotAllowed"] = 6] = "JoinCodeNotAllowed";
    ResponseCode[ResponseCode[/** No connection to the target available (perhaps the client has disconnected?). */ "ConnectionUnavailable"] = 7] = "ConnectionUnavailable";
    ResponseCode[ResponseCode[/** Device id not known! */ "DeviceIdNotKnown"] = 8] = "DeviceIdNotKnown";
    ResponseCode[ResponseCode[/** Ping-pong response received after timeout. */ "PongTooLate"] = 9] = "PongTooLate";
})($ece558983632ed02$export$b044ccb39e003d90 || ($ece558983632ed02$export$b044ccb39e003d90 = {}));
function $ece558983632ed02$export$1ce4a0e1ecd4fd1(code) {
    return $ece558983632ed02$export$b044ccb39e003d90[code];
}
function $ece558983632ed02$export$fc2e5c0702897c60(...codes) {
    return "[" + codes.map((c)=>`${$ece558983632ed02$export$1ce4a0e1ecd4fd1(c)}:${c}`).join(", ") + "]";
}


var $c9cbdb97f2e17b01$export$dd43557c09bea516;
(function(WebSocketCloseCode) {
    WebSocketCloseCode[WebSocketCloseCode[// See https://tools.ietf.org/html/rfc6455#section-7.4
    "Normal"] = 1000] = "Normal";
    WebSocketCloseCode[WebSocketCloseCode["GoingAway"] = 1001] = "GoingAway";
    WebSocketCloseCode[WebSocketCloseCode["ProtocolError"] = 1002] = "ProtocolError";
    WebSocketCloseCode[WebSocketCloseCode[/** Custom error code for retry */ "ClientConnectionTimeoutRetrying"] = 3003] = "ClientConnectionTimeoutRetrying";
})($c9cbdb97f2e17b01$export$dd43557c09bea516 || ($c9cbdb97f2e17b01$export$dd43557c09bea516 = {}));



/**
 * Unified interface for serialization and deserialization.
 * This prepares us for different deserialization methods in the future (e.g. MsgPack).
 */ class $45cc45bc6ff10c4c$export$ba718fe489b1c39c {
    constructor(){
        this.serialize = (obj, replacer)=>{
            if (!replacer) replacer = this.DefaultReplacer;
            return JSON.stringify(obj, replacer);
        };
        this.deserialize = (obj, reviver)=>{
            if (!reviver) reviver = this.DefaultReplacer;
            return JSON.parse(obj, reviver);
        };
        this.addIgnoredField = (fieldName)=>{
            if (this.IgnoredFields.includes(fieldName)) return;
            this.IgnoredFields.push(fieldName);
        };
        this.removeIgnoredField = (fieldName)=>{
            const index = this.IgnoredFields.indexOf(fieldName);
            if (0 <= index) this.IgnoredFields.splice(index, 1);
        };
        this.DefaultReplacer = (key, value)=>{
            if (this.IgnoredFields.includes(key)) return undefined;
            return value;
        };
        this.IgnoredFields = [
            "_dataObjCached"
        ];
    }
}
const $45cc45bc6ff10c4c$export$fdc2059f5348fd07 = new $45cc45bc6ff10c4c$export$ba718fe489b1c39c();


var $600696615019689e$exports = {};
// https://github.com/maxogden/websocket-stream/blob/48dc3ddf943e5ada668c31ccd94e9186f02fafbd/ws-fallback.js
var $600696615019689e$var$ws = null;
if (typeof WebSocket !== "undefined") $600696615019689e$var$ws = WebSocket;
else if (typeof MozWebSocket !== "undefined") $600696615019689e$var$ws = MozWebSocket;
else if (typeof $parcel$global !== "undefined") $600696615019689e$var$ws = $parcel$global.WebSocket || $parcel$global.MozWebSocket;
else if (typeof window !== "undefined") $600696615019689e$var$ws = window.WebSocket || window.MozWebSocket;
else if (typeof self !== "undefined") $600696615019689e$var$ws = self.WebSocket || self.MozWebSocket;
$600696615019689e$exports = $600696615019689e$var$ws;


class $9203233d15d6efe0$export$98b66c25bb38499d {
    constructor(url, name){
        this.name = name;
        this._onConnected = new (0, $6384862cb2bc9a13$exports.SimpleEventDispatcher)();
        this._onMessage = new (0, $6384862cb2bc9a13$exports.SimpleEventDispatcher)();
        this._onError = new (0, $6384862cb2bc9a13$exports.SimpleEventDispatcher)();
        this._onClose = new (0, $6384862cb2bc9a13$exports.SimpleEventDispatcher)();
        this.succeedWhenConnected = ()=>this.succeedOn($9203233d15d6efe0$export$8ec5a56855ecd7b2.Connected);
        this.succeedWhenClosed = ()=>this.succeedOn($9203233d15d6efe0$export$8ec5a56855ecd7b2.Close);
        this.succeedOn = (criterion)=>{
            // Already in correct state?
            if (conditionMatches(criterion, this.socket.readyState)) return Promise.resolve(new Event(eventNameFromCriterion(criterion)));
            // Otherwise an actual Promise
            return new Promise((resolve, reject)=>{
                const cbConnected = (evt)=>{
                    unsubscribeAll();
                    if ($9203233d15d6efe0$export$8ec5a56855ecd7b2.Connected === criterion) {
                        this.logger.debug("connected = success");
                        resolve(evt);
                    } else {
                        this.logger.debug("connected = fail");
                        reject(evt);
                    }
                };
                const cbError = (evt)=>{
                    unsubscribeAll();
                    if ($9203233d15d6efe0$export$8ec5a56855ecd7b2.Error === criterion) {
                        this.logger.debug("error (event) = success");
                        resolve(evt);
                    } else {
                        this.logger.debug("error (event) = fail");
                        reject(evt);
                    }
                };
                const cbClose = (evt)=>{
                    unsubscribeAll();
                    if ($9203233d15d6efe0$export$8ec5a56855ecd7b2.Close === criterion) {
                        this.logger.debug("closed = success");
                        resolve(evt);
                    } else {
                        this.logger.debug("closed = fail");
                        reject(evt);
                    }
                };
                this.onConnected.subscribe(cbConnected);
                this.onError.subscribe(cbError);
                this.onClose.subscribe(cbClose);
                const unsubscribeAll = ()=>{
                    this.onConnected.unsubscribe(cbConnected);
                    this.onError.unsubscribe(cbError);
                    this.onClose.unsubscribe(cbClose);
                };
            });
            function eventNameFromCriterion(criterion) {
                switch(criterion){
                    case $9203233d15d6efe0$export$8ec5a56855ecd7b2.Connected:
                        return "open";
                    case $9203233d15d6efe0$export$8ec5a56855ecd7b2.Close:
                        return "closed";
                    case $9203233d15d6efe0$export$8ec5a56855ecd7b2.Error:
                        return "error";
                    default:
                        throw new Error(`Unexpected criterion "${criterion}"`);
                }
            }
            function conditionMatches(criterion, readyState) {
                const toMatch = toWebSocketState(criterion);
                function toWebSocketState(criterion) {
                    switch(criterion){
                        case $9203233d15d6efe0$export$8ec5a56855ecd7b2.Connected:
                            return $600696615019689e$exports.OPEN;
                        case $9203233d15d6efe0$export$8ec5a56855ecd7b2.Close:
                            return $600696615019689e$exports.CLOSED;
                        case $9203233d15d6efe0$export$8ec5a56855ecd7b2.Error:
                            return $600696615019689e$exports.CLOSED; // a bit iffy
                    }
                }
                return toMatch === readyState;
            }
        };
        this.sendToServer = async (msg, expectSuccess = false)=>{
            return new Promise((resolve, reject)=>{
                // SEND
                const serialized = (0, $45cc45bc6ff10c4c$export$fdc2059f5348fd07).serialize(msg);
                this.logger.debug("Preparing to send:", serialized);
                this.socket.send(serialized);
                // Would not expect result here since send will not have finished until we return
                // (Do not expect to have received a response after send() since it has not yet sent.
                this.logger.debug("Ready to send.  Setting up transient response listener.");
                const cb = (evt)=>{
                    this.logger.debug("Received (after send):", evt.data);
                    let newResponse;
                    try {
                        newResponse = (0, $45cc45bc6ff10c4c$export$fdc2059f5348fd07).deserialize(evt.data); // assume it's a string since that's what we send
                    // TODO: Validate against a schema?!
                    } catch (e) {
                        this.logger.error(`Failed to deserialize: "${evt.data}"`);
                        this.socket.removeEventListener("message", cb);
                        reject(e); // = rejected
                        return;
                    }
                    if (msg.msgId === newResponse.msgId) {
                        this.logger.debug("Received expected response:", newResponse);
                        this.socket.removeEventListener("message", cb);
                        if (expectSuccess) {
                            if ((0, $ece558983632ed02$export$b044ccb39e003d90).Success !== newResponse.responseCode) {
                                this.logger.warn(this.name, "Response expected success but result is", newResponse.responseCode, "so failing Promise with", newResponse);
                                reject(newResponse); // Reject if failure and expected success
                                return;
                            }
                        }
                        // else
                        this.logger.debug("Response is Success so resolving Promise");
                        resolve(newResponse);
                    } else this.logger.debug("Not the response we are looking for:", newResponse);
                };
                this.socket.addEventListener("message", cb);
            });
        };
        this.sendTextToServer = (data)=>{
            this.logger.debug("Preparing to send:", data);
            this.socket.send(data);
        };
        this.close = (code = (0, $c9cbdb97f2e17b01$export$dd43557c09bea516).Normal, reason)=>{
            // check this.socket.readyState (this.socket.OPEN)
            this.logger.silly("close() socket.state:", this.socket.readyState);
            switch(this.socket.readyState){
                case $600696615019689e$exports.CLOSING:
                case $600696615019689e$exports.CLOSED:
                    return Promise.resolve(new Event("close"));
                case $600696615019689e$exports.CONNECTING:
                    throw new Error("Cannot close a socket that is still connecting!");
                case $600696615019689e$exports.OPEN:
                    break;
                default:
                    throw new Error(`Unexpected state:${this.socket.readyState}`);
            }
            const completionPromise = this.succeedWhenClosed();
            this.socket.close(code, reason);
            return completionPromise;
        };
        this.toString = ()=>{
            return `${this.name} (state:${this.socket.readyState})`;
        };
        this.logger = (0, $7653766080191e46$export$4ac4545211fd8567).build(`${$9203233d15d6efe0$export$98b66c25bb38499d.name}-${name}`);
        this.socket = new $600696615019689e$exports(url);
        if (!name) this.name = url;
        // Connection opened
        this.socket.addEventListener("open", (evt)=>{
            if (this.logger.getLevel() < (0, $7653766080191e46$export$243e62d78d3b544d).Silly) this.logger.debug("Connected");
            else this.logger.silly("Connected", evt);
            this._onConnected.dispatch(evt);
        });
        // Listen for messages
        this.socket.addEventListener("message", (evt)=>{
            if (this.logger.getLevel() < (0, $7653766080191e46$export$243e62d78d3b544d).Silly) this.logger.debug("Received message");
            else this.logger.silly("Received message:", evt.data);
            const data = this.convertData(evt.data);
            this._onMessage.dispatch(data);
        });
        this.socket.addEventListener("error", (evt)=>{
            this.logger.error("Error:", evt);
            this._onError.dispatch(evt);
        });
        this.socket.addEventListener("close", (evt)=>{
            if (this.logger.getLevel() < (0, $7653766080191e46$export$243e62d78d3b544d).Silly) this.logger.debug("Closed");
            else this.logger.silly("Closed:", evt);
            this._onClose.dispatch(evt);
        });
    // These do not get delivered (at least for local WS)
    // this.socket.addEventListener('ping', (evt) => {
    // 	this.logger.log('Ping:', evt);
    // });
    //
    // this.socket.addEventListener('pong', (evt) => {
    // 	this.logger.log('Pong:', evt);
    // });
    }
    get state() {
        return this.socket.readyState;
    }
    get onConnected() {
        return this._onConnected.asEvent();
    }
    get onMessage() {
        return this._onMessage.asEvent();
    }
    get onError() {
        return this._onError.asEvent();
    }
    get onClose() {
        return this._onClose.asEvent();
    }
    convertData(data) {
        switch(typeof data){
            case "object":
                return data;
            case "string":
                const result = (0, $45cc45bc6ff10c4c$export$fdc2059f5348fd07).deserialize(data);
                if ("string" === typeof result) this.logger.error(`Suspicious result from DefaultSerializer.deserialize(${data}) = string '${result}'`);
                return result;
            default:
                throw new Error(`Decoding ${typeof data} is not implemented for "${data}"`);
        }
    }
}
var $9203233d15d6efe0$export$8ec5a56855ecd7b2;
(function(SucceedOn) {
    SucceedOn[SucceedOn["Connected"] = 0] = "Connected";
    SucceedOn[SucceedOn["Close"] = 1] = "Close";
    SucceedOn[SucceedOn["Error"] = 2] = "Error";
})($9203233d15d6efe0$export$8ec5a56855ecd7b2 || ($9203233d15d6efe0$export$8ec5a56855ecd7b2 = {}));
var $9203233d15d6efe0$export$79c97be8e4b361a5;
(function(WebSocketState) {
    WebSocketState[WebSocketState[/** The connection is not yet open. */ "CONNECTING"] = 0] = "CONNECTING";
    WebSocketState[WebSocketState[/** The connection is open and ready to communicate. */ "OPEN"] = 1] = "OPEN";
    WebSocketState[WebSocketState[/** The connection is in the process of closing. */ "CLOSING"] = 2] = "CLOSING";
    WebSocketState[WebSocketState[/** The connection is closed. */ "CLOSED"] = 3] = "CLOSED";
})($9203233d15d6efe0$export$79c97be8e4b361a5 || ($9203233d15d6efe0$export$79c97be8e4b361a5 = {}));


class $6203a972a9ff690c$export$2e2bcd8739ae039 {
    static idIsOutsideReservedRange(msgId) {
        // outside reserved range, return as is
        return msgId < $6203a972a9ff690c$export$2e2bcd8739ae039.MsgReservedMin || $6203a972a9ff690c$export$2e2bcd8739ae039.MsgReservedMax < msgId;
    }
    constructor(msgId){
        this.toString = ()=>`${this.constructor.name}(msgId:${this.msgId}, command:${this.command})`;
        this.msgId = msgId;
    }
    static processSuppliedMsgIdInReservedRangeIntoValue(msgId) {
        // outside reserved range, return as is
        if (this.idIsOutsideReservedRange(msgId)) return msgId;
        switch(msgId){
            case $6203a972a9ff690c$export$2e2bcd8739ae039.MsgIdInvalidToBeOverwritten:
            case $6203a972a9ff690c$export$2e2bcd8739ae039.NoMsgIdMeansError:
                // Known special values get returned as is
                return msgId;
            case $6203a972a9ff690c$export$2e2bcd8739ae039.MsgIdAuto:
            default:
                // auto and default get forced to auto
                return $6203a972a9ff690c$export$2e2bcd8739ae039.MsgIdAuto;
        }
    }
    static #_ = (()=>{
        this.MsgIdAuto = 0;
    })();
    static #_1 = (()=>{
        this.MsgIdInvalidToBeOverwritten = -1;
    })();
    static #_2 = (()=>{
        this.NoMsgIdMeansError = -2;
    })();
    static #_3 = (()=>{
        this.MsgReservedMin = -8;
    })();
    static #_4 = (()=>{
        this.MsgReservedMax = 8;
    })();
}


function $5c3a3c7a2682a2e2$export$3a957106b34c04ba(o) {
    return undefined !== o.msgId && undefined !== o.command;
}





class $abb26e4ba3984e6c$export$66ca603c2dfa0a14 {
    static buildMsgId(msgId) {
        // id increments (positively)
        // Handle number overflow and restarting sequence
        if (Number.MAX_SAFE_INTEGER === $abb26e4ba3984e6c$export$66ca603c2dfa0a14.nextMsgId) $abb26e4ba3984e6c$export$66ca603c2dfa0a14.nextMsgId = (0, $6203a972a9ff690c$export$2e2bcd8739ae039).MsgReservedMax + 1;
        return (0, $6203a972a9ff690c$export$2e2bcd8739ae039).MsgIdAuto !== msgId && (0, $6203a972a9ff690c$export$2e2bcd8739ae039).MsgReservedMax < msgId ? msgId : $abb26e4ba3984e6c$export$66ca603c2dfa0a14.nextMsgId++;
    }
    static #_ = (()=>{
        this.nextMsgId = (0, $6203a972a9ff690c$export$2e2bcd8739ae039).MsgReservedMax + 1;
    })();
}


class $d9c3bcda72478cd8$export$1072ac89ff30a339 extends (0, $6203a972a9ff690c$export$2e2bcd8739ae039) {
}
class $d9c3bcda72478cd8$export$2e2bcd8739ae039 extends $d9c3bcda72478cd8$export$1072ac89ff30a339 {
    constructor(msgId = (0, $6203a972a9ff690c$export$2e2bcd8739ae039).MsgIdAuto){
        super((0, $abb26e4ba3984e6c$export$66ca603c2dfa0a14).buildMsgId((0, $6203a972a9ff690c$export$2e2bcd8739ae039).processSuppliedMsgIdInReservedRangeIntoValue(msgId)));
        this.toString = ()=>`${this.constructor.name}(msgId:${this.msgId}, command:${this.command})`;
    }
}




class $49358498d56ce88d$export$2e2bcd8739ae039 {
    constructor(msgId, responseCode, errorDetails){
        this.toString = ()=>{
            if (this.errorDetails) return `${this.constructor.name}(msgId:${this.msgId}, responseCode:${(0, $ece558983632ed02$export$1ce4a0e1ecd4fd1)(this.responseCode)}(${this.responseCode}), ${this.toStringExtra()} "${this.errorDetails}")`;
            else return `${this.constructor.name}(msgId:${this.msgId}, responseCode:${(0, $ece558983632ed02$export$1ce4a0e1ecd4fd1)(this.responseCode)}(${this.responseCode}) ${this.toStringExtra()})`;
        };
        this.msgId = msgId;
        this.responseCode = responseCode;
        this.errorDetails = errorDetails;
    }
    toStringExtra() {
        return "";
    }
}


class $949c2d101aceae10$export$2e2bcd8739ae039 extends (0, $49358498d56ce88d$export$2e2bcd8739ae039) {
    static buildSuccess(msgId) {
        return new $949c2d101aceae10$export$2e2bcd8739ae039(msgId, (0, $ece558983632ed02$export$b044ccb39e003d90).Success);
    }
    static buildError(msgId, responseCode, errorDetails) {
        return new $949c2d101aceae10$export$2e2bcd8739ae039(msgId, responseCode, errorDetails);
    }
    constructor(msgId, responseCode, errorDetails){
        super(msgId, responseCode, errorDetails);
    }
}





var $aLUwE = parcelRequire("aLUwE");

const $36be9672d514f119$var$SuperParanoidChecks = false;
class $36be9672d514f119$export$2e2bcd8739ae039 {
    static #_ = (()=>{
        this.MaxAttemptsDefault = 8;
    })();
    static nonBlockingUpdateDevice(backingStore, deviceId, updater) {
        return $36be9672d514f119$export$2e2bcd8739ae039.nonBlockingUpdate(async ()=>await backingStore.getDeviceByDeviceId(deviceId), updater, (deviceInner)=>backingStore.updateDevice(deviceInner));
    }
    static nonBlockingUpdateGame(backingStore, joinCode, updater) {
        return $36be9672d514f119$export$2e2bcd8739ae039.nonBlockingUpdate(async ()=>await backingStore.getGameByJoinCode(joinCode), updater, (game)=>backingStore.updateGame(game));
    }
    static nonBlockingUpdateServerMessageIdRecord(backingStore, updater) {
        return $36be9672d514f119$export$2e2bcd8739ae039.nonBlockingUpdate(backingStore.getMessageIdRecord, updater, backingStore.updateRecord);
    }
    /**
	 * Attempt to get, update and put a `T` in a non-blocking algorithm approach (iteratively until success).
	 * @param getItemClosure Closure that gets the item from the database.
	 * @param updateItemClosure Closure that updates the item retrieved from the database.
	 * @param putItemClosure Closure that puts the item back to the database.
	 * @param maxAttempts How many times to try before giving up.
	 */ static async nonBlockingUpdate(getItemClosure, updateItemClosure, putItemClosure, maxAttempts = $36be9672d514f119$export$2e2bcd8739ae039.MaxAttemptsDefault) {
        for(let attempt = 0; attempt < maxAttempts; attempt++){
            $36be9672d514f119$var$Log.silly("1. Get the item");
            let t;
            try {
                t = await getItemClosure();
            } catch (e) {
                $36be9672d514f119$var$Log.error("Failed to get:", e);
                throw e;
            }
            // Log.silly('Got:', JSON.stringify(t));
            $36be9672d514f119$var$Log.silly("2. Update item");
            try {
                updateItemClosure(t);
            } catch (e) {
                $36be9672d514f119$var$Log.error(`nonBlockingUpdate(): updateItemClosure() failed to update ${JSON.stringify(t)}:`, e);
                throw e;
            }
            $36be9672d514f119$var$Log.silly("3. Persist to the store");
            try {
                if (await putItemClosure(t)) {
                    $36be9672d514f119$var$Log.debug(`nonBlockingUpdate() succeeded on attempt ${attempt} for:`, t);
                    if ($36be9672d514f119$var$SuperParanoidChecks) {
                        const t2 = await getItemClosure();
                        $36be9672d514f119$var$Log.debug("nonBlockingUpdate() SuperParanoidChecks after =", t2);
                    }
                    return t;
                }
            } catch (e) {
                $36be9672d514f119$var$Log.error(`Failed to put ${JSON.stringify(t)}:`, e);
                throw e;
            }
        // Loop until success!
        }
        const errMsg = `Failed to nonBlockingUpdate() after ${maxAttempts} so failing`;
        $36be9672d514f119$var$Log.error(errMsg);
        throw errMsg;
    }
}
const $36be9672d514f119$var$Log = (0, $7653766080191e46$export$4ac4545211fd8567).build("DatabaseUtils");


// See `RK-Working-Notes/20220511-ServerAWSConversationNotes.md` for summary table.
var $7337a6838e6b6ed7$export$2edcab8dd1869daa;
(function(RecordType) {
    RecordType[RecordType[/** A device that has not yet declared its type.  Used when devices first connect. */ "NotYetKnown"] = 0] = "NotYetKnown";
    RecordType[RecordType[/** A Game (not a device).  Id is join code. */ "Game"] = 1] = "Game";
    RecordType[RecordType[/** A controller. */ "ControllerDevice"] = 2] = "ControllerDevice";
    RecordType[RecordType[/** The connection of a game. */ "GameDevice"] = 3] = "GameDevice";
    RecordType[RecordType[/**
	 * ConnectionId to DeviceId redirect (because they differ).
	 * Happens when a device disconnects and reconnects.
	 * Before disconnect, the connectionId and deviceId match (so it's fast to query).
	 * After reconnect, this new record redirects us from the new connectionId to the updated deviceId.
	 * N.b. Should not be set for `deviceId`s.
	 */ "RedirectConnectionIdToDeviceId"] = 4] = "RedirectConnectionIdToDeviceId";
    RecordType[RecordType[/**
	 * Server-sent message id numbers are kept distinct by recording last used one in this field.
	 * @see MessageIdFactoryServer
	 */ "ServerMessageIdRecord"] = 5] = "ServerMessageIdRecord";
})($7337a6838e6b6ed7$export$2edcab8dd1869daa || ($7337a6838e6b6ed7$export$2edcab8dd1869daa = {}));
const $7337a6838e6b6ed7$export$f73954576c7789c9 = 432000; // 432000; // 5 days.
const $7337a6838e6b6ed7$export$6eac0361fba0e053 = 10;
const $7337a6838e6b6ed7$export$2de718b62fe03686 = 60;
function $7337a6838e6b6ed7$export$b537a80e67b4967d(roundDown = true) {
    const raw = Date.now() / 1000;
    return roundDown ? Math.floor(raw) : Math.ceil(raw);
}
function $7337a6838e6b6ed7$export$95ceb05b52189d35(roundDown = true) {
    const raw = $7337a6838e6b6ed7$export$b537a80e67b4967d() + $7337a6838e6b6ed7$export$f73954576c7789c9;
    return roundDown ? Math.floor(raw) : Math.ceil(raw);
}
function $7337a6838e6b6ed7$export$ca8d74432be7487f(pingPongTimeoutSeconds) {
    // Important to round *BOTH* (now and total) *up* so fractional pingPongTimeoutSeconds will be more than zero!
    return Math.ceil($7337a6838e6b6ed7$export$b537a80e67b4967d(false) + pingPongTimeoutSeconds);
}
function $7337a6838e6b6ed7$export$4f3ee5f576326bce(joinCodeOrDeviceId) {
    if (!joinCodeOrDeviceId) throw "Null joinCodeOrDeviceId";
    if ("number" === typeof joinCodeOrDeviceId) return joinCodeOrDeviceId;
    if ("string" === typeof joinCodeOrDeviceId) {
        const num = parseInt(joinCodeOrDeviceId);
        if (isNaN(num)) throw `Failed to convert to number, joinCodeOrDeviceId:"${joinCodeOrDeviceId}"`;
        // noinspection ConstantOnRightSideOfComparisonJS -- easier to read this way round
        if (0 <= num || num <= 9999) return num;
        throw `Failed to convert to valid join code number (0000-9999), joinCodeOrDeviceId:"${joinCodeOrDeviceId}"`;
    }
    throw `Failed to convert to join code, joinCodeOrDeviceId:"${joinCodeOrDeviceId}"`;
}
function $7337a6838e6b6ed7$export$8c5c382ed467f380(joinCodeOrDeviceId) {
    if (!joinCodeOrDeviceId) throw "Null joinCodeOrDeviceId";
    if ("string" === typeof joinCodeOrDeviceId) return joinCodeOrDeviceId;
    throw `Failed to convert to device id, joinCodeOrDeviceId:"${joinCodeOrDeviceId}"`;
}



/**
 * Enumeration of valid commands.
 */ var $5928c1920647ce73$export$8cc9b4ffb655d255;
(function(CommandValue) {
    CommandValue["GetDeviceId"] = "GetDeviceId";
    CommandValue["RegisterGame"] = "RegisterGame";
    CommandValue["AddController"] = "AddController";
    CommandValue[/** Permanent disconnect. */ "RemoveDevice"] = "RemoveDevice";
    CommandValue[/** Temporary disconnect. */ "Disconnected"] = "Disconnected";
    CommandValue["Message"] = "Message";
    CommandValue["Ping"] = "Ping";
    CommandValue["Pong"] = "Pong";
    CommandValue["ServerInfo"] = "ServerInfo";
    CommandValue["ServerInfoControllerConnected"] = "ServerInfoControllerConnected";
    CommandValue["ServerInfoControllerDisconnected"] = "ServerInfoControllerDisconnected";
    CommandValue["ServerInfoGameConnected"] = "ServerInfoGameConnected";
    CommandValue["ServerInfoGameDisconnected"] = "ServerInfoGameDisconnected";
    CommandValue["BootDevice"] = "BootDevice";
})($5928c1920647ce73$export$8cc9b4ffb655d255 || ($5928c1920647ce73$export$8cc9b4ffb655d255 = {}));


var $4579d1fd9382140c$export$b5d9228d85ef4461;
(function(ServerInfoCode) {
    ServerInfoCode[ServerInfoCode[/** Should not be used since suggests uninitialised value. */ "UnknownDoNotUse"] = 0] = "UnknownDoNotUse";
    ServerInfoCode[ServerInfoCode[/** New connection info. */ "Connected"] = 1] = "Connected";
    ServerInfoCode[ServerInfoCode[/** Controller connected. */ "ControllerConnected"] = 2] = "ControllerConnected";
    ServerInfoCode[ServerInfoCode[/** Controller disconnected permanently. */ "ControllerDisconnectedPermanently"] = 3] = "ControllerDisconnectedPermanently";
    ServerInfoCode[ServerInfoCode[/** Game disconnected permanently. */ "GameDisconnectedPermanently"] = 4] = "GameDisconnectedPermanently";
    ServerInfoCode[ServerInfoCode[/** Controller disconnected temporarily. */ "ControllerDisconnectedTemporarily"] = 5] = "ControllerDisconnectedTemporarily";
    ServerInfoCode[ServerInfoCode[/** Game disconnected temporarily. */ "GameDisconnectedTemporarily"] = 6] = "GameDisconnectedTemporarily";
    ServerInfoCode[ServerInfoCode[/** Controller reconnected. */ "ControllerReconnected"] = 7] = "ControllerReconnected";
    ServerInfoCode[ServerInfoCode[/** Game reconnected. */ "GameReconnected"] = 8] = "GameReconnected";
})($4579d1fd9382140c$export$b5d9228d85ef4461 || ($4579d1fd9382140c$export$b5d9228d85ef4461 = {}));
function $4579d1fd9382140c$export$c1e4a7cdf5805c66(code) {
    return $4579d1fd9382140c$export$b5d9228d85ef4461[code];
}
function $4579d1fd9382140c$export$3c8fdee56ed004d2(...codes) {
    return "[" + codes.map((c)=>`${$4579d1fd9382140c$export$c1e4a7cdf5805c66(c)}:${c}`).join(", ") + "]";
}








class $1b98b361de1c3ab7$export$2e2bcd8739ae039 extends (0, $6203a972a9ff690c$export$2e2bcd8739ae039) {
    /**
	 * An informational message from the server.
	 *
	 * @param infoCode Code indicating the information conveyed.
	 * @param details Textual explanation on the situation.
	 * @param msgId Optional message Id.
	 *   Automatically generated for new messages and used to correlate with responses.
	 *   Should be unique from a given client.  Globally unique when combined with the device Id.
	 */ constructor(infoCode, details, msgId = (0, $6203a972a9ff690c$export$2e2bcd8739ae039).MsgIdAuto){
        // 2023/01/23 This used to use MessageIdFactoryServer to generate numbers but since we now have to await a database operation,
        // we instead store the auto value then set it to the actual value when it is sent! (See `Outbound`.)
        super((0, $6203a972a9ff690c$export$2e2bcd8739ae039).processSuppliedMsgIdInReservedRangeIntoValue(msgId));
        this.command = (0, $5928c1920647ce73$export$8cc9b4ffb655d255).ServerInfo;
        this.toString = ()=>`${this.constructor.name}(msgId:${this.msgId}, command:${this.command}, infoCode:${(0, $4579d1fd9382140c$export$c1e4a7cdf5805c66)(this.infoCode)}(${this.infoCode}), details:"${this.details}")`;
        this.infoCode = infoCode;
        this.details = details;
    }
    static isMsgInfoFromServer(o) {
        return (0, $5c3a3c7a2682a2e2$export$3a957106b34c04ba)(o) && (0, $5928c1920647ce73$export$8cc9b4ffb655d255).ServerInfo === o.command;
    }
    static buildFromIMessage(o) {
        if (!$1b98b361de1c3ab7$export$2e2bcd8739ae039.isMsgInfoFromServer(o)) {
            const errMsg = `Non-${$1b98b361de1c3ab7$export$2e2bcd8739ae039.name} input supplied: ${(0, $003b09fe89de2289$export$f84e8e69fd4488a5)(o)}`;
            (0, $7653766080191e46$export$2e2bcd8739ae039).error(errMsg);
            throw new Error(errMsg);
        }
        const withMethods = new $1b98b361de1c3ab7$export$2e2bcd8739ae039((0, $4579d1fd9382140c$export$b5d9228d85ef4461).UnknownDoNotUse, "InvalidDataToBeOverwritten", this.MsgIdInvalidToBeOverwritten);
        Object.assign(withMethods, o); // copy `o` over withMethods
        return withMethods;
    }
}





class $4fcde0f79289f5b4$export$2e2bcd8739ae039 extends (0, $1b98b361de1c3ab7$export$2e2bcd8739ae039) {
    /**
	 * An informational message from the server indicating that a controller has connected.
	 *
	 * @param deviceId Which device connected.
	 * @param playerName The name of the player who connected.  Not present when reconnecting.
	 * @param isReconnect True when this message is reconnect.
	 * @param msgId Optional message id.
	 *   Automatically generated for new messages and used to correlate with responses.
	 *   Should be unique from a given client.  Globally unique when combined with the device Id.
	 */ constructor(deviceId, playerName, isReconnect = false, msgId = (0, $6203a972a9ff690c$export$2e2bcd8739ae039).MsgIdAuto){
        super((0, $4579d1fd9382140c$export$b5d9228d85ef4461).ControllerConnected, "", msgId);
        this.command = (0, $5928c1920647ce73$export$8cc9b4ffb655d255).ServerInfoControllerConnected;
        this.toString = ()=>`${this.constructor.name}(msgId:${this.msgId}, command:${this.command}, infoCode:${this.infoCode}, deviceId:${this.deviceId} details:"${this.details}")`;
        this.deviceId = deviceId;
        this.playerName = playerName;
        this.isReconnect = isReconnect;
    }
    static isValid(o) {
        return (0, $5c3a3c7a2682a2e2$export$3a957106b34c04ba)(o) && (0, $5928c1920647ce73$export$8cc9b4ffb655d255).ServerInfoControllerConnected === o.command;
    }
    static buildFromIMessage(o) {
        if (!$4fcde0f79289f5b4$export$2e2bcd8739ae039.isValid(o)) {
            const errMsg = `Non-${$4fcde0f79289f5b4$export$2e2bcd8739ae039.name} input supplied: ${(0, $003b09fe89de2289$export$f84e8e69fd4488a5)(o)}`;
            (0, $7653766080191e46$export$2e2bcd8739ae039).error(errMsg);
            throw new Error(errMsg);
        }
        const withMethods = new $4fcde0f79289f5b4$export$2e2bcd8739ae039(o.deviceId, o.playerName, o.isReconnect, o.msgId);
        // Object.assign(withMethods, o); // copy `o` over withMethods = redundant in this case
        return withMethods;
    }
}



const $7604178d47c4cbae$export$198ce3236b7bb3ba = "NO_PLAYER_NAME";
class $7604178d47c4cbae$export$2e2bcd8739ae039 extends (0, $d9c3bcda72478cd8$export$2e2bcd8739ae039) {
    constructor(joinCode, playerName, msgId = (0, $6203a972a9ff690c$export$2e2bcd8739ae039).MsgIdAuto){
        super(msgId);
        this.command = (0, $5928c1920647ce73$export$8cc9b4ffb655d255).AddController;
        /**
	 * Add a controller to a game.
	 * (1) Update the game with the device,
	 * (2) Update device with the game,
	 * (3) Inform the game and
	 * (4) Inform the controller.
	 */ this.run = async (connectionId, context, postToConnection)=>{
            const backingStore = context.backingStore;
            const device = await backingStore.getDeviceByConnectionId(connectionId); // throws if does not exist
            $7604178d47c4cbae$var$Log.debug(`[${this.msgId}] adding connectionId:${connectionId} = device:${device} to game:${this.joinCode} with playerName:"${this.playerName}"`);
            (0, (/*@__PURE__*/$parcel$interopDefault($aLUwE)))(undefined !== device.connectionId, `addControllerToGame() found no connectionId in ${device}`);
            // Before proceeding to update the Game, validate that it is connected.
            // (we do not allow even temporarily disconnected games to be joined)
            // That said, this only checks we _think_ it is connected -- not that it is actually connected.
            $7604178d47c4cbae$var$Log.debug("1. Update the game with the device (non-blocking loop attempting to update Game in DB)");
            if (!await context.operations.gameIsConnected(this)) return (0, $949c2d101aceae10$export$2e2bcd8739ae039).buildError(this.msgId, (0, $ece558983632ed02$export$b044ccb39e003d90).ConnectionUnavailable, "Game is presently disconnected (temporarily?)");
            $7604178d47c4cbae$var$Log.debug("2. Update the game with the device (non-blocking loop attempting to update Game in DB)");
            const game = await (0, $36be9672d514f119$export$2e2bcd8739ae039).nonBlockingUpdate(// Get
            async ()=>{
                let game;
                try {
                    game = await backingStore.getGameByJoinCode(this.joinCode);
                } catch  {
                /* nop = fall-through */ }
                if (game) return game;
                const errMsg = `Invalid join code "${this.joinCode}" from deviceId:${device}`;
                $7604178d47c4cbae$var$Log.error(errMsg);
                throw (0, $949c2d101aceae10$export$2e2bcd8739ae039).buildError(this.msgId, (0, $ece558983632ed02$export$b044ccb39e003d90).JoinCodeInvalid, errMsg);
            }, // Update
            (game)=>{
                if (!game.addController(device.id, device.connectionId)) {
                    const errMsg = `Device "${device}" failed to join game "${this.joinCode}"`;
                    $7604178d47c4cbae$var$Log.error(errMsg);
                    throw (0, $949c2d101aceae10$export$2e2bcd8739ae039).buildError(this.msgId, (0, $ece558983632ed02$export$b044ccb39e003d90).JoinCodeNotAllowed, errMsg);
                }
            }, // Put
            (game)=>backingStore.updateGame(game));
            $7604178d47c4cbae$var$Log.debug("3. Update device record");
            await (0, $36be9672d514f119$export$2e2bcd8739ae039).nonBlockingUpdate(async ()=>await backingStore.getDeviceByDeviceId(device.id), (device)=>{
                $7604178d47c4cbae$var$Log.silly("Recording that device", device, "is a Controller connected to game", game);
                device.game = game.joinCode;
                device.type = (0, $7337a6838e6b6ed7$export$2edcab8dd1869daa).ControllerDevice;
            }, (device)=>backingStore.updateDevice(device));
            // Store player name for device in case needed by game when reconnecting
            context.operations.setPlayerNameForDeviceId(device.id, this.playerName);
            $7604178d47c4cbae$var$Log.debug("4. Inform the game");
            const result = await context.outbound.sendToDeviceIds([
                game.gameDeviceId
            ], new (0, $4fcde0f79289f5b4$export$2e2bcd8739ae039)(device.id, this.playerName, false), postToConnection);
            if ((0, $ece558983632ed02$export$b044ccb39e003d90).Success === result.responseCode) {
                $7604178d47c4cbae$var$Log.debug("5. Inform the controller");
                return (0, $949c2d101aceae10$export$2e2bcd8739ae039).buildSuccess(this.msgId);
            }
            $7604178d47c4cbae$var$Log.error(`Failed to inform game of controller connected: ${result}`);
            // The rest of this is undoing the database changes.
            $7604178d47c4cbae$var$Log.debug("4e1. Undo Update device record");
            await (0, $36be9672d514f119$export$2e2bcd8739ae039).nonBlockingUpdate(async ()=>await backingStore.getDeviceByDeviceId(device.id), (device)=>{
                $7604178d47c4cbae$var$Log.silly("Recording that device", device, "is a Controller NOT connected to game", game);
                device.game = ""; // blank TODO: Is this the correct way to clear a field?  Perhaps delete field?
                device.type = (0, $7337a6838e6b6ed7$export$2edcab8dd1869daa).ControllerDevice;
            }, (device)=>backingStore.updateDevice(device));
            $7604178d47c4cbae$var$Log.debug("4e2. Undo Update Game record");
            await (0, $36be9672d514f119$export$2e2bcd8739ae039).nonBlockingUpdate(// Get
            async ()=>{
                let game;
                try {
                    game = await backingStore.getGameByJoinCode(this.joinCode);
                } catch  {
                /* nop = fall-through */ }
                if (game) return game;
                const errMsg = `Invalid join code "${this.joinCode}" from deviceId:${device}`;
                $7604178d47c4cbae$var$Log.error(errMsg);
                throw (0, $949c2d101aceae10$export$2e2bcd8739ae039).buildError(this.msgId, (0, $ece558983632ed02$export$b044ccb39e003d90).JoinCodeInvalid, errMsg);
            }, // Update
            (game)=>{
                if (!game.removeController(device.id, device.connectionId)) {
                    const errMsg = `Device "${device}" failed to UN-join game "${this.joinCode}"`;
                    $7604178d47c4cbae$var$Log.error(errMsg);
                    throw (0, $949c2d101aceae10$export$2e2bcd8739ae039).buildError(this.msgId, (0, $ece558983632ed02$export$b044ccb39e003d90).JoinCodeNotAllowed, errMsg);
                }
            }, // Put
            (game)=>backingStore.updateGame(game));
            return (0, $949c2d101aceae10$export$2e2bcd8739ae039).buildError(this.msgId, result.responseCode, result.errorDetails);
        };
        this.toString = ()=>`${this.constructor.name}(msgId:${this.msgId}, command:${this.command}, joinCode:${this.joinCode}, playerName:"${this.playerName}")`;
        this.joinCode = joinCode;
        // Validator now rejects playerName containing 'bad words'.
        // const Filter = require('bad-words');
        // const filter = new Filter();
        // this.playerName = filter.clean(playerName);
        this.playerName = playerName;
    }
    static isMsgAddController(o) {
        return undefined !== o.joinCode && (0, $5c3a3c7a2682a2e2$export$3a957106b34c04ba)(o) && (0, $5928c1920647ce73$export$8cc9b4ffb655d255).AddController === o.command;
    }
    static buildFromIMessage(o) {
        const withMethods = new $7604178d47c4cbae$export$2e2bcd8739ae039((0, $2282782f43399dd4$export$18392905b7dc50), $7604178d47c4cbae$export$198ce3236b7bb3ba, this.MsgIdInvalidToBeOverwritten);
        Object.assign(withMethods, o); // copy `o` over withMethods
        return withMethods;
    }
    buildErrorResponse(responseCode, errorDetails) {
        return (0, $949c2d101aceae10$export$2e2bcd8739ae039).buildError(this.msgId, responseCode, errorDetails);
    }
}
const $7604178d47c4cbae$var$Log = (0, $7653766080191e46$export$4ac4545211fd8567).build($7604178d47c4cbae$export$2e2bcd8739ae039.name);












const $a777eb3b9a183cf7$export$7d240f959e36a4dc = "NO_DEVICE_ID";
function $a777eb3b9a183cf7$export$1e199c838b8c622f(deviceId) {
    $a777eb3b9a183cf7$var$Log.silly("deviceIsValid(", deviceId, ")");
    return undefined !== deviceId && $a777eb3b9a183cf7$export$7d240f959e36a4dc !== deviceId && 0 < deviceId.length;
}
const $a777eb3b9a183cf7$var$Log = (0, $7653766080191e46$export$4ac4545211fd8567).build("DeviceId");



class $6725f8189aaf3ae0$export$2e2bcd8739ae039 extends (0, $49358498d56ce88d$export$2e2bcd8739ae039) {
    static buildSuccess(msgId, deviceId, otherDeviceIds, otherDevicePlayerNames, otherDevicesDisconnected) {
        return new $6725f8189aaf3ae0$export$2e2bcd8739ae039(msgId, (0, $ece558983632ed02$export$b044ccb39e003d90).Success, deviceId, otherDeviceIds, otherDevicePlayerNames, otherDevicesDisconnected);
    }
    static buildError(msgId, responseCode, errorDetails) {
        return new $6725f8189aaf3ae0$export$2e2bcd8739ae039(msgId, responseCode, (0, $a777eb3b9a183cf7$export$7d240f959e36a4dc), [], [], [], errorDetails);
    }
    constructor(msgId, responseCode, deviceId, otherDeviceIds, otherDevicePlayerNames, otherDevicesDisconnected, errorDetails){
        super(msgId, responseCode, errorDetails);
        this.toStringExtra = ()=>{
            return `deviceId:${this.deviceId}`;
        };
        this.deviceId = deviceId;
        this.otherDeviceIds = otherDeviceIds;
        this.otherDevicePlayerNames = otherDevicePlayerNames;
        this.otherDevicesDisconnected = otherDevicesDisconnected;
    }
}




class $2c119e9236f4c4d4$export$2e2bcd8739ae039 extends (0, $d9c3bcda72478cd8$export$2e2bcd8739ae039) {
    constructor(desiredDeviceId, allowReclaimingConnected, msgId = (0, $6203a972a9ff690c$export$2e2bcd8739ae039).MsgIdAuto){
        super(msgId);
        this.desiredDeviceId = desiredDeviceId;
        this.allowReclaimingConnected = allowReclaimingConnected;
        this.command = (0, $5928c1920647ce73$export$8cc9b4ffb655d255).GetDeviceId;
        this.run = async (connectionId, context, postToConnection)=>{
            try {
                const deviceId = await context.operations.getOrAddDeviceForConnectionId(connectionId, postToConnection, this.desiredDeviceId, this.allowReclaimingConnected);
                // Also include info about all other devices in response
                //	(deviceIds, player names and whether temp. disconnected),
                //	which the game client can use to update controller records if needed.
                let otherDeviceIds = [];
                let otherDevicePlayerNames = [];
                let otherDevicesDisconnected = [];
                let game = await context.backingStore.getGameByJoinCode(deviceId.game ?? "", false);
                if (game) for (const controllerDeviceId of game.controllerDeviceIds){
                    if (controllerDeviceId === deviceId.id) continue;
                    otherDeviceIds.push(controllerDeviceId);
                    let playerName = context.operations.getPlayerNameForDeviceId(controllerDeviceId);
                    otherDevicePlayerNames.push(playerName);
                    let device = await context.backingStore.getDeviceByDeviceId(controllerDeviceId);
                    otherDevicesDisconnected.push(device?.disconnected ?? true);
                }
                (0, $7653766080191e46$export$2e2bcd8739ae039).debug(`[${this.msgId}] ConnectionId:${connectionId} = deviceId:${deviceId}`);
                return (0, $6725f8189aaf3ae0$export$2e2bcd8739ae039).buildSuccess(this.msgId, deviceId.id, otherDeviceIds, otherDevicePlayerNames, otherDevicesDisconnected);
            } catch (e) {
                let errorString;
                switch(typeof e){
                    case "string":
                        errorString = e;
                        break;
                    // See WebSocketServer.onConnection
                    // case 'object':
                    // 	const o:object = <object> e;
                    //	if ('responseCode' in o || o instanceof ErrorWithCode) { ... } else ... ?
                    // 	errorString = JSON.stringify(o);
                    // 	break;
                    default:
                        errorString = JSON.stringify(e);
                        break;
                }
                return (0, $6725f8189aaf3ae0$export$2e2bcd8739ae039).buildError(this.msgId, (0, $ece558983632ed02$export$b044ccb39e003d90).Failure, errorString); // TODO: Leaks secret data!
            }
        };
        this.toString = ()=>`${this.constructor.name}(msgId:${this.msgId}, command:${this.command})`;
    }
    static isMsgGetDeviceId(o) {
        return (0, $5c3a3c7a2682a2e2$export$3a957106b34c04ba)(o) && (0, $5928c1920647ce73$export$8cc9b4ffb655d255).GetDeviceId === o.command;
    }
    static buildFromIMessage(o) {
        const withMethods = new $2c119e9236f4c4d4$export$2e2bcd8739ae039(undefined, undefined, this.MsgIdInvalidToBeOverwritten);
        Object.assign(withMethods, o); // copy `o` over withMethods
        return withMethods;
    }
    buildSuccessResponse(deviceId, otherDeviceIds, otherDevicePlayerNames, otherDevicesDisconnected) {
        return (0, $6725f8189aaf3ae0$export$2e2bcd8739ae039).buildSuccess(this.msgId, deviceId, otherDeviceIds, otherDevicePlayerNames, otherDevicesDisconnected);
    }
    buildErrorResponse(responseCode, errorDetails) {
        return (0, $6725f8189aaf3ae0$export$2e2bcd8739ae039).buildError(this.msgId, responseCode, errorDetails);
    }
}









class $b56d79d72faacc82$export$2e2bcd8739ae039 extends (0, $49358498d56ce88d$export$2e2bcd8739ae039) {
    static buildSuccess(msgId, numRecipientsDeliveredTo) {
        return new $b56d79d72faacc82$export$2e2bcd8739ae039(msgId, (0, $ece558983632ed02$export$b044ccb39e003d90).Success, numRecipientsDeliveredTo);
    }
    static buildError(msgId, responseCode, errorDetails) {
        return new $b56d79d72faacc82$export$2e2bcd8739ae039(msgId, responseCode, 0, errorDetails);
    }
    constructor(msgId, responseCode, numRecipientsDeliveredTo, errorDetails){
        super(msgId, responseCode, errorDetails);
        this.toStringExtra = ()=>`numDeliveredTo:${this.numRecipientsDeliveredTo}`;
        // Invalid to use negative recipients or success with zero
        if (0 > numRecipientsDeliveredTo || (0, $ece558983632ed02$export$b044ccb39e003d90).Success === responseCode && 0 === numRecipientsDeliveredTo) {
            const errMsg = `numRecipientsDeliveredTo:${numRecipientsDeliveredTo} and responseCode:${responseCode}`;
            throw new Error(errMsg);
        }
        this.numRecipientsDeliveredTo = numRecipientsDeliveredTo;
    }
}







class $b77ef7ec1849431b$export$2e2bcd8739ae039 extends (0, $d9c3bcda72478cd8$export$2e2bcd8739ae039) {
    static #_ = (()=>{
        /**
	 * Messages received out-of-order are ignored based upon the value associated with this field.
	 * E.g. `state` messages are compared to one another and not with `narrative` messages (which are only compared with other `narrative` messages).
	 * IMPORTANT: Ensure this is kept in-sync with the Game code:
	 * `cooperation.multiturn.messages.connection.Constants.MsgMessage.MsgTopicName`.
	 */ this.MsgTopicName = "meta.message.topic";
    })();
    // TODO-2021/09/26: Better type for `_dataObjCached`?
    /**
	 *
	 * @param data Data to be sent to the recipient(s).
	 * @param joinCode The join code of the game.
	 * @param deviceId Optionally client-supplied sender device Id.
	 *   Valid (as yet) to be -1 (NoDeviceId) and it will be populated by the sender (WebSockets) or inferred by the receiver (P2P).
	 * @param msgId Optional message Id.
	 *   Automatically generated for new messages and used to correlate with responses.
	 *   Should be unique from a given client.  Globally unique when combined with the device Id.
	 */ constructor(data, joinCode, deviceId = (0, $a777eb3b9a183cf7$export$7d240f959e36a4dc), msgId = (0, $6203a972a9ff690c$export$2e2bcd8739ae039).MsgIdAuto){
        super(msgId);
        this.command = (0, $5928c1920647ce73$export$8cc9b4ffb655d255).Message;
        /**
	 * On the server, this is called by `RoutingServer.processMessage()` to perform the message.
	 */ this.run = async (connectionId, context, postToConnection)=>{
            if ((0, $a777eb3b9a183cf7$export$7d240f959e36a4dc) === this.deviceId) try {
                const device = await context.backingStore.getDeviceByConnectionId(connectionId); // throws if undefined
                this.deviceId = device.id;
            } catch (e) {
                // Error if unknown.  (impossible atm since uses ConnectionId for deviceId but future reconnect code ...)
                return (0, $b56d79d72faacc82$export$2e2bcd8739ae039).buildError(this.msgId, (0, $ece558983632ed02$export$b044ccb39e003d90).Failure, `No known deviceId for this connection for ${this}`);
            }
            const game = await context.backingStore.getGameByJoinCode(this.joinCode);
            if (!game) return (0, $b56d79d72faacc82$export$2e2bcd8739ae039).buildError(this.msgId, (0, $ece558983632ed02$export$b044ccb39e003d90).Failure, `Failed to find game "${this.joinCode}" for ${this}`);
            // Do the actual send of the message.
            return context.outbound.sendToOthersForSenderDeviceId(game, this.deviceId, this, postToConnection);
        };
        /**
	 * Get the data as decoded into an object.
	 * Caches the result to allow multiple uses without re-parsing or passing around.
	 * Uses `DefaultSerializer` to prepare for different deserialization methods in the future (e.g. MsgPack).
	 */ this.getDataDecoded = ()=>{
            if (this._dataObjCached) return this._dataObjCached;
            try {
                return this._dataObjCached = (0, $45cc45bc6ff10c4c$export$fdc2059f5348fd07).deserialize(this.data);
            } catch (e) {
                //infoView.error('Failed to parse message from Game due to:', e, 'message was:', this);
                return undefined;
            }
        };
        this.toString = ()=>`${this.constructor.name}(msgId:${this.msgId}, command:${this.command}, joinCode:${this.joinCode}, deviceId?:${this.deviceId}, data:${this.data})`;
        this.data = data;
        this.joinCode = joinCode;
        this.deviceId = deviceId;
        if ("string" !== typeof data) {
            const errMsg = `Non-string 'data' supplied in ${this}`; // TODO: Better error
            $b77ef7ec1849431b$var$Log.error(errMsg);
            throw new Error(errMsg);
        }
    }
    static isMsgMessage(o) {
        // deviceId is optional so omitted below
        return undefined !== o.data && "string" === typeof o.data && (0, $5c3a3c7a2682a2e2$export$3a957106b34c04ba)(o) && (0, $5928c1920647ce73$export$8cc9b4ffb655d255).Message === o.command;
    }
    static buildFromIMessage(o) {
        if (!$b77ef7ec1849431b$export$2e2bcd8739ae039.isMsgMessage(o)) {
            const errMsg = `Non-${$b77ef7ec1849431b$export$2e2bcd8739ae039.name} input supplied: ${JSON.stringify(o)}`;
            $b77ef7ec1849431b$var$Log.error(errMsg);
            throw new Error(errMsg);
        }
        const withMethods = new $b77ef7ec1849431b$export$2e2bcd8739ae039("InvalidDataToBeOverwritten", (0, $2282782f43399dd4$export$18392905b7dc50), (0, $a777eb3b9a183cf7$export$7d240f959e36a4dc), this.MsgIdInvalidToBeOverwritten);
        Object.assign(withMethods, o); // copy `o` over withMethods
        return withMethods;
    }
    buildErrorResponse(responseCode, errorDetails) {
        return (0, $b56d79d72faacc82$export$2e2bcd8739ae039).buildError(this.msgId, responseCode, errorDetails);
    }
}
const $b77ef7ec1849431b$var$Log = (0, $7653766080191e46$export$4ac4545211fd8567).build($b77ef7ec1849431b$export$2e2bcd8739ae039.name);











class $07accd22d495465f$export$2e2bcd8739ae039 extends (0, $49358498d56ce88d$export$2e2bcd8739ae039) {
    static buildSuccess(msgId) {
        return new $07accd22d495465f$export$2e2bcd8739ae039(msgId, (0, $ece558983632ed02$export$b044ccb39e003d90).Success);
    }
    static buildError(msgId, responseCode, errorDetails) {
        return new $07accd22d495465f$export$2e2bcd8739ae039(msgId, responseCode, errorDetails);
    }
    constructor(msgId, responseCode, errorDetails){
        super(msgId, responseCode, errorDetails);
    }
}





class $fbd3986847477f13$export$2e2bcd8739ae039 extends (0, $d9c3bcda72478cd8$export$2e2bcd8739ae039) {
    /**
	 * A 'pong' from a *client* which should result in `MsgResponsePong`.
	 * (Server responds to client `MsgPing`s via `MsgResponsePong`.)
	 *
	 * @param msgId Optional message Id.
	 *   Automatically generated for new messages and used to correlate with responses.
	 *   Should be unique from a given client.  Globally unique when combined with the device Id.
	 */ constructor(msgId = (0, $6203a972a9ff690c$export$2e2bcd8739ae039).MsgIdAuto){
        super((0, $abb26e4ba3984e6c$export$66ca603c2dfa0a14).buildMsgId((0, $6203a972a9ff690c$export$2e2bcd8739ae039).processSuppliedMsgIdInReservedRangeIntoValue(msgId)));
        this.command = (0, $5928c1920647ce73$export$8cc9b4ffb655d255).Pong;
        this.run = async (connectionId, context, postToConnection)=>{
            (0, $7653766080191e46$export$2e2bcd8739ae039).debug(`[${this.msgId}] ConnectionId:${connectionId} PONG`);
            const success = await context.operations.pongReceivedFrom(connectionId, this.msgId);
            return success ? (0, $07accd22d495465f$export$2e2bcd8739ae039).buildSuccess(this.msgId) : (0, $07accd22d495465f$export$2e2bcd8739ae039).buildError(this.msgId, (0, $ece558983632ed02$export$b044ccb39e003d90).PongTooLate, "Too slow to respond to ping = connection lost.");
        };
        this.toString = ()=>`${this.constructor.name}(msgId:${this.msgId}, command:${this.command})`;
    }
    static isMsgPong(o) {
        return (0, $5c3a3c7a2682a2e2$export$3a957106b34c04ba)(o) && (0, $5928c1920647ce73$export$8cc9b4ffb655d255).Pong === o.command;
    }
    static buildFromIMessage(o) {
        if (!$fbd3986847477f13$export$2e2bcd8739ae039.isMsgPong(o)) {
            const errMsg = `Non-${$fbd3986847477f13$export$2e2bcd8739ae039.name} input supplied: ${JSON.stringify(o)}`;
            (0, $7653766080191e46$export$2e2bcd8739ae039).error(errMsg);
            throw new Error(errMsg);
        }
        const withMethods = new $fbd3986847477f13$export$2e2bcd8739ae039(this.MsgIdInvalidToBeOverwritten);
        Object.assign(withMethods, o); // copy `o` over withMethods
        return withMethods;
    }
    buildSuccessResponse() {
        return (0, $07accd22d495465f$export$2e2bcd8739ae039).buildSuccess(this.msgId);
    }
    buildErrorResponse(responseCode, errorDetails) {
        return (0, $07accd22d495465f$export$2e2bcd8739ae039).buildError(this.msgId, responseCode, errorDetails);
    }
}







class $9357ad5b53ef7d7d$export$2e2bcd8739ae039 extends (0, $49358498d56ce88d$export$2e2bcd8739ae039) {
    static buildSuccess(msgId) {
        return new $9357ad5b53ef7d7d$export$2e2bcd8739ae039(msgId, (0, $ece558983632ed02$export$b044ccb39e003d90).Success);
    }
    static buildError(msgId, responseCode, errorDetails) {
        return new $9357ad5b53ef7d7d$export$2e2bcd8739ae039(msgId, responseCode, errorDetails);
    }
    constructor(msgId, responseCode, errorDetails){
        super(msgId, responseCode, errorDetails);
    }
}











class $3344fb9994b43b72$export$2e2bcd8739ae039 extends (0, $1b98b361de1c3ab7$export$2e2bcd8739ae039) {
    /**
	 * An informational message from the server indicating that a controller has disconnected.
	 *
	 * @param deviceId Which device disconnected.
	 * @param permanent Whether permanent (true) or temporary (false) disconnection.
	 * @param details Textual explanation on the situation.
	 * @param msgId Optional message Id.
	 *   Automatically generated for new messages and used to correlate with responses.
	 *   Should be unique from a given client.  Globally unique when combined with the device Id.
	 */ constructor(deviceId, permanent, details, msgId = (0, $6203a972a9ff690c$export$2e2bcd8739ae039).MsgIdAuto){
        super(permanent ? (0, $4579d1fd9382140c$export$b5d9228d85ef4461).ControllerDisconnectedPermanently : (0, $4579d1fd9382140c$export$b5d9228d85ef4461).ControllerDisconnectedTemporarily, details, msgId);
        this.command = (0, $5928c1920647ce73$export$8cc9b4ffb655d255).ServerInfoControllerDisconnected;
        this.toString = ()=>`${this.constructor.name}(msgId:${this.msgId}, command:${this.command}, infoCode:${this.infoCode}, deviceId:${this.deviceId} details:"${this.details}")`;
        this.deviceId = deviceId;
    }
    static isValid(o) {
        return (0, $5c3a3c7a2682a2e2$export$3a957106b34c04ba)(o) && (0, $5928c1920647ce73$export$8cc9b4ffb655d255).ServerInfoControllerDisconnected === o.command;
    }
    static buildFromIMessage(o) {
        if (!$3344fb9994b43b72$export$2e2bcd8739ae039.isValid(o)) {
            const errMsg = `Non-${$3344fb9994b43b72$export$2e2bcd8739ae039.name} input supplied: ${(0, $003b09fe89de2289$export$f84e8e69fd4488a5)(o)}`;
            (0, $7653766080191e46$export$2e2bcd8739ae039).error(errMsg);
            throw new Error(errMsg);
        }
        const withMethods = new $3344fb9994b43b72$export$2e2bcd8739ae039(o.deviceId, false, "TO_BE_OVERWRITTEN", o.msgId);
        Object.assign(withMethods, o); // copy `o` over withMethods
        return withMethods;
    }
}





class $326eb2a386b47c26$export$2e2bcd8739ae039 extends (0, $d9c3bcda72478cd8$export$2e2bcd8739ae039) {
    constructor(msgId = (0, $6203a972a9ff690c$export$2e2bcd8739ae039).MsgIdAuto){
        super(msgId);
        this.command = (0, $5928c1920647ce73$export$8cc9b4ffb655d255).RemoveDevice;
        /**
	 * Permanently disconnect a device, tidying-up all records and informing peers of removal.
	 */ this.run = async (connectionId, context, postToConnection)=>{
            try {
                $326eb2a386b47c26$var$Log.debug(`[${this.msgId}] Permanently disconnecting ConnectionId:${connectionId}`);
                await context.operations.doConnectionClosure(connectionId, postToConnection, async (device, game)=>{
                    // Controller
                    $326eb2a386b47c26$var$Log.debug("Inform Game that a controller disconnected using MsgInfoFromServer");
                    const msg = new (0, $3344fb9994b43b72$export$2e2bcd8739ae039)(device.id, true, `Controller disconnected ${device} permanently`);
                    // Inform the device that disconnected of its own disconnection - e.g. if the player left multiple controller
                    //	tabs open and hence a connection has been left open, it'll notify the player on receiving this
                    await context.outbound.sendToDeviceIds([
                        device.id
                    ], msg, postToConnection);
                    const result = await context.outbound.sendToDeviceIds([
                        game.gameDeviceId
                    ], msg, postToConnection);
                    if ((0, $ece558983632ed02$export$b044ccb39e003d90).Success !== result.responseCode) $326eb2a386b47c26$var$Log.error("Failed to send controller", device, "disconnect message to game", game);
                    // Remove from game -- is actually done by deleteDeviceId() so skip redoing
                    // await this.backingStore.removeDeviceFromGame(game.joinCode, deviceId);
                    await context.backingStore.deleteDevice(device.id);
                }, async (device, game)=>{
                    // Game
                    if (0 !== game.controllerDeviceIds.length) {
                        $326eb2a386b47c26$var$Log.debug("Inform controllers that Game has disconnected using MsgInfoFromServer");
                        const msg = new (0, $1b98b361de1c3ab7$export$2e2bcd8739ae039)((0, $4579d1fd9382140c$export$b5d9228d85ef4461).GameDisconnectedPermanently, "Game disconnected permanently");
                        const result = await context.outbound.sendToDeviceIds(game.controllerDeviceIds, msg, postToConnection);
                        if ((0, $ece558983632ed02$export$b044ccb39e003d90).Success !== result.responseCode) $326eb2a386b47c26$var$Log.warn(`Failed to send game (permanent) disconnect message to controllers due to ${result}`);
                    }
                    // Remove data
                    // Remove device but tell it not to try to check for being in a game (since we know it's the Game's device)
                    await context.backingStore.deleteDevice(device.id, false);
                    await context.backingStore.deleteGame(game);
                });
                $326eb2a386b47c26$var$Log.debug(`[${this.msgId}] Permanently disconnected ConnectionId:${connectionId}`);
                return (0, $9357ad5b53ef7d7d$export$2e2bcd8739ae039).buildSuccess(this.msgId);
            } catch (e) {
                let errorString;
                switch(typeof e){
                    case "string":
                        errorString = e;
                        break;
                    default:
                        errorString = JSON.stringify(e);
                        break;
                }
                return (0, $9357ad5b53ef7d7d$export$2e2bcd8739ae039).buildError(this.msgId, (0, $ece558983632ed02$export$b044ccb39e003d90).Failure, errorString); // TODO: Leaks secret data!
            }
        };
        this.toString = ()=>`${this.constructor.name}(msgId:${this.msgId}, command:${this.command})`;
    }
    static isMsgDisconnectDevicePermanently(o) {
        return (0, $5c3a3c7a2682a2e2$export$3a957106b34c04ba)(o) && (0, $5928c1920647ce73$export$8cc9b4ffb655d255).RemoveDevice === o.command;
    }
    static buildFromIMessage(o) {
        const withMethods = new $326eb2a386b47c26$export$2e2bcd8739ae039();
        Object.assign(withMethods, o); // copy `o` over withMethods
        return withMethods;
    }
    buildSuccessResponse() {
        return (0, $9357ad5b53ef7d7d$export$2e2bcd8739ae039).buildSuccess(this.msgId);
    }
    buildErrorResponse(responseCode, errorDetails) {
        return (0, $9357ad5b53ef7d7d$export$2e2bcd8739ae039).buildError(this.msgId, responseCode, errorDetails);
    }
}
const $326eb2a386b47c26$var$Log = (0, $7653766080191e46$export$4ac4545211fd8567).build($326eb2a386b47c26$export$2e2bcd8739ae039.name);





var $aLUwE = parcelRequire("aLUwE");
class $1e9f9fda8df65d24$export$649b280af6458229 {
    /**
	 * Construct a new GameProxy.
	 * @param desiredDeviceId Optionally request this `DeviceId`.
	 * @param previousJoinCode Optionally provide the joinCode.
	 * 		Needed when reconnecting with a game for the MsgMessages sent to be valid.
	 * @param sessionIndex The index of this session (for logging).
	 * @param wsUrl The WebSocketServer URL to connect to.
	 */ constructor(desiredDeviceId, previousJoinCode, sessionIndex, wsUrl){
        this.sessionIndex = sessionIndex;
        this.connect = ()=>{
            // If not NotConnected (which means first connection)
            // and not AwaitingReconnect (which means we haven't yet started reconnecting)
            // THEN we skip connecting.  The implication is we already started reconnecting!
            if ($1e9f9fda8df65d24$export$7254cc27399e90bd.NotConnected !== this._state && $1e9f9fda8df65d24$export$7254cc27399e90bd.AwaitingReconnect !== this._state) {
                this.logger.silly("already connecting");
                return Promise.resolve();
            }
            this.reconnectCount++;
            return new Promise((resolve)=>{
                this.logger.log(`Connecting to server (from state:${this._state}, reconnectNum:${this.reconnectCount})`);
                // Tidy previous connection if set
                if (this.connection) {
                    // TODO-20230106: Should we (a) test connection is disconnected? (we'd need to add status checking code)
                    this.connection.onConnected.unsubscribe(this.onConnectedEvent);
                    this.connection.onMessage.unsubscribe(this.onMessage);
                    this.connection.onClose.unsubscribe(this.onConnectionCloseOrErrorEvent);
                    this.connection.onError.unsubscribe(this.onConnectionCloseOrErrorEvent);
                }
                this._state = $1e9f9fda8df65d24$export$7254cc27399e90bd.Connecting;
                // Try initial connection.  Most of the time, this will succeed.
                // DNS problems can result in hang.  Network issues can result in error.
                // When the event occurs (close/error), it is received and reconnect attempted.
                this.logger.silly("connect(): START");
                if (!this.firstPromiseResolve) {
                    this.logger.log("First time connection = promise stashed to resolve later");
                    this.firstPromiseResolve = resolve;
                }
                this.connection = new (0, $9203233d15d6efe0$export$98b66c25bb38499d)(this.wsUrl, `(s${this.sessionIndex},c${this.reconnectCount})(${this.wsUrl})`);
                this.connection.onConnected.one(async (evt)=>{
                    this._state = $1e9f9fda8df65d24$export$7254cc27399e90bd.Connected;
                    this.logger.silly("connect(): CONNECTED. evt:", evt);
                    this.logger.log(`Connected ${this.connection?.name}.`);
                    // We get new deviceId or reconnect with our previous one
                    // This will throw Error if failure but we let that cancel everything and fall out
                    await this.getDeviceIdNewOrExisting();
                    if (undefined === this.deviceId) {
                        const errMsg = "No deviceId found after getDeviceIdNewOrExisting()";
                        this.logger.error(errMsg);
                        throw new Error(errMsg);
                    }
                    // Make sure we use the original resolve if such we have
                    const resolveToUse = this.firstPromiseResolve ?? resolve;
                    this.firstPromiseResolve = undefined;
                    // We'll do the onConnected Event before resolving the Promise in hopes of making user life easier (but maybe it would be OK after?)
                    this.onConnectedEvent(evt);
                    resolveToUse();
                });
                // 2. Ongoing registration to detect future failure and inform the game
                this.connection.onClose.subscribe(this.onConnectionCloseOrErrorEvent);
                this.connection.onError.subscribe(this.onConnectionCloseOrErrorEvent);
                // 3. Ongoing registration for messages
                this.connection.onMessage.subscribe(this.onMessage);
            });
        };
        this.closeConnection = async (sendPermanentDisconnectLeaveGame = false, code = (0, $c9cbdb97f2e17b01$export$dd43557c09bea516).Normal, reason)=>{
            this._state = $1e9f9fda8df65d24$export$7254cc27399e90bd.Closing;
            // If timer for reconnect, cancel it!
            if (this.reconnectTimer) {
                this.logger.log("Cancelling reconnect timer");
                clearTimeout(this.reconnectTimer);
                this.reconnectTimer = undefined;
            }
            if (!this.connection) {
                this.logger.silly(`No connection so skipping closing for session ${this.sessionIndex}`);
                this._state = $1e9f9fda8df65d24$export$7254cc27399e90bd.Closed;
                return;
            }
            if (sendPermanentDisconnectLeaveGame && this.connection.state == (0, $9203233d15d6efe0$export$79c97be8e4b361a5).OPEN) {
                this.logger.log(`Permanently (leaving game) disconnecting ${this.connection}`);
                await this.connection.sendToServer(new (0, $326eb2a386b47c26$export$2e2bcd8739ae039)());
            }
            this.logger.log(`closing ${this.connection}`);
            this.connection.onClose.clear();
            this.connection.onError.clear();
            this.connection.onMessage.clear();
            this.connection.onConnected.clear();
            // Copy and wipe before closing so nothing tries to send after here.
            const connection = this.connection;
            this.connection = undefined;
            try {
                await connection.close(code, reason);
                this._state = $1e9f9fda8df65d24$export$7254cc27399e90bd.Closed;
                this.logger.silly("closeConnection(): CLOSED");
            } catch (e) {
                this.logger.warn("Closing caused error:", e);
            }
        };
        this.getDeviceIdNewOrExisting = async ()=>{
            $aLUwE(this.connection);
            this.logger.log(`Getting deviceId: ${this._deviceId ?? "(new)"}...`);
            let errMsg;
            try {
                $aLUwE(this.connection);
                this.logger.silly("getDeviceIdNewOrExisting() current deviceId:", this._deviceId);
                const response = await this.connection.sendToServer(new (0, $2c119e9236f4c4d4$export$2e2bcd8739ae039)(this._deviceId, this.previousDeviceId !== undefined));
                if ((0, $ece558983632ed02$export$b044ccb39e003d90).Success === response.responseCode) {
                    // Success
                    if (this._deviceId) {
                        // Success with previously-requested deviceId
                        if (this._deviceId === response.deviceId) {
                            this.logger.log(`Successfully reconnected with deviceId:${this.deviceId} (previous:${this.previousDeviceId} = updating to new now)`);
                            // Reset previous to this new one so future reconnects (checking `didRejoinPreviousSession`) know we reconnected
                            this.previousDeviceId = response.deviceId;
                            return;
                        } else if ((0, $a777eb3b9a183cf7$export$1e199c838b8c622f)(response.deviceId)) {
                            this.logger.warn(`Failed to reconnect with previous deviceId (was "${this._deviceId}", now "${response.deviceId}")`);
                            this._deviceId = response.deviceId;
                            // TODO-20230209: Controller should handle failure to reconnect with previous deviceId!
                            return;
                        } else {
                            errMsg = `Received invalid deviceId:"${response.deviceId}"`;
                            this.logger.warn(errMsg);
                        }
                    } else // Success with no previously-requested deviceId
                    if ((0, $a777eb3b9a183cf7$export$1e199c838b8c622f)(response.deviceId)) {
                        this._deviceId = response.deviceId;
                        // (not assigning `previousDeviceId` here since that tells `didRejoinPreviousSession` that we rejoined and don't need certain info)
                        this.logger.log(`Successfully got new deviceId ${this.deviceId}`);
                        return;
                    } else {
                        errMsg = `Received invalid deviceId:"${response.deviceId}"`;
                        this.logger.warn(errMsg);
                    }
                } else {
                    // Failure getting DeviceId! (with or without requesting one)
                    this.logger.error(`Failed to get deviceId (leaving current deviceId ${this._deviceId}): ${(0, $003b09fe89de2289$export$f84e8e69fd4488a5)(response)}`);
                    errMsg = "Failed to get deviceId = retry";
                }
            } catch (e) {
                // Error getting DeviceId! (with or without requesting one)
                this.logger.error(`Error getting deviceId: ${(0, $003b09fe89de2289$export$f84e8e69fd4488a5)(e)}`);
                errMsg = "Error getting deviceId = retry";
            }
            throw new Error(errMsg);
        };
        this.setCurrentJoinCode = (newJoinCode)=>{
            this.logger.log(`Setting joinCode:'${newJoinCode}'`);
            $aLUwE.ok((0, $2282782f43399dd4$export$3636fa6b664761ad)(newJoinCode), newJoinCode);
            this.joinCode = newJoinCode;
            this._onJoinCodeSet.dispatch(newJoinCode);
        };
        this.sendTurnSetAndReady = async (turnSet)=>{
            this.logger.log(`Sending ${turnSet}`);
            const data = `{
	"commands": [ 
		{
			"command": "MultiTurn.setTurns",
			"turns":${turnSet.toJSON()}
		},
		{
			"command": "MultiTurn.ready",
			"ready": true,
		}
	]
}`;
            await this.sendToGameAndWait(data);
        };
        this.sendAutoReady = async (autoReadyEnabled)=>{
            const data = `{
	"command": "MultiTurn.autoReady",
	"autoReady": ${autoReadyEnabled}
}`;
            await this.sendToGameAndWait(data);
        };
        this.sendItemManagementResultsAndReady = async (itemManagementData, characterIndex)=>{
            const itemsJSONSection = itemManagementData.itemsToPartialJSON();
            const data = `{
	"command": "MultiTurn.controllerModMessage",
	"controller.itemVoteResults": "",
	${itemsJSONSection}${itemsJSONSection != "" ? "," : ""}
	"characterIndex": ${characterIndex}
}`;
            await this.sendToGameAndWait(data);
            await this.sendReadyState(true);
        };
        this.sendNarrativeCharacterText = async (characterWritingData)=>{
            const data = {
                command: "MultiTurn.controllerModMessage",
                "controller.narrativeCharacterText": "",
                characterInternalName: characterWritingData.selectedCharacterInternalName,
                characterDisplayName: characterWritingData.selectedCharacterDisplayName,
                mainText: characterWritingData.selectedCharacterText
            };
            await this.sendToGameAndWait(JSON.stringify(data));
        };
        this.sendCharacterSelectRequest = async (characterIndex)=>{
            this.logger.log(`Requesting character selection: ${characterIndex}`);
            const data = `{
	"meta.select.requestCharacter": "${characterIndex}"
}`;
            await this.sendToGameAndWait(data);
        };
        this.sendNonCharacterSelectRequest = async ()=>{
            this.logger.log(`Requesting selection for any available non-character`);
            const data = `{
	"meta.select.requestNonCharacter": ""
}`;
            await this.sendToGameAndWait(data);
        };
        this.sendReadyState = async (ready)=>{
            const readyData = `{
	"command": "MultiTurn.ready",
	"ready": ${ready},
}`;
            await this.sendToGameAndWait(readyData);
        };
        this.joinGame = async (joinCode, playerName)=>{
            $aLUwE(this.connection);
            this.logger.log("Registering controller:");
            let response;
            try {
                response = await this.connection.sendToServer(new (0, $7604178d47c4cbae$export$2e2bcd8739ae039)(joinCode, playerName));
            } catch (e) {
                if (!e) throw new $1e9f9fda8df65d24$var$JoinError((0, $ece558983632ed02$export$b044ccb39e003d90).OtherError, "Unknown error!");
                else if ("object" === typeof e) {
                    // && e instanceof MsgAddControllerResponse) { // TODO: Or it might be a MsgResponseConnectionIdNotFound
                    const errResponse = e;
                    throw new $1e9f9fda8df65d24$var$JoinError(errResponse.responseCode, errResponse.errorDetails);
                } else throw e;
            }
            this.logger.log("Register controller response:", response);
            if ((0, $ece558983632ed02$export$b044ccb39e003d90).Success !== response.responseCode) throw new $1e9f9fda8df65d24$var$JoinError(response.responseCode, response.errorDetails);
        // else success
        };
        this.sendToGameAndWait = async (data, whileWaiting = $1e9f9fda8df65d24$var$WhileWaiting.DisableInput)=>{
            //assert(this.connection, 'No connection'); // TODO-20240424 this error does not appear.  Instead get `{"generatedMessage":false,"code":"ERR_ASSERTION","expected":true,"operator":"=="}`
            if (!this.connection) throw new $1e9f9fda8df65d24$var$MsgError((0, $ece558983632ed02$export$b044ccb39e003d90).ConnectionUnavailable, "No connection");
            this.logger.log(`Sending data: ${data}`);
            this._onStartSendingToGame.dispatch();
            this.doWhileWaiting(true, whileWaiting);
            let response;
            try {
                $aLUwE((0, $2282782f43399dd4$export$3636fa6b664761ad)(this.joinCode), this.joinCode);
                response = await this.connection.sendToServer(new (0, $b77ef7ec1849431b$export$2e2bcd8739ae039)(data, this.joinCode));
            } catch (e) {
                if (!e) {
                    const errMsg = `Unknown error sending data:${data}`;
                    this.logger.log(errMsg);
                    throw new $1e9f9fda8df65d24$var$MsgError((0, $ece558983632ed02$export$b044ccb39e003d90).OtherError, errMsg);
                } else if ("object" === typeof e) {
                    const errResponse = e;
                    const errMsg = `${errResponse.errorDetails} while sending data:${data}`;
                    this.logger.log(errMsg);
                    throw new $1e9f9fda8df65d24$var$MsgError(errResponse.responseCode, errMsg);
                } else {
                    this.logger.log(e);
                    throw e;
                }
            } finally{
                this.doWhileWaiting(false, whileWaiting);
                this._onDoneOrFailSendingToGame.dispatch();
            }
            // (async response received from send)
            this.logger.log(`Response to data:${data} :`, response);
            if ((0, $ece558983632ed02$export$b044ccb39e003d90).Success !== response.responseCode) throw new $1e9f9fda8df65d24$var$MsgError(response.responseCode, response.errorDetails);
        // else success
        };
        this.onConnectionCloseOrErrorEvent = (evt)=>{
            // Not an error -- just informative since we will try to reconnect
            this.logger.log("Closed:", evt, "connection:", this.connection);
            if (undefined === this.connection) {
                this.logger.log("Reconnection already scheduled");
                return;
            }
            switch(this.connection.state){
                case (0, $9203233d15d6efe0$export$79c97be8e4b361a5).OPEN:
                case (0, $9203233d15d6efe0$export$79c97be8e4b361a5).CONNECTING:
                    this.logger.log("already reconnecting/reconnected");
                    return;
            }
            switch(this._state){
                case $1e9f9fda8df65d24$export$7254cc27399e90bd.Closing:
                case $1e9f9fda8df65d24$export$7254cc27399e90bd.Closed:
                    this.logger.log("Instructed to close so not reconnecting");
                    return;
            }
            this.logger.log(`Reconnecting automatically in ${this.pauseBetweenReconnects}ms for ${this.connection}`);
            this.connection = undefined;
            this._state = $1e9f9fda8df65d24$export$7254cc27399e90bd.AwaitingReconnect;
            $aLUwE(!this.reconnectTimer);
            this.reconnectTimer = setTimeout(async ()=>{
                this.reconnectTimer = undefined;
                if ($1e9f9fda8df65d24$export$7254cc27399e90bd.AwaitingReconnect !== this._state) {
                    this.logger.log(`On reconnect timer elapsed, state:${this._state} so skipping reconnect.`);
                    return;
                }
                this.logger.log(`Attempting reconnect (${this.pauseBetweenReconnects}ms delay has elapsed)`);
                await this.connect();
            }, this.pauseBetweenReconnects);
            this._onConnectionEvent.dispatch(evt);
        };
        this.onConnectedEvent = (evt)=>{
            this._state = $1e9f9fda8df65d24$export$7254cc27399e90bd.Connected;
            this.logger.silly("onConnectedEvent():", evt);
            this._onConnectionEvent.dispatch(evt);
        };
        this.onMessage = async (msg)=>{
            if ("command" in msg) switch(msg.command){
                case (0, $5928c1920647ce73$export$8cc9b4ffb655d255).Message:
                    const msgMessage = (0, $b77ef7ec1849431b$export$2e2bcd8739ae039).buildFromIMessage(msg);
                    if (this.isOutOfDate(msgMessage)) {
                        this.logger.warn(`Ignoring out-of-date message:${msgMessage}`);
                        return;
                    }
                    this._onMsgMessage.dispatch(msgMessage);
                    break;
                case (0, $5928c1920647ce73$export$8cc9b4ffb655d255).ServerInfo:
                    const msgServerInfo = (0, $1b98b361de1c3ab7$export$2e2bcd8739ae039).buildFromIMessage(msg);
                    this._onMsgServerInfo.dispatch(msgServerInfo);
                    break;
                case (0, $5928c1920647ce73$export$8cc9b4ffb655d255).ServerInfoControllerDisconnected:
                    const msgServerInfoControllerDisconnect = (0, $3344fb9994b43b72$export$2e2bcd8739ae039).buildFromIMessage(msg);
                    this._onMsgServerInfo.dispatch(msgServerInfoControllerDisconnect);
                    break;
                case (0, $5928c1920647ce73$export$8cc9b4ffb655d255).Ping:
                    await this.sendPong(msg.msgId);
                    break;
                case (0, $5928c1920647ce73$export$8cc9b4ffb655d255).GetDeviceId:
                case (0, $5928c1920647ce73$export$8cc9b4ffb655d255).RegisterGame:
                case (0, $5928c1920647ce73$export$8cc9b4ffb655d255).AddController:
                case (0, $5928c1920647ce73$export$8cc9b4ffb655d255).ServerInfoControllerConnected:
                case (0, $5928c1920647ce73$export$8cc9b4ffb655d255).ServerInfoGameConnected:
                case (0, $5928c1920647ce73$export$8cc9b4ffb655d255).ServerInfoGameDisconnected:
                    break;
                default:
                    const errMsg = `onMessage() - unhandled message Command type: ${msg.command} (msg id: ${msg.msgId})`;
                    this.logger.error(errMsg);
                    throw new Error(errMsg);
            }
            else if ("responseCode" in msg) this.logger.debug("onMessage() received response (hopefully handled by sendToGameAndWait()):", msg);
            else if ("msgId" in msg) {
                const msgId = msg["msgId"];
                // msg has msgId but no command
                // Happens when msg implements IResponse rather than IMessage (should onMessage be receiving these?)
                this.logger.warn(`onMessage() msg has msgId (${msgId}) but no command:`, msg);
            } else // msg has no command or msgId
            throw new Error(`onMessage() - unexpected type for msg parameter: ${typeof msg}: ${(0, $003b09fe89de2289$export$f84e8e69fd4488a5)(msg)}`);
        };
        this.sendPong = async (msgId)=>{
            const loggerName = "sendPong()";
            this.logger.log(loggerName);
            $aLUwE(this.connection, "No connection");
            let response;
            try {
                response = await this.connection.sendToServer(new (0, $fbd3986847477f13$export$2e2bcd8739ae039)(msgId));
            } catch (e) {
                const errMsg = `Failed responding to ping:${(0, $003b09fe89de2289$export$f84e8e69fd4488a5)(e)}`;
                this.logger.error(errMsg);
                throw new Error(errMsg);
            }
            switch(response.responseCode){
                case (0, $ece558983632ed02$export$b044ccb39e003d90).Success:
                    this.logger.log(loggerName, "successfully responded to ping");
                    break;
                case (0, $ece558983632ed02$export$b044ccb39e003d90).Failure:
                    this.logger.warn("We were too slow to respond to ping and lost our deviceId.  Need to reconnect");
                    break;
                default:
                    const errMsg = `Pong resulted in unexpected response:${(0, $ece558983632ed02$export$1ce4a0e1ecd4fd1)(response.responseCode)}`;
                    this.logger.error(errMsg);
                    throw new Error(errMsg);
            }
        };
        this.isOutOfDate = (msgMessage)=>{
            // Server sent messages (negative message Ids) are not considered outdated by this code.
            if (0 > msgMessage.msgId) return false;
            this.logger.debug("isOutOfDate() checking: ", msgMessage);
            let data;
            try {
                data = msgMessage.getDataDecoded();
            } catch (e) {
                this.logger.warn(`Failed to decode message data:${e}`);
                return false;
            }
            const topic = data[(0, $b77ef7ec1849431b$export$2e2bcd8739ae039).MsgTopicName];
            if (undefined === topic) return false;
            this.logger.debug("isOutOfDate() topic:", topic, "msgId:", msgMessage.msgId, "data:", data);
            const greatest = this.greatestMessageMsgIdSeen.get(topic) ?? 0;
            // We consider duplicate (=) messages to also be out of date (since seen already).
            if (msgMessage.msgId <= greatest) return true;
            this.greatestMessageMsgIdSeen.set(topic, msgMessage.msgId);
            return false;
        };
        this.greatestMessageMsgIdSeen = new Map();
        this._onConnectionEvent = new (0, $6384862cb2bc9a13$exports.SimpleEventDispatcher)();
        this._onMsgMessage = new (0, $6384862cb2bc9a13$exports.SimpleEventDispatcher)();
        this._onMsgServerInfo = new (0, $6384862cb2bc9a13$exports.SimpleEventDispatcher)();
        this._onJoinCodeSet = new (0, $6384862cb2bc9a13$exports.SimpleEventDispatcher)();
        this._onStartSendingToGame = new (0, $6384862cb2bc9a13$exports.SimpleEventDispatcher)();
        this._onDoneOrFailSendingToGame = new (0, $6384862cb2bc9a13$exports.SimpleEventDispatcher)();
        this.joinCode = (0, $2282782f43399dd4$export$18392905b7dc50);
        this.reconnectCount = 0;
        this._state = $1e9f9fda8df65d24$export$7254cc27399e90bd.NotConnected;
        this.pauseBetweenReconnects = 500;
        this.logger = (0, $7653766080191e46$export$4ac4545211fd8567).build(`${$1e9f9fda8df65d24$export$649b280af6458229.name}(s${sessionIndex})`);
        if (undefined !== wsUrl) this.wsUrl = wsUrl;
        else if (undefined !== $1e9f9fda8df65d24$var$WsUrlDefault && "" !== $1e9f9fda8df65d24$var$WsUrlDefault) this.wsUrl = $1e9f9fda8df65d24$var$WsUrlDefault;
        else {
            const errMsg = "ERROR: environmental variable `MFG_WSS` not defined at build time to tell us WSS server to use!";
            this.logger.error(errMsg);
            throw new Error(errMsg);
        }
        if (undefined !== desiredDeviceId) {
            this.logger.log(`Will attempt to use previous deviceId:${desiredDeviceId}`);
            this.previousDeviceId = this._deviceId = desiredDeviceId;
        }
        if (undefined !== previousJoinCode) {
            this.logger.log(`Will attempt to use previous joinCode:${previousJoinCode}`);
            this.setCurrentJoinCode(previousJoinCode);
        }
        // ParcelJS Hot module reloading = only during development
        // See https://parceljs.org/features/development/
        if (null) {
            this.logger.debug("Registering ParcelJS module reloading handlers");
            null.dispose((data)=>{
                this.logger.warn("ParcelJS Hot Module Reload = dispose()");
                return this.closeConnection(false, (0, $c9cbdb97f2e17b01$export$dd43557c09bea516).ClientConnectionTimeoutRetrying, "ParcelJS reload (GameProxy)");
            });
            null.accept(()=>{
                this.logger.warn(`ParcelJS Hot Module Reload = accept() (reload) state:${this.stateName}`);
                if (this.state !== $1e9f9fda8df65d24$export$7254cc27399e90bd.Connected) return;
                return this.closeConnection(false, (0, $c9cbdb97f2e17b01$export$dd43557c09bea516).ClientConnectionTimeoutRetrying, "ParcelJS reloaded (GameProxy)");
            });
        }
    }
    /**
	 * Dispatched for connection established/closed/errored events from the server.
	 * Reconnection is handled automatically so this is mostly for UI updates.
	 */ get onConnectionEvent() {
        return this._onConnectionEvent.asEvent();
    }
    get onMsgMessage() {
        return this._onMsgMessage.asEvent();
    }
    get onMsgServerInfo() {
        return this._onMsgServerInfo.asEvent();
    }
    get onJoinCodeSet() {
        return this._onJoinCodeSet.asEvent();
    }
    get onStartSendingToGame() {
        return this._onStartSendingToGame.asEvent();
    }
    get onDoneOrFailSendingToGame() {
        return this._onDoneOrFailSendingToGame.asEvent();
    }
    get deviceId() {
        return this._deviceId;
    }
    get state() {
        return this._state;
    }
    get stateName() {
        return $1e9f9fda8df65d24$export$9c0ea6d32e659c02(this._state);
    }
    get didRejoinPreviousSession() {
        return this.previousDeviceId === this._deviceId;
    }
    doWhileWaiting(enableNotDisable, whileWaiting) {
        switch(whileWaiting){
            case $1e9f9fda8df65d24$var$WhileWaiting.DisableInput:
                // TODO: Disable further input if enableNotDisable and re-enable otherwise
                this.logger.log(enableNotDisable ? "input disabled" : "input re-enabled");
                break;
            case $1e9f9fda8df65d24$var$WhileWaiting.DoNothing:
                break;
        }
    }
}
// N.b. Parcel inlines the value at compile-time so the browser runs against the correct WebSocket server.
const $1e9f9fda8df65d24$var$WsUrlDefault = "wss://kygf0d49s9.execute-api.us-east-1.amazonaws.com/Dev";
class $1e9f9fda8df65d24$var$JoinError extends Error {
    constructor(responseCode, message){
        super(message);
        this.responseCode = responseCode;
    }
}
class $1e9f9fda8df65d24$var$MsgError extends Error {
    constructor(responseCode, message){
        super(message);
        this.responseCode = responseCode;
    }
}
var $1e9f9fda8df65d24$var$WhileWaiting;
(function(WhileWaiting) {
    WhileWaiting[WhileWaiting["DoNothing"] = 0] = "DoNothing";
    WhileWaiting[WhileWaiting["DisableInput"] = 1] = "DisableInput";
})($1e9f9fda8df65d24$var$WhileWaiting || ($1e9f9fda8df65d24$var$WhileWaiting = {}));
var $1e9f9fda8df65d24$export$7254cc27399e90bd;
(function(State) {
    State[State[/** Between being created and asked to initially connect. */ "NotConnected"] = 0] = "NotConnected";
    State[State[/** When connecting, both initially and after any non-explicit disconnections. */ "Connecting"] = 1] = "Connecting";
    State[State[/** When connected. */ "Connected"] = 2] = "Connected";
    State[State[/** Only when explicitly asked to close. */ "Closing"] = 3] = "Closing";
    State[State[/** Only when explicitly closed. */ "Closed"] = 4] = "Closed";
    State[State[/** When scheduled reconnect (after pause) but not yet started. */ "AwaitingReconnect"] = 5] = "AwaitingReconnect";
})($1e9f9fda8df65d24$export$7254cc27399e90bd || ($1e9f9fda8df65d24$export$7254cc27399e90bd = {}));
function $1e9f9fda8df65d24$export$9c0ea6d32e659c02(s) {
    return $1e9f9fda8df65d24$export$7254cc27399e90bd[s];
}
function $1e9f9fda8df65d24$export$afd78fa5a47845ca(...states) {
    return "[" + states.map((c)=>`${$1e9f9fda8df65d24$export$9c0ea6d32e659c02(c)}:${c}`).join(", ") + "]";
}





// Keep this synchronised with the C# version.
var $b4fc6cc2eeeabf82$export$4797cb943f901b2e;
(function(ControllerState) {
    ControllerState[ControllerState["JoinScreen"] = 0] = "JoinScreen";
    ControllerState[ControllerState["WaitingForSetup"] = 1] = "WaitingForSetup";
    ControllerState[ControllerState["CharacterSelect"] = 2] = "CharacterSelect";
    ControllerState[ControllerState["WaitingForInput"] = 3] = "WaitingForInput";
    ControllerState[ControllerState["WatchingActions"] = 4] = "WatchingActions";
    ControllerState[ControllerState["ItemPlacementVote"] = 5] = "ItemPlacementVote";
    ControllerState[ControllerState["ItemPlacementResults"] = 6] = "ItemPlacementResults";
    ControllerState[ControllerState["LevelFinished"] = 7] = "LevelFinished";
})($b4fc6cc2eeeabf82$export$4797cb943f901b2e || ($b4fc6cc2eeeabf82$export$4797cb943f901b2e = {}));


class $677b4c43f3df91ac$export$1d5a868e16232420 {
    static fromJSON(json) {
        const o = JSON.parse(json);
        const turns = new Array(o.length);
        // const withMethods = new TurnSet(o.length);
        for(let i = 0; i < o.length; i++)turns[i] = new $677b4c43f3df91ac$export$f02bc863a6b78ce2(o[i].action, o[i].data);
        const withMethods = new $677b4c43f3df91ac$export$1d5a868e16232420(turns);
        return withMethods;
    }
    constructor(turnsOrNumTurns){
        this.get = (index)=>{
            if (0 > index || index >= this._turns.length) throw new Error(`index:${index} is out of bounds of 0..${this._turns.length} ${this}`);
            return this._turns[index];
        };
        this.set = (index, turn)=>{
            if (0 > index || index >= this._turns.length) throw new Error(`index:${index} is out of bounds of 0..${this._turns.length} ${this}`);
            this._turns[index] = turn;
        };
        this.clear = ()=>{
            for(let i = 0; i < this._turns.length; i++)this._turns[i].clear();
        };
        this.toJSON = ()=>JSON.stringify(this._turns);
        this.toString = ()=>{
            let s = `${$677b4c43f3df91ac$export$1d5a868e16232420.name}:[\n`;
            for(let i = 0; i < this._turns.length; i++)s += `  ${i}\t: ${this._turns[i]}\n`;
            s += "  ]";
            return s;
        };
        if ("number" === typeof turnsOrNumTurns) {
            this.numTurns = turnsOrNumTurns;
            this._turns = Array(this.numTurns);
            for(let i = 0; i < this.numTurns; i++)this._turns[i] = new $677b4c43f3df91ac$export$f02bc863a6b78ce2("", "");
        } else {
            this.numTurns = turnsOrNumTurns.length;
            this._turns = turnsOrNumTurns;
        }
    }
    equals(other) {
        if (this.numTurns !== other.numTurns) return false;
        for(let i = 0; i < this.numTurns; i++){
            if (!this._turns[i].equals(other._turns[i])) return false;
        }
        return true;
    }
    buildSelectionWasMadeForTurns() {
        return this._turns.map((t)=>"" !== t.action);
    }
}
class $677b4c43f3df91ac$export$f02bc863a6b78ce2 {
    static fromJSON(json) {
        const o = JSON.parse(json);
        const withMethods = new $677b4c43f3df91ac$export$f02bc863a6b78ce2(o.action, o.data);
        return withMethods;
    }
    constructor(action, data){
        this.clear = ()=>{
            this.action = "";
            this.data = "";
        };
        this.toString = ()=>`(action:\"${this.action}\", data:\"${this.data}\")`;
        this.action = action;
        this.data = data;
    }
    equals(other) {
        return this.action === other.action && this.data === other.data;
    }
}



class $109c27dde40935f6$export$68656b7c8056ebd6 {
    constructor(turnSet, playerSelectionsMade){
        this.toJSON = ()=>{
            return `"turns": ${this.turnSet.toJSON()}, "playerSelectionsMade": ${JSON.stringify(this.playerSelectionsMade)}`;
        };
        this.turnSet = turnSet;
        this.playerSelectionsMade = playerSelectionsMade;
    }
    static fromJSON(json) {
        // Remove all spaces - different broswers handle whitespace differently when saving/getting json string from cookie!
        json = json.replace(/\s/g, "");
        const turnsJSON = json.substring(8, json.indexOf(',"playerSelectionsMade"'));
        const playerSelectionsMadeJSON = json.substring(json.indexOf("playerSelectionsMade") + 22);
        const turnSetWithMethods = (0, $677b4c43f3df91ac$export$1d5a868e16232420).fromJSON(turnsJSON);
        const playerSelectionsMade = JSON.parse(playerSelectionsMadeJSON);
        const withMethods = new $109c27dde40935f6$export$68656b7c8056ebd6(turnSetWithMethods, playerSelectionsMade);
        return withMethods;
    }
}




var $d397f6c459ccf808$exports = {};
var $f3c9c3cc57413c91$exports = {};
$f3c9c3cc57413c91$exports = JSON.parse('{"words":["ahole","anus","ash0le","ash0les","asholes","ass","Ass Monkey","Assface","assh0le","assh0lez","asshole","assholes","assholz","asswipe","azzhole","bassterds","bastard","bastards","bastardz","basterds","basterdz","Biatch","bitch","bitches","Blow Job","boffing","butthole","buttwipe","c0ck","c0cks","c0k","Carpet Muncher","cawk","cawks","Clit","cnts","cntz","cock","cockhead","cock-head","cocks","CockSucker","cock-sucker","crap","cum","cunt","cunts","cuntz","dick","dild0","dild0s","dildo","dildos","dilld0","dilld0s","dominatricks","dominatrics","dominatrix","dyke","enema","f u c k","f u c k e r","fag","fag1t","faget","fagg1t","faggit","faggot","fagg0t","fagit","fags","fagz","faig","faigs","fart","flipping the bird","fuck","fucker","fuckin","fucking","fucks","Fudge Packer","fuk","Fukah","Fuken","fuker","Fukin","Fukk","Fukkah","Fukken","Fukker","Fukkin","g00k","God-damned","h00r","h0ar","h0re","hells","hoar","hoor","hoore","jackoff","jap","japs","jerk-off","jisim","jiss","jizm","jizz","knob","knobs","knobz","kunt","kunts","kuntz","Lezzian","Lipshits","Lipshitz","masochist","masokist","massterbait","masstrbait","masstrbate","masterbaiter","masterbate","masterbates","Motha Fucker","Motha Fuker","Motha Fukkah","Motha Fukker","Mother Fucker","Mother Fukah","Mother Fuker","Mother Fukkah","Mother Fukker","mother-fucker","Mutha Fucker","Mutha Fukah","Mutha Fuker","Mutha Fukkah","Mutha Fukker","n1gr","nastt","nigger;","nigur;","niiger;","niigr;","orafis","orgasim;","orgasm","orgasum","oriface","orifice","orifiss","packi","packie","packy","paki","pakie","paky","pecker","peeenus","peeenusss","peenus","peinus","pen1s","penas","penis","penis-breath","penus","penuus","Phuc","Phuck","Phuk","Phuker","Phukker","polac","polack","polak","Poonani","pr1c","pr1ck","pr1k","pusse","pussee","pussy","puuke","puuker","qweir","recktum","rectum","retard","sadist","scank","schlong","screwing","semen","sex","sexy","Sh!t","sh1t","sh1ter","sh1ts","sh1tter","sh1tz","shit","shits","shitter","Shitty","Shity","shitz","Shyt","Shyte","Shytty","Shyty","skanck","skank","skankee","skankey","skanks","Skanky","slag","slut","sluts","Slutty","slutz","son-of-a-bitch","tit","turd","va1jina","vag1na","vagiina","vagina","vaj1na","vajina","vullva","vulva","w0p","wh00r","wh0re","whore","xrated","xxx","b!+ch","bitch","blowjob","clit","arschloch","fuck","shit","ass","asshole","b!tch","b17ch","b1tch","bastard","bi+ch","boiolas","buceta","c0ck","cawk","chink","cipa","clits","cock","cum","cunt","dildo","dirsa","ejakulate","fatass","fcuk","fuk","fux0r","hoer","hore","jism","kawk","l3itch","l3i+ch","masturbate","masterbat*","masterbat3","motherfucker","s.o.b.","mofo","nazi","nigga","nigger","nutsack","phuck","pimpis","pusse","pussy","scrotum","sh!t","shemale","shi+","sh!+","slut","smut","teets","tits","boobs","b00bs","teez","testical","testicle","titt","w00se","jackoff","wank","whoar","whore","*damn","*dyke","*fuck*","*shit*","@$$","amcik","andskota","arse*","assrammer","ayir","bi7ch","bitch*","bollock*","breasts","butt-pirate","cabron","cazzo","chraa","chuj","Cock*","cunt*","d4mn","daygo","dego","dick*","dike*","dupa","dziwka","ejackulate","Ekrem*","Ekto","enculer","faen","fag*","fanculo","fanny","feces","feg","Felcher","ficken","fitt*","Flikker","foreskin","Fotze","Fu(*","fuk*","futkretzn","gook","guiena","h0r","h4x0r","hell","helvete","hoer*","honkey","Huevon","hui","injun","jizz","kanker*","kike","klootzak","kraut","knulle","kuk","kuksuger","Kurac","kurwa","kusi*","kyrpa*","lesbo","mamhoon","masturbat*","merd*","mibun","monkleigh","mouliewop","muie","mulkku","muschi","nazis","nepesaurio","nigger*","orospu","paska*","perse","picka","pierdol*","pillu*","pimmel","piss*","pizda","poontsee","poop","porn","p0rn","pr0n","preteen","pula","pule","puta","puto","qahbeh","queef*","rautenberg","schaffer","scheiss*","schlampe","schmuck","screw","sh!t*","sharmuta","sharmute","shipal","shiz","skribz","skurwysyn","sphencter","spic","spierdalaj","splooge","suka","b00b*","testicle*","titt*","twat","vittu","wank*","wetback*","wichser","wop*","yed","zabourah"]}');


var $d397f6c459ccf808$require$localList = $f3c9c3cc57413c91$exports.words;
var $d9bdf8e0eeb17b82$exports = {};



$d9bdf8e0eeb17b82$exports = {
    object: (parcelRequire("hVfHM")),
    array: (parcelRequire("4NgFl")),
    regex: (parcelRequire("76U8F"))
};


var $d397f6c459ccf808$require$baseList = $d9bdf8e0eeb17b82$exports.array;
class $d397f6c459ccf808$var$Filter {
    /**
   * Filter constructor.
   * @constructor
   * @param {object} options - Filter instance options
   * @param {boolean} options.emptyList - Instantiate filter with no blacklist
   * @param {array} options.list - Instantiate filter with custom list
   * @param {string} options.placeHolder - Character used to replace profane words.
   * @param {string} options.regex - Regular expression used to sanitize words before comparing them to blacklist.
   * @param {string} options.replaceRegex - Regular expression used to replace profane words with placeHolder.
   * @param {string} options.splitRegex - Regular expression used to split a string into words.
   */ constructor(options = {}){
        Object.assign(this, {
            list: options.emptyList && [] || Array.prototype.concat.apply($d397f6c459ccf808$require$localList, [
                $d397f6c459ccf808$require$baseList,
                options.list || []
            ]),
            exclude: options.exclude || [],
            splitRegex: options.splitRegex || /\b/,
            placeHolder: options.placeHolder || "*",
            regex: options.regex || /[^a-zA-Z0-9|\$|\@]|\^/g,
            replaceRegex: options.replaceRegex || /\w/g
        });
    }
    /**
   * Determine if a string contains profane language.
   * @param {string} string - String to evaluate for profanity.
   */ isProfane(string) {
        return this.list.filter((word)=>{
            const wordExp = new RegExp(`\\b${word.replace(/(\W)/g, "\\$1")}\\b`, "gi");
            return !this.exclude.includes(word.toLowerCase()) && wordExp.test(string);
        }).length > 0 || false;
    }
    /**
   * Replace a word with placeHolder characters;
   * @param {string} string - String to replace.
   */ replaceWord(string) {
        return string.replace(this.regex, "").replace(this.replaceRegex, this.placeHolder);
    }
    /**
   * Evaluate a string for profanity and return an edited version.
   * @param {string} string - Sentence to filter.
   */ clean(string) {
        return string.split(this.splitRegex).map((word)=>{
            return this.isProfane(word) ? this.replaceWord(word) : word;
        }).join(this.splitRegex.exec(string)[0]);
    }
    /**
   * Add word(s) to blacklist filter / remove words from whitelist filter
   * @param {...string} word - Word(s) to add to blacklist
   */ addWords() {
        let words = Array.from(arguments);
        this.list.push(...words);
        words.map((word)=>word.toLowerCase()).forEach((word)=>{
            if (this.exclude.includes(word)) this.exclude.splice(this.exclude.indexOf(word), 1);
        });
    }
    /**
   * Add words to whitelist filter
   * @param {...string} word - Word(s) to add to whitelist.
   */ removeWords() {
        this.exclude.push(...Array.from(arguments).map((word)=>word.toLowerCase()));
    }
}
$d397f6c459ccf808$exports = $d397f6c459ccf808$var$Filter;


/**
 * A *STRING* regular expression for a valid player name.
 * Must be a string to allow it to be used in MessageValidator.
 * Presently 2 to 32 non-JSON nor HTML chars (for now).
 * I.e. none of:
 * - HTML:
 *  - <
 *  - >
 *  - &
 *  - /
 * - JSON:
 *  - }
 *  - "
 *  - '
 *  - \
 *  - ;
 */ const $f48d6121add2f34d$export$81a7c15c6ae5a63e = "^[^;/<>&}\"'\\\\]{2,32}$";
const $f48d6121add2f34d$export$5902b431f52a9802 = 2;
const $f48d6121add2f34d$export$4cca1cec671ed7ed = 32;



const $a73b546ea725d550$export$b57493bfe7fffdae = 2;
const $a73b546ea725d550$export$966717a988b7e73e = 100;
class $a73b546ea725d550$export$2b90dbfed7b418ed {
    get selectedCharacterInternalName() {
        return this.characterNamesAndText[this.selectedCharacterIndex].internalName;
    }
    get selectedCharacterDisplayName() {
        return this.characterNamesAndText[this.selectedCharacterIndex].displayName;
    }
    get selectedCharacterText() {
        return this.characterNamesAndText[this.selectedCharacterIndex].text;
    }
    get selectedCharacterIndex() {
        return this._selectedCharacterIndex;
    }
    get isFirstCharacterSelected() {
        return this._selectedCharacterIndex === 0;
    }
    get isLastCharacterSelected() {
        return this._selectedCharacterIndex === this.characterNamesAndText.length - 1;
    }
    constructor(characterInternalNameData, characterDisplayNameData, restoreText){
        this.setSelectedCharacterIndex = (newIndex)=>{
            if (newIndex < 0 || newIndex >= this.characterNamesAndText.length) {
                (0, $7653766080191e46$export$2e2bcd8739ae039).warn(`setSelectedCharacterIndex with invalid index: ${newIndex} (Expected 0-${this.characterNamesAndText.length - 1})`);
                return;
            }
            this._selectedCharacterIndex = newIndex;
        };
        this.incrementSelectedCharacterIndex = ()=>{
            if (this.selectedCharacterIndex >= this.characterNamesAndText.length - 1) return;
            this._selectedCharacterIndex++;
        };
        this.decrementSelectedCharacterIndex = ()=>{
            if (this.selectedCharacterIndex <= 0) return;
            this._selectedCharacterIndex--;
        };
        this.resetSelectedCharacterIndex = ()=>{
            this._selectedCharacterIndex = 0;
        };
        this.getCharacterNameToTextMap = ()=>{
            let map = new Map();
            this.characterNamesAndText.forEach((nameAndText)=>{
                if (nameAndText.text !== "") map.set(nameAndText.internalName, nameAndText.text);
            });
            return map;
        };
        this.doCharacterInternalNamesMatchThis = (characterNames)=>{
            if (characterNames.length !== this.characterNamesAndText.length) return false;
            const newNamesCopy = characterNames.slice();
            for(let i = 0; i < this.characterNamesAndText.length; i++){
                const expectedName = this.characterNamesAndText[i].internalName;
                if (!newNamesCopy.includes(expectedName)) return false;
                newNamesCopy.splice(newNamesCopy.indexOf(expectedName, 0), 1);
            }
            return true;
        };
        let playerCharacterNames = [];
        let otherCharacterNames = [];
        characterInternalNameData.forEach((name, index)=>{
            const characterNameAndText = new $a73b546ea725d550$export$a1e79d4710a40a2c(name, characterDisplayNameData[index]);
            if (restoreText.has(name)) characterNameAndText.setText(restoreText.get(name));
            if (name.includes("player_")) playerCharacterNames.push(characterNameAndText);
            else otherCharacterNames.push(characterNameAndText);
        });
        playerCharacterNames.sort((a, b)=>a.displayName.localeCompare(b.displayName));
        otherCharacterNames.sort((a, b)=>a.displayName.localeCompare(b.displayName));
        this.characterNamesAndText = playerCharacterNames.concat(otherCharacterNames);
        this._selectedCharacterIndex = 0;
    }
    setTextInputForSelectedCharacter(text) {
        this.characterNamesAndText[this.selectedCharacterIndex].setText(text);
    }
}
class $a73b546ea725d550$export$a1e79d4710a40a2c {
    get text() {
        return this._text;
    }
    constructor(internalName, displayName){
        this.setText = (newText)=>{
            // Ensure text is within max length limit
            if (newText.length > $a73b546ea725d550$export$966717a988b7e73e) newText = newText.substring(0, $a73b546ea725d550$export$966717a988b7e73e);
            // Ensure no line breaks
            newText = newText.replace(/(\r\n|\n|\r)/gm, "");
            this._text = newText;
        };
        this.internalName = internalName;
        this.displayName = displayName;
        this._text = "";
    }
}


function $58dbd298dd17636b$export$ebb36375df04bd2a(data) {
    let result = $58dbd298dd17636b$var$validateJoinCode(data.joinCode);
    if (!result.isValid) return result;
    return $58dbd298dd17636b$var$validatePlayerName(data.playerName);
}
function $58dbd298dd17636b$export$84ea90aca0ecf643(inputText) {
    // Disallow empty/single-letter messages
    if ((0, $a73b546ea725d550$export$b57493bfe7fffdae) > inputText.length) return {
        isValid: false,
        errorText: `Your message is too short. It should be at least ${0, $a73b546ea725d550$export$b57493bfe7fffdae} characters.`
    };
    // Disallow messages over max allowed length
    // Note: maxlength is also set on the HTML text field, so this shouldn't be seen, but here just in case.
    // The maxlength value of the TextArea (id: 'writerInputField') should match WriterInputMaxLength.
    if ((0, $a73b546ea725d550$export$966717a988b7e73e) < inputText.length) return {
        isValid: false,
        errorText: `Your message is too long. It should be no more than ${0, $a73b546ea725d550$export$966717a988b7e73e} characters.`
    };
    // No bad words
    const badWords = new (0, (/*@__PURE__*/$parcel$interopDefault($d397f6c459ccf808$exports)))();
    if (badWords.isProfane(inputText)) return {
        isValid: false,
        errorText: "Sorry, that text failed our family friendliness check."
    };
    return {
        isValid: true
    };
}
function $58dbd298dd17636b$var$validateJoinCode(joinCode) {
    if ((0, $2282782f43399dd4$export$3636fa6b664761ad)(joinCode)) return {
        isValid: true
    };
    return {
        isValid: false,
        errorText: `Sorry, that join code is not quite right.  It should be ${0, $2282782f43399dd4$export$a6fe2dd80e8fc03e}.  Please check it?`
    };
}
/**
 * Validate player name for length, with PlayerNameRegexString and naughty words (we're family friendly).
 * These are also done on the server in MessageValidator but it's better and faster to check on the client.
 */ function $58dbd298dd17636b$var$validatePlayerName(playerNameText) {
    if ((0, $f48d6121add2f34d$export$5902b431f52a9802) > playerNameText.length) return {
        isValid: false,
        errorText: "Please enter a player name (at least 2 letters)."
    };
    if ((0, $f48d6121add2f34d$export$4cca1cec671ed7ed) < playerNameText.length) return {
        isValid: false,
        errorText: "Sorry, player names must be fewer than 32 letters."
    };
    if (!playerNameText.match((0, $f48d6121add2f34d$export$81a7c15c6ae5a63e))) return {
        isValid: false,
        errorText: "Sorry, that player name is not allowed."
    };
    const badWords = new (0, (/*@__PURE__*/$parcel$interopDefault($d397f6c459ccf808$exports)))();
    if (badWords.isProfane(playerNameText)) return {
        isValid: false,
        errorText: "Sorry, that player name failed our family friendliness check."
    };
    return {
        isValid: true
    };
}






class $4b1e45d61ed1a70b$export$5730f849b02574b8 {
    get enabledOrDefault() {
        return this.enabled ?? true;
    }
    get hasDirectionDataOrDefault() {
        return this.hasDirectionData ?? false;
    }
    get labelOrDefault() {
        return this.label ?? "";
    }
    get mainColourOrDefault() {
        return this.mainColour ?? "#000000";
    }
    get secondaryColourOrDefault() {
        return this.secondaryColour ?? this.mainColour ?? "#000000";
    }
    get isCoOperationButton() {
        return this._isCoOperationButton;
    }
    constructor(isCoOperationButton, action, enabled, hasDirectionData, label, imageName, imageBase64, mainColour, secondaryColour){
        this.toString = ()=>{
            return `enabled: ${this.enabled}, action: ${this.action}, hasDirectionData: ${this.hasDirectionData}, label: ${this.label}, image: ${this.getTruncatedImageText()}, mainColour: ${this.mainColour}, secondaryColour: ${this.secondaryColour}`;
        };
        this.createImageObjectURL = async (imageURLCache)=>{
            if (!this.imageBase64) return;
            if (!this.imageName) throw new Error(`Expected imageName to have a value when creating image URL for ${this}`);
            await imageURLCache.createImageObjectURL(this.imageName, this.imageBase64);
        };
        this.getTruncatedImageText = ()=>{
            const Length = 10;
            if (!this.imageBase64) return "";
            if (this.imageBase64.length <= Length) return this.imageBase64;
            return `${this.imageBase64.substring(0, Length - 1)}...`;
        };
        this._isCoOperationButton = isCoOperationButton;
        this.action = action;
        this.enabled = enabled;
        this.hasDirectionData = hasDirectionData;
        this.label = label;
        this.imageName = imageName;
        this.imageBase64 = imageBase64;
        this.mainColour = mainColour;
        this.secondaryColour = secondaryColour;
    }
}


/**
 * Constants for data in MsgMessages received on GameProxy's connection
 */ class $ee66a3e070746278$export$11f36a4bab39d793 {
    static #_ = (()=>{
        this.SetState = "setState";
    })();
    static #_1 = (()=>{
        this.ConfirmCharacters = class {
            static #_ = (()=>{
                this.Name = "meta.game.confirmCharacters";
            })();
            static #_1 = (()=>{
                this.AllNonCharactersSelected = "allNonCharactersSelected";
            })();
        };
    })();
    static #_2 = (()=>{
        this.ThrowEnabled = "meta.game.throwEnabled";
    })();
    static #_3 = (()=>{
        this.NumTurns = "meta.game.numTurns";
    })();
    static #_4 = (()=>{
        this.ReclaimedController = "reclaimedController";
    })();
    static #_5 = (()=>{
        this.BootController = "bootController";
    })();
    static #_6 = (()=>{
        this.CustomController = class {
            static #_ = (()=>{
                this.ActionButton = "customController.actionButton";
            })();
        };
    })();
    static #_7 = (()=>{
        this.ImageBase64 = class {
            static #_ = (()=>{
                this.ImageName = "imageBase64.imageName";
            })();
            static #_1 = (()=>{
                this.Data = "imageBase64.data";
            })();
        };
    })();
    static #_8 = (()=>{
        this.ItemManagement = class {
            static #_ = (()=>{
                this.Name = "itemManagementData";
            })();
            static #_1 = (()=>{
                this.Positions = "placementPositions";
            })();
            static #_2 = (()=>{
                this.ItemNames = "itemNames";
            })();
        };
    })();
    static #_9 = (()=>{
        this.NarrativeCharacters = class {
            static #_ = (()=>{
                this.Name = "narrativeCharactersData";
            })();
            static #_1 = (()=>{
                this.CharacterInternalNames = "characterInternalNames";
            })();
            static #_2 = (()=>{
                this.CharacterDisplayNames = "characterDisplayNames";
            })();
        };
    })();
}



class $b07ee39fb2d6b957$export$74cd332a2d711c2f {
    get selectedItemVoteIndex() {
        return this._selectedItemVoteIndex;
    }
    get selectedItem() {
        return this.items[this.selectedItemVoteIndex];
    }
    constructor(placementPositionCount, itemNames, initialSelectedIndex, sessionIndex, cookieHelper){
        this.incrementSelectedItemVoteIndex = ()=>{
            if (this.selectedItemVoteIndex >= this.items.length - 1) return;
            this._selectedItemVoteIndex++;
        };
        this.decrementSelectedItemVoteIndex = ()=>{
            if (this.selectedItemVoteIndex <= 0) return;
            this._selectedItemVoteIndex--;
        };
        this.resetSelectedItemVoteIndex = ()=>{
            this._selectedItemVoteIndex = 0;
        };
        this.selectPositionForCurrentItem = (positionIndex, sessionIndex)=>{
            (0, $7653766080191e46$export$2e2bcd8739ae039).log(`Selecting position index ${positionIndex} for selected item ${this.selectedItemVoteIndex} (${this.selectedItem.itemName})`);
            return this.selectPositionForItemAtIndex(this.selectedItemVoteIndex, positionIndex, sessionIndex);
        };
        this.autoSelectNextItemWithoutPositionAfterDelay = async ()=>{
            await new Promise((_)=>setTimeout(_, 300));
            // Auto-select the next item that doesn't have a position chosen (if any)
            for(let i = this.selectedItemVoteIndex; i < this.items.length; i++){
                if (i == this.selectedItemVoteIndex) continue;
                const item = this.items[i];
                if (item.positionIndex < 0) {
                    this._selectedItemVoteIndex = i;
                    break;
                }
            }
        };
        this.positionIsSelectedForAnyItemOtherThan = (itemName, positionIndex)=>{
            if (positionIndex == -1) // -1 = Nowhere, any number of items can select this
            return false;
            for (let item of this.items){
                if (item.itemName === itemName) continue;
                if (item.positionIndex === positionIndex) return true;
            }
            return false;
        };
        this.positionIsSelectedForAnyItem = (positionIndex)=>{
            return this.positionIsSelectedForAnyItemOtherThan(null, positionIndex);
        };
        this.itemsToPartialJSON = ()=>{
            let data = "";
            for(let i = 0; i < this.items.length; i++){
                const item = this.items[i];
                if (item.positionIndex < 0) continue;
                data = data.concat(`"placementPos${item.positionIndex}": ${JSON.stringify(item.itemName)},`);
            }
            if (data.length > 0) data = data.substring(0, data.length - 1);
            return data;
        };
        this.selectPositionForItemWithName = (itemName, positionIndex, sessionIndex, setCookie)=>{
            for(let i = 0; i < this.items.length; i++){
                if (this.items[i].itemName == itemName) return this.selectPositionForItemAtIndex(i, positionIndex, sessionIndex, setCookie);
            }
            (0, $7653766080191e46$export$2e2bcd8739ae039).warn(`No item with name "${itemName}", so no selection was made`);
            return [
                false,
                false
            ];
        };
        this.selectPositionForItemAtIndex = (itemIndex, positionIndex, sessionIndex, setCookie = true)=>{
            (0, $7653766080191e46$export$2e2bcd8739ae039).log(`Selecting position index ${positionIndex} for item ${itemIndex}`);
            if (itemIndex < -1 || itemIndex >= this.items.length) {
                (0, $7653766080191e46$export$2e2bcd8739ae039).warn(`Invalid itemIndex: ${itemIndex} (expected 0 - ${this.items.length - 1})`);
                return [
                    false,
                    false
                ];
            }
            if (positionIndex < -1 || positionIndex >= this.placementPositionCount) {
                (0, $7653766080191e46$export$2e2bcd8739ae039).warn(`Invalid positionIndex: ${positionIndex} (expected 0 - ${this.placementPositionCount - 1})`);
                return [
                    false,
                    false
                ];
            }
            const item = this.items[itemIndex];
            if (this.positionIsSelectedForAnyItemOtherThan(item.itemName, positionIndex)) return [
                false,
                false
            ];
            if (item.positionIndex === positionIndex) {
                item.positionIndex = -1;
                (0, $7653766080191e46$export$2e2bcd8739ae039).log(`Deselecting any position for item ${itemIndex} (${item.itemName})`);
                if (setCookie) this.cookieHelper.setItemVotesForSessionIndex(sessionIndex, this.itemsToPartialJSON());
                return [
                    true,
                    false
                ];
            } else {
                item.positionIndex = positionIndex;
                if (setCookie) this.cookieHelper.setItemVotesForSessionIndex(sessionIndex, this.itemsToPartialJSON());
                return [
                    true,
                    true
                ];
            }
        };
        this.tryRestoreSelectionsFromCookies = (sessionIndex)=>{
            const selectionsJSON = this.cookieHelper.getItemVotesForSessionIndexJSON(sessionIndex);
            if (selectionsJSON === undefined || selectionsJSON == "") return;
            let selectedItemsForPositions = JSON.parse(`{${selectionsJSON}}`);
            for(let i = 0; i < this.placementPositionCount; i++){
                const itemForPos = selectedItemsForPositions[`placementPos${i}`];
                if (itemForPos === undefined || itemForPos == "") continue;
                this.selectPositionForItemWithName(itemForPos, i, sessionIndex, false);
            }
        };
        this.placementPositionCount = placementPositionCount;
        this._selectedItemVoteIndex = initialSelectedIndex;
        this.cookieHelper = cookieHelper;
        this.items = [];
        itemNames.forEach((itemName)=>{
            this.items.push(new $b07ee39fb2d6b957$export$d9998cb192f8cd51(itemName));
        });
        this.tryRestoreSelectionsFromCookies(sessionIndex);
    }
}
class $b07ee39fb2d6b957$export$d9998cb192f8cd51 {
    constructor(itemName){
        this.itemName = itemName;
        this.positionIndex = -1; // -1 = Nowhere
    }
}



class $dd300fc197dcf9fe$export$a3eb6b94b1e7587a {
    get sessionIndex() {
        return this._sessionIndex;
    }
    set sessionIndex(value) {
        this._sessionIndex = value;
    }
    get itemManagementData() {
        return this._itemManagementData;
    }
    get characterWritingData() {
        return this._characterWritingData;
    }
    get turnsPerRound() {
        return this._turnsPerRound;
    }
    static #_ = (()=>{
        /** Configure game input selection behaviour: */ this.DefaultSelectedActionNumber = 0;
    })();
    static #_1 = (()=>{
        this.AutoSelectionEnabled = true;
    })();
    static #_2 = (()=>{
        this.CanReadyWithEmptyTurns = true;
    })();
    static #_3 = (()=>{
        this.CharacterPlayerCount = 4;
    })();
    static #_4 = (()=>{
        this.NonCharacterPlayerCount = 4;
    })();
    get onGameSessionEnded() {
        return this._onGameSessionEnded.asEvent();
    }
    get hasSelectedCharacter() {
        return this.characterIndex > -1;
    }
    get isNonCharacterPlayer() {
        return this.characterIndex >= $dd300fc197dcf9fe$export$a3eb6b94b1e7587a.CharacterPlayerCount && this.characterIndex < $dd300fc197dcf9fe$export$a3eb6b94b1e7587a.CharacterPlayerCount + $dd300fc197dcf9fe$export$a3eb6b94b1e7587a.NonCharacterPlayerCount;
    }
    constructor(app, sessionIndex, viewManager, cookieHelper, playerName){
        this.cookieHelper = cookieHelper;
        this.isReady = false;
        this.selectionWasMadeForTurn = [];
        this.connecting = false;
        this.joinedGame = false;
        this._turnsPerRound = (0, $ac58392a9f7a45e7$export$86fbec116b87613f).DefaultTurnsPerRound;
        this._onGameSessionEnded = new (0, $6384862cb2bc9a13$exports.SimpleEventDispatcher)();
        this.connectToGame = async ()=>{
            await this.tryConnect();
        };
        this.tryConnect = async ()=>{
            this.logger.debug(`tryConnect() connecting:${this.connecting}`);
            if (this.connecting) return;
            try {
                this.viewManager.setConnectingInfoToDisplay(this.sessionIndex + 1, undefined, this.playerName);
                this.viewManager.show((0, $8b07c0f1748354ec$export$27a5bd065ad55220).Connecting);
                // TODO-20230114: Show some "Connecting" message to user
                this.connecting = true;
                await this.game.connect();
                // No longer get deviceId here -- done automatically within connect() (and especially reconnect when it restores existing deviceId)
                this.connecting = false;
                await this.connected();
            } catch (e) {
                this.connecting = false;
                if (!e || !(e instanceof Error)) {
                    if ("string" === typeof e) e = new Error(e);
                    else e = new Error("Unknown error.");
                }
                this.logger.error("Failed to connect:", e.message, ": ", e);
            // (onConnectionEvent handles showing error dialog to player)
            }
        };
        this.onImageUrlCreated = (imageName)=>{
            if (!this.isActiveInView) return;
            if (this.currentControllerState === (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementVote) this.updateItemPlacementVoteVisuals();
        };
        this.endSession = async (closeConnection = true)=>{
            this.logger.log(`Ending GameSession (${this.sessionIndex}) and closing connection`);
            // Hide tab that was used to switch to this session
            this.viewManager.setPlayerTabShowing(this.sessionIndex, false);
            // Unsub/remove listeners
            window.removeEventListener("popstate", this.onWindowPopState);
            this.game.onMsgMessage.unsubscribe(this.onMsgMessage);
            this.game.onMsgServerInfo.unsubscribe(this.onMsgServerInfo);
            this.game.onConnectionEvent.unsubscribe(this.onConnectionEvent);
            this.game.onJoinCodeSet.unsubscribe(this.viewManager.setJoinCodeText);
            this.game.onStartSendingToGame.unsubscribe(this.onProxyStartSendingToGame);
            this.game.onDoneOrFailSendingToGame.unsubscribe(this.onProxyDoneOrFailSendingToGame);
            this.cookieHelper.clearDeviceIdForSessionIndex(this.sessionIndex);
            // Join code cookie is cleared only when ALL game sessions were ended (see: App.onGameSessionEnded)
            try {
                if (closeConnection) await this.game.closeConnection(true);
            } catch (e) {
                throw e;
            } finally{
                this._onGameSessionEnded.dispatch(this);
            }
        };
        this.becameActiveSession = async (alreadyActive)=>{
            this.logger.debug(`GameSession ${this.sessionIndex} became active session (alreadyActive:${alreadyActive}), controllerState:${this.currentControllerState}`);
            switch(this.currentControllerState){
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).JoinScreen:
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForSetup:
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WatchingActions:
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementResults:
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).LevelFinished:
                    break;
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput:
                    if (this.isNonCharacterPlayer) {
                        if (!this.app.resettingApp) this.viewManager.show((0, $8b07c0f1748354ec$export$27a5bd065ad55220).WriterTextInput, true);
                        this.updateWriterTextInputVisuals();
                    } else {
                        if (!this.app.resettingApp) this.viewManager.show((0, $8b07c0f1748354ec$export$27a5bd065ad55220).GameInputPhase, true);
                        // Initialise button visuals from the active session's TurnSet and ensure GameInputPhase is showing
                        this.initialiseInputPhaseVisuals();
                    }
                    break;
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).CharacterSelect:
                    await this.updateCharacterSelectVisuals();
                    break;
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementVote:
                    this.updateItemPlacementVoteVisuals();
                    break;
                default:
                    throw new Error(`Unexpected ControllerState for becameActiveSession: ${this.currentControllerState}`);
            }
            // Update tab visuals to ensure correct session is visually selected
            this.updatePlayerTabVisuals();
        };
        this.joinGame = async (joinGameParams)=>{
            this.logger.debug("joinGame(", joinGameParams, `) = GameSession ${this.sessionIndex}: Joining game`);
            if (this.currentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).JoinScreen) {
                this.logger.error(`joinGame should only be called when currentControllerState === JoinScreen, not ${this.currentControllerState}`);
                return {
                    success: false
                };
            }
            const joinCode = joinGameParams.forceJoinCode ?? joinGameParams.joinCode;
            // Ensure the joinCode that will be validated is definitely the joinCode we are using
            //	(i.e. if we are using forceJoinCode, we want to make sure we're validating that one)
            joinGameParams.joinCode = joinCode;
            const validationResult = (0, $58dbd298dd17636b$export$ebb36375df04bd2a)(joinGameParams);
            if (!validationResult.isValid) {
                await this.viewManager.showInfoPopupDialog("Error", validationResult.errorText, null);
                return {
                    success: false
                };
            }
            // TODO-2022/08/15: Encode/strip player name so no other dodgy content! (HTML exploits?)
            this._playerName = joinGameParams.playerName;
            this.viewManager.setPlayerTabShowing(this.sessionIndex, true);
            this.game.setCurrentJoinCode(joinCode);
            if (this.isActiveInView) this.viewManager.show((0, $8b07c0f1748354ec$export$27a5bd065ad55220).Joining);
            try {
                await this.game.joinGame(joinCode, joinGameParams.playerName);
                this.logger.debug("Joined.  Awaiting start.");
                if (this.isActiveInView) {
                    this.viewManager.setupJoinedPlayersList(this.app.allJoinedPlayerNames, this.app._sessionCount);
                    this.viewManager.show((0, $8b07c0f1748354ec$export$27a5bd065ad55220).WaitOrAddPlayers, true);
                }
                this.onJoinedOrRejoinedGame();
                return {
                    success: true,
                    joinCode: joinCode
                };
            } catch (e) {
                if (!e || !(e instanceof Error)) e = new Error("Error:" + e);
                let error = e;
                // TODO-20230509: Better way to assert we know responseCode is in here
                const responseCode = "responseCode" in error ? error.responseCode : (0, $ece558983632ed02$export$b044ccb39e003d90).UnknownDoNotUse;
                const responseCodeName = (0, $ece558983632ed02$export$1ce4a0e1ecd4fd1)(responseCode);
                this.logger.error("Failed to join game, try again:", error.message, responseCodeName, e);
                if (this.isActiveInView) {
                    // TODO-2022/08/15: Use ResponseCode + messages table for errors --> L10N!
                    if ((0, $ece558983632ed02$export$b044ccb39e003d90).JoinCodeNotAllowed === responseCode) await this.viewManager.showInfoPopupDialog("Error", "Cannot join that game, maybe it's full?", ()=>this.viewManager.show((0, $8b07c0f1748354ec$export$27a5bd065ad55220).Lobby, true), "Close");
                    else if ((0, $ece558983632ed02$export$b044ccb39e003d90).JoinCodeInvalid === responseCode || error.message.replace(/\s/g, "").toLowerCase().includes("joincode")) // Error message (removed spaces & lowercase) contains 'joincode', show specific join code error popup
                    await this.viewManager.showInfoPopupDialog("Error", "We don't know that join code, please check it's right?", ()=>this.viewManager.show((0, $8b07c0f1748354ec$export$27a5bd065ad55220).Lobby, true), "Close");
                    else await this.viewManager.showInfoPopupDialog("Error", "Failed to join game.", ()=>this.viewManager.show((0, $8b07c0f1748354ec$export$27a5bd065ad55220).Lobby, true), "Close", true, error.message);
                }
                return {
                    success: false
                };
            }
        };
        this.consumeEvent = (evt)=>{
            /*evt = evt || window.event; -- latter is deprecated! */ if ("undefined" == typeof evt.stopPropagation) evt.cancelBubble = true;
            else evt.stopPropagation();
        };
        this.onCancelOrBack = ()=>{
            switch(this.viewManager.getCurrentViewId()){
                case (0, $8b07c0f1748354ec$export$27a5bd065ad55220).CharacterSelect:
                case (0, $8b07c0f1748354ec$export$27a5bd065ad55220).GameInputPhase:
                case (0, $8b07c0f1748354ec$export$27a5bd065ad55220).ItemPlacementVote:
                case (0, $8b07c0f1748354ec$export$27a5bd065ad55220).WriterTextInput:
                    if (this.isActiveInView) this.viewManager.showGameMenu();
                    break;
                default:
                    break;
            }
        };
        this.requestCharacterSelection = async (newCharacterIndex)=>{
            if (this.currentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).CharacterSelect) {
                this.logger.error(`requestCharacterSelection should only be called when currentControllerState is ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).CharacterSelect]}, but is ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[this.currentControllerState]}`);
                return;
            }
            if (this.characterIndex === newCharacterIndex) // The requested character was already selected by this device, instead
            //	set the character index to -1, which will deselect the character
            newCharacterIndex = -1;
            try {
                await this.game.sendCharacterSelectRequest(newCharacterIndex);
                if (newCharacterIndex > -1) this.waitingOnCharacterSelectRequest = true;
            } catch (e) {
                this.logger.error("Failed to send character selection to The Game due to:", e);
            }
        };
        this.requestNonCharacterSelection = async ()=>{
            if (this.currentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).CharacterSelect) {
                this.logger.error(`requestNonCharacterSelection should only be called when currentControllerState is ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).CharacterSelect]}`);
                return;
            }
            if (this.isNonCharacterPlayer) {
                // Already selected a non-character, deselect
                await this.requestCharacterSelection(-1);
                return;
            }
            // Try selecting any available non-character index
            try {
                await this.game.sendNonCharacterSelectRequest();
                this.waitingOnCharacterSelectRequest = true;
            } catch (e) {
                this.logger.error("Failed to send non-character selection to The Game due to:", e);
            }
        };
        this.selectATurnNumber = (turnNumber)=>{
            if (undefined === this.turnSet) throw new Error("Trying to select a turn with undefined turnSet");
            if (this.currentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput) {
                this.logger.error("selectATurnNumber should only be called when currentControllerState === WaitingForInput");
                return;
            }
            this.logger.log(`Selecting turn: ${turnNumber}`);
            this.currentlySelectingTurnNumber = turnNumber;
            this.cookieHelper.setSelectedTurnForSessionIndex(this.sessionIndex, turnNumber);
            if (this.isActiveInView) {
                // Update action previews with current actions for each turn
                for(let i = 0; i < this.turnSet.numTurns; i++);
                this.viewManager.updateTurnSelectedVisuals(turnNumber, this.turnsPerRound);
            }
            if (this.selectionWasMadeForTurn[turnNumber]) {
                // Selection has already been made for this turn
                const actionNum = this.app.getActionNumberByName(this.turnSet.get(turnNumber).action);
                const selectedActionForThisTurn = actionNum;
                this.selectActionNumber(selectedActionForThisTurn, false);
            } else // No selection has been made for this turn, select the default action
            this.selectActionNumber($dd300fc197dcf9fe$export$a3eb6b94b1e7587a.DefaultSelectedActionNumber, false);
        };
        this.selectActionNumber = async (actionNumber, playerPressed)=>{
            if (undefined === this.turnSet) throw new Error("Trying to select an action, but turnSet is undefined");
            if (this.currentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput) throw new Error("selectActionWithName should only be called when currentControllerState === WaitingForInput");
            if (undefined === this.currentlySelectingTurnNumber) throw new Error("Trying to select an action, but no turn number was selected yet");
            if (actionNumber < 0 || actionNumber >= (0, $ac58392a9f7a45e7$export$86fbec116b87613f).ActionButtonCount) throw new Error(`actionNumber (${actionNumber}) is out of range of the available action types`);
            const selectedTurn = this.currentlySelectingTurnNumber;
            let previouslySelectedTurnData = "";
            // When the player presses a new action button, reset any existing action/data for this turn
            if (playerPressed) {
                previouslySelectedTurnData = this.turnSet.get(selectedTurn).data;
                this.turnSet.set(selectedTurn, new (0, $677b4c43f3df91ac$export$f02bc863a6b78ce2)("", ""));
                this.selectionWasMadeForTurn[selectedTurn] = false;
                this.viewManager.setTurnButtonVisual(selectedTurn, true, undefined, "", this.app.imageURLCache);
            }
            // Then select the new action (this does not set the turn, that only happens when selection is complete, which may require extra data, e.g. direction)
            this.selectedActionNumber = actionNumber;
            const buttonData = this.app.getActionButtonData(actionNumber);
            const actionRequiresData = buttonData.hasDirectionDataOrDefault;
            if (this.isActiveInView) {
                this.viewManager.updateActionSelectedVisuals(actionNumber);
                this.viewManager.setDirectionalButtonsForAction(buttonData);
                this.viewManager.setDirectionButtonsEnabled(actionRequiresData && buttonData.enabledOrDefault);
                this.viewManager.updateDirectionSelectedVisuals("");
            }
            let dataForCurrentTurn = this.turnSet.get(selectedTurn).data;
            if (dataForCurrentTurn === "" && previouslySelectedTurnData !== "") dataForCurrentTurn = previouslySelectedTurnData;
            if (actionRequiresData && dataForCurrentTurn !== "") await this.selectDataForCurrentTurn(dataForCurrentTurn, playerPressed, false);
            else if (!actionRequiresData) // Action does not require data - selection is complete and the turn can be set
            await this.completeTurnSelection(actionNumber, buttonData.action, "", playerPressed);
        };
        this.selectDataForCurrentTurn = async (data, playerPressed, allowAutoSelectNext = true)=>{
            if (undefined === this.selectedActionNumber) throw new Error("Trying to set data with no selected action number");
            const buttonData = this.app.getActionButtonData(this.selectedActionNumber);
            if (!buttonData.hasDirectionDataOrDefault) {
                this.logger.warn(`Selecting data for an action that does not require any (action ${this.selectedActionNumber})`);
                return;
            }
            if (this.isActiveInView) this.viewManager.updateDirectionSelectedVisuals(data);
            // Action does not require data - we're done selecting for this turn
            await this.completeTurnSelection(this.selectedActionNumber, buttonData.action, data, playerPressed, allowAutoSelectNext);
        };
        this.completeTurnSelection = async (actionIndex, actionName, data, playerPressed, allowAutoSelectNext = true)=>{
            if (undefined === this.turnSet) throw new Error("Trying to set action and data for selected turn, but turnSet is undefined");
            if (undefined === this.currentlySelectingTurnNumber) throw new Error("Trying to set action and data for selected turn, but currentlySelectingTurnNumber is undefined");
            const selectedTurn = this.currentlySelectingTurnNumber;
            this.logger.log(`Completing selection for turn ${selectedTurn} - ${actionName} ${data} (Player pressed: ${playerPressed})`);
            this.turnSet.set(selectedTurn, new (0, $677b4c43f3df91ac$export$f02bc863a6b78ce2)(actionName, data));
            this.selectionWasMadeForTurn[selectedTurn] = true;
            this.cookieHelper.setTurnSetForSessionIndex(this.sessionIndex, new (0, $109c27dde40935f6$export$68656b7c8056ebd6)(this.turnSet, this.selectionWasMadeForTurn));
            if (playerPressed) // Un-ready if the player made a new selection
            try {
                await this.setReadyAndSend(false, false);
            } catch (e) {
                this.logger.error(`ERROR: Failed to tell The Game we are not ready:`, e);
            }
            if (this.isActiveInView) {
                this.viewManager.setTurnButtonVisual(selectedTurn, true, this.app.getActionButtonData(actionIndex), data, this.app.imageURLCache);
                // Allow the player to press 'ready' when they have selected an action for every turn
                if ($dd300fc197dcf9fe$export$a3eb6b94b1e7587a.CanReadyWithEmptyTurns) this.viewManager.setReadyButtonShowing(true);
                else this.viewManager.setReadyButtonShowing(this.allTurnsSelected());
            }
            // If this selection was triggered by the player pressing a button,
            //	automatically select the next empty turn (unless AutoSelectionEnabled is false)
            //	If there are no empty turns, just select the next turn
            if (!playerPressed || !$dd300fc197dcf9fe$export$a3eb6b94b1e7587a.AutoSelectionEnabled || !allowAutoSelectNext) return;
            let nextTurn = selectedTurn < this.turnsPerRound - 1 ? selectedTurn + 1 : 0;
            let nextEmptyTurn;
            for(let i = 0; i < this.turnsPerRound; i++)if (!this.selectionWasMadeForTurn[i]) {
                // Found an empty turn
                if (i > selectedTurn) {
                    // If an empty turn exists after the current one, select it
                    nextEmptyTurn = i;
                    break;
                } else if (nextEmptyTurn === undefined) // The first empty turn will be selected if there are no empty turns after the current one
                nextEmptyTurn = i;
            }
            this.selectATurnNumber(nextEmptyTurn ?? nextTurn);
        };
        this.allTurnsSelected = ()=>{
            for(let i = 0; i < this.turnsPerRound; i++){
                if (!this.selectionWasMadeForTurn[i]) return false;
            }
            return true;
        };
        this.changeSessionIndex = (newIndex)=>{
            this.viewManager.setPlayerTabShowing(this.sessionIndex, false);
            // Update cookies so can resume if reloaded
            this.cookieHelper.clearDeviceIdForSessionIndex(this.sessionIndex);
            this.cookieHelper.setDeviceIdForSessionIndex(newIndex, this.deviceId);
            this.sessionIndex = newIndex;
            this.viewManager.setPlayerTabShowing(this.sessionIndex, true);
        };
        this.onReadyButtonPressed = async (ready)=>{
            if (this.isNonCharacterPlayer && this.currentControllerState === (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput) {
                // For non-character players in WaitingForInput state, the 'Ready' button instead becomes a 'send narrative text' button
                await this.trySendNarrativeCharacterText();
                return;
            }
            // Standard ready or un-ready (sends ready state msg to game)
            await this.setReadyAndSend(ready, true);
            if (!ready && this.currentControllerState === (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput) // When un-readying in WaitingForInput state, reset/clear moves after setting/send ready = false state
            await this.resetForNewRound();
        };
        this.trySendAutoReady = async (autoReady)=>{
            if (!this.hasSelectedCharacter) {
                this.logger.warn(`Told to send auto-ready = ${autoReady} to game, but no character is selected for session ${this.sessionIndex},` + ` so not sending because this session is not partaking in the game/no player router will be present`);
                return false;
            }
            if (!autoReady) {
                await this.game.sendAutoReady(false);
                // Player un-readys when disabling auto-ready
                await this.setReadyWithoutSending(false, false);
                return true;
            }
            if (this.currentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput) {
                this.logger.error(`trySendAutoReady: Not sending autoReady enabled in ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[this.currentControllerState]} state`);
                return false;
            }
            await this.game.sendAutoReady(true);
            return true;
        };
        this.updateReadyStateVisuals = (visualReadyPressed)=>{
            this.viewManager.updateSessionReadyStateVisuals(this.sessionIndex, visualReadyPressed);
            if (this.isActiveInView) // Set whether "Ready!" button should appear to be pressed/disabled based on the given visualReadyPressed value,
            //	but only allow the 'unready' button to be displayed if this.isReady == true, i.e. definitely in ready state
            this.viewManager.setReadyButtonPressed(visualReadyPressed, this.isReady);
        };
        this.setReadyWithoutSending = async (ready, allowAutoSessionChange)=>{
            await this.setReady(ready, false, allowAutoSessionChange);
        };
        this.setReadyAndSend = async (ready, allowAutoSessionChange)=>{
            await this.setReady(ready, true, allowAutoSessionChange);
        };
        this.setReady = async (ready, sendState, allowAutoSessionChange)=>{
            this.logger.debug("setReady(", ready, ", sendState:", sendState, ")");
            if (this.isReady === ready) {
                this.logger.debug("setReady: Already marked as ready:", ready);
                return;
            }
            // Update visuals straight away (before awaiting sending of state) for immediate user feedback
            //	- If something goes wrong when sending/updating the state, this visual change will be reverted
            this.updateReadyStateVisuals(ready);
            try {
                if (sendState) {
                    const sendSuccess = await this.trySendReadyState(ready);
                    if (!sendSuccess) {
                        // Logging handled in trySendReadyState
                        this.updateReadyStateVisuals(this.isReady);
                        return;
                    }
                }
                this.isReady = ready;
                this.logger.log("setReady: Ready status successfully set to:", ready);
            } catch (e) {
                this.updateReadyStateVisuals(this.isReady);
                throw new Error(`Failed to send ready status to The Game due to: ${e}`);
            }
            this.updateReadyStateVisuals(this.isReady);
            if (ready && allowAutoSessionChange) {
                // Switch to the next GameSession where the player is not 'ready' so they can make their selections
                await this.app.switchToNextNonReadyGameSession(this.sessionIndex);
                return;
            }
        };
        this.trySendReadyState = async (ready)=>{
            if (!this.hasSelectedCharacter) {
                this.logger.warn(`Told to send ready = ${ready} to game, but no character is selected for session ${this.sessionIndex},` + ` so not sending because this session is not partaking in the game/no player router will be present`);
                return false;
            }
            if (!ready) {
                // Send to game: Not ready!
                await this.game.sendReadyState(false);
                return true;
            }
            // Send to game: Ready! (And other things depending on state)
            if (this.currentControllerState === (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput) {
                if (this.isNonCharacterPlayer) {
                    this.logger.error(`trySendReadyState: No need to send ready state for non-character player in WaitingForInput state`);
                    return false;
                }
                // Send actions *and* set ready true
                await this.game.sendTurnSetAndReady(this.turnSet);
            } else if (this.currentControllerState === (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementVote) {
                // Sent item placement data *and* set ready to true
                if (!this.itemManagementData) {
                    this.logger.error(`Trying to send item management results to game with null ItemManagementData`);
                    return false;
                }
                await this.game.sendItemManagementResultsAndReady(this.itemManagementData, this.characterIndex);
            } else this.logger.error(`Trying to send ready state to game in unexpected controller state: ${this.currentControllerState}`);
            return true;
        };
        this.trySendNarrativeCharacterText = async ()=>{
            if (!this.hasSelectedCharacter) {
                this.logger.warn(`Told to send narrative to game, but no character is selected for session ${this.sessionIndex},` + ` so not sending because this session is not partaking in the game/no router will be present`);
                return false;
            }
            // Non-character player: Send narrative text *and* set ready true
            if (this.characterWritingData === undefined) {
                this.logger.error(`No characterWritingData in trySendNarrativeCharacterText for non-player character (GameSession ${this.sessionIndex})`);
                return false;
            }
            // Validate writer text input before sending
            const validationResult = (0, $58dbd298dd17636b$export$84ea90aca0ecf643)(this.characterWritingData.selectedCharacterText);
            if (!validationResult.isValid) {
                await this.viewManager.showInfoPopupDialog("Error", validationResult.errorText, null);
                return false;
            }
            await this.game.sendNarrativeCharacterText(this.characterWritingData);
            // Message was sent, reset/clear text
            this.characterWritingData.setTextInputForSelectedCharacter("");
            // Update visuals for writer input view (including disabling the 'ready'/'send' button),
            //	only if this is still the active game session after text was sent
            if (this.isActiveInView) this.viewManager.updateWriterTextInputSelectionVisuals(this.characterWritingData);
            // Update character text cookie so cleared text is not saved & restored
            const textForAllCharacters = this.characterWritingData.getCharacterNameToTextMap();
            this.cookieHelper.setCharacterTextForSessionIndex(this.sessionIndex, textForAllCharacters);
            return true;
        };
        this.connected = async ()=>{
            // Show another tab for switching to this session
            this.viewManager.setPlayerTabShowing(this.sessionIndex, true);
            const isRejoining = this.game.didRejoinPreviousSession;
            // If we rejoined an 'in-progress' game (possibly still being set-up!), the Game sends a message to tell us the state to go to.
            this.logger.log(`Connected: isRejoining:${isRejoining}`);
            // Controller state was already initialised to JoinScreen when this session was created.
            // If reconnecting, the game will send a msg with whatever state we need to return to,
            //	and App will update the view based on this state once all sessions have connected.
            if (isRejoining) {
                this.onJoinedOrRejoinedGame();
                this.viewManager.show((0, $8b07c0f1748354ec$export$27a5bd065ad55220).WaitOrAddPlayers, true);
                this.logger.debug(`showing WaitOrAddPlayers for ${this.sessionIndex} which ${this.isInitialSession ? "is" : "is not"} the initial session`);
            } else {
                this.viewManager.setupLobbyUI(this.isInitialSession);
                this.viewManager.show((0, $8b07c0f1748354ec$export$27a5bd065ad55220).Lobby, true);
                this.logger.debug(`showing lobby for ${this.sessionIndex} which ${this.isInitialSession ? "is" : "is not"} the initial session`);
            }
        };
        this.onMsgMessage = async (msgMessage)=>{
            this.logger.silly("onMsgMessage:", msgMessage); // TODO-20230309: TEMP debug
            let data; // TODO-2021/09/26: Better type?
            try {
                data = msgMessage.getDataDecoded();
            } catch (e) {
                this.logger.error("Failed to parse message from Game due to:", e, "message was:", msgMessage);
                return;
            }
            if (data.hasOwnProperty((0, $ee66a3e070746278$export$11f36a4bab39d793).ReclaimedController)) {
                this.logger.debug(`Received "${(0, $ee66a3e070746278$export$11f36a4bab39d793).ReclaimedController}" msg this device, meaning it's now active in a different tab/instance`);
                await this.onExternalDisconnectOrReclaimed(false);
                return;
            }
            if (data.hasOwnProperty((0, $ee66a3e070746278$export$11f36a4bab39d793).BootController)) {
                await this.onBootControllerMsgMessage();
                // We've been booted and the connection was closed, nothing more to do here
                return;
            }
            if (data.hasOwnProperty((0, $ee66a3e070746278$export$11f36a4bab39d793).CustomController.ActionButton)) {
                this.onCustomControllerActionButtonMsgMessage(data);
                // Action button data is not sent as part of a combined message, so no need to check others
                return;
            }
            if (data.hasOwnProperty((0, $ee66a3e070746278$export$11f36a4bab39d793).ImageBase64.ImageName)) {
                this.onImageBase64MsgMessage(data);
                // Base64 image data is not sent as part of a combined message, so no need to check others
                return;
            }
            // Not else-if chain to allow combined reconnect messages
            // (have SetState, ConfirmCharacters, and (sometimes) ItemManagement in one)
            // Need to know confirmed character selection before setting state,
            // since the view that's shown for some states may depend on if a selection was made
            if (data.hasOwnProperty((0, $ee66a3e070746278$export$11f36a4bab39d793).ConfirmCharacters.Name)) await this.onConfirmCharactersMsgMessage(data);
            if (data.hasOwnProperty((0, $ee66a3e070746278$export$11f36a4bab39d793).SetState)) {
                const newStateTxt = data[(0, $ee66a3e070746278$export$11f36a4bab39d793).SetState];
                const newState = (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[newStateTxt];
                // TODO: Validate it is a `ControllerState`
                await this.setControllerState(newState);
            }
            if (data.hasOwnProperty((0, $ee66a3e070746278$export$11f36a4bab39d793).ItemManagement.Name)) this.onItemManagementMsgMessage(data);
            if (data.hasOwnProperty((0, $ee66a3e070746278$export$11f36a4bab39d793).NarrativeCharacters.Name)) this.onNarrativeCharactersMsgMessage(data);
            if (data.hasOwnProperty((0, $ee66a3e070746278$export$11f36a4bab39d793).NumTurns)) await this.onNumTurnsMsgMessage(data);
        };
        this.onBootControllerMsgMessage = async ()=>{
            this.logger.log(`deviceId ${this.deviceId} was booted from the game, ending GameSession`);
            // End this session without closing connection - the actual device disconnect/removal is handled in MsgBootDevice
            await this.endSession(false);
            // Display dialog to notify the player(s) that someone on this device was booted
            this.viewManager.showInfoPopupDialog("", `${this.playerName} was removed from the game by the host.`, null);
        };
        this.onCustomControllerActionButtonMsgMessage = (data)=>{
            const actionButtonData = data[(0, $ee66a3e070746278$export$11f36a4bab39d793).CustomController.ActionButton];
            if (!actionButtonData.hasOwnProperty("buttonIndex")) throw new Error(`No buttonIndex property in received controller action button data`);
            let buttonIndex = actionButtonData["buttonIndex"];
            this.setActionButtonFromControllerData(actionButtonData, buttonIndex);
        };
        this.onImageBase64MsgMessage = (data)=>{
            if (!data.hasOwnProperty((0, $ee66a3e070746278$export$11f36a4bab39d793).ImageBase64.Data)) throw new Error(`No ${(0, $ee66a3e070746278$export$11f36a4bab39d793).ImageBase64.Data} property in data for msg with ${(0, $ee66a3e070746278$export$11f36a4bab39d793).ImageBase64.ImageName}: ${data}`);
            const imageName = data[(0, $ee66a3e070746278$export$11f36a4bab39d793).ImageBase64.ImageName];
            const imageBase64Data = data[(0, $ee66a3e070746278$export$11f36a4bab39d793).ImageBase64.Data];
            // Create image URL from base 64 data and add it to the image URL cache
            this.app.imageURLCache.createImageObjectURL(imageName, imageBase64Data);
        };
        this.onItemManagementMsgMessage = (data)=>{
            if (!data.hasOwnProperty((0, $ee66a3e070746278$export$11f36a4bab39d793).ItemManagement.Positions)) throw new Error(`No ${(0, $ee66a3e070746278$export$11f36a4bab39d793).ItemManagement.Positions} property in ${(0, $ee66a3e070746278$export$11f36a4bab39d793).ItemManagement.Name}: ${data}`);
            if (!data.hasOwnProperty((0, $ee66a3e070746278$export$11f36a4bab39d793).ItemManagement.ItemNames)) throw new Error(`No ${(0, $ee66a3e070746278$export$11f36a4bab39d793).ItemManagement.ItemNames} property in ${(0, $ee66a3e070746278$export$11f36a4bab39d793).ItemManagement.Name}: ${data}`);
            let initialSelectedItemIndex = 0;
            if (this.itemManagementData !== undefined) initialSelectedItemIndex = this.itemManagementData.selectedItemVoteIndex;
            const placementPositions = data[(0, $ee66a3e070746278$export$11f36a4bab39d793).ItemManagement.Positions];
            const itemNames = data[(0, $ee66a3e070746278$export$11f36a4bab39d793).ItemManagement.ItemNames];
            this._itemManagementData = new (0, $b07ee39fb2d6b957$export$74cd332a2d711c2f)(placementPositions.length, itemNames, initialSelectedItemIndex, this.sessionIndex, this.cookieHelper);
            if (this.isActiveInView && this.currentControllerState === (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementVote) this.updateItemPlacementVoteVisuals();
        };
        this.onNarrativeCharactersMsgMessage = (data)=>{
            if (!this.hasSelectedCharacter || !this.isNonCharacterPlayer) return;
            if (!data.hasOwnProperty((0, $ee66a3e070746278$export$11f36a4bab39d793).NarrativeCharacters.CharacterInternalNames)) throw new Error(`No ${(0, $ee66a3e070746278$export$11f36a4bab39d793).NarrativeCharacters.CharacterInternalNames} property in ${(0, $ee66a3e070746278$export$11f36a4bab39d793).NarrativeCharacters.Name}: ${data}`);
            if (!data.hasOwnProperty((0, $ee66a3e070746278$export$11f36a4bab39d793).NarrativeCharacters.CharacterDisplayNames)) throw new Error(`No ${(0, $ee66a3e070746278$export$11f36a4bab39d793).NarrativeCharacters.CharacterDisplayNames} property in ${(0, $ee66a3e070746278$export$11f36a4bab39d793).NarrativeCharacters.Name}: ${data}`);
            const characterInternalNames = data[(0, $ee66a3e070746278$export$11f36a4bab39d793).NarrativeCharacters.CharacterInternalNames];
            const characterDisplayNames = data[(0, $ee66a3e070746278$export$11f36a4bab39d793).NarrativeCharacters.CharacterDisplayNames];
            const sameCharactersReceived = this.characterWritingData?.doCharacterInternalNamesMatchThis(characterInternalNames) ?? false;
            if (sameCharactersReceived) return;
            this._characterWritingData = new (0, $a73b546ea725d550$export$2b90dbfed7b418ed)(characterInternalNames, characterDisplayNames, this.cookieHelper.getCharacterTextForSessionIndex(this.sessionIndex));
            if (this.isActiveInView && this.currentControllerState === (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput && this.isNonCharacterPlayer) this.updateWriterTextInputVisuals();
        };
        this.onConfirmCharactersMsgMessage = async (data)=>{
            const allSelected = data[(0, $ee66a3e070746278$export$11f36a4bab39d793).ConfirmCharacters.Name];
            if (!data.hasOwnProperty((0, $ee66a3e070746278$export$11f36a4bab39d793).ConfirmCharacters.AllNonCharactersSelected)) throw new Error(`No ${(0, $ee66a3e070746278$export$11f36a4bab39d793).ConfirmCharacters.AllNonCharactersSelected} property in ${(0, $ee66a3e070746278$export$11f36a4bab39d793).ConfirmCharacters.Name}: ${data}`);
            this.allNonCharactersSelected = data[(0, $ee66a3e070746278$export$11f36a4bab39d793).ConfirmCharacters.AllNonCharactersSelected];
            const newCharacterIndex = data[this.deviceId];
            this.selectedCharacterIndexes = [];
            for(const property in data){
                this.logger.debug(`Checking data: ${property}`);
                // Skip known commands (supplied with the reconnect message)
                switch(property){
                    case (0, $ee66a3e070746278$export$11f36a4bab39d793).ConfirmCharacters.Name:
                    case (0, $ee66a3e070746278$export$11f36a4bab39d793).ConfirmCharacters.AllNonCharactersSelected:
                    case (0, $ee66a3e070746278$export$11f36a4bab39d793).SetState:
                    case (0, $ee66a3e070746278$export$11f36a4bab39d793).ThrowEnabled:
                    case (0, $ee66a3e070746278$export$11f36a4bab39d793).NumTurns:
                    case (0, $ee66a3e070746278$export$11f36a4bab39d793).ItemManagement.Name:
                    case (0, $ee66a3e070746278$export$11f36a4bab39d793).ItemManagement.ItemNames:
                    case (0, $ee66a3e070746278$export$11f36a4bab39d793).ItemManagement.Positions:
                    case (0, $ee66a3e070746278$export$11f36a4bab39d793).NarrativeCharacters.Name:
                    case (0, $ee66a3e070746278$export$11f36a4bab39d793).NarrativeCharacters.CharacterInternalNames:
                    case (0, $ee66a3e070746278$export$11f36a4bab39d793).NarrativeCharacters.CharacterDisplayNames:
                    case (0, $b77ef7ec1849431b$export$2e2bcd8739ae039).MsgTopicName:
                        continue;
                }
                // TODO-2023/03/19 This assumes a 'ConfirmCharacters' message only has an array mapping deviceId to character number.
                //   This precludes/limits using a combined message (which we're now doing).  The message sent needs restructuring.
                //   For now, skipping anything not a number but any combined message that uses numeric values will cause problems here!
                if (!("number" === typeof data[property])) {
                    this.logger.warn(`Skipping data:${property} which is not a number but got: ${data[property]}`);
                    continue;
                }
                this.selectedCharacterIndexes.push(data[property]);
            }
            if (newCharacterIndex !== undefined && newCharacterIndex >= -1 && newCharacterIndex < $dd300fc197dcf9fe$export$a3eb6b94b1e7587a.CharacterPlayerCount + $dd300fc197dcf9fe$export$a3eb6b94b1e7587a.NonCharacterPlayerCount) {
                this.logger.log(`Confirming character selection index for ${this.deviceId}: ${newCharacterIndex} (All selected: ${allSelected})`);
                this.characterIndex = newCharacterIndex;
            } else this.logger.error(`Invalid character index when receiving ${(0, $ee66a3e070746278$export$11f36a4bab39d793).ConfirmCharacters.Name}: ${newCharacterIndex}`);
            if (this.currentControllerState === (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).CharacterSelect) {
                await this.updateCharacterSelectVisuals();
                if (this.waitingOnCharacterSelectRequest) await this.app.switchToNextNonReadyGameSession(this.sessionIndex);
            }
            this.waitingOnCharacterSelectRequest = false;
            this.updatePlayerTabVisuals();
        };
        this.onNumTurnsMsgMessage = async (data)=>{
            let newTurnsPerRound = data[(0, $ee66a3e070746278$export$11f36a4bab39d793).NumTurns];
            if (newTurnsPerRound < (0, $ac58392a9f7a45e7$export$86fbec116b87613f).MinValidTurnsPerRound) newTurnsPerRound = (0, $ac58392a9f7a45e7$export$86fbec116b87613f).MinValidTurnsPerRound;
            else if (newTurnsPerRound > (0, $ac58392a9f7a45e7$export$86fbec116b87613f).MaxValidTurnsPerRound) newTurnsPerRound = (0, $ac58392a9f7a45e7$export$86fbec116b87613f).MaxValidTurnsPerRound;
            if (newTurnsPerRound !== this.turnsPerRound) {
                this._turnsPerRound = newTurnsPerRound;
                if (this.currentControllerState == (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput) await this.resetForNewRound();
            }
        };
        this.setActionButtonFromControllerData = async (actionButtonData, buttonIndex)=>{
            if (buttonIndex < 0) throw new Error(`Invalid buttonIndex (${buttonIndex}) when trying to add action button using data received from game`);
            if (buttonIndex >= (0, $ac58392a9f7a45e7$export$86fbec116b87613f).ActionButtonCount) {
                this.logger.warn(`Trying to add action button with button index: ${buttonIndex}. Skipping since we currently only allow a maximum of ${(0, $ac58392a9f7a45e7$export$86fbec116b87613f).ActionButtonCount} buttons to be defined.`);
                return;
            }
            // Create new ControllerActionButton from received data
            const actionButtonInstance = new (0, $4b1e45d61ed1a70b$export$5730f849b02574b8)(false, actionButtonData.action, actionButtonData.enabled, actionButtonData.hasDirectionData, actionButtonData.label, actionButtonData.imageName, actionButtonData.imageBase64, actionButtonData.mainColour, actionButtonData.secondaryColour);
            // Create image URL from base 64 data and add it to the image URL cache
            await actionButtonInstance.createImageObjectURL(this.app.imageURLCache);
            // Assign the new button to the CustomControllerData that's used to determine how buttons will look & their associated actions
            this.app.setCustomControllerActionButton(buttonIndex, actionButtonInstance);
        };
        this.onMsgServerInfo = async (msgServerInfo)=>{
            let infoCode = msgServerInfo.infoCode;
            switch(infoCode){
                case (0, $4579d1fd9382140c$export$b5d9228d85ef4461).Connected:
                case (0, $4579d1fd9382140c$export$b5d9228d85ef4461).ControllerConnected:
                case (0, $4579d1fd9382140c$export$b5d9228d85ef4461).ControllerReconnected:
                    //nop
                    // These aren't sent to the 'peer controllers' so never really seen
                    this.logger.debug(`Info from server: peer (not us) controller:`, msgServerInfo);
                    break;
                case (0, $4579d1fd9382140c$export$b5d9228d85ef4461).ControllerDisconnectedTemporarily:
                case (0, $4579d1fd9382140c$export$b5d9228d85ef4461).ControllerDisconnectedPermanently:
                    const disconnectInfoMsg = msgServerInfo;
                    if (disconnectInfoMsg.deviceId == this.deviceId) {
                        this.logger.debug(`Received ${(0, $4579d1fd9382140c$export$b5d9228d85ef4461).ControllerDisconnectedTemporarily} for this device, meaning it disconnected in a different tab/instance`);
                        await this.onExternalDisconnectOrReclaimed(disconnectInfoMsg.infoCode == (0, $4579d1fd9382140c$export$b5d9228d85ef4461).ControllerDisconnectedPermanently);
                    }
                    break;
                case (0, $4579d1fd9382140c$export$b5d9228d85ef4461).GameDisconnectedTemporarily:
                case (0, $4579d1fd9382140c$export$b5d9228d85ef4461).GameReconnected:
                    this.logger.debug(`Info from server: Game:`, msgServerInfo);
                    break;
                case (0, $4579d1fd9382140c$export$b5d9228d85ef4461).GameDisconnectedPermanently:
                    if (this.isActiveInView) // Game disconnected - show error then reset the app to start afresh
                    await this.viewManager.showInfoPopupDialog("Error", "Connection to the game was lost.", this.app.resetApp, "Close");
                    break;
                case (0, $4579d1fd9382140c$export$b5d9228d85ef4461).UnknownDoNotUse:
                    throw new Error(`onMsgServerInfo() received msg with bad ${(0, $4579d1fd9382140c$export$b5d9228d85ef4461)}: ${infoCode}: ${(0, $003b09fe89de2289$export$f84e8e69fd4488a5)(msgServerInfo)}`);
                default:
                    throw new Error(`Unhandled ${(0, $4579d1fd9382140c$export$b5d9228d85ef4461)} for onMsgServerInfo(): ${infoCode}: ${(0, $003b09fe89de2289$export$f84e8e69fd4488a5)(msgServerInfo)}`);
            }
        };
        this.onExternalDisconnectOrReclaimed = async (didDisconnectPermanently)=>{
            // Don't end sessions or close our connection, because this will cause duplicate
            //	disconnect messages to be sent to the game, and may cause a controller that's
            //	in the process of reclaiming the device to be disconnected.
            // Instead, switch to a state that does not allow any data to be sent from this controller,
            //	and inform the player so that they can either reset/end all sessions,
            //	or refresh to try and reclaim the existing device in the current tab.
            await this.setControllerState((0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForSetup);
            this.viewManager.setDisconnectedOverlayShowing(true, didDisconnectPermanently);
        };
        this.onConnectionEvent = async (evt)=>{
            // 2023/02/06: This is dispatched right before we attempt to reconnect (automatically)
            //   As such, perhaps show an info screen or perhaps start a timer before showing (and cancel if reconnected).
            if (!this.isActiveInView) return;
            if (evt instanceof CloseEvent) {
                // Connection closed
                this.logger.warn("Connection closed  = reconnecting.");
                this.viewManager.show((0, $8b07c0f1748354ec$export$27a5bd065ad55220).Reconnecting);
            } else switch(evt.type){
                case "error":
                    // Connection error
                    this.logger.warn("Connection error = reconnecting");
                    this.viewManager.show((0, $8b07c0f1748354ec$export$27a5bd065ad55220).Reconnecting);
                    break;
                case "open":
                    // connected
                    if (this.connecting) {
                        this.logger.log(`First time connecting so stashing deviceId:${this.game.deviceId} in cookie to allow reconnecting in future`);
                        if (undefined !== this.game.deviceId) this.cookieHelper.setDeviceIdForSessionIndex(this.sessionIndex, this.game.deviceId);
                        return;
                    }
                    // Hide reconnecting dialog
                    this.viewManager.restorePreviousView();
                    break;
                default:
                    this.logger.warn(`UNHANDLED connection event type:"${evt.type}": ${(0, $003b09fe89de2289$export$f84e8e69fd4488a5)(evt)}`);
                    break;
            }
        };
        this.onJoinedOrRejoinedGame = ()=>{
            if (!this.game.deviceId) {
                this.logger.error("onJoinedGameOrReconnected with undefined deviceId");
                return;
            }
            this.joinedGame = true;
            this.cookieHelper.setDeviceIdForSessionIndex(this.sessionIndex, this.game.deviceId);
        };
        this.onProxyStartSendingToGame = ()=>{
            this.viewManager.setMessagePendingOverlayShowing(true);
        };
        this.onProxyDoneOrFailSendingToGame = ()=>{
            this.viewManager.setMessagePendingOverlayShowing(false);
        };
        this.setControllerState = async (state)=>{
            const prevState = this.currentControllerState;
            this.currentControllerState = state;
            await this.actUponControllerState(prevState, state);
        };
        this.actUponControllerState = async (previousState, state)=>{
            if (state !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput) this._characterWritingData = undefined;
            switch(state){
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).JoinScreen:
                    break;
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForSetup:
                    // Set default controller data while setting up to be used if no custom data is received from the game
                    this.app.resetControllerDataToDefault();
                    this.cookieHelper.clearTurnSetForSessionIndex(this.sessionIndex);
                    this.cookieHelper.clearSelectedTurnForSessionIndex(this.sessionIndex);
                    this.cookieHelper.clearItemVotesForSessionIndex(this.sessionIndex);
                    break;
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).CharacterSelect:
                    await this.updateCharacterSelectVisuals();
                    // Ensure all tabs are not highlighted when entering char select
                    //	(some may be left highlighted from the previous state)
                    this.updateReadyStateVisuals(this.isReady);
                    this.updatePlayerTabVisuals();
                    // Clear any stored player-written character text from a previous level/session
                    this.cookieHelper.clearCharacterTextForSessionIndex(this.sessionIndex);
                    break;
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput:
                    if (previousState !== state) await this.resetForNewRound();
                    this.updatePlayerTabVisuals();
                    break;
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementVote:
                    if (previousState !== state) {
                        this.itemManagementData?.resetSelectedItemVoteIndex();
                        await this.setReadyWithoutSending(false, false);
                    }
                    this.updateItemPlacementVoteVisuals();
                    this.updatePlayerTabVisuals();
                    break;
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WatchingActions:
                    this.cookieHelper.clearTurnSetForSessionIndex(this.sessionIndex);
                    this.cookieHelper.clearItemVotesForSessionIndex(this.sessionIndex);
                    await this.setReadyWithoutSending(false, false);
                    break;
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementResults:
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).LevelFinished:
                    await this.setReadyWithoutSending(false, false);
                    break;
                default:
                    throw new Error(`Unhandled controller state:${state}`);
            }
            await this.app.actUponControllerStateChange(state);
        };
        this.updatePlayerTabVisuals = ()=>{
            if (this.app.activeGameSessionInView === undefined) return;
            this.viewManager.updatePlayerTabVisuals(this.app.activeGameSessionInView.sessionIndex, this.app.activeGameSessionInView.playerName ?? "", this.app.allSelectedCharacterIndexes);
        };
        this.initialiseInputPhaseVisuals = ()=>{
            this.updateReadyStateVisuals(this.isReady);
            if (!this.isActiveInView) {
                this.logger.debug("initialiseInputPhaseVisuals() but not the active view");
                return;
            }
            this.viewManager.positionReadyUnreadyButtonsForGameInput();
            if ($dd300fc197dcf9fe$export$a3eb6b94b1e7587a.CanReadyWithEmptyTurns) this.viewManager.setReadyButtonShowing(true);
            else this.viewManager.setReadyButtonShowing(this.allTurnsSelected());
            this.viewManager.updateCharacterPreviewImage(this.characterIndex);
            // Setup turn selection buttons for num turns
            this.viewManager.setupTurnButtons(this.turnsPerRound);
            // Initialise turn button visuals from the chosen actions in this.turnSet
            for(let i = 0; i < this.turnsPerRound; i++){
                const turn = this.turnSet.get(i);
                this.viewManager.setTurnButtonVisual(i, this.selectionWasMadeForTurn[i], this.selectionWasMadeForTurn[i] ? this.app.getActionButtonData(this.app.getActionNumberByName(turn.action)) : undefined, turn.data, this.app.imageURLCache);
            }
            // Initialise all action buttons from CustomControllerData
            for(let i = 0; i < (0, $ac58392a9f7a45e7$export$86fbec116b87613f).ActionButtonCount; i++){
                const actionButtonData = this.app.getActionButtonData(i);
                this.viewManager.setActionButtonVisual(i, actionButtonData, this.app.imageURLCache);
                this.viewManager.setActionButtonEnabled(i, actionButtonData);
            }
            if (this.currentlySelectingTurnNumber !== undefined) this.selectATurnNumber(this.currentlySelectingTurnNumber);
        };
        this.updateItemPlacementVoteVisuals = ()=>{
            if (this.currentControllerState != (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementVote) {
                this.logger.warn(`Trying to update ItemPlacementVote visuals while controller state is not ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementVote} (Current state: ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[this.currentControllerState]} ${this.currentControllerState})`);
                return;
            }
            this.updateReadyStateVisuals(this.isReady);
            if (!this.isActiveInView) return;
            this.viewManager.positionReadyUnreadyButtonsForItemVote();
            this.viewManager.updateItemPlacementVoteVisuals(this.itemManagementData, this.app.imageURLCache);
            this.viewManager.setReadyButtonShowing(true);
        };
        this.updateWriterTextInputVisuals = ()=>{
            if (this.currentControllerState != (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput) {
                this.logger.warn(`Trying to update WriterTextInput visuals while controller state is not ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput} (Current state: ${this.currentControllerState})`);
                return;
            }
            if (!this.isActiveInView) return;
            if (!this.isNonCharacterPlayer) return;
            this.viewManager.positionReadyUnreadyButtonsForWriterTextInput();
            this.viewManager.initialiseWriterTextInputVisuals(this.characterWritingData);
            this.viewManager.setReadyButtonShowing(true);
        };
        this.updateCharacterSelectVisuals = async ()=>{
            // Skip if not currently selecting characters.
            if (this.currentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).CharacterSelect) {
                this.logger.warn(`Trying to update CharacterSelect visuals while controller state is not ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).CharacterSelect} (Current state: ${this.currentControllerState})`);
                return;
            }
            // All buttons default to the 'Unselected' state, then any selections are setup below
            let buttonStates = [];
            for(let i = 0; i < $dd300fc197dcf9fe$export$a3eb6b94b1e7587a.CharacterPlayerCount + $dd300fc197dcf9fe$export$a3eb6b94b1e7587a.NonCharacterPlayerCount; i++)buttonStates[i] = (0, $8b07c0f1748354ec$export$7a1472f96d5bc930).Unselected;
            let thisPlayerMadeSelection = false;
            // Setup the buttonStates array - character button visuals are determined by CharacterButtonState.
            //	A button with an index that matches this session's characterIndex should display as 'SelectedByThis', meaning
            //	the active player has selected the button. 'SelectedByOther' indicates a button that was selected by another player.
            for(let i = 0; i < this.selectedCharacterIndexes.length; i++){
                const characterIndex = this.selectedCharacterIndexes[i];
                if (characterIndex >= 0 && characterIndex < buttonStates.length) {
                    if (characterIndex === this.characterIndex) {
                        buttonStates[characterIndex] = (0, $8b07c0f1748354ec$export$7a1472f96d5bc930).SelectedByThis;
                        thisPlayerMadeSelection = true;
                    } else buttonStates[characterIndex] = (0, $8b07c0f1748354ec$export$7a1472f96d5bc930).SelectedByOther;
                }
            }
            if (this.isActiveInView) // Update button visuals to reflect buttonStates for this session
            this.viewManager.updateCharacterSelectButtons(buttonStates, this.isNonCharacterPlayer, this.allNonCharactersSelected);
            // The player is 'ready' if they made a selection
            await this.setReadyWithoutSending(thisPlayerMadeSelection, false);
        };
        this.restoreTurnsOrInitialiseTurnSet = ()=>{
            if (this.turnSet === undefined) {
                // Only try restoring turns if none are defined, i.e. reloading from scratch, not resetting after a previous turn
                const restoreTurnSet = this.cookieHelper.getTurnSetForSessionIndex(this.sessionIndex);
                const restoreTurnSelection = this.cookieHelper.getSelectedTurnForSessionIndex(this.sessionIndex);
                const validRestoreTurnSet = restoreTurnSet !== undefined && restoreTurnSet.turnSet.numTurns == this.turnsPerRound;
                if (validRestoreTurnSet) {
                    this.turnSet = restoreTurnSet.turnSet;
                    this.selectionWasMadeForTurn = restoreTurnSet.playerSelectionsMade;
                    this.currentlySelectingTurnNumber = restoreTurnSelection;
                    return;
                }
            }
            // Not restoring or no valid turns to restore - fresh set of empty turns
            this.turnSet = new (0, $677b4c43f3df91ac$export$1d5a868e16232420)(this.turnsPerRound);
            this.selectionWasMadeForTurn = [];
            this.currentlySelectingTurnNumber = 0;
        };
        this.resetForNewRound = async ()=>{
            if (this.currentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput) {
                this.logger.error("resetForNewRound should only be called when currentControllerState === WaitingForInput");
                return;
            }
            if (this.isActiveInView) this.viewManager.setupTurnButtons(this.turnsPerRound);
            this.restoreTurnsOrInitialiseTurnSet();
            this.cookieHelper.setTurnSetForSessionIndex(this.sessionIndex, new (0, $109c27dde40935f6$export$68656b7c8056ebd6)(this.turnSet, this.selectionWasMadeForTurn));
            if (this.isActiveInView) {
                if (this.isNonCharacterPlayer) this.updateWriterTextInputVisuals();
                else this.initialiseInputPhaseVisuals();
            }
            await this.setReadyWithoutSending(false, false);
        };
        this.onWindowPopState = (event)=>{
            if (event instanceof PopStateEvent) this.onCancelOrBack();
        };
        window.addEventListener("popstate", this.onWindowPopState);
        this.logger = (0, $7653766080191e46$export$4ac4545211fd8567).build(`${$dd300fc197dcf9fe$export$a3eb6b94b1e7587a.name}(s${sessionIndex})`);
        this.app = app;
        this._sessionIndex = sessionIndex;
        this.characterIndex = -1;
        this.selectedCharacterIndexes = [];
        this.allNonCharactersSelected = false;
        this.waitingOnCharacterSelectRequest = false;
        this.viewManager = viewManager;
        this.currentControllerState = (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).JoinScreen;
        this._playerName = playerName;
        this.app.imageURLCache.onImageUrlCreated.subscribe(this.onImageUrlCreated);
        // Do we have a deviceId in a cookie?
        const previousDeviceId = cookieHelper.getDeviceIdForSessionIndex(sessionIndex);
        const previousJoinCode = cookieHelper.getJoinCode();
        this.logger.log(`Previous deviceId:${previousDeviceId}, previous joinCode:${previousJoinCode}`);
        this.game = new (0, $1e9f9fda8df65d24$export$649b280af6458229)(previousDeviceId, previousJoinCode, sessionIndex);
        // Subscribe for messages from game
        this.game.onMsgMessage.subscribe(this.onMsgMessage);
        this.game.onMsgServerInfo.subscribe(this.onMsgServerInfo);
        // Subscribe for connection established/close/error events from WebSocket
        this.game.onConnectionEvent.subscribe(this.onConnectionEvent);
        this.game.onJoinCodeSet.subscribe(this.viewManager.setJoinCodeText);
        if (previousJoinCode) this.viewManager.setJoinCodeText(previousJoinCode);
        this.game.onStartSendingToGame.subscribe(this.onProxyStartSendingToGame);
        this.game.onDoneOrFailSendingToGame.subscribe(this.onProxyDoneOrFailSendingToGame);
        // ParcelJS HOt module reloading = only during development
        // See https://parceljs.org/features/development/
        if (null) {
            this.logger.debug("Registering ParcelJS module reloading handlers");
            null.dispose((data)=>{
                this.logger.warn("ParcelJS Hot Module Reload = dispose()");
                if (!this.game) return;
                return this.game.closeConnection(false, (0, $c9cbdb97f2e17b01$export$dd43557c09bea516).ClientConnectionTimeoutRetrying, "ParcelJS reload (GameSession)");
            });
            null.accept(async ()=>{
                this.logger.warn("ParcelJS Hot Module Reload = accept() (reload)");
                if (!this.game) return;
                await this.game.closeConnection(false, (0, $c9cbdb97f2e17b01$export$dd43557c09bea516).ClientConnectionTimeoutRetrying, "ParcelJS reloaded (GameSession)");
                this.logger.warn("ParcelJS Hot Module Reload = accept() = reconnecting");
                await this.tryConnect();
            });
        }
    }
    get selectedCharacterIndex() {
        return this.characterIndex;
    }
    get deviceId() {
        return this.game.deviceId ?? "";
    }
    get playerName() {
        return this._playerName;
    }
    get playerIsReady() {
        return this.isReady;
    }
    get hasJoinedGame() {
        return this.joinedGame;
    }
    get isActiveInView() {
        return this.app.isActiveGameSessionInView(this);
    }
    get isInitialSession() {
        return 0 === this.sessionIndex;
    }
}



var $8b07c0f1748354ec$export$7a1472f96d5bc930;
(function(CharacterButtonState) {
    CharacterButtonState[CharacterButtonState["SelectedByThis"] = 0] = "SelectedByThis";
    CharacterButtonState[CharacterButtonState["SelectedByOther"] = 1] = "SelectedByOther";
    CharacterButtonState[CharacterButtonState["Unselected"] = 2] = "Unselected";
})($8b07c0f1748354ec$export$7a1472f96d5bc930 || ($8b07c0f1748354ec$export$7a1472f96d5bc930 = {}));
class $8b07c0f1748354ec$export$e2fb22396d3bf4b8 {
    constructor(){
        this.currentStackPhase = -1 // -1 when not set
        ;
        /**
	 * Dictionary of stackName to array of HTMLElement phases.
	 * @private
	 */ this.stacks = {};
        /**
	 * Dictionary of view name to HTMLElement.
	 * @private
	 */ this.views = {};
        this.infoPopupResult = "";
        this.getCurrentViewId = ()=>{
            return this.currentViewId ? this.currentViewId : "";
        };
        this.hideAll = ()=>{
            $8b07c0f1748354ec$var$Log.debug("hideAll");
            for(const key in this.views)this.views[key].style.display = "none";
        };
        this.show = (id, forceRefresh = false)=>{
            if (!forceRefresh && this.currentViewId === id) {
                $8b07c0f1748354ec$var$Log.warn(`Already showing View:`, id);
                return;
            }
            const view = this.views[id];
            if (view) {
                // Stash previous in case need to restore
                this.previousViewId = this.currentViewId;
                this.currentViewId = id;
                this.hideAll();
                $8b07c0f1748354ec$var$Log.debug("show id", id, "= view", view);
                view.style.display = "block";
                this.onShowingView(id);
            } else $8b07c0f1748354ec$var$Log.warn("Could not find view with ID:", id);
        };
        this.onShowingView = (id)=>{
            if ("Lobby" === id) {
                // Show logo header in lobby only
                this.setElementShowing("lobbyHeader", true);
                const joinCodeInputField = this.getElementByIdExpectNonNull("joinCode");
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const joinCodeParam = urlParams.get("joinCode");
                if (joinCodeParam !== null && (0, $2282782f43399dd4$export$3636fa6b664761ad)(joinCodeParam)) joinCodeInputField.value = joinCodeParam;
            } else this.setElementShowing("lobbyHeader", false);
            // Show player tabs (for switching between GameSessions) in certain views
            const showPlayerTabs = "CharacterSelect" === id || "GameInputPhase" === id || "ItemPlacementVote" === id || "WriterTextInput" === id;
            this.setElementShowing("playerTabsAndMenu", showPlayerTabs);
            this.updatePlayerNameLayout();
            this.setDefaultFocusForView(id);
            // Get URL search parameters
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            // Push browser history states for back button behaviour, retaining current URL parameters (e.g. joinCode)
            urlParams.delete("view");
            urlParams.append("view", "ConfirmLeave");
            history.pushState(id, "", `./?${urlParams.toString()}`);
            urlParams.delete("view");
            urlParams.append("view", id);
            history.pushState(id, "", `./?${urlParams.toString()}`);
        };
        this.restorePreviousView = ()=>{
            if (!this.previousViewId) {
                $8b07c0f1748354ec$var$Log.warn("No previousViewId to restore");
                return;
            }
            this.show(this.previousViewId);
        };
        this.onWindowResized = (event)=>{
            this.updatePlayerNameLayout();
        };
        this.setupWheelScrollsHorizontallyElements = ()=>{
            // For any elements with the class 'wheelScrollsHorizontally', the scroll wheel will
            // adjust their horizontal scroll rather than trying to scroll vertically as is standard
            const horizontalScrollElements = document.getElementsByClassName("wheelScrollsHorizontally");
            for(let i = 0; i < horizontalScrollElements.length; ++i){
                const horizontalScrollElement = horizontalScrollElements[i];
                horizontalScrollElement.addEventListener("wheel", function(e) {
                    if (e.deltaX !== 0) // Scrolling horizontally, continue as normal
                    return;
                    if (e.deltaY !== 0) {
                        // Add vertical scroll delta to horizontal scroll instead
                        horizontalScrollElement.scrollLeft += e.deltaY;
                        e.preventDefault();
                    }
                });
            }
        };
        this.showGameMenu = ()=>{
            // Push empty history state to prevent further back presses
            history.pushState(null, "", null);
            this.getElementByIdExpectNonNull("gameMenu").style.display = "block";
        };
        this.mostRecentDisplayedTotalConnectionCount = 0;
        this.updatePlayerNameLayout = ()=>{
            let playerNameTop = this.getElementByIdExpectNonNull("playerNameTop");
            let playerNameOverflow = this.getElementByIdExpectNonNull("playerNameOverflowPanel");
            let minPageSize = Math.min(document.documentElement.clientWidth, document.documentElement.clientHeight);
            let vminWidth = playerNameTop.clientWidth / minPageSize * 100;
            if (vminWidth === 0) return;
            // If width > 65, there is enough space to display the player name alongside tabs at the top.
            //	Otherwise, it should be displayed in a separate 'overflow' panel underneath the tabs.
            let displayAtTop = vminWidth > 65;
            playerNameTop.style.visibility = displayAtTop ? "visible" : "hidden";
            playerNameOverflow.style.visibility = displayAtTop ? "hidden" : "visible";
        };
        this.setDefaultFocusForView = (id)=>{
            let focusElement = null;
            switch(id){
                case "Lobby":
                    // Autofocus on join code field in lobby, or player name if join code field is hidden/filled
                    const joinCodeInputField = this.getElementByIdExpectNonNull("joinCode");
                    if ("none" === joinCodeInputField.style.display || (0, $2282782f43399dd4$export$3636fa6b664761ad)(joinCodeInputField.value)) focusElement = this.getElementByIdExpectNonNull("playerName");
                    else focusElement = joinCodeInputField;
                    break;
                case "Default":
                case "Connecting":
                case "Reconnecting":
                case "LookAtScreen":
                case "Joining":
                case "WaitOrAddPlayers":
                case "CharacterSelect":
                case "GameInputPhase":
                case "ItemPlacementVote":
                case "WriterTextInput":
                    // nop
                    return;
                default:
                    throw new Error(`Unexpected view id for setDefaultFocusForView: ${id}`);
            }
            if (null === focusElement) {
                $8b07c0f1748354ec$var$Log.error(`Null focusElement in setDefaultFocusForView for view id: ${id}`);
                return;
            }
            focusElement.focus();
        };
        this.updateJoinCodeToggles = (on)=>{
            const joinCodeElements = document.querySelectorAll(".joinCodeContainer");
            for (const joinCodeElement of joinCodeElements){
                const toggleButtonImageElement = joinCodeElement.querySelector(".actionButtonImage");
                if (toggleButtonImageElement === null) {
                    $8b07c0f1748354ec$var$Log.warn("Failed to get .actionButtonImage from .joinCodeContainer");
                    continue;
                }
                const toggleTextElement = joinCodeElement.querySelector(".joinCodeText");
                if (toggleTextElement === null) {
                    $8b07c0f1748354ec$var$Log.warn("Failed to get .joinCodeText from .joinCodeContainer");
                    continue;
                }
                const toggleTextPlaceholderElement = joinCodeElement.querySelector(".joinCodeTextHidden");
                if (toggleTextPlaceholderElement === null) {
                    $8b07c0f1748354ec$var$Log.warn("Failed to get .joinCodeTextHidden from .joinCodeContainer");
                    continue;
                }
                if (on) {
                    toggleButtonImageElement.classList.remove("showEyeImage");
                    toggleButtonImageElement.classList.add("hideEyeImage");
                    toggleTextElement.style.display = "block";
                    toggleTextPlaceholderElement.style.display = "none";
                } else {
                    toggleButtonImageElement.classList.remove("hideEyeImage");
                    toggleButtonImageElement.classList.add("showEyeImage");
                    toggleTextElement.style.display = "none";
                    toggleTextPlaceholderElement.style.display = "block";
                }
            }
        };
        this.showConfirmLeaveDialog = ()=>{
            // Push empty history state to prevent further back presses
            history.pushState(null, "", null);
            // Show leave confirmation dialog
            const confirmLeave = this.getElementByIdExpectNonNull("confirmLeaveGame");
            confirmLeave.style.display = "block";
        };
        this.showInfoPopupDialog = (titleText, infoText, onButton1Pressed, button1Text = "Close", canShowDetailedInfo = false, detailedInfoText = "")=>{
            return new Promise((resolve)=>{
                $8b07c0f1748354ec$var$Log.log(`Showing info popup dialog: "${infoText}", details:"${detailedInfoText}"`);
                // Push empty history state to prevent further back presses
                history.pushState(null, "", null);
                const popupElement = this.getElementByIdExpectNonNull("infoPopup");
                popupElement.style.display = "block";
                const titleTextElement = this.getElementByIdExpectNonNull("popupTitleText");
                // Title element is hidden if no title text was given
                titleTextElement.style.display = titleText === "" ? "none" : "block";
                titleTextElement.innerText = titleText;
                const infoTextElement = this.getElementByIdExpectNonNull("popupInfoText");
                infoTextElement.innerText = infoText;
                const buttonText = this.getElementByIdExpectNonNull("errorPopupButton1");
                buttonText.innerText = button1Text;
                // if canShowDetailedInfo: allow player to press a button that shows detailText
                this.setElementShowing("detailedErrorButton", canShowDetailedInfo);
                this.infoPopupResult = "";
                const detailText = this.getElementByIdExpectNonNull("detailedErrorText");
                detailText.style.display = "none";
                detailText.innerText = detailedInfoText;
                // Record global callback which will be triggered from HTML's call to setInfoPopupResult()
                this.infoPopupCallback = ()=>{
                    this.infoPopupCallback = undefined;
                    if ("button1" === this.infoPopupResult) {
                        if (onButton1Pressed) {
                            $8b07c0f1748354ec$var$Log.log("Info popup: Triggering button1 action");
                            onButton1Pressed();
                        } else $8b07c0f1748354ec$var$Log.log("Info popup: Closing without triggering action");
                    }
                    popupElement.style.display = "none";
                    // Complete the Promise
                    resolve();
                };
            });
        };
        // noinspection JSUnusedGlobalSymbols -- used from HTML
        this.setInfoPopupResult = (result)=>{
            $8b07c0f1748354ec$var$Log.log(`setInfoPopupResult: "${result}"`);
            this.infoPopupResult = result;
            if (!this.infoPopupCallback) throw new Error(`No infoPopupCallback defined in setInfoPopupResult(${result})`);
            this.infoPopupCallback();
        };
        /** A named stack of 'screens' in order to be able to show them behind one another */ this.addStackWithPhases = (stackName, phaseIds)=>{
            const newStack = []; // initialize new array
            for(let i = 0; i < phaseIds.length; i++){
                let view = this.views[phaseIds[i]];
                if (null == view) $8b07c0f1748354ec$var$Log.warn("Could not find view phase with ID:", phaseIds[i]);
                else newStack.push(view);
            }
            this.stacks[stackName] = newStack; // initialize new array
        };
        this.showStackPhase = (stackName, phaseNumToShow)=>{
            const stack = this.stacks[stackName];
            if (null == stack) {
                $8b07c0f1748354ec$var$Log.error(`Stack "${stackName}" not found in `, this.stacks);
                return;
            }
            for(let i = 0; i <= phaseNumToShow; i++)stack[i].style.display = "block";
            for(let i = phaseNumToShow + 1; i < stack.length; i++)stack[i].style.display = "none";
            this.currentStack = stackName;
            this.currentStackPhase = phaseNumToShow;
        };
        this.popStackPhase = ()=>{
            $8b07c0f1748354ec$var$Log.log("popping currentStack:'" + this.currentStack + "' with currentStackPhase:'" + this.currentStackPhase + "'");
            if (null == this.currentStack || 0 > this.currentStackPhase) {
                $8b07c0f1748354ec$var$Log.error("No currentStack:'" + this.currentStack + "' or currentStackPhase:'" + this.currentStackPhase + "'");
                return;
            }
            if (0 === this.currentStackPhase) {
                this.show("GameInputPhase");
                this.currentStack = undefined;
                this.currentStackPhase = -1;
                return;
            }
            this.showStackPhase(this.currentStack, this.currentStackPhase - 1);
        };
        this.setupLobbyUI = (isInitialSession)=>{
            $8b07c0f1748354ec$var$Log.log(`Setting up lobby (isInitialSession: ${isInitialSession})`);
            // Only show join code title/input field if the first player is joining
            //	(All subsequent players should be joining the same game, and hence should not change the join code)
            this.setElementShowing("joinCodeTitle", isInitialSession);
            this.setElementShowing("joinCode", isInitialSession);
            // If this isn't the first player joining, show button that allows them to cancel joining
            this.setElementShowing("cancelJoinButton", !isInitialSession);
            const nameTitle = this.getElementByIdExpectNonNull("nameTitleText");
            // Clarify name is for 'New Player' when adding more than one on a single device
            nameTitle.innerText = isInitialSession ? "Player Name" : `Name of New Player`;
            const joinCodeField = document.getElementById("joinCode");
            if (!joinCodeField) throw new Error("Could not find joinCode input field when setting up lobby UI");
            const playerNameField = document.getElementById("playerName");
            if (!playerNameField) throw new Error("Could not find joinCode input field when setting up lobby UI");
            // Reset input field text values
            joinCodeField.value = "";
            playerNameField.value = "";
        };
        this.setupJoinedPlayersList = (playerNames, sessionCount)=>{
            this.setElementShowing("addPlayerInfo", sessionCount < (0, $ac58392a9f7a45e7$export$86fbec116b87613f).MaxGameSessions, "flex");
            const playerNamesList = this.getElementByIdExpectNonNull("playerNamesList");
            // Remove all but the first child from the list of player names
            //	(the first child is playerNameListElement which we want to clone)
            for(let i = playerNamesList.childNodes.length - 1; i > 1; i--)playerNamesList.childNodes[i].remove();
            // playerNameListElement is hidden and used as a template to clone from
            const playerNameElement = this.getElementByIdExpectNonNull("playerNameListElement");
            // Add a new playerNameElement clone for each player name,
            //	each will display the name along with a button for removing that player
            playerNames.forEach((name, index)=>{
                const clone = playerNameElement.cloneNode(true);
                clone.id = `${clone.id}${index}`;
                clone.style.display = "flex";
                playerNamesList.appendChild(clone);
                // Show name
                const nameText = clone.querySelector(".playerNameText");
                if (!nameText) throw new Error("Failed to get playerNameText from cloned playerNameListElement");
                nameText.innerText = name;
                // Set button tab index to allow tab/enter key selection
                const removeButton = clone.querySelector(".pressEffectButtonSmall");
                if (!removeButton) throw new Error("Failed to get pressEffectButtonSmall from cloned playerNameListElement");
                removeButton.tabIndex = 100 + index;
            });
        };
        this.setJoinCodeText = (newJoinCode)=>{
            const joinCodeText = this.getElementByIdExpectNonNull("joinCodeText");
            joinCodeText.innerText = newJoinCode;
            const disconnectJoinCodeText = this.getElementByIdExpectNonNull("joinCodeText_disconnectedOverlay");
            disconnectJoinCodeText.innerText = newJoinCode;
        };
        this.setTurnInfoHeaderText = (turnNum)=>{
            const turnInfoHeader = this.getElementByIdExpectNonNull("turnInfoHeader");
            turnInfoHeader.innerText = `Choose an action for turn ${turnNum + 1}`;
        };
        this.showHelpPanel = (infoText, titleText)=>{
            this.getElementByIdExpectNonNull("helpPanelTitleText").innerText = titleText;
            // Using innerHTML for infoText to allow bold text, styling, and line breaks,
            //	so remove elements with any other tags first for safety
            const infoTextDoc = new DOMParser().parseFromString(infoText, "text/html");
            const scriptTags = infoTextDoc.body.getElementsByTagName("*");
            [
                ...scriptTags
            ].forEach((tag)=>{
                $8b07c0f1748354ec$var$Log.log(tag.tagName);
                if (tag.tagName !== "BR" && tag.tagName !== "B" && tag.tagName !== "SPAN") tag.remove();
            });
            this.getElementByIdExpectNonNull("helpPanelInfoText").innerHTML = infoTextDoc.body.innerHTML;
            this.getElementByIdExpectNonNull("helpPanel").style.display = "block";
        };
        this.setDisconnectedOverlayShowing = (show, didDisconnectPermanently)=>{
            this.getElementByIdExpectNonNull("disconnectedOverlay").style.display = show ? "block" : "none";
            if (show) this.getElementByIdExpectNonNull("disconnectReloadButton").style.display = didDisconnectPermanently ? "none" : "block";
        };
        this.setAwayOverlayShowing = (show)=>{
            this.getElementByIdExpectNonNull("awayOverlay").style.display = show ? "block" : "none";
        };
        this.setMessagePendingOverlayShowing = (show)=>{
            this.getElementByIdExpectNonNull("messagePendingOverlay").style.display = show ? "block" : "none";
        };
        this.setReadyButtonShowing = (show)=>{
            const readyButton = this.getElementByIdExpectNonNull("readyButton");
            readyButton.style.visibility = show ? "visible" : "hidden";
        };
        // Show/hide all help buttons, which are currently specific to Co OPERATION
        this.setHelpButtonsShowing = (show)=>{
            this.getElementByIdExpectNonNull("helpButton_writer").style.display = show ? "block" : "none";
            this.getElementByIdExpectNonNull("helpButton_actions").style.display = show ? "block" : "none";
        };
        this.positionReadyUnreadyButtonsForGameInput = ()=>{
            $8b07c0f1748354ec$var$Log.debug("positionReadyUnreadyButtonsForGameInput");
            const readyButton = this.getElementByIdExpectNonNull("readyButton");
            readyButton.classList.remove("readyButtonItemVote");
            readyButton.classList.remove("readyButtonWriterTextInput");
            readyButton.classList.add("readyButtonActionInput");
            const unreadyButton = this.getElementByIdExpectNonNull("unreadyButton");
            unreadyButton.classList.remove("unreadyButtonItemVote");
            unreadyButton.classList.remove("unreadyButtonWriterTextInput");
            unreadyButton.classList.add("unreadyButtonActionInput");
            this.getElementByIdExpectNonNull("readyButton_gameInput").appendChild(readyButton);
            this.getElementByIdExpectNonNull("unreadyButton_gameInput").appendChild(unreadyButton);
            readyButton.innerText = "Ready!";
            this.addReadyButtonTouchTarget(readyButton);
        };
        this.positionReadyUnreadyButtonsForItemVote = ()=>{
            $8b07c0f1748354ec$var$Log.debug("positionReadyUnreadyButtonsForItemVote");
            const readyButton = this.getElementByIdExpectNonNull("readyButton");
            readyButton.classList.remove("readyButtonActionInput");
            readyButton.classList.remove("readyButtonWriterTextInput");
            readyButton.classList.add("readyButtonItemVote");
            const unreadyButton = this.getElementByIdExpectNonNull("unreadyButton");
            unreadyButton.classList.remove("unreadyButtonActionInput");
            unreadyButton.classList.remove("unreadyButtonWriterTextInput");
            unreadyButton.classList.add("unreadyButtonItemVote");
            this.getElementByIdExpectNonNull("readyButton_itemVote").appendChild(readyButton);
            this.getElementByIdExpectNonNull("unreadyButton_itemVote").appendChild(unreadyButton);
            readyButton.innerText = "Ready!";
            this.addReadyButtonTouchTarget(readyButton);
        };
        this.positionReadyUnreadyButtonsForWriterTextInput = ()=>{
            $8b07c0f1748354ec$var$Log.debug("positionReadyUnreadyButtonsForWriterTextInput");
            const readyButton = this.getElementByIdExpectNonNull("readyButton");
            readyButton.classList.remove("readyButtonActionInput");
            readyButton.classList.remove("readyButtonItemVote");
            readyButton.classList.add("readyButtonWriterTextInput");
            const unreadyButton = this.getElementByIdExpectNonNull("unreadyButton");
            unreadyButton.classList.remove("unreadyButtonActionInput");
            unreadyButton.classList.remove("unreadyButtonItemVote");
            unreadyButton.classList.add("unreadyButtonWriterTextInput");
            this.getElementByIdExpectNonNull("readyButton_writerTextInput").appendChild(readyButton);
            this.getElementByIdExpectNonNull("unreadyButton_writerTextInput").appendChild(unreadyButton);
            readyButton.innerText = "Send";
            this.addReadyButtonTouchTarget(readyButton);
        };
        this.addReadyButtonTouchTarget = (readyButton)=>{
            const touchTargetElementToClone = this.getElementByIdExpectNonNull("readyButtonTouchTarget");
            const touchTargetClone = touchTargetElementToClone.cloneNode(true);
            touchTargetClone.id = "";
            touchTargetClone.style.display = "block";
            readyButton.appendChild(touchTargetClone);
        };
        this.setReadyButtonPressed = (pressed, allowUnready = true)=>{
            const readyButton = this.getElementByIdExpectNonNull("readyButton");
            $8b07c0f1748354ec$var$Log.debug("setReadyButtonPressed(pressed:", pressed, ", allowUnready:", allowUnready, ") on readyButton:", readyButton);
            // Show the 'unready' button when ready is pressed
            const unreadyButton = this.getElementByIdExpectNonNull("unreadyButton");
            unreadyButton.style.visibility = pressed && allowUnready ? "visible" : "hidden";
            if (pressed) {
                readyButton.classList.add("readyButtonPressed");
                unreadyButton.classList.add("fadeInAnimated");
            } else {
                readyButton.classList.remove("readyButtonPressed");
                unreadyButton.classList.remove("fadeInAnimated");
            }
        };
        this.setActionButtonEnabled = (buttonNumber, actionButtonData)=>{
            const actionButtonElement = this.getElementByIdExpectNonNull(`actionButton${buttonNumber}`);
            const actionButtonInnerElement = this.getElementByIdExpectNonNull(`actionButtonInner${buttonNumber}`);
            const actionButtonImageElement = this.getElementByIdExpectNonNull(`actionButtonImage${buttonNumber}`);
            const actionLabelElement = this.getElementByIdExpectNonNull(`actionLabel${buttonNumber}`);
            if (actionButtonData.enabledOrDefault) {
                actionButtonElement.tabIndex = 120 + buttonNumber;
                actionButtonElement.classList.remove("disabledButton");
                actionButtonImageElement.classList.remove("lockedImage");
                actionLabelElement.innerText = actionButtonData.labelOrDefault;
            } else {
                actionButtonElement.tabIndex = -1;
                actionButtonElement.classList.add("disabledButton");
                actionButtonElement.style.backgroundColor = "#8a8a8a";
                actionButtonInnerElement.style.backgroundColor = "#e7e7e7";
                actionButtonImageElement.classList.add("lockedImage");
                actionLabelElement.innerText = "[?]";
            }
        };
        this.updateTurnSelectedVisuals = (currentTurn, numberOfTurns)=>{
            for(let i = 0; i < numberOfTurns; i++){
                const turnButtonElement = this.getElementByIdExpectNonNull(`turnButton${i}`);
                turnButtonElement.className = i === currentTurn ? "actionButton actionButtonSelected" : "actionButton";
            }
            const actionsHeadingElement = this.getElementByIdExpectNonNull("actionsHeadingText");
            if (numberOfTurns <= 1) actionsHeadingElement.innerText = "This turn, I will...";
            else actionsHeadingElement.innerText = `On turn ${(currentTurn + 1).toString()}, I will...`;
        };
        this.updateActionSelectedVisuals = (currentAction)=>{
            for(let i = 0; i < (0, $ac58392a9f7a45e7$export$86fbec116b87613f).ActionButtonCount; i++){
                const actionButtonElement = this.getElementByIdExpectNonNull(`actionButton${i}`);
                if (i === currentAction) actionButtonElement.classList.add("actionButtonSelected");
                else actionButtonElement.classList.remove("actionButtonSelected");
            }
        };
        this.updateDirectionSelectedVisuals = (selectedDirection)=>{
            for(let i = 0; i < (0, $ac58392a9f7a45e7$export$86fbec116b87613f).AllDirectionNames.length; i++){
                const directionName = (0, $ac58392a9f7a45e7$export$86fbec116b87613f).AllDirectionNames[i];
                const directionButtonElement = this.getElementByIdExpectNonNull(`${directionName}DirectionalButton`);
                if (selectedDirection == directionName) directionButtonElement.classList.add("directionalButtonSelected");
                else directionButtonElement.classList.remove("directionalButtonSelected");
            }
        };
        this.setupTurnButtons = (numberOfTurns)=>{
            const turnHeadingTextElement = this.getElementByIdExpectNonNull("turnHeadingText");
            if (numberOfTurns <= 1) turnHeadingTextElement.innerText = `My chosen action:`;
            else turnHeadingTextElement.innerText = `My ${numberOfTurns} turns are:`;
            const turnButtonsParent = this.getElementByIdExpectNonNull("turnButtonsPanel");
            // Remove any existing children ready to add new turn buttons
            for(let i = turnButtonsParent.childNodes.length - 1; i >= 0; i--)turnButtonsParent.childNodes[i].remove();
            // Add turn button clone for each turn
            for(let i = 0; i < numberOfTurns; i++){
                const cloneFrom = this.getElementByIdExpectNonNull("turnButtonTemplate");
                const clone = cloneFrom.cloneNode(true);
                clone.id = `turnButton${i}`;
                clone.style.display = "flex";
                const turnButtonInner = clone.children[0];
                turnButtonInner.id = `turnButtonInner${i}`;
                turnButtonInner.children[0].id = `turnButtonImage${i}`;
                const actionNumberText = clone.children[2];
                if (numberOfTurns <= 1) {
                    // Button doesn't need to be selectable when there's only 1 turn
                    clone.tabIndex = -1;
                    clone.style.pointerEvents = "none";
                    // No need to show turn number when there's only 1 turn
                    const actionNumberPanel = clone.children[1];
                    actionNumberPanel.style.display = "none";
                    actionNumberText.innerText = "";
                } else {
                    clone.tabIndex = 101 + i;
                    actionNumberText.innerText = (i + 1).toString();
                }
                turnButtonsParent.appendChild(clone);
            }
        };
        this.setTurnButtonVisual = (turnNumber, turnSelected, actionButtonData, data, imageURLCache)=>{
            const turnButtonElement = this.getElementByIdExpectNonNull(`turnButton${turnNumber}`);
            const turnButtonInnerElement = this.getElementByIdExpectNonNull(`turnButtonInner${turnNumber}`);
            const turnImageElement = this.getElementByIdExpectNonNull(`turnButtonImage${turnNumber}`);
            turnImageElement.style.backgroundImage = "";
            if (!turnSelected || actionButtonData === undefined) {
                turnButtonElement.style.backgroundColor = "";
                turnButtonInnerElement.style.backgroundColor = "";
                turnImageElement.className = "actionButtonImage";
                return;
            }
            turnButtonElement.style.backgroundColor = actionButtonData.mainColourOrDefault;
            turnButtonInnerElement.style.backgroundColor = actionButtonData.secondaryColourOrDefault;
            if (actionButtonData.isCoOperationButton) {
                const actionImageName = this.getImageNameFromAction(actionButtonData.action);
                const dataImageName = data ? data.charAt(0).toUpperCase() + data.slice(1) : "";
                turnImageElement.className = `actionButtonImage animatedIcon ${actionImageName}${dataImageName}Image`;
            } else {
                turnImageElement.className = `actionButtonImage`;
                if (actionButtonData === undefined || actionButtonData.imageName === undefined) return;
                const cachedImageUrl = imageURLCache.tryGet(actionButtonData.imageName);
                turnImageElement.style.backgroundImage = cachedImageUrl.success ? `url('${cachedImageUrl.url}')` : "";
            }
        };
        this.setActionButtonVisual = (actionNumber, actionButtonData, imageURLCache)=>{
            const actionButtonElement = this.getElementByIdExpectNonNull(`actionButton${actionNumber}`);
            const actionButtonInnerElement = this.getElementByIdExpectNonNull(`actionButtonInner${actionNumber}`);
            const actionLabelElement = this.getElementByIdExpectNonNull(`actionLabel${actionNumber}`);
            const actionButtonImageElement = this.getElementByIdExpectNonNull(`actionButtonImage${actionNumber}`);
            actionButtonImageElement.style.backgroundImage = "";
            actionButtonElement.style.backgroundColor = actionButtonData.mainColourOrDefault;
            actionButtonInnerElement.style.backgroundColor = actionButtonData.secondaryColourOrDefault;
            actionLabelElement.innerText = actionButtonData.labelOrDefault;
            if (actionButtonData.isCoOperationButton) {
                const actionImageName = this.getImageNameFromAction(actionButtonData.action);
                actionButtonImageElement.className = `actionButtonImage animatedIcon ${actionImageName}Image`;
            } else {
                actionButtonImageElement.className = "actionButtonImage animatedIcon";
                if (!actionButtonData.imageName) return;
                const cachedImageUrl = imageURLCache.tryGet(actionButtonData.imageName);
                actionButtonImageElement.style.backgroundImage = cachedImageUrl.success ? `url('${cachedImageUrl.url}')` : "";
            }
        };
        this.setDirectionalButtonsForAction = (actionButtonData)=>{
            for(let i = 0; i < (0, $ac58392a9f7a45e7$export$86fbec116b87613f).AllDirectionNames.length; i++){
                const directionName = (0, $ac58392a9f7a45e7$export$86fbec116b87613f).AllDirectionNames[i];
                // const directionButtonElement = this.getElementByIdExpectNonNull(`${directionName}DirectionalButton`);
                const directionImageElement = this.getElementByIdExpectNonNull(`${directionName}ArrowImage`);
                const directionNameUpper = directionName.charAt(0).toUpperCase() + directionName.slice(1);
                if (actionButtonData.isCoOperationButton) // Default (Co OPERATION) action, change class name based on action to get the related arrow style
                directionImageElement.className = `directionalButtonImage ${actionButtonData.action}${directionNameUpper}Image`;
                else // For custom actions, we default to using the 'move' directional arrows
                directionImageElement.className = `directionalButtonImage move${directionNameUpper}Image`;
            }
        };
        this.setDirectionButtonsEnabled = (enabled)=>{
            for(let i = 0; i < (0, $ac58392a9f7a45e7$export$86fbec116b87613f).AllDirectionNames.length; i++){
                const directionName = (0, $ac58392a9f7a45e7$export$86fbec116b87613f).AllDirectionNames[i];
                const directionButtonElement = this.getElementByIdExpectNonNull(`${directionName}DirectionalButton`);
                if (enabled) directionButtonElement.classList.remove("disabledHidden");
                else directionButtonElement.classList.add("disabledHidden");
            }
            const dirInfoText = this.getElementByIdExpectNonNull("directionInfoText");
            if (enabled) dirInfoText.classList.remove("disabledHidden");
            else dirInfoText.classList.add("disabledHidden");
        };
        /**
	 * Enable a player tab (optionally setting its label).
	 */ this.setPlayerTabShowing = (tabIndex, show)=>{
            const tabElement = document.getElementById(`playerTabButton${tabIndex}`);
            if (!tabElement) {
                $8b07c0f1748354ec$var$Log.error(`Player tab element not found: playerTabButton${tabIndex}`);
                return;
            }
            if (!tabElement.firstElementChild) throw new Error(`No children under: playerTabButton${tabIndex}`);
            // Use 'tabButton' class for all tabs, plus 'selectedTab' for the one that is now selected
            tabElement.style.display = show ? "block" : "none";
        };
        this.updatePlayerTabVisuals = (activeTabIndex, activePlayerName, characterIndexes)=>{
            // When the selected tab changes, the visuals of all tabs are updated to ensure only one is visually selected
            for(let i = 0; i < (0, $ac58392a9f7a45e7$export$86fbec116b87613f).MaxGameSessions; i++){
                const tabElement = document.getElementById(`playerTabButton${i}`);
                if (!tabElement) throw new Error(`Player tab element not found: playerTabButton${i}`);
                // Use 'tabButton' class for all tabs, plus 'selectedTab' for the one that is now selected
                tabElement.className = i === activeTabIndex ? "tabButton playerTab selectedTab" : "tabButton playerTab";
                const playerImageElement = document.getElementById(`playerTabImage${i}`);
                if (!playerImageElement) throw new Error(`Player tab image element not found: playerImageElement${i}`);
                if (i >= characterIndexes.length || characterIndexes[i] < 0) // Negative index or out of range = No character has been selected yet
                playerImageElement.className = `tabPlayerImage characterPendingImage`;
                else {
                    const characterNum = characterIndexes[i];
                    if (characterNum === undefined) continue;
                    // A character was selected, show  a 'highlighted' image with that character,
                    // or an 'unselected' version for all tabs other than the selected one
                    if (characterNum < (0, $dd300fc197dcf9fe$export$a3eb6b94b1e7587a).CharacterPlayerCount) playerImageElement.className = i === activeTabIndex ? `tabPlayerImage character${characterIndexes[i] + 1}HighlightedImage` : `tabPlayerImage character${characterIndexes[i] + 1}UnselectedImage`;
                    else playerImageElement.className = i === activeTabIndex ? `tabPlayerImage nonCharacterWriterHighlightedImage` : `tabPlayerImage nonCharacterWriterUnselectedImage`;
                }
            }
            // Also display the name of the selected player (this is updated in two places, one of which
            //	will be visible at any given time depending on the screen size/orientation)
            const playerNameTopElement = this.getElementByIdExpectNonNull("playerNameTop");
            const playerNameOverflowElement = this.getElementByIdExpectNonNull("playerNameOverflow");
            // Prepend the name that is displayed next to player tabs with a space for better visual spacing
            playerNameTopElement.innerText = `\u00a0${activePlayerName}`;
            playerNameOverflowElement.innerText = activePlayerName;
        };
        this.updateSessionReadyStateVisuals = (sessionIndex, ready)=>{
            const readyIndicatorElement = document.getElementById(`readyIndicator${sessionIndex}`);
            if (!readyIndicatorElement) throw new Error(`Could not find ready indicator element 'readyIndicator${sessionIndex}'`);
            readyIndicatorElement.className = ready ? "tabReadyImage tickImage" : "tabReadyImage actionsPendingImage";
        };
        this.updateCharacterPreviewImage = (characterIndex)=>{
            const characterPreviewElement = document.getElementById("characterPreview");
            if (!characterPreviewElement) throw new Error("Could not find characterPreview elememnt");
            characterPreviewElement.className = `characterPreviewImage${characterIndex + 1}`;
            characterPreviewElement.classList.remove("fadeInQuickAnimated");
            characterPreviewElement.style.visibility = "hidden";
            setTimeout(()=>{
                characterPreviewElement.classList.add("fadeInQuickAnimated");
                characterPreviewElement.style.visibility = "visible";
            }, 10);
        };
        this.updateCharacterSelectButtons = (buttonStates, nonCharacterSelected, allNonCharactersSelected)=>{
            // Characters
            for(let i = 0; i < (0, $dd300fc197dcf9fe$export$a3eb6b94b1e7587a).CharacterPlayerCount; i++){
                const characterButton = this.getElementByIdExpectNonNull(`characterButton${i}`);
                const icon = this.getElementByIdExpectNonNull(`characterIcon${i}`);
                switch(buttonStates[i]){
                    case $8b07c0f1748354ec$export$7a1472f96d5bc930.SelectedByThis:
                        characterButton.className = "pressEffectButton characterSelectButton selectedButton selectedScale";
                        icon.className = `characterSelectButtonImage character${i + 1}SelectedImage`;
                        break;
                    case $8b07c0f1748354ec$export$7a1472f96d5bc930.SelectedByOther:
                        characterButton.className = "pressEffectButton characterSelectButton buttonOutline unselectedButton";
                        icon.className = `characterSelectButtonImage character${i + 1}CrossImage`;
                        break;
                    case $8b07c0f1748354ec$export$7a1472f96d5bc930.Unselected:
                        characterButton.className = "pressEffectButton characterSelectButton buttonOutline";
                        icon.className = `characterSelectButtonImage character${i + 1}UnselectedImage`;
                        break;
                    default:
                        throw new Error(`Unexpected CharacterButtonState for updateCharacterSelectButtons: ${buttonStates[i]}`);
                }
            }
            // Non-characters
            const nonCharacterButton = this.getElementByIdExpectNonNull(`nonCharacterButton0`);
            const nonCharacterIcon = this.getElementByIdExpectNonNull(`nonCharacterIcon0`);
            if (nonCharacterSelected) {
                nonCharacterButton.className = "pressEffectButton characterSelectButton nonCharacterButton selectedButton selectedScale";
                nonCharacterIcon.className = "characterSelectButtonImage nonCharacterButtonImage nonCharacterWriterSelectedImage";
            } else if (allNonCharactersSelected) {
                nonCharacterButton.className = "pressEffectButton characterSelectButton nonCharacterButton buttonOutline unselectedButton";
                nonCharacterIcon.className = "characterSelectButtonImage nonCharacterButtonImage nonCharacterWriterCrossImage";
            } else {
                nonCharacterButton.className = "pressEffectButton characterSelectButton nonCharacterButton buttonOutline";
                nonCharacterIcon.className = "characterSelectButtonImage nonCharacterButtonImage nonCharacterWriterUnselectedImage";
            }
        };
        this.updateItemPlacementVoteVisuals = (itemManagementData, imageUrlCache)=>{
            if (!itemManagementData) return;
            const selectedItemIndex = itemManagementData.selectedItemVoteIndex;
            // Display selected item name
            const selectedItemText = this.getElementByIdExpectNonNull("selectedItemText");
            selectedItemText.innerText = itemManagementData.selectedItem.itemName;
            // Hide left/right item previews & left/right directional arrow button if looking at the first/last item
            this.getElementByIdExpectNonNull("itemPreviewLeft").style.opacity = selectedItemIndex <= 0 ? "0" : "";
            this.getElementByIdExpectNonNull("itemPreviewRight").style.opacity = selectedItemIndex >= itemManagementData.items.length - 1 ? "0" : "";
            this.getElementByIdExpectNonNull("itemVoteLeftButton").style.display = selectedItemIndex <= 0 ? "none" : "block";
            this.getElementByIdExpectNonNull("itemVoteRightButton").style.display = selectedItemIndex >= itemManagementData.items.length - 1 ? "none" : "block";
            // Set icon images for the previous, current and next items
            for(let i = 0; i < itemManagementData.items.length; i++){
                let itemPreviewElement;
                if (i === selectedItemIndex) itemPreviewElement = this.getElementByIdExpectNonNull("itemPreviewMainImage");
                else if (i === selectedItemIndex - 1) itemPreviewElement = this.getElementByIdExpectNonNull("itemPreviewLeftImage");
                else if (i === selectedItemIndex + 1) itemPreviewElement = this.getElementByIdExpectNonNull("itemPreviewRightImage");
                else continue;
                const cachedImgResult = imageUrlCache.tryGet(`Icon_LevelItem_${itemManagementData.items[i].itemName}`);
                itemPreviewElement.style.backgroundImage = cachedImgResult.success ? `url('${cachedImgResult.url}')` : "";
            }
            const itemPositionButtonsPanel = this.getElementByIdExpectNonNull("itemPositionButtonsPanel");
            // Remove all but the first child from the list of position buttons
            //	(the first child is itemPositionButton which we want to clone)
            for(let i = itemPositionButtonsPanel.childNodes.length - 1; i > 1; i--)itemPositionButtonsPanel.childNodes[i].remove();
            // We'll use itemPositionButton as a template to clone from
            const itemPositionButton = this.getElementByIdExpectNonNull("itemPositionButton");
            // Add an itemPositionButton clone for each placement position
            for(let i = 0; i < itemManagementData.placementPositionCount; i++)this.addItemPositionButton(itemPositionButtonsPanel, itemPositionButton, i, itemManagementData);
        };
        this.initialiseWriterTextInputVisuals = (characterWritingData)=>{
            this.setupWriterCharacterScrollButtons(characterWritingData);
            this.updateWriterTextInputSelectionVisuals(characterWritingData, true, true, true);
        };
        this.updateWriterTextInputSelectionVisuals = (characterWritingData, selectionChanged = true, updateButtonStyling = true, instantScroll = false)=>{
            if (!characterWritingData) {
                // Nothing to display, disable the ready (send) button for now (by applying button pressed styling)
                this.setReadyButtonPressed(true, false);
                return;
            }
            // Enable the ready (send) button only if the min. allowed number of characters was entered
            this.setReadyButtonPressed(characterWritingData.selectedCharacterText.length < (0, $a73b546ea725d550$export$b57493bfe7fffdae), false);
            if (!selectionChanged) return;
            // Display name of selected character
            const characterNameTextElement = this.getElementByIdExpectNonNull("writerCharacterNameText");
            if (characterNameTextElement.innerText !== characterWritingData.selectedCharacterDisplayName) {
                characterNameTextElement.classList.remove("fadeInQuickAnimated");
                characterNameTextElement.style.visibility = "hidden";
                characterNameTextElement.innerText = characterWritingData.selectedCharacterDisplayName;
                setTimeout(()=>{
                    characterNameTextElement.classList.add("fadeInQuickAnimated");
                    characterNameTextElement.style.visibility = "visible";
                }, 10);
            }
            // Apply styling to selected character button
            const selectedElement = this.getElementByIdExpectNonNull(`writerCharacterButton${characterWritingData.selectedCharacterIndex}`);
            this.scrollElementIntoViewCentered(selectedElement, instantScroll);
            if (updateButtonStyling) this.updateWriterCharacterScrollButtonsStyling(selectedElement);
            // Update input field (TextArea) with any text that was already written for the selected character
            const inputFieldElement = this.getElementByIdExpectNonNull("writerInputField");
            inputFieldElement.value = characterWritingData.selectedCharacterText;
            // Hide left/right arrow button if first/last character is selected
            const leftArrowButtonElement = this.getElementByIdExpectNonNull("writerCharacterLeftButton");
            const rightArrowButtonElement = this.getElementByIdExpectNonNull("writerCharacterRightButton");
            leftArrowButtonElement.classList.remove("disabledFade");
            rightArrowButtonElement.classList.remove("disabledFade");
            if (characterWritingData.isFirstCharacterSelected) leftArrowButtonElement.classList.add("disabledFade");
            else if (characterWritingData.isLastCharacterSelected) rightArrowButtonElement.classList.add("disabledFade");
        };
        this.updateWriterCharacterScrollButtonsStyling = (selectedElement)=>{
            const scrollList = this.getElementByIdExpectNonNull("writerCharacterScrollList");
            for (let child of scrollList.children){
                if (child.classList.contains("placeholderButton")) continue;
                let childHTML = child;
                if (child === selectedElement) {
                    childHTML.style.opacity = "1";
                    childHTML.classList.add("actionButtonSelected");
                } else {
                    childHTML.style.opacity = "0.5";
                    childHTML.classList.remove("actionButtonSelected");
                }
            }
        };
        this.getCentremostElementInScrollView = (scrollElement)=>{
            const scrollElementRect = scrollElement.getBoundingClientRect();
            const containerCentreX = scrollElementRect.left + scrollElementRect.width / 2;
            let centremostElement = null;
            let centremostElementIndex = 0;
            let minDistance = Infinity;
            let scrollIndex = 0;
            for (let child of scrollElement.children){
                const childRect = child.getBoundingClientRect();
                const childCentreX = childRect.left + childRect.width / 2;
                const distanceX = Math.abs(containerCentreX - childCentreX);
                if (!child.classList.contains("placeholderButton") && distanceX < minDistance) {
                    centremostElement = child;
                    centremostElementIndex = scrollIndex - $8b07c0f1748354ec$export$e2fb22396d3bf4b8.ScrollElementPadding;
                    minDistance = distanceX;
                }
                scrollIndex++;
            }
            return {
                element: centremostElement,
                elementIndex: centremostElementIndex
            };
        };
        this.scrollElementIntoViewCentered = (selectedElement, instantScroll)=>{
            selectedElement.scrollIntoView({
                behavior: instantScroll ? "instant" : "auto",
                block: "center",
                inline: "center"
            });
        };
        /**
	 * Returns the join code that has been entered into the HTML input field
	 * IF the field is being displayed (otherwise empty string),
	 * also returns the player name that has been entered.
	 */ this.tryGetJoinCodeAndPlayerNameFromHTML = ()=>{
            let joinCode = "";
            const joinCodeTxt = document.getElementById("joinCode");
            if (joinCodeTxt.style.display !== "none") joinCode = joinCodeTxt.value.trim();
            const playerNameInput = document.getElementById("playerName");
            const playerNameText = playerNameInput.value.trim();
            return {
                joinCode: joinCode,
                playerName: playerNameText
            };
        };
        this.addItemPositionButton = async (parent, cloneFrom, index, itemManagementData)=>{
            const clone = cloneFrom.cloneNode(true);
            clone.id = `${clone.id}${index}`;
            clone.style.display = "flex";
            parent.appendChild(clone);
            const posText1 = clone.querySelector(".itemPositionText1");
            if (!posText1) throw new Error('Failed to get element with class "itemPositionText1" from cloned itemPositionButton');
            posText1.innerText = "Position";
            const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            const posText2 = clone.querySelector(".itemPositionText2");
            if (!posText2) throw new Error('Failed to get element with class "itemPositionText2" from cloned itemPositionButton');
            posText2.innerText = index >= 0 && index < alphabet.length ? alphabet[index] : "";
            if (itemManagementData.selectedItem.positionIndex == index) {
                // This position is selected for the current item, so button is selected
                // Tiny delay so button will animates to new selection style
                await new Promise((_)=>setTimeout(_, 5));
                clone.classList.add("actionButtonSelected");
                clone.classList.add("actionButtonItemPositionSelected");
            } else if (itemManagementData.positionIsSelectedForAnyItem(index)) {
                // This position is selected for a different item, so button is disabled
                clone.classList.add("disabledButton");
                clone.classList.add("actionButtonItemPositionDisabled");
            }
        };
        this.setupWriterCharacterScrollButtons = (characterWritingData)=>{
            const scrollListParent = this.getElementByIdExpectNonNull("writerCharacterScrollList");
            // Clear existing child elements
            for(let i = scrollListParent.childNodes.length - 1; i >= 0; i--)scrollListParent.childNodes[i].remove();
            if (characterWritingData === undefined) return;
            // writerCharacterPlaceholder is hidden and used as a template to clone from
            const characterPlaceholderElement = this.getElementByIdExpectNonNull("writerCharacterPlaceholder");
            // writerCharacterButton is hidden and used as a template to clone from
            const characterButtonElement = this.getElementByIdExpectNonNull("writerCharacterButton");
            // Buffer/placeholder elements for left side of scroll
            for(let i = 0; i < $8b07c0f1748354ec$export$e2fb22396d3bf4b8.ScrollElementPadding; i++)this.cloneAndAddElement(characterPlaceholderElement, scrollListParent, i.toString(), "grid");
            // Button for each character
            characterWritingData.characterNamesAndText.forEach((nameAndText, index)=>{
                const clone = this.cloneAndAddElement(characterButtonElement, scrollListParent, index.toString(), "grid");
                const imageElement = clone.querySelector(".writerCharacterImage");
                if (!imageElement) throw new Error('Failed to get image element with class "writerCharacterImage" from cloned writerCharacterButton');
                $8b07c0f1748354ec$var$Log.debug(`Setting image: ${imageElement.className}`);
                const internalNameNoWhitespace = nameAndText.internalName.replace(/\s/g, "");
                imageElement.className = `writerCharacterImage actionButtonImage characterAvatarImage_default characterAvatarImage_${internalNameNoWhitespace}`;
            });
            // Buffer/placeholder elements for right side of scroll
            for(let i = 0; i < $8b07c0f1748354ec$export$e2fb22396d3bf4b8.ScrollElementPadding; i++)this.cloneAndAddElement(characterPlaceholderElement, scrollListParent, i.toString(), "grid");
        };
        this.setElementShowing = (elementId, showing, showDisplayType = "block")=>{
            const element = document.getElementById(elementId);
            if (element) element.style.display = showing ? showDisplayType : "none";
            else $8b07c0f1748354ec$var$Log.error(`Calling setElementShowing with invalid element id: ${elementId}`);
        };
        this.getImageNameFromAction = (actionName)=>{
            switch(actionName){
                case "move":
                case "act":
                case "throw":
                    return actionName;
                case "":
                    return "wait";
                default:
                    $8b07c0f1748354ec$var$Log.warn(`getImageNameFromAction: Unexpected action name '${actionName}'`);
                    return "unknown";
            }
        };
        this.cloneAndAddElement = (elementToClone, parentElement, idAppend, displayType)=>{
            const clone = elementToClone.cloneNode(true);
            clone.id = `${clone.id}${idAppend}`;
            clone.style.display = displayType;
            parentElement.appendChild(clone);
            return clone;
        };
        this.getElementByIdExpectNonNull = (id)=>{
            const element = document.getElementById(id);
            if (!element) throw new Error(`Expected to find element with id ${id}, but was null`);
            return element;
        };
        // Record all the views
        document.querySelectorAll(".view").forEach((v)=>this.views[v.id] = v);
        addEventListener("resize", this.onWindowResized);
        this.setupWheelScrollsHorizontallyElements();
    }
    static #_ = (()=>{
        this.ScrollElementPadding = 2;
    })();
    setConnectingInfoToDisplay(currentCount, totalCount, playerName) {
        if (totalCount !== undefined) this.mostRecentDisplayedTotalConnectionCount = totalCount;
        else totalCount = this.mostRecentDisplayedTotalConnectionCount;
        const connectingTextElement = this.getElementByIdExpectNonNull("connectingLabel");
        const playerNameText = playerName !== undefined ? ` ${playerName}` : "";
        if (totalCount > 1) connectingTextElement.innerText = `Connecting${playerNameText}...\n(${currentCount}/${totalCount})`;
        else connectingTextElement.innerText = `Connecting${playerNameText}...`;
    }
}
var $8b07c0f1748354ec$export$27a5bd065ad55220;
(function(View) {
    View["Default"] = "Default";
    View["Connecting"] = "Connecting";
    View["Reconnecting"] = "Reconnecting";
    View["Joining"] = "Joining";
    View["LookAtScreen"] = "LookAtScreen";
    View["Lobby"] = "Lobby";
    View["WaitOrAddPlayers"] = "WaitOrAddPlayers";
    View["CharacterSelect"] = "CharacterSelect";
    View["GameInputPhase"] = "GameInputPhase";
    View["ItemPlacementVote"] = "ItemPlacementVote";
    View["WriterTextInput"] = "WriterTextInput";
})($8b07c0f1748354ec$export$27a5bd065ad55220 || ($8b07c0f1748354ec$export$27a5bd065ad55220 = {}));
const $8b07c0f1748354ec$var$Log = (0, $7653766080191e46$export$4ac4545211fd8567).build($8b07c0f1748354ec$export$e2fb22396d3bf4b8.name);



function $7fc63af29f7868be$export$ee291b338082bbed() {
    // 20230419 Mobile Chromium-based browsers (inc. Chrome) ceased responding to `ontouchend` within HTML!
    //   To fix, found could add `onmouseup` handler instead!
    //   To remove duplicate messages, had to remove the `ontouchend` handler.
    $7fc63af29f7868be$var$Log.debug("addTouchHandlesForMouse");
    const elements = document.getElementsByTagName("*");
    $7fc63af29f7868be$var$Log.debug(`addTouchHandlesForMouse() found ${elements.length} elements`);
    let numStart = 0, numEnd = 0;
    for(let i = 0; i < elements.length; ++i){
        const element = elements[i];
        const ontouchstart = element.getAttribute("ontouchstart");
        if (ontouchstart) {
            numStart++;
            element.setAttribute("onmousedown", ontouchstart);
        }
        const ontouchend = element.getAttribute("ontouchend");
        if (ontouchend) {
            numEnd++;
            // 20230419 Removed `ontouchend` to remove duplicated events
            element.removeAttribute("ontouchend");
            element.setAttribute("onmouseup", ontouchend);
        }
    }
    $7fc63af29f7868be$var$Log.debug(`addTouchHandlesForMouse() found ${numStart} touchStart and ${numEnd} touchEnd`);
}
const $7fc63af29f7868be$var$Log = (0, $7653766080191e46$export$4ac4545211fd8567).build("utils");






class $57efccf44429ad06$export$2e2bcd8739ae039 {
    constructor(app){
        this.app = app;
        this.isActive = false;
        this.controls = [
            new $57efccf44429ad06$var$Control("1", async ()=>this.app.onSelectActionButtonPressed(null, 0)),
            new $57efccf44429ad06$var$Control("2", async ()=>this.app.onSelectActionButtonPressed(null, 1)),
            new $57efccf44429ad06$var$Control("3", async ()=>this.app.onSelectActionButtonPressed(null, 2)),
            new $57efccf44429ad06$var$Control("4", async ()=>this.app.onSelectActionButtonPressed(null, 3)),
            new $57efccf44429ad06$var$Control("w", async ()=>await this.app.onSelectDataButtonPressed(null, "north")),
            new $57efccf44429ad06$var$Control("d", async ()=>await this.app.onSelectDataButtonPressed(null, "east")),
            new $57efccf44429ad06$var$Control("s", async ()=>await this.app.onSelectDataButtonPressed(null, "south")),
            new $57efccf44429ad06$var$Control("a", async ()=>await this.app.onSelectDataButtonPressed(null, "west")),
            new $57efccf44429ad06$var$Control("r", async ()=>await this.app.onReadyButtonPressed(null))
        ];
        this.onKeyPress = async (event)=>{
            if (!this.isActive) return;
            if (this.app.activeGameSessionInView.isNonCharacterPlayer) // Active session is not controlling a character, ignore keyboard shortcuts
            return;
            if (this.app.mostRecentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput) // Not waiting for player input, ignore keyboard shortcuts
            return;
            const key = event.shiftKey ? event.key.toUpperCase() : event.key;
            for (const control of this.controls)if (control.key === key) {
                await control.delegate();
                this.app.consumeEvent(event);
                return;
            }
        };
        this.setActive = (active)=>{
            this.isActive = active;
        };
        document.addEventListener("keypress", this.onKeyPress);
    }
}
class $57efccf44429ad06$var$Control {
    constructor(key, delegate){
        this.key = key;
        this.delegate = delegate;
    }
}




class $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a {
    static #_ = (()=>{
        this.CookieNameSessionsList = "sessionsList";
    })();
    static #_1 = (()=>{
        this.CookieNameJoinCode = "joinCode";
    })();
    static #_2 = (()=>{
        this.CookieNameJoinCodeVisible = "joinCodeVisible";
    })();
    static #_3 = (()=>{
        this.CookieNameDeviceIdPrefix = "deviceId";
    })();
    static #_4 = (()=>{
        this.CookieNameItemVotesPrefix = "itemVotes";
    })();
    static #_5 = (()=>{
        this.CookieNameTurnSetPrefix = "turnSet";
    })();
    static #_6 = (()=>{
        this.CookieNameSelectedTurnPrefix = "selectedTurn";
    })();
    static #_7 = (()=>{
        this.CookieNameCharacterTextPrefix = "characterText";
    })();
    // Cookie helper functions from https://stackoverflow.com/questions/14573223/set-cookie-and-get-cookie-with-javascript
    static setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = "; expires=" + date.toUTCString();
        }
        // Uses SameSite=Strict to prevent CSRF attacks and reduce console warnings.
        // See https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie#samesitesamesite-value
        document.cookie = name + "=" + (value || "") + expires + "; SameSite=Strict; path=/";
    }
    static getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(";");
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(" " === c.charAt(0))c = c.substring(1, c.length);
            if (0 === c.indexOf(nameEQ)) return c.substring(nameEQ.length, c.length);
        }
        return undefined;
    }
    static eraseCookie(name) {
        document.cookie = name + "=; SameSite=Strict; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
    constructor(){
        this.canSetSessionsCookie = true;
        this.preventSettingSessionsCookie = ()=>{
            this.canSetSessionsCookie = false;
        };
        this.allowSettingSessionsCookie = ()=>{
            this.canSetSessionsCookie = true;
        };
        this.setSessionsList = (sessionsList)=>{
            if (!this.canSetSessionsCookie) {
                $1d0dbe8b9395cf5a$var$Log.debug("setSessionsList(): not setting because canSetSessionsCookie == false");
                return;
            }
            if (0 === sessionsList.length) {
                $1d0dbe8b9395cf5a$var$Log.log("setSessionsList(): clearing");
                $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.eraseCookie($1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameSessionsList);
                return;
            }
            const listJSON = JSON.stringify(sessionsList);
            $1d0dbe8b9395cf5a$var$Log.debug("setSessionsList():", listJSON);
            $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.setCookie($1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameSessionsList, listJSON, 1);
        };
        this.getSessionsList = ()=>{
            const resultJSON = $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.getCookie($1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameSessionsList);
            $1d0dbe8b9395cf5a$var$Log.debug("getSessionsList():", resultJSON);
            if (undefined === resultJSON) return undefined;
            try {
                const sessionList = JSON.parse(resultJSON);
                return sessionList;
            } catch  {
                return undefined;
            }
        };
        this.setJoinCode = (joinCode)=>{
            $1d0dbe8b9395cf5a$var$Log.debug("setJoinCode():", joinCode);
            $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.setCookie($1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameJoinCode, joinCode, 1);
        };
        this.getJoinCode = ()=>{
            const result = $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.getCookie($1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameJoinCode);
            $1d0dbe8b9395cf5a$var$Log.debug("getJoinCode():", result);
            return result;
        };
        this.clearJoinCode = ()=>{
            $1d0dbe8b9395cf5a$var$Log.debug("clearJoinCode()");
            $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.eraseCookie($1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameJoinCode);
        };
        this.setJoinCodeVisible = (isVisible)=>{
            $1d0dbe8b9395cf5a$var$Log.debug(`setJoinCodeVisible(): ${isVisible}`);
            $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.setCookie($1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameJoinCodeVisible, isVisible ? "true" : "false", 1);
        };
        this.getJoinCodeVisible = ()=>{
            const result = $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.getCookie($1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameJoinCodeVisible);
            $1d0dbe8b9395cf5a$var$Log.debug("getJoinCodeVisible():", result);
            // Return true if undefined - join code should be visible by default
            if (result === undefined || typeof result !== "string") return true;
            return result.replace(/\s/g, "") !== "false";
        };
        this.setCharacterTextForSessionIndex = (sessionIndex, characterText)=>{
            const characterTextJSON = JSON.stringify(Array.from(characterText.entries()));
            $1d0dbe8b9395cf5a$var$Log.debug(`setCharacterTextForSessionIndex(${sessionIndex}, ${characterText.size} ${characterTextJSON})`);
            $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.setCookie(`${$1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameCharacterTextPrefix}-${sessionIndex}`, characterTextJSON, 1);
        };
        this.getCharacterTextForSessionIndex = (sessionIndex)=>{
            const result = $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.getCookie(`${$1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameCharacterTextPrefix}-${sessionIndex}`);
            $1d0dbe8b9395cf5a$var$Log.debug(`getCharacterTextForSessionIndex(${sessionIndex}): = ${result}`);
            if (result === undefined) return new Map();
            const characterNamesAndTextMap = new Map(JSON.parse(result));
            return characterNamesAndTextMap;
        };
        this.clearCharacterTextForSessionIndex = (sessionIndex)=>{
            $1d0dbe8b9395cf5a$var$Log.debug(`clearCharacterTextForSessionIndex(${sessionIndex})`);
            $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.eraseCookie(`${$1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameCharacterTextPrefix}-${sessionIndex}`);
        };
        this.setDeviceIdForSessionIndex = (sessionIndex, deviceId)=>{
            $1d0dbe8b9395cf5a$var$Log.debug(`setDeviceIdForSessionIndex(${sessionIndex}, ${deviceId})`);
            $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.setCookie(`${$1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameDeviceIdPrefix}-${sessionIndex}`, deviceId, 1);
        };
        this.getDeviceIdForSessionIndex = (sessionIndex)=>{
            const result = $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.getCookie(`${$1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameDeviceIdPrefix}-${sessionIndex}`);
            $1d0dbe8b9395cf5a$var$Log.debug(`getDeviceIdForSessionIndex(${sessionIndex}): = ${result}`);
            return result;
        };
        this.clearDeviceIdForSessionIndex = (sessionIndex)=>{
            $1d0dbe8b9395cf5a$var$Log.debug(`clearDeviceIdForSessionIndex(${sessionIndex})`);
            $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.eraseCookie(`${$1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameDeviceIdPrefix}-${sessionIndex}`);
        };
        this.setItemVotesForSessionIndex = (sessionIndex, itemsJson)=>{
            $1d0dbe8b9395cf5a$var$Log.debug(`setItemVotesForSessionIndex(${sessionIndex})`);
            $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.setCookie(`${$1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameItemVotesPrefix}-${sessionIndex}`, itemsJson, 1);
        };
        this.getItemVotesForSessionIndexJSON = (sessionIndex)=>{
            $1d0dbe8b9395cf5a$var$Log.debug(`getItemVotesForSessionIndexJSON(${sessionIndex})`);
            return $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.getCookie(`${$1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameItemVotesPrefix}-${sessionIndex}`) ?? "";
        };
        this.clearItemVotesForSessionIndex = (sessionIndex)=>{
            $1d0dbe8b9395cf5a$var$Log.debug(`ItemVotesForSessionIndex(${sessionIndex})`);
            $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.eraseCookie(`${$1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameItemVotesPrefix}-${sessionIndex}`);
        };
        this.setTurnSetForSessionIndex = (sessionIndex, turnSet)=>{
            const json = turnSet.toJSON();
            $1d0dbe8b9395cf5a$var$Log.debug(`setTurnSetForSessionIndex(${sessionIndex}): ${json}`);
            $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.setCookie(`${$1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameTurnSetPrefix}-${sessionIndex}`, json, 1);
        };
        this.getTurnSetForSessionIndex = (sessionIndex)=>{
            const turnsJSON = $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.getCookie(`${$1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameTurnSetPrefix}-${sessionIndex}`);
            $1d0dbe8b9395cf5a$var$Log.debug(`getTurnSetForSessionIndex(${sessionIndex}): ${turnsJSON}`);
            if (undefined === turnsJSON) return undefined;
            return (0, $109c27dde40935f6$export$68656b7c8056ebd6).fromJSON(turnsJSON);
        };
        this.clearTurnSetForSessionIndex = (sessionIndex)=>{
            $1d0dbe8b9395cf5a$var$Log.debug(`clearTurnSetForSessionIndex(${sessionIndex})`);
            $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.eraseCookie(`${$1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameTurnSetPrefix}-${sessionIndex}`);
        };
        this.setSelectedTurnForSessionIndex = (sessionIndex, selectedTurnNumber)=>{
            $1d0dbe8b9395cf5a$var$Log.debug(`setSelectedTurnForSessionIndex(${sessionIndex}): ${selectedTurnNumber}`);
            $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.setCookie(`${$1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameSelectedTurnPrefix}-${sessionIndex}`, selectedTurnNumber.toString(), 1);
        };
        this.getSelectedTurnForSessionIndex = (sessionIndex)=>{
            const selectedTurn = $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.getCookie(`${$1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameSelectedTurnPrefix}-${sessionIndex}`);
            $1d0dbe8b9395cf5a$var$Log.debug(`getSelectedTurnForSessionIndex(${sessionIndex}): ${selectedTurn}`);
            if (undefined == selectedTurn) return 0;
            return parseInt(selectedTurn);
        };
        this.clearSelectedTurnForSessionIndex = (sessionIndex)=>{
            $1d0dbe8b9395cf5a$var$Log.debug(`clearSelectedTurnForSessionIndex(${sessionIndex})`);
            $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.eraseCookie(`${$1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.CookieNameSelectedTurnPrefix}-${sessionIndex}`);
        };
    }
}
const $1d0dbe8b9395cf5a$var$Log = (0, $7653766080191e46$export$4ac4545211fd8567).build($1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a.name);






class $630cf7121ecbb9c7$export$5a9b27c5cf630af2 {
    constructor(actionButtons){
        this.setActionButton = (index, actionButton)=>{
            if (index < 0 || index >= (0, $ac58392a9f7a45e7$export$86fbec116b87613f).ActionButtonCount) throw new Error(`Invalid index (${index}, expected between 0 and ${(0, $ac58392a9f7a45e7$export$86fbec116b87613f).ActionButtonCount - 1}) when setting action button on ${this}`);
            if (!this.actionButtons) this.actionButtons = [];
            this.actionButtons[index] = actionButton;
            (0, $7653766080191e46$export$2e2bcd8739ae039).log(`Set actionButton at index ${index} to: ${actionButton}`);
        };
        this.toString = ()=>{
            return `${$630cf7121ecbb9c7$export$5a9b27c5cf630af2.name} (${this.actionButtons ? this.actionButtons.join(" | ") : "Empty"})`;
        };
        this.actionButtons = actionButtons;
    }
    static #_ = (()=>{
        // Default (CO OPERATION) data defining actions & related action button properties
        this.getDefaultControllerData = ()=>{
            return new $630cf7121ecbb9c7$export$5a9b27c5cf630af2([
                new (0, $4b1e45d61ed1a70b$export$5730f849b02574b8)(true, "move", true, true, "Move", "", undefined, "#019748", "#bdffdc"),
                new (0, $4b1e45d61ed1a70b$export$5730f849b02574b8)(true, "act", true, true, "Interact", "", undefined, "#c86400", "#ffd9b3"),
                new (0, $4b1e45d61ed1a70b$export$5730f849b02574b8)(true, "", true, false, "Wait", undefined, "", "#2397e4", "#b9e3ff"),
                new (0, $4b1e45d61ed1a70b$export$5730f849b02574b8)(true, "throw", true, true, "Throw", undefined, "", "#e8d734", "#fffdc0")
            ]);
        };
    })();
    static #_1 = (()=>{
        this.isDefaultActionName = (actionName)=>{
            const actionWithName = $630cf7121ecbb9c7$export$5a9b27c5cf630af2.getDefaultControllerData().actionButtons.find((a)=>a.action === actionName);
            return actionWithName !== undefined;
        };
    })();
}




class $ca76646b87041aa8$export$3f9ddc829742610b {
    get onImageUrlCreated() {
        return this._onImageUrlCreated.asEvent();
    }
    constructor(){
        this.keyToUrl = new Map();
        this._onImageUrlCreated = new (0, $6384862cb2bc9a13$exports.SimpleEventDispatcher)();
        this.createImageObjectURL = async (imageName, imageBase64)=>{
            const key = imageName;
            const cached = this.tryGet(key);
            if (cached.success) {
                (0, $7653766080191e46$export$2e2bcd8739ae039).log(`Already have cached URL for image '${key}': ${cached.url}`);
                return;
            }
            const base64Response = await fetch(`data:image/png;base64,${imageBase64}`);
            const blob = await base64Response.blob();
            if (this.tryGet(key).success) {
                // Image URL was added to cache while we were awaiting
                (0, $7653766080191e46$export$2e2bcd8739ae039).warn(`Skipping creating URL for key ${key}, one was already created & cached while fetch/blob was taking place`);
                return;
            }
            const newUrl = URL.createObjectURL(blob);
            this.add(key, newUrl);
            this._onImageUrlCreated.dispatch(key);
        };
        this.tryGet = (key)=>{
            if (this.keyToUrl.has(key)) return {
                success: true,
                url: this.keyToUrl.get(key)
            };
            return {
                success: false
            };
        };
        this.add = (key, urlToAdd)=>{
            if (this.keyToUrl.has(key)) throw new Error(`URL image cache already contains an entry with key '${key}'`);
            this.keyToUrl.set(key, urlToAdd);
            (0, $7653766080191e46$export$2e2bcd8739ae039).log(`Added image URL to cache - key: '${key}', url: ${urlToAdd}`);
        };
    }
}




var $aLUwE = parcelRequire("aLUwE");
class $9935c47765ab2268$export$887464dca0f26780 {
    static #_ = (()=>{
        /** The amount of time to wait before the game is considered hung. */ this.HangTime = 40000;
    })();
    static #_1 = (()=>{
        /** Id to find in the HTML to show the hint. */ this.HintId = "reloadIfHung";
    })();
    constructor(){
        this.showing = false;
        this.startTimer = ()=>{
            (0, $7653766080191e46$export$2e2bcd8739ae039).log("Starting hung timer (after hiding the hint)");
            this.hide();
            this.timer = setTimeout(()=>{
                this.timer = undefined;
                this.show();
            }, $9935c47765ab2268$export$887464dca0f26780.HangTime);
        };
        this.stopTimerAndHide = ()=>{
            if (this.timer) {
                (0, $7653766080191e46$export$2e2bcd8739ae039).log("Cancelling reconnect timer");
                clearTimeout(this.timer);
                this.timer = undefined;
                this.hide();
            }
        };
        this.show = ()=>{
            if (!this.showing) {
                this.showing = true;
                (0, $7653766080191e46$export$2e2bcd8739ae039).debug("showing");
                // TODO: Show reload hint
                const hint = document.getElementById($9935c47765ab2268$export$887464dca0f26780.HintId);
                $aLUwE(hint);
                hint.style.display = "block";
            } else (0, $7653766080191e46$export$2e2bcd8739ae039).debug("already showing");
        };
        this.hide = ()=>{
            if (this.showing) {
                this.showing = false;
                (0, $7653766080191e46$export$2e2bcd8739ae039).debug("hiding");
                // TODO: Hide reload hint
                const hint = document.getElementById($9935c47765ab2268$export$887464dca0f26780.HintId);
                $aLUwE(hint);
                hint.style.display = "none";
            } else (0, $7653766080191e46$export$2e2bcd8739ae039).debug("already hidden");
        };
    }
}


var $e28ba69f83870993$export$ab0202365e783f74;
(function(CoOperationHelpInfoType) {
    CoOperationHelpInfoType[CoOperationHelpInfoType["WriterPlayer"] = 0] = "WriterPlayer";
    CoOperationHelpInfoType[CoOperationHelpInfoType["PlanningActions"] = 1] = "PlanningActions";
})($e28ba69f83870993$export$ab0202365e783f74 || ($e28ba69f83870993$export$ab0202365e783f74 = {}));
class $e28ba69f83870993$export$1ea1c440ecc5b610 {
    static #_ = (()=>{
        this.getCoOperationHelpInfo = (helpInfoType, turnsPerRound)=>{
            switch(helpInfoType){
                case $e28ba69f83870993$export$ab0202365e783f74.WriterPlayer:
                    return {
                        titleText: "Writers",
                        infoText: "Writers can write the character dialogue. Your text will be displayed on the shared game screen while other players plan their actions. Create the game narrative or just make up fun quips!<br /><br />This is a good option if you want to contribute creatively rather than make the tactical decisions."
                    };
                case $e28ba69f83870993$export$ab0202365e783f74.PlanningActions:
                    if (turnsPerRound <= 1) return {
                        titleText: "Planning Actions",
                        infoText: `Select your action, then press "Ready!".<br />` + "When you <b>select an action</b>, also <b>choose a direction</b> for it.<br /><br />" + 'After all the doctor characters have pressed "Ready!", they will perform their actions.<br /><br />' + '<b><span style="color: #bdffdc">Move:</span></b> Run to the next tile.<br />' + '<b><span style="color: #ffd9b3">Interact:</span></b> Pick up/place down/use objects.<br />' + '<b><span style="color: #b9e3ff">Wait:</span></b> Do nothing.<br />' + '<b><span style="color: #fffdc0">Throw:</span></b> If an object can be picked up, it can be thrown.'
                    };
                    else return {
                        titleText: "Planning Actions",
                        infoText: `Schedule ${turnsPerRound} actions, then press "Ready!".<br />` + "Each time you <b>select an action</b>, also <b>choose a direction</b> for it.<br /><br />" + 'After all the doctor characters have pressed "Ready!", they will perform their scheduled actions.<br /><br />' + '<b><span style="color: #bdffdc">Move:</span></b> Run to the next tile.<br />' + '<b><span style="color: #ffd9b3">Interact:</span></b> Pick up/place down/use objects.<br />' + '<b><span style="color: #b9e3ff">Wait:</span></b> Do nothing.<br />' + '<b><span style="color: #fffdc0">Throw:</span></b> If an object can be picked up, it can be thrown.'
                    };
                default:
                    throw new Error(`Unexpected ${$e28ba69f83870993$export$ab0202365e783f74}: ${helpInfoType}`);
            }
        };
    })();
}


class $ac58392a9f7a45e7$export$86fbec116b87613f {
    get mostRecentControllerState() {
        return this._mostRecentControllerState;
    }
    get resettingApp() {
        return this._resettingApp;
    }
    get _sessionCount() {
        return this.gameSessions.length;
    }
    static #_ = (()=>{
        this.MaxGameSessions = 8;
    })();
    static #_1 = (()=>{
        this.DefaultTurnsPerRound = 4;
    })();
    static #_2 = (()=>{
        this.MinValidTurnsPerRound = 1;
    })();
    static #_3 = (()=>{
        this.MaxValidTurnsPerRound = 8;
    })();
    static #_4 = (()=>{
        this.AllDirectionNames = [
            "north",
            "east",
            "south",
            "west"
        ];
    })();
    static #_5 = (()=>{
        // Temporary hardcoded number of actions, in the future this could be moddable
        this.ActionButtonCount = 4;
    })();
    constructor(){
        /** public to allow HTML to access. */ this.viewManager = new (0, $8b07c0f1748354ec$export$e2fb22396d3bf4b8)();
        this.cookieHelper = new (0, $1d0dbe8b9395cf5a$export$6f5af4a2b14b7e2a)();
        this.gameSessions = [];
        this._resettingApp = false;
        this.awayAutoReadying = false;
        this.joinCodeVisible = true;
        this.imageURLCache = new (0, $ca76646b87041aa8$export$3f9ddc829742610b)();
        this.writerButtonsScrolling = false;
        this.isActiveGameSessionInView = (gameSession)=>{
            return gameSession === this.activeGameSessionInView;
        };
        this.setCustomControllerActionButton = (buttonIndex, actionButton)=>{
            this.controllerData.setActionButton(buttonIndex, actionButton);
            // Hide Co OPERATION-specific help buttons when using custom controls
            this.viewManager.setHelpButtonsShowing(false);
        };
        this.resetControllerDataToDefault = ()=>{
            this.controllerData = (0, $630cf7121ecbb9c7$export$5a9b27c5cf630af2).getDefaultControllerData();
            // Only show Co OPERATION-specific help buttons when using default controls
            this.viewManager.setHelpButtonsShowing(true);
        };
        this.getActionButtonData = (index)=>{
            if (index < 0 || index >= $ac58392a9f7a45e7$export$86fbec116b87613f.ActionButtonCount) throw new Error(`Invalid index (${index}) when trying to get action button data, expected between 0 and ${$ac58392a9f7a45e7$export$86fbec116b87613f.ActionButtonCount - 1}`);
            if (this.controllerData.actionButtons && index < this.controllerData.actionButtons.length) return this.controllerData.actionButtons[index];
            return (0, $630cf7121ecbb9c7$export$5a9b27c5cf630af2).getDefaultControllerData().actionButtons[index];
        };
        this.getActionNumberByName = (actionName, expectSuccesss = true)=>{
            const defaultControllerData = (0, $630cf7121ecbb9c7$export$5a9b27c5cf630af2).getDefaultControllerData();
            for(let i = 0; i < $ac58392a9f7a45e7$export$86fbec116b87613f.ActionButtonCount; i++){
                let actionButtonData;
                if (this.controllerData.actionButtons && i < this.controllerData.actionButtons.length) actionButtonData = this.controllerData.actionButtons[i];
                else actionButtonData = defaultControllerData.actionButtons[i];
                if (actionButtonData.action === actionName) return i;
            }
            if (expectSuccesss) throw new Error(`Unable to find ${(0, $4b1e45d61ed1a70b$export$5730f849b02574b8).name} with action name '${actionName}' when trying to get action number`);
            else {
                $ac58392a9f7a45e7$var$Log.debug(`Unable to find ${(0, $4b1e45d61ed1a70b$export$5730f849b02574b8).name} with action name '${actionName}' when trying to get action number (not expecting success)`);
                return -1;
            }
        };
        // noinspection JSUnusedGlobalSymbols -- (used by HTML)
        this.consumeEvent = (evt)=>{
            /*evt = evt || window.event; -- latter is deprecated! */ if ("undefined" == typeof evt.stopPropagation) evt.cancelBubble = true;
            else evt.stopPropagation();
        };
        // noinspection JSUnusedGlobalSymbols -- Used by HTML
        this.onReloadButtonPressed = ()=>{
            location.reload();
        };
        // noinspection JSUnusedGlobalSymbols -- Used by HTML
        this.onMenuButtonPressed = ()=>{
            this.buttonPressVibration();
            this.viewManager.showGameMenu();
        };
        // noinspection JSUnusedGlobalSymbols -- Used by HTML
        this.onJoinButtonPressed = async (pressedElement)=>{
            if (this.mostRecentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).JoinScreen) {
                $ac58392a9f7a45e7$var$Log.warn(`Ignoring join button press because not in ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).JoinScreen]} state, is ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[this.mostRecentControllerState]}`);
                return;
            }
            await this.awaitButtonPressIfNotAlready("joinButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                this.buttonPressVibration();
                // Use join code from HTML input field by default.  Priority order:
                // 1. From `forceJoinCode` (set by successful join by a session on this controller)
                // 2. From UI (when button pressed)
                // 3. From cookie.
                const joinParams = this.viewManager.tryGetJoinCodeAndPlayerNameFromHTML();
                if (!joinParams.joinCode) {
                    const joinCodeFromCookie = this.cookieHelper.getJoinCode();
                    if (joinCodeFromCookie) joinParams.joinCode = joinCodeFromCookie;
                }
                joinParams.forceJoinCode = this.forceJoinCode;
                const result = await this.activeGameSessionInView.joinGame(joinParams);
                if (result.success) {
                    this.forceJoinCode = result.joinCode;
                    this.cookieHelper.setJoinCode(result.joinCode);
                    this.updateSessionsCookie();
                }
            // else wrong join code.
            // A dialog is shown elsewhere which, when dismissed, refreshes the join screen.
            });
        };
        // noinspection JSUnusedGlobalSymbols -- Used by HTML
        this.onCancelJoinButtonPressed = async (pressedElement)=>{
            await this.awaitButtonPressIfNotAlready("cancelJoinButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                this.buttonPressVibration();
                // Ends/closes connection of the most recent GameSession, which is
                //	expected to be the activeGameSessionInView when the Cancel button is pressed
                if (!this.isActiveGameSessionInView(this.gameSessions[this.gameSessions.length - 1])) {
                    $ac58392a9f7a45e7$var$Log.error("Expected activeGameSessionInView to be the most recent GameSession when calling onCancelJoinButtonPressed, but it was not");
                    return;
                }
                if (await this.tryEndGameSessionAtIndex(this.gameSessions.length - 1)) {
                    // Session ended, show WaitOrAddPlayers view with updated player names
                    this.viewManager.setupJoinedPlayersList(this.allJoinedPlayerNames, this._sessionCount);
                    this.viewManager.show((0, $8b07c0f1748354ec$export$27a5bd065ad55220).WaitOrAddPlayers);
                } else // TODO-2022/08/16: Await ignored.  Should we restructure slightly?
                this.viewManager.showInfoPopupDialog("Error", "Failed to cancel joining game.", null);
            });
        };
        // noinspection JSUnusedGlobalSymbols -- Used by HTML
        this.onAreaOutsideMenuPressed = ()=>{
            this.buttonPressVibration();
            this.activeGameSessionInView.onCancelOrBack();
        };
        // noinspection JSUnusedGlobalSymbols -- Used by HTML
        this.onJoinCodeToggleButtonPressed = ()=>{
            this.buttonPressVibration();
            this.joinCodeVisible = !this.joinCodeVisible;
            this.cookieHelper.setJoinCodeVisible(this.joinCodeVisible);
            this.viewManager.updateJoinCodeToggles(this.joinCodeVisible);
        };
        // noinspection JSUnusedGlobalSymbols -- Used by HTML
        this.onPlayerTabButtonPressed = async (tabIndex)=>{
            this.buttonPressVibration();
            if (await this.trySwitchActiveGameSession(tabIndex)) $ac58392a9f7a45e7$var$Log.log(`Selecting player tab: ${tabIndex}`);
        };
        // noinspection JSUnusedGlobalSymbols -- Used by HTML
        this.onSelectCharacterButtonPressed = async (pressedElement, characterIndex)=>{
            if (this.mostRecentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).CharacterSelect) {
                $ac58392a9f7a45e7$var$Log.warn(`Ignoring select character button press because not in ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).CharacterSelect]} state`);
                return;
            }
            await this.awaitButtonPressIfNotAlready("selectCharacterButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                this.buttonPressVibration();
                await this.activeGameSessionInView.requestCharacterSelection(characterIndex);
            });
        };
        // noinspection JSUnusedGlobalSymbols -- Used by HTML
        this.onSelectNonCharacterButtonPressed = async (pressedElement, characterIndex)=>{
            if (this.mostRecentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).CharacterSelect) {
                $ac58392a9f7a45e7$var$Log.warn(`Ignoring select non-character button press because not in ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).CharacterSelect]} state`);
                return;
            }
            await this.awaitButtonPressIfNotAlready("selectCharacterButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                this.buttonPressVibration();
                await this.activeGameSessionInView.requestNonCharacterSelection();
            });
        };
        // noinspection JSUnusedGlobalSymbols -- Used by HTML
        this.onAddPlayerButtonPressed = async (pressedElement)=>{
            if (this.mostRecentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).JoinScreen) {
                $ac58392a9f7a45e7$var$Log.warn(`Ignoring add player button press because not in ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).JoinScreen]} state`);
                return;
            }
            await this.awaitButtonPressIfNotAlready("addPlayerButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                this.buttonPressVibration();
                this.viewManager.setConnectingInfoToDisplay(1, 1);
                // Add player on this device: Try to add a new GameSession & make it the active one
                if (await this.tryAddGameSession()) await this.trySwitchActiveGameSession(this.gameSessions.length - 1);
            });
        };
        // noinspection JSUnusedGlobalSymbols -- Used by HTML
        this.onRemovePlayerButtonPressed = async (pressedElement)=>{
            if (this.mostRecentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).JoinScreen) {
                $ac58392a9f7a45e7$var$Log.warn(`Ignoring remove player button press because not in ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).JoinScreen]} state`);
                return;
            }
            await this.awaitButtonPressIfNotAlready("removePlayerButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                this.buttonPressVibration();
                // The pressedElement is the button that triggered this function call, and
                //	its parent is the playerNameElement (which contains the button and text showing the player's name)
                const playerNameElement = pressedElement.parentNode;
                if (!playerNameElement) throw new Error("Failed to get parent node of pressedElement");
                if (!playerNameElement.parentNode) throw new Error("Failed to get parent node of playerNameElement");
                // Get the index of the playerNameElement as a child of its parent
                //	Players are listed in order of sessionIndex, so we can get that from this
                const elementIndex = Array.prototype.indexOf.call(playerNameElement.parentNode.childNodes, playerNameElement);
                // The first playerNameElement is not the first child, so we need to
                //	subtract to account for that and get a 0-based session index
                const sessionIndex = elementIndex - 2;
                if (sessionIndex < 0 || sessionIndex >= $ac58392a9f7a45e7$export$86fbec116b87613f.MaxGameSessions) throw new Error(`Unexpected (invalid) session index when trying to remove player: ${sessionIndex}`);
                // Remove player by ending the GameSession
                if (!await this.tryEndGameSessionAtIndex(sessionIndex, true)) await this.viewManager.showInfoPopupDialog("Error", "Failed to remove player.", null);
            });
        };
        // noinspection JSUnusedGlobalSymbols -- Used by HTML
        this.onHelpButtonPressed = (helpTextOrType, titleText = "")=>{
            let infoTextToDisplay = helpTextOrType;
            let titleTextToDisplay = titleText;
            const coOpHelpInfo = (0, $e28ba69f83870993$export$ab0202365e783f74)[helpTextOrType];
            if (coOpHelpInfo !== undefined) {
                let coOpInfoTextAndTitle = (0, $e28ba69f83870993$export$1ea1c440ecc5b610).getCoOperationHelpInfo(coOpHelpInfo, this.activeGameSessionInView.turnsPerRound);
                infoTextToDisplay = coOpInfoTextAndTitle.infoText;
                titleTextToDisplay = coOpInfoTextAndTitle.titleText;
            }
            this.viewManager.showHelpPanel(infoTextToDisplay, titleTextToDisplay);
        };
        // noinspection JSUnusedGlobalSymbols -- Used by HTML
        this.onSelectTurnButtonPressed = async (pressedElement)=>{
            if (this.awayAutoReadying) {
                $ac58392a9f7a45e7$var$Log.warn("Ignoring select turn button press because awayAutoReadying");
                return;
            }
            if (!pressedElement.parentNode) return;
            const elementIndex = Array.prototype.indexOf.call(pressedElement.parentNode.childNodes, pressedElement);
            const turnNumIndex = elementIndex;
            await this.awaitButtonPressIfNotAlready("selectTurnButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                this.activeGameSessionInView.selectATurnNumber(turnNumIndex);
                this.buttonPressVibration();
            });
        };
        // noinspection JSUnusedGlobalSymbols -- Used by HTML
        this.onSelectActionButtonPressed = async (pressedElement, actionNumber)=>{
            if (this.awayAutoReadying) {
                $ac58392a9f7a45e7$var$Log.warn("Ignoring select action button press because awayAutoReadying");
                return;
            }
            await this.awaitButtonPressIfNotAlready("selectActionButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                if (actionNumber < 0 || actionNumber >= $ac58392a9f7a45e7$export$86fbec116b87613f.ActionButtonCount) $ac58392a9f7a45e7$var$Log.log(`Trying to select action with invalid action number: ${actionNumber}`);
                this.buttonPressVibration();
                await this.activeGameSessionInView.selectActionNumber(actionNumber, true);
            });
        };
        // noinspection JSUnusedGlobalSymbols -- Used by HTML
        this.onSelectDataButtonPressed = async (pressedElement, data)=>{
            if (this.awayAutoReadying) {
                $ac58392a9f7a45e7$var$Log.warn("Ignoring select data button press because awayAutoReadying");
                return;
            }
            await this.awaitButtonPressIfNotAlready("selectDataButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                this.buttonPressVibration();
                await this.activeGameSessionInView.selectDataForCurrentTurn(data, true);
            });
        };
        // noinspection JSUnusedGlobalSymbols -- Used by HTML
        this.onReadyButtonPressed = async (pressedElement)=>{
            if (this.awayAutoReadying) {
                $ac58392a9f7a45e7$var$Log.warn("Ignoring ready button press because awayAutoReadying");
                return;
            }
            await this.awaitButtonPressIfNotAlready("readyButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                this.buttonPressVibration();
                try {
                    await this.activeGameSessionInView.onReadyButtonPressed(true);
                } catch (e) {
                    this.viewManager.showInfoPopupDialog("Error", `Something went wrong and the game might not know that you're ready.
						Try refreshing the page.`, null);
                    throw e;
                }
            });
        };
        // noinspection JSUnusedGlobalSymbols -- Used by HTML
        this.onUnreadyButtonPressed = async (pressedElement)=>{
            if (this.awayAutoReadying) {
                $ac58392a9f7a45e7$var$Log.warn("Ignoring unready button press because awayAutoReadying");
                return;
            }
            await this.awaitButtonPressIfNotAlready("unreadyButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                this.buttonPressVibration();
                try {
                    await this.activeGameSessionInView.onReadyButtonPressed(false);
                } catch (e) {
                    this.viewManager.showInfoPopupDialog("Error", `Something went wrong and the game might not know that you've cancelled your actions.
						Try refreshing the page.`, null);
                    throw e;
                }
            });
        };
        this.onAwayButtonPressed = async (pressedElement)=>{
            if (this.mostRecentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput && this.mostRecentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementVote) {
                $ac58392a9f7a45e7$var$Log.warn(`onAwayButtonPressed: Doing nothing in ${this.mostRecentControllerState ? (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[this.mostRecentControllerState] : "undefined"} state`);
                return;
            }
            await this.awaitButtonPressIfNotAlready("awayButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                this.buttonPressVibration();
                let autoReadyAttemptCount = 0;
                let autoReadySuccessCount = 0;
                for (const gameSession of this.gameSessions){
                    if (!gameSession.hasJoinedGame) continue;
                    autoReadyAttemptCount++;
                    try {
                        await gameSession.trySendAutoReady(true);
                        autoReadySuccessCount++;
                    } catch (e) {
                        $ac58392a9f7a45e7$var$Log.error(`Failed to send auto-ready enable messsage for session ${gameSession.sessionIndex}: ${e}`);
                    }
                }
                if (autoReadySuccessCount >= autoReadyAttemptCount) {
                    this.awayAutoReadying = true;
                    this.viewManager.setAwayOverlayShowing(true);
                } else {
                    $ac58392a9f7a45e7$var$Log.error(`Tried to send ${autoReadyAttemptCount} auto-ready enable messages to game, but only ${autoReadySuccessCount} succeeded`);
                    this.viewManager.showInfoPopupDialog("Error", `Something went wrong and the game might not know that you're away.
						Try refreshing the page.`, null);
                }
            });
        };
        this.onBackFromAwayButtonPressed = async (pressedElement)=>{
            if (this.mostRecentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput && this.mostRecentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementVote) {
                $ac58392a9f7a45e7$var$Log.warn(`onBackFromAwayButtonPressed: Doing nothing in ${this.mostRecentControllerState ? (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[this.mostRecentControllerState] : "undefined"} state`);
                return;
            }
            await this.awaitButtonPressIfNotAlready("backFromAwayButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                this.buttonPressVibration();
                let autoReadyDisableAttemptCount = 0;
                let autoReadyDisableSuccessCount = 0;
                for (const gameSession of this.gameSessions){
                    if (!gameSession.hasJoinedGame) continue;
                    autoReadyDisableAttemptCount++;
                    try {
                        await gameSession.trySendAutoReady(false);
                        autoReadyDisableSuccessCount++;
                    } catch (e) {
                        $ac58392a9f7a45e7$var$Log.error(`Failed to send auto-ready disable messsage for session ${gameSession.sessionIndex}: ${e}`);
                    }
                }
                if (autoReadyDisableSuccessCount > 0) {
                    this.awayAutoReadying = false;
                    this.viewManager.setAwayOverlayShowing(false);
                }
                if (autoReadyDisableSuccessCount < autoReadyDisableAttemptCount) {
                    $ac58392a9f7a45e7$var$Log.error(`Tried to send ${autoReadyDisableAttemptCount} auto-ready disable messages to game, but only ${autoReadyDisableSuccessCount} succeeded`);
                    this.viewManager.showInfoPopupDialog("Error", `Something went wrong and the game might not know that you're back.
						Try refreshing the page.`, null);
                }
            });
        };
        this.onItemVoteLeftButtonPressed = async (pressedElement)=>{
            if (this.mostRecentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementVote) {
                $ac58392a9f7a45e7$var$Log.warn(`Ignoring item vote left button press because not in ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementVote]} state`);
                return;
            }
            if (!this.activeGameSessionInView.itemManagementData) return;
            await this.awaitButtonPressIfNotAlready("itemVoteLeftButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                this.buttonPressVibration();
                this.activeGameSessionInView.itemManagementData?.decrementSelectedItemVoteIndex();
                this.activeGameSessionInView.updateItemPlacementVoteVisuals();
            });
        };
        this.onItemVoteRightButtonPressed = async (pressedElement)=>{
            if (this.mostRecentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementVote) {
                $ac58392a9f7a45e7$var$Log.warn(`Ignoring item vote right button press because not in ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementVote]} state`);
                return;
            }
            if (!this.activeGameSessionInView.itemManagementData) return;
            await this.awaitButtonPressIfNotAlready("itemVoteRightButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                this.buttonPressVibration();
                this.activeGameSessionInView.itemManagementData?.incrementSelectedItemVoteIndex();
                this.activeGameSessionInView.updateItemPlacementVoteVisuals();
            });
        };
        this.onItemPositionButtonPressed = async (pressedElement)=>{
            if (this.mostRecentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementVote) {
                $ac58392a9f7a45e7$var$Log.warn(`Ignoring item vote position button press because not in ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementVote]} state`);
                return;
            }
            if (!this.activeGameSessionInView.itemManagementData) return;
            if (!pressedElement.parentNode) return;
            const elementIndex = Array.prototype.indexOf.call(pressedElement.parentNode.childNodes, pressedElement);
            const positionIndex = elementIndex - 2;
            await this.awaitButtonPressIfNotAlready("itemPositionButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                this.buttonPressVibration();
                const itemManagementData = this.activeGameSessionInView.itemManagementData;
                const newSelection = itemManagementData?.selectPositionForCurrentItem(positionIndex, this.activeGameSessionInView.sessionIndex);
                if (newSelection?.[0]) // Unready when selection is changed/toggled
                this.activeGameSessionInView.onReadyButtonPressed(false);
                this.activeGameSessionInView.updateItemPlacementVoteVisuals();
                if (newSelection?.[1]) {
                    // If a position was chosen, display the next item that does not already have a position set
                    await itemManagementData?.autoSelectNextItemWithoutPositionAfterDelay();
                    this.activeGameSessionInView.updateItemPlacementVoteVisuals();
                }
            });
        };
        this.onWriterCharacterButtonPressed = async (pressedElement)=>{
            if (this.mostRecentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput) {
                $ac58392a9f7a45e7$var$Log.warn(`Ignoring writer character position button press because not in ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput]} state`);
                return;
            }
            if (!this.activeGameSessionInView.isNonCharacterPlayer) {
                $ac58392a9f7a45e7$var$Log.debug("onWriterCharacterButtonPressed, but active session is not a writer, so doing nothing");
                return;
            }
            if (this.writerButtonsScrolling) return;
            await this.awaitButtonPressIfNotAlready("writerCharacterButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                this.buttonPressVibration();
                this.viewManager.scrollElementIntoViewCentered(pressedElement);
            });
        };
        this.onWriterCharacterLeftButtonPressed = async (pressedElement)=>{
            if (this.mostRecentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput) {
                $ac58392a9f7a45e7$var$Log.warn(`Ignoring writer character left button press because not in ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput]} state`);
                return;
            }
            if (!this.activeGameSessionInView.isNonCharacterPlayer) {
                $ac58392a9f7a45e7$var$Log.debug("onWriterCharacterLeftButtonPressed, but active session is not a writer, so doing nothing");
                return;
            }
            const characterWritingData = this.activeGameSessionInView.characterWritingData;
            if (characterWritingData === undefined) return;
            await this.awaitButtonPressIfNotAlready("writerCharacterLeftButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                this.buttonPressVibration();
                characterWritingData.decrementSelectedCharacterIndex();
                this.viewManager.updateWriterTextInputSelectionVisuals(characterWritingData, true, false);
            });
        };
        this.onWriterCharacterRightButtonPressed = async (pressedElement)=>{
            if (this.mostRecentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput) {
                $ac58392a9f7a45e7$var$Log.warn(`Ignoring writer character right button press because not in ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput]} state`);
                return;
            }
            if (!this.activeGameSessionInView.isNonCharacterPlayer) {
                $ac58392a9f7a45e7$var$Log.debug("onWriterCharacterRightButtonPressed, but active session is not a writer, so doing nothing");
                return;
            }
            const characterWritingData = this.activeGameSessionInView.characterWritingData;
            if (characterWritingData === undefined) return;
            await this.awaitButtonPressIfNotAlready("writerCharacterRightButton", pressedElement, this.activeGameSessionInView.deviceId, async ()=>{
                this.buttonPressVibration();
                characterWritingData.incrementSelectedCharacterIndex();
                this.viewManager.updateWriterTextInputSelectionVisuals(characterWritingData, true, false);
            });
        };
        this.onWriterCharacterSelectScroll = async (scrollElement)=>{
            this.writerButtonsScrolling = true;
            const centremost = this.viewManager.getCentremostElementInScrollView(scrollElement);
            this.viewManager.updateWriterCharacterScrollButtonsStyling(centremost.element);
            // Set a timeout to run writerCharacterScrollEnd after scrolling ends, first clearing any existing one
            // (There's currently no good/fully supported built-in event for onScrollEnd)
            if (this.writerButtonsScrollTimeout) window.clearTimeout(this.writerButtonsScrollTimeout);
            this.writerButtonsScrollTimeout = setTimeout(()=>this.onWriterCharacterSelectScrollEnd(centremost.elementIndex), 200);
        };
        this.onWriterTextInputChanged = (textAreaElement)=>{
            if (!this.activeGameSessionInView.isNonCharacterPlayer) {
                $ac58392a9f7a45e7$var$Log.debug("onWriterTextInputChanged, but active session is not a writer, so doing nothing");
                return;
            }
            if (this.activeGameSessionInView.characterWritingData === undefined) return;
            const characterWritingData = this.activeGameSessionInView.characterWritingData;
            characterWritingData.setTextInputForSelectedCharacter(textAreaElement.value);
            textAreaElement.value = characterWritingData.selectedCharacterText;
            this.viewManager.updateWriterTextInputSelectionVisuals(characterWritingData, false);
            const textForAllCharacters = this.activeGameSessionInView.characterWritingData.getCharacterNameToTextMap();
            this.cookieHelper.setCharacterTextForSessionIndex(this.activeGameSessionInView.sessionIndex, textForAllCharacters);
        };
        this.actUponControllerStateChange = async (state)=>{
            const enteringExisingState = state === this.mostRecentControllerState;
            this._mostRecentControllerState = state;
            if (!enteringExisingState) this.hungKludge.stopTimerAndHide();
            this.keyboardController.setActive(false);
            let view;
            if (this.activeGameSessionInView === undefined) await this.trySwitchActiveGameSession(0);
            switch(state){
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).JoinScreen:
                    this.awayAutoReadying = false;
                    view = (0, $8b07c0f1748354ec$export$27a5bd065ad55220).WaitOrAddPlayers;
                    break;
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForSetup:
                    // End any GameSessions that did not join before setup
                    //await this.endGameSessionsThatHaveNotJoined();
                    if (!this.resettingApp && this.activeGameSessionInView.sessionIndex !== 0) await this.trySwitchActiveGameSession(0);
                    view = (0, $8b07c0f1748354ec$export$27a5bd065ad55220).LookAtScreen;
                    if (!enteringExisingState) this.hungKludge.startTimer();
                    break;
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).CharacterSelect:
                    view = (0, $8b07c0f1748354ec$export$27a5bd065ad55220).CharacterSelect;
                    break;
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput:
                    // Default to the first GameSession when inputting actions
                    if (!this.resettingApp && this.activeGameSessionInView.sessionIndex !== 0) await this.trySwitchActiveGameSession(0);
                    this.keyboardController.setActive(true);
                    if (this.activeGameSessionInView.hasSelectedCharacter) {
                        if (this.activeGameSessionInView.isNonCharacterPlayer) view = (0, $8b07c0f1748354ec$export$27a5bd065ad55220).WriterTextInput;
                        else view = (0, $8b07c0f1748354ec$export$27a5bd065ad55220).GameInputPhase;
                    } else {
                        $ac58392a9f7a45e7$var$Log.error(`no character on WaitingForInput state for active session: ${this.activeGameSessionInView.sessionIndex} (${this.activeGameSessionInView.playerName})`);
                        // Active session did not yet select a character (joined mid-game?),
                        //	so don't show any kind of input screen
                        view = (0, $8b07c0f1748354ec$export$27a5bd065ad55220).LookAtScreen;
                    }
                    break;
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementVote:
                    // Default to the first GameSession when inputting votes
                    if (!this.resettingApp && this.activeGameSessionInView.sessionIndex !== 0) await this.trySwitchActiveGameSession(0);
                    if (this.activeGameSessionInView.hasSelectedCharacter) view = (0, $8b07c0f1748354ec$export$27a5bd065ad55220).ItemPlacementVote;
                    else // Active session did not yet select a character (joined mid-game?),
                    //	so don't show voting input screen
                    view = (0, $8b07c0f1748354ec$export$27a5bd065ad55220).LookAtScreen;
                    break;
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WatchingActions:
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementResults:
                case (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).LevelFinished:
                    view = (0, $8b07c0f1748354ec$export$27a5bd065ad55220).LookAtScreen;
                    if (!enteringExisingState) this.hungKludge.startTimer();
                    break;
                default:
                    throw new Error(`Unhandled controller state:${state}`);
            }
            if (!enteringExisingState && this.awayAutoReadying && (state == (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput || state == (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).ItemPlacementVote)) this.viewManager.setAwayOverlayShowing(true);
            else this.viewManager.setAwayOverlayShowing(false);
            $ac58392a9f7a45e7$var$Log.log(`App actUponControllerStateChange: ${(0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e)[state]}`);
            if (view === undefined) {
                $ac58392a9f7a45e7$var$Log.log(`App actUponControllerStateChange: no View to show`);
                // No new view to show
                return;
            }
            if (this.resettingApp) {
                $ac58392a9f7a45e7$var$Log.log(`App actUponControllerStateChange: Ressetting game so not showing view "${view}"`);
                // The view will get updated based on controller state after resetting is completed, so skip for now
                return;
            }
            $ac58392a9f7a45e7$var$Log.log(`App actUponControllerStateChange: Showing view "${view}"`);
            this.viewManager.show(view);
        };
        /**
	 * Shows the default (splash) view, ends any existing game sessions,
	 * then adds an initial one ready to allow the player to join a game,
	 * or tries to restore previous ones from cookies
	 */ this.resetApp = async ()=>{
            if (this.resettingApp) {
                $ac58392a9f7a45e7$var$Log.warn(`Calling resetApp() while already resetting`);
                return;
            }
            this._resettingApp = true;
            this.awayAutoReadying = false;
            this.viewManager.setDisconnectedOverlayShowing(false);
            this.viewManager.show((0, $8b07c0f1748354ec$export$27a5bd065ad55220).Default);
            // Reset forceJoinCode in case it was set previously
            this.forceJoinCode = undefined;
            try {
                // Ensure no active GameSessions
                await this.endAllExistingGameSessions();
            } catch (e) {
                $ac58392a9f7a45e7$var$Log.error(`Error while trying to endAllExistingGameSessions() in resetApp(): ${e}`);
            }
            // Force reset to default state
            if (this.mostRecentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).JoinScreen) this.actUponControllerStateChange((0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).JoinScreen);
            // Pause briefly while the Default/splash screen is being displayed.
            // This (plus the other delay below) also reduces reconnect issues by giving the game/server enough time to
            //	finish handling any (temporary) disconnections that may have just occured if the page was refreshed.
            // Without the delay, there are more frequent sparodic cases where a device is marked as
            //	disconnected while the game is in the process of handling its reconnection.
            await new Promise((resolve)=>setTimeout(resolve, 800));
            this.cookieHelper.preventSettingSessionsCookie();
            this.gameSessions = [];
            let restoredSessions = false;
            try {
                let numPreviousSessionsAdded = 0;
                const previousSessionIndicesAndNames = this.cookieHelper.getSessionsList();
                if (undefined !== previousSessionIndicesAndNames) {
                    // also true when empty
                    $ac58392a9f7a45e7$var$Log.debug("Found previous sessions = recreating");
                    // (See above comment re. delay)
                    await new Promise((resolve)=>setTimeout(resolve, 700));
                    for (const previousSessionIndexAndName of previousSessionIndicesAndNames){
                        this.viewManager.setConnectingInfoToDisplay(1, previousSessionIndicesAndNames.length);
                        if (await this.tryAddGameSession(previousSessionIndexAndName[0], previousSessionIndexAndName[1])) numPreviousSessionsAdded++;
                    }
                    restoredSessions = true;
                    if (numPreviousSessionsAdded < previousSessionIndicesAndNames.length) $ac58392a9f7a45e7$var$Log.warn(`Only reconnected ${numPreviousSessionsAdded} out of ${previousSessionIndicesAndNames.length} previous sessions`);
                }
            } catch (e) {
                $ac58392a9f7a45e7$var$Log.error(`Error while trying to restore sessions in resetApp(): ${e}`);
            }
            this.cookieHelper.allowSettingSessionsCookie();
            try {
                // After restoring previous sessions, we only want to keep the ones that have joined game
                // 	(some may have been booted since we were last trying to join)
                await this.endGameSessionsThatHaveNotJoined(true, true);
            } catch (e) {
                $ac58392a9f7a45e7$var$Log.error(`Error while trying to endGameSessionsThatHaveNotJoined() in resetApp(): ${e}`);
            }
            // (Not as an `else` to above in case all previous sessions fail,
            //	or there were no restored sessions that had joined a game)
            if (0 === this._sessionCount) {
                // Add initial game session
                $ac58392a9f7a45e7$var$Log.debug("No previous sessions = creating first");
                this.viewManager.setConnectingInfoToDisplay(1, 1);
                if (!await this.tryAddGameSession()) {
                    this._resettingApp = false;
                    throw new Error(`Unable to add initial ${(0, $dd300fc197dcf9fe$export$a3eb6b94b1e7587a)} in resetApp()`);
                }
            }
            await this.trySwitchActiveGameSession(this._sessionCount - 1);
            this._resettingApp = false;
            if (restoredSessions && this.mostRecentControllerState !== (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).JoinScreen) // Force actUponControllerStateChange, since view is not updated on state change while in the process of restoring sessions
            await this.actUponControllerStateChange(this.mostRecentControllerState);
        };
        this.switchToNextNonReadyGameSession = async (currentSessionIndex)=>{
            // Ignore (don't auto-switch to) non-character players when waiting for action input
            let ignoreNonCharacterPlayers = this.mostRecentControllerState === (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).WaitingForInput;
            let nextNonReadySession;
            for(let i = 0; i < this.gameSessions.length; i++)if (!this.gameSessions[i].playerIsReady && (!this.gameSessions[i].isNonCharacterPlayer || !ignoreNonCharacterPlayers)) {
                // Found an GameSession where the player is not 'ready'
                if (i > currentSessionIndex) {
                    // The session comes after the current one, let's switch to it
                    nextNonReadySession = i;
                    break;
                } else if (nextNonReadySession === undefined) // This is the first non-ready session that was found, it will be used
                //	if none are found with a session index greater than the current one
                //	(We favour picking a session that comes after the current one, otherwise we loop back around)
                nextNonReadySession = i;
            }
            if (nextNonReadySession !== undefined) {
                $ac58392a9f7a45e7$var$Log.log(`Switching to the next non-ready GameSession: ${nextNonReadySession}`);
                await this.trySwitchActiveGameSession(nextNonReadySession);
            } else $ac58392a9f7a45e7$var$Log.log(`All players are 'ready', so not switching to another GameSession`);
        };
        this.trySwitchActiveGameSession = async (sessionIndex)=>{
            if (sessionIndex < 0 || sessionIndex >= this.gameSessions.length) {
                $ac58392a9f7a45e7$var$Log.error(`switchActiveGameSession called with invalid sessionIndex: ${sessionIndex}`);
                return false;
            }
            let alreadyActive = this.isActiveGameSessionInView(this.gameSessions[sessionIndex]);
            $ac58392a9f7a45e7$var$Log.log(`Switching active GameSession: ${sessionIndex} (alreadyActive: ${alreadyActive})`);
            if (!alreadyActive) this._activeGameSessionInView = this.gameSessions[sessionIndex];
            // Visually selects the corresponding tab
            this.viewManager.updatePlayerTabVisuals(sessionIndex, this.activeGameSessionInView.playerName ?? "", this.allSelectedCharacterIndexes);
            await this.activeGameSessionInView.becameActiveSession(alreadyActive);
            return true;
        };
        this.endAllExistingGameSessions = async ()=>{
            if (!this.gameSessions || this.gameSessions.length < 1) return; // No GameSessions to end
            const endSessionTasks = [];
            for(let i = this.gameSessions.length - 1; i >= 0; i--){
                endSessionTasks.push(this.tryEndGameSessionAtIndex(i, true));
                // Small delay between ending each session leads to fewer failed attempts to update db on device disconnect
                await new Promise((resolve)=>setTimeout(resolve, 100));
            }
            const endSessionResults = await Promise.all(endSessionTasks);
            if (endSessionResults.includes(false)) {
                $ac58392a9f7a45e7$var$Log.error(`Unable to end all GameSessions - tryEndGameSessionAtIndex() failed for at least one session`);
                return;
            }
            $ac58392a9f7a45e7$var$Log.log("Successsfully ended all GameSessions");
        };
        /**
	 * Ends any GameSessions that were created but did not join a game
	 * e.g. This can happen if the host starts a game while someone is in the process of adding a player/session
	 */ this.endGameSessionsThatHaveNotJoined = async (allowNoSessions, continueWhileResettingApp)=>{
            let sessionEnded;
            // Keep looping through gameSessions and ending any that have not joined a game
            //	until none are found. Done this way because tryEndGameSessionAtIndex manipulates the
            //	gameSessions array, so a single for loop could lead to wrong/invalid indexes being removed
            do {
                sessionEnded = false;
                for(let i = 0; i < this.gameSessions.length; i++)if (!this.gameSessions[i].hasJoinedGame) {
                    if (await this.tryEndGameSessionAtIndex(i, allowNoSessions)) sessionEnded = true;
                    break;
                }
            }while (sessionEnded && (continueWhileResettingApp === true || !this.resettingApp));
        };
        this.tryAddGameSession = async (desiredSessionIndex, playerName)=>{
            if (!this.gameSessions || this.gameSessions.length >= $ac58392a9f7a45e7$export$86fbec116b87613f.MaxGameSessions) {
                // Max number of players already joined on this device
                this.viewManager.showInfoPopupDialog("Error", "No more players allowed on this device.", null);
                return false;
            }
            desiredSessionIndex ??= this.gameSessions.length; // default value
            let newSession = new (0, $dd300fc197dcf9fe$export$a3eb6b94b1e7587a)(this, desiredSessionIndex, this.viewManager, this.cookieHelper, playerName);
            this.gameSessions.push(newSession);
            $ac58392a9f7a45e7$var$Log.log(`Added new GameSession ${desiredSessionIndex} (current count: ${this.gameSessions.length})`);
            await newSession.connectToGame();
            newSession.onGameSessionEnded.subscribe(this.onGameSessionEnded);
            this.updateSessionsCookie();
            this.viewManager.setupJoinedPlayersList(this.allJoinedPlayerNames, this._sessionCount);
            return true;
        };
        this.tryEndGameSessionAtIndex = async (sessionIndex, allowNoSessions = false)=>{
            if (1 >= this.gameSessions.length && !allowNoSessions) {
                $ac58392a9f7a45e7$var$Log.error("endGameSessionAtIndex: Can't end GameSession - would result in no sessions");
                return false;
            }
            if (0 > sessionIndex || sessionIndex >= this.gameSessions.length) {
                $ac58392a9f7a45e7$var$Log.error(`endGameSessionAtIndex called with invalid playerIndex: ${sessionIndex}`);
                return false;
            }
            $ac58392a9f7a45e7$var$Log.log(`Ending GameSession at playerIndex: ${sessionIndex}`);
            try {
                // End session/close connection
                await this.gameSessions[sessionIndex].endSession();
            } catch (e) {
                $ac58392a9f7a45e7$var$Log.error(`Error while trying to end GameSession ${sessionIndex} - ${e}`);
                return false;
            }
            return true;
        };
        this.onAllGameSessionsEnded = async ()=>{
            // All game sessions ended - clear all relavant cookies
            this.cookieHelper.clearJoinCode();
            for(let i = 0; i < $ac58392a9f7a45e7$export$86fbec116b87613f.MaxGameSessions; i++){
                this.cookieHelper.clearDeviceIdForSessionIndex(i);
                // Also hide all players tabs - sometimes some can be left visible if all sessions are
                // ended simultaneously due to session numbers changing mid-sessions-ending
                this.viewManager.setPlayerTabShowing(i, false);
            }
            // Reset and go back to initial join view
            // (May already be in process of resetting if all sessions are ended from resetApp())
            if (!this.resettingApp) return this.resetApp();
        };
        this.onGameSessionEnded = async (sessionThatEnded)=>{
            $ac58392a9f7a45e7$var$Log.log(`GameSession ${sessionThatEnded.sessionIndex} was ended (connection closed)`);
            // Remove closed session from gameSessions array and clear subscription
            // let closedSession: GameSession = this.gameSessions.splice(sessionIndex, 1)[0];
            this.gameSessions.splice(this.gameSessions.indexOf(sessionThatEnded), 1);
            sessionThatEnded.onGameSessionEnded.unsubscribe(this.onGameSessionEnded);
            // Ensure GameSession indexes reflect their current positions within the gameSessions array
            for(let i = 0; i < this.gameSessions.length; i++)this.gameSessions[i].changeSessionIndex(i);
            if (0 < this.gameSessions.length) try {
                // Switch to the most recent existing GameSession in case the activeGameSessionInView was the removed one
                await this.trySwitchActiveGameSession(this.gameSessions.length - 1);
            } catch (e) {
                $ac58392a9f7a45e7$var$Log.error(`Error trying to switch active game session in onGameSessionEnded - ${e}`);
            }
            this.updateSessionsCookie();
            if (this.gameSessions.length > 0) // Player removed, show WaitOrAddPlayers view with updated player names
            this.viewManager.setupJoinedPlayersList(this.allJoinedPlayerNames, this._sessionCount);
            else return this.onAllGameSessionsEnded();
        };
        this.onWriterCharacterSelectScrollEnd = (selectedIndex)=>{
            if (!this.activeGameSessionInView.isNonCharacterPlayer) {
                $ac58392a9f7a45e7$var$Log.debug("onWriterCharacterSelectScrollEnd, but active session is not a writer, so doing nothing");
                return;
            }
            this.writerButtonsScrolling = false;
            if (this.activeGameSessionInView.characterWritingData !== undefined) this.activeGameSessionInView.characterWritingData.setSelectedCharacterIndex(selectedIndex);
            this.viewManager.updateWriterTextInputSelectionVisuals(this.activeGameSessionInView.characterWritingData);
        };
        /**
	 * Maps from UI event name + deviceId to whether it is currently being awaited.
	 * The addition of `deviceId` allows one session to use button while another is still pending.
	 * E.g. P1 chooses a character then P2 can still select one while server has not replied to P1.
	 */ this.uiEventsAwaiting = new Map();
        // Protection from button spamming - either awaits the given funcToAwait, or skips the
        //	function call if we're still awaiting a previous button press with the same uiEventName
        this.awaitButtonPressIfNotAlready = async (uiEventName, pressedElement, deviceId, funcToAwait)=>{
            const key = `${uiEventName}-${deviceId}`;
            if (this.uiEventsAwaiting.get(key) ?? false) {
                $ac58392a9f7a45e7$var$Log.warn(`Skipping button press for '${uiEventName}' for device ${deviceId} (already awaited)`);
                return;
            }
            this.uiEventsAwaiting.set(key, true);
            // Apply disabledFromCode style to the element that was pressed
            //	to give players some visual feedback while awaiting
            pressedElement?.classList.add("disabledFromCode");
            try {
                await funcToAwait();
            } catch (e) {
                throw e;
            } finally{
                this.uiEventsAwaiting.set(key, false);
                pressedElement?.classList.remove("disabledFromCode");
            }
        };
        // TODO: TEMP
        (0, $7653766080191e46$export$4ac4545211fd8567).setDefaultDefaultLevelAndAllExistingLevels((0, $7653766080191e46$export$243e62d78d3b544d).All);
        this.viewManager.hideAll();
        (0, $7fc63af29f7868be$export$ee291b338082bbed)();
        this._mostRecentControllerState = (0, $b4fc6cc2eeeabf82$export$4797cb943f901b2e).JoinScreen;
        // Default controller data for CO OPERATION (initialises this.controllerData)
        this.resetControllerDataToDefault();
        // Add initial GameSession, or restore from cookiess
        this.resetApp();
        this.keyboardController = new (0, $57efccf44429ad06$export$2e2bcd8739ae039)(this);
        // Loss/gain of focus (modern version)
        document.addEventListener("visibilitychange", this.onVisibilityChange);
        // Loss/Gain of focus (old version = paranoia)
        document.addEventListener("blur", this.onBlur);
        document.addEventListener("focus", this.onFocus);
        // // Intercept the "Reload" button
        // window.addEventListener('beforeunload', this.onBeforeUnload, { capture: true });
        // // Do not rely on 'unload' event = often not fired (especially on mobile browsers)
        // window.addEventListener('unload', this.onUnload);
        // Inisialise join code visibility to saved value (or true by default)
        this.joinCodeVisible = this.cookieHelper.getJoinCodeVisible();
        this.viewManager.updateJoinCodeToggles(this.joinCodeVisible);
        this.hungKludge = new (0, $9935c47765ab2268$export$887464dca0f26780)();
    }
    get activeGameSessionInView() {
        return this._activeGameSessionInView;
    }
    get allJoinedPlayerNames() {
        // filter defined playerNames only
        return this.gameSessions.flatMap((s)=>s.playerName ? [
                s.playerName
            ] : []);
    }
    get allSelectedCharacterIndexes() {
        return this.gameSessions.flatMap((s)=>s.selectedCharacterIndex);
    }
    updateSessionsCookie() {
        let list = this.gameSessions.filter((s)=>s.hasJoinedGame).map((s)=>[
                s.sessionIndex,
                s.playerName ?? ""
            ]);
        this.cookieHelper.setSessionsList(list);
    }
    buttonPressVibration() {
    // window.navigator.vibrate(50);
    }
    onVisibilityChange() {
        $ac58392a9f7a45e7$var$Log.log("onVisibilityChange():", document.visibilityState);
    }
    onBlur(evt) {
        $ac58392a9f7a45e7$var$Log.log("onBlur():", evt);
    }
    onFocus(evt) {
        $ac58392a9f7a45e7$var$Log.log("onFocus():", evt);
    }
}
const $ac58392a9f7a45e7$var$Log = (0, $7653766080191e46$export$4ac4545211fd8567).build($ac58392a9f7a45e7$export$86fbec116b87613f.name);
// @ts-ignore // TODO: Fix this non-reference
window.app = new $ac58392a9f7a45e7$export$86fbec116b87613f();


//# sourceMappingURL=GamePad.764da3ed.js.map
